(function() {
  'use strict';

  angular
    .module('inspinia', ['satellizer', 'ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'pascalprecht.translate', 'ngIdle', 'LocalStorageModule', 'plotly', 'chart.js', 'as.sortable','angular-loading-bar', 'summernote', 'base64', 'ngTagsInput', 'ngBootstrap', 'ui.grid', 'ui.grid.pagination', 'ui.grid.resizeColumns', 'ui.grid.moveColumns', 'ui.grid.saveState', 'checklist-model','oitozero.ngSweetAlert', 'angulartics', 'angulartics.piwik']);

})();

/**
 * translateCtrl - Controller for translate
 * Added by Ravi - 8-Aug-2017
 */
function translateCtrl($translate, $scope, initFunction) {
    $scope.changeLanguage = function (langKey) {
        $translate.use(langKey);
        $scope.language = langKey;
        initFunction.toastrTranslation();
    };
}

angular
    .module('inspinia')
    .controller('translateCtrl', translateCtrl);
function ROICtrl($scope, $rootScope, APIService, $filter, $http, SweetAlert, filterFilter, $uibModal, $sce) {
    // Get customer name so correct data is loaded from s3
    $scope.customer = $rootScope.userProfile.customer.name;
    var bucket = 'healthjump-webapps';
    var prefix = 'customer-portal/customers/' + $scope.customer + '/roi-mapping/';
    var s3 = new AWS.S3({
        apiVersion: '2006-03-01'
    });

    // Only display Team Selection and Active Agents on page load
    $scope.showPrompt = true;
    $scope.hideCategories = true;
    $scope.hideDocuments = true;

    $scope.getPracticeList = function () {
        if ($scope.customer === 'sharecare') {
            return 'https://dbx.healthjump.com/api/queries/409/results.json?api_key=cHG0Mewyg0wgoYaDhCPCmoq94KcFc7yoo8sS4GUX'
        } else if ($scope.customer === 'sandbox') {
            return 'https://dbx.healthjump.com/api/queries/445/results.json?api_key=jDemX31bd4T5mmcH4axA1CrCd9AaujV12Oy3yc5h'
        } else if ($scope.customer === 'healthmark_group') {
            return 'https://dbx.healthjump.com/api/queries/658/results.json?api_key=7gJ4k6ocvXl8hXkXLlD9NdTMZb9rCTEahnf7X4R1'
        }
    };

    // Init practices array
    $scope.practices = [];
    $http.get($scope.getPracticeList()).then(function (response) {
        var practices = response.data.query_result.data.rows;
        angular.forEach(practices, function (p) {
            var practiceObj = {
                client_id: p.client_id,
                name: p.name,
                install_date: p.install_date
            };
            $scope.practices.push(practiceObj);
        });
    });

    // Pagination & filtering list of practices
    $scope.totalPracticesList = $scope.practices.length;

    $scope.pageSize = 5; // holds the number of items per page

    $scope.$watch('searchPractice', function (term) {
        var obj = term;

        $scope.filterPracticesList = filterFilter($scope.practices, obj);
        $scope.currentPage = 1;
    });

    // Get master categories from s3
    var params = {
        Bucket: bucket,
        Key: prefix + "master_categories.json"
    };
    s3.getObject(params, function (err, data) {
        if (err) {
            // Add master_categories file to s3 if it doesn't exist yet
            var emptyCategories = '[]';
            var params = {
                Bucket: bucket,
                Key: prefix + 'master_categories.json',
                Body: emptyCategories
            };
            s3.upload(params, function (err, data) {
                console.log(err, data);
            });
        } else $scope.categories = JSON.parse(data.Body); // successful response
    });

    // Get master ROI types from s3
    var params = {
        Bucket: bucket,
        Key: prefix + "master_request_types.json"
    };
    s3.getObject(params, function (err, data) {
        if (err) {
            // Add master_request_types file to s3 if it doesn't exist yet
            var emptyTypes = '[]';
            var params = {
                Bucket: bucket,
                Key: prefix + 'master_request_types.json',
                Body: emptyTypes
            };
            s3.upload(params, function (err, data) {
                console.log(err, data);
            });
        } else $scope.request_types = JSON.parse(data.Body); // successful response
    });

    // Get Teams from DBX
    $scope.getTeamsList = function () {
        if ($scope.customer === 'sharecare') {
            return 'https://dbx.healthjump.com/api/queries/322/results.json?api_key=011HKFe3o0oDhAsCvAcOCACLitJzFeDtmgXidJ54'
        } else if ($scope.customer === 'sandbox') {
            return 'https://dbx.healthjump.com/api/queries/449/results.json?api_key=o8CGbyIQt3FoxWtNWHGJoEudw64M93s00crLCFzh'
        } else if ($scope.customer === 'healthmark_group') {
            return 'https://dbx.healthjump.com/api/queries/657/results.json?api_key=p7uDlA9qRmKPjzTJhCSQyeXmlN3NUGNWpBvVKOhC'
        }
    };

    $http.get($scope.getTeamsList()).then(function (response) {
        $scope.hideCategories = true;
        $scope.hideDocuments = true;

        $scope.teams = response.data.query_result.data.rows;

        // Init teamsList array
        $scope.teamsList = [];
        angular.forEach($scope.teams, function (team) {
            var teamObj = {
                name: team.clinicid
            };
            $scope.teamsList.push(teamObj);
        });

        // Initializing array to store the teams selected
        $scope.teams = {
            selected: []
        };

        $scope.allTeams = function () {
            if ($scope.selectedAll) {
                $scope.selectedAll = true;
                $scope.teams.selected = $scope.teamsList;
            } else {
                $scope.selectedAll = false;
                $scope.teams.selected = [];
            }
        };

        // To select all files
        // $scope.allClinics = function () {
        //     if ($scope.selectedAll) {
        //         $scope.selectedAll = true;
        //         angular.forEach($scope.clinicsList, function (clinic) {
        //             clinic.selected = true;
        //         });
        //         $scope.clinics.selected = angular.copy($scope.clinicsList);

        //     } else {
        //         $scope.selectedAll = false;
        //         angular.forEach($scope.clinicsList, function (clinic) {
        //             clinic.selected = false;
        //         });
        //         $scope.clinics.selected = [];
        //     }
        //     console.log($scope.clinics.selected);
        //     console.log($scope.clinics.selected.length);
        // };

        // To track selected files
        $scope.checkStatus = function () {
            var checkCount = 0;
            angular.forEach($scope.teamsList, function (team) {
                if (team.selected) checkCount++;
            });
            $scope.selectedAll = (checkCount === $scope.teamsList.length);
        };

        // Pagination & filtering list of Teams
        $scope.totalTeamsList = $scope.teamsList.length;

        $scope.pageSize = 5; // holds the number of items per page

        $scope.$watch('searchTeam', function (term) {
            var obj = {
                name: term
            };

            $scope.filterTeamsList = filterFilter($scope.teamsList, obj);
            $scope.currentPage = 1;
        });
    });

    this.loadCategories = function () {
        $scope.showPrompt = false;
        $scope.hideCategories = false;
        $scope.hideDocuments = true;

        // Function to be called to update s3 when adding or removing master categories
        $scope.updateCategories = function () {
            var data = JSON.stringify($scope.categories, function (key, value) {
                if (key === "$$hashKey") {
                    return undefined;
                }
                return value;
            });

            var params = {
                Bucket: bucket,
                Key: prefix + 'master_categories.json',
                Body: data
            };
            s3.upload(params, function (err, data) {
                console.log(err, data);
            });
            toastr.success('Categories successfully updated', 'Success');
        };

        // Function to be called to update s3 when adding or removing master ROI types
        $scope.updateROITypes = function () {
            var data = JSON.stringify($scope.request_types, function (key, value) {
                if (key === "$$hashKey") {
                    return undefined;
                }
                return value;
            });

            var params = {
                Bucket: bucket,
                Key: prefix + 'master_request_types.json',
                Body: data
            };
            s3.upload(params, function (err, data) {
                console.log(err, data);
            });
            toastr.success('ROI types successfully updated', 'Success');
        };

        // Increment request_types.id when adding new tag
        $scope.onROITypeAdded = function ($tag) {
            var index = $scope.request_types.indexOf($tag);
            $scope.request_types[index].id = $scope.request_types.length;

            // Update master list in s3
            $scope.updateROITypes();
        };

        // Increment categories.id when adding new tag
        $scope.onCategoryAdded = function ($tag) {
            var index = $scope.categories.indexOf($tag);
            $scope.categories[index].id = $scope.categories.length;

            // Update master list in s3
            $scope.updateCategories();
        };

        // Pull latest team mappings from s3
        var params = {
            Bucket: bucket,
            Key: prefix + 'roi_mapping.json'
        };
        s3.getObject(params, function (err, data) {
            if (err) {
                // Add roi_mapping file to s3 if it doesn't exist yet
                var emptyROIMapping = '[]';
                var params = {
                    Bucket: bucket,
                    Key: prefix + 'roi_mapping.json',
                    Body: emptyROIMapping
                };
                s3.upload(params, function (err, data) {
                    console.log(err, data);
                });
            } else $scope.roiMappings = JSON.parse(data.Body);

            // List of all ROI types assigned to each team
            $scope.teamROIList = [];
            // For each selected team, create an array of ROI Mappings
            angular.forEach($scope.roiMappings, function (mapping) {
                if ($scope.teams.selected.map(function (e) {
                    return e.name;
                }).indexOf(mapping.name) !== -1) {
                    // List of all category names for the selected team(s)
                    categories = [];
                    // Find the name of the category based on the category id
                    angular.forEach(mapping.categories, function (category) {
                        cat = $filter('filter')($scope.categories, {
                            'id': category
                        })[0].name;
                        categories.push(cat);
                    });

                    // Find the name of the request type based on the request_type_id
                    var roi = $filter('filter')($scope.request_types, {
                        'id': mapping.request_type_id
                    })[0].name;
                    var request = {
                        name: mapping.name,
                        request_type: roi,
                        categories: categories
                    };
                    // Populate the teamROIList for use in the view
                    $scope.teamROIList.push(request);
                }
            });

            $scope.$watch('searchROI', function (term) {
                var obj = term;

                $scope.filterTeamROIList = filterFilter($scope.teamROIList, obj);

                // Pagination & filtering list of Team ROI mappings
                $scope.totalteamROIList = $scope.teamROIList.length;

                $scope.currentPage = 1;
                $scope.pageSize = 10; // holds the number of items per page
                $scope.maxSize = 10; // max number of pages to display

                // Calculate the number of pages based on max page size
                $scope.numPages = Math.ceil($scope.totalteamROIList / $scope.pageSize);

                // Function to be called when adding/removing categories from team mappings
                $scope.updateROIMapping = function () {
                    // Convert updated mappings to match format of objects in roi_mappings.json
                    angular.forEach($scope.filterTeamROIList, function (map) {
                        categories = [];
                        // Find the IDs of the categories based on the names
                        angular.forEach(map.categories, function (category) {
                            cat = $filter('filter')($scope.categories, {
                                'name': category.name
                            })[0].id;
                            categories.push(cat);
                        });

                        // Find the ID of the roi type based on the name
                        var roiArr = $filter('filter')($scope.request_types, {
                            'name': map.request_type
                        });
                        // Filter the results to get an exact name match
                        var roi;
                        angular.forEach(roiArr, function (r) {
                            if (r.name === map.request_type) {
                                roi = r.id
                            }
                        });

                        // Init object which will match format of objects in s3
                        var roiObj = {
                            name: map.name,
                            request_type_id: roi,
                            categories: categories
                        };

                        // Update full roiMappings list with updated categories
                        $scope.roiMappings.find(function (mapping) {
                            return mapping.name + mapping.request_type_id === roiObj.name + roiObj.request_type_id;
                        }).categories = roiObj.categories;

                    });

                    // Overwrite file in s3 with complete list of updated mappings
                    var data = JSON.stringify($scope.roiMappings, function (key, value) {
                        if (key === "$$hashKey") {
                            return undefined;
                        }
                        return value;
                    });
                    var params = {
                        Bucket: bucket,
                        Key: prefix + 'roi_mapping.json',
                        Body: data
                    };

                    s3.upload(params, function (err, data) {
                        console.log(err, data);
                    });
                    toastr.success('Mapping updated', 'Success');
                };

                // Initialize new mapping object to be added to teamsROIList
                $scope.mappingToAdd = {
                    request_type: "",
                    categories: ""
                };

                $scope.addMapping = function () {
                    // Loop through teams selected to add team name to the new mapping objects
                    angular.forEach($scope.teams.selected, function (team) {
                        var newMapping = {
                            name: team.name,
                            request_type: $scope.mappingToAdd.request_type,
                            categories: $scope.mappingToAdd.categories
                        };

                        // Check if ROI Type is already mapped for the team(s) selected before push
                        function mappingExists(newMapping) {
                            return $scope.filterTeamROIList.some(function (mapping) {
                                return mapping.name + mapping.request_type === newMapping.name + newMapping.request_type;
                            });
                        }

                        if (mappingExists(newMapping)) {
                            toastr.error(newMapping.request_type + ' mapping already created for ' + newMapping.name, 'Error', {
                            });
                        } else {
                            // Update list in UI
                            $scope.filterTeamROIList.push(newMapping);

                            // Get category IDs & request_type_ids for newMapping and update full roiMappings list
                            category_ids = [];
                            // Find the IDs of the categories based on the names
                            angular.forEach(newMapping.categories, function (category) {
                                cat = $filter('filter')($scope.categories, {
                                    'name': category.name
                                })[0].id;
                                category_ids.push(cat);
                            });

                            // Find the request_type_id based on the request_type
                            // var request_type_id = $filter('filter')($scope.request_types, {
                            //     'name': newMapping.request_type
                            // })[0].id;
                            var request_type_idArr = $filter('filter')($scope.request_types, {
                                'name': newMapping.request_type
                            });
                            // Filter the results to get an exact name match
                            var request_type_id;
                            angular.forEach(request_type_idArr, function (r) {
                                if (r.name === newMapping.request_type) {
                                    request_type_id = r.id
                                }
                            });

                            var newMappingUpdated = {
                                name: newMapping.name,
                                request_type_id: request_type_id,
                                categories: category_ids
                            };

                            $scope.roiMappings.push(newMappingUpdated);

                            toastr.info('Adding ' + newMapping.request_type + ' mapping for ' + newMapping.name + ', please do not refresh or close the page', '');

                            // Overwrite file in s3 with complete list of mappings
                            var data = JSON.stringify($scope.roiMappings, function (key, value) {
                                if (key === "$$hashKey") {
                                    return undefined;
                                }
                                return value;
                            });
                            var params = {
                                Bucket: bucket,
                                Key: prefix + 'roi_mapping.json',
                                Body: data
                            };

                            s3.upload(params, function (err, data) {
                                console.log(err, data);
                            });
                        }
                    });
                };

                $scope.showStuff = function () {
                    console.log($scope.filterTeamROIList);
                }

                // Delete row from team mapping table
                $scope.deleteMapping = function (mapping) {
                    // Remove mapping from the filtered list in UI
                    var index = $scope.filterTeamROIList.indexOf(mapping);
                    $scope.filterTeamROIList.splice(index, 1);

                    // Mapping object from UI has roi type name (not id), so we have to get the id from master roi types first
                    // var request_type_id = $filter('filter')($scope.request_types, {
                    //     'name': mapping.request_type
                    // })[0].id;
                    var request_type_idArr = $filter('filter')($scope.request_types, {
                        'name': mapping.request_type
                    });
                    // Filter the results to get an exact name match
                    var request_type_id;
                    angular.forEach(request_type_idArr, function (r) {
                        if (r.name === mapping.request_type) {
                            request_type_id = r.id;
                        }
                    });

                    // Remove mapping from the full roiMappings array
                    $scope.updatedROIMapping = $scope.roiMappings.filter(function (roi_mapping) {
                        return roi_mapping.name + roi_mapping.request_type_id !== mapping.name + request_type_id
                    });

                    // Overwrite file in s3 with complete list of mappings
                    var data = JSON.stringify($scope.updatedROIMapping, function (key, value) {
                        if (key === "$$hashKey") {
                            return undefined;
                        }
                        return value;
                    });
                    var params = {
                        Bucket: bucket,
                        Key: prefix + 'roi_mapping.json',
                        Body: data
                    };
                    console.log(request_type_idArr, request_type_id);
                    s3.upload(params, function (err, data) {
                        console.log(err, data);
                    });
                    toastr.success('Mapping deleted', 'Success');
                };

                // Prompt user to confirm before deleting master ROI Type tag
                $scope.onROIRemoval = function ($tag) {
                    SweetAlert.swal({
                        title: "Cannot remove master ROI types.",
                        text: "ROI type deletion has temporarily been disabled.",
                        type: "warning",
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                    });
                    return false;
                    // return new Promise(function (resolve, reject) {
                    //     // Loop through all teams (not just those selected on page) to determine if the ROI Type to be deleted has been mapped
                    //     $scope.mappedROI = [];
                    //     angular.forEach($scope.roiMappings, function (map) {
                    //         var roi = $filter('filter')($scope.request_types, {'id': map.request_type_id})[0].name;
                    //         $scope.mappedROI.push(roi);
                    //     });
                    //     // Loop through teamROIList as well in case new mappings were added
                    //     angular.forEach($scope.teamROIList, function (map) {
                    //         $scope.mappedROI.push(map.request_type);
                    //     });
                    //     // Show sweetalert if the ROI Type has been mapped
                    //     if ($scope.mappedROI.map(function (e) {
                    //         return e;
                    //     }).indexOf($tag.name) !== -1) {
                    //         SweetAlert.swal({
                    //                 title: "Are you sure?",
                    //                 text: "Deleting an ROI Type from the master list will also delete all existing team mappings associated with it.",
                    //                 type: "warning",
                    //                 showCancelButton: true,
                    //                 confirmButtonColor: "#DD6B55",
                    //                 confirmButtonText: "Yes, please delete",
                    //                 cancelButtonText: "Cancel",
                    //                 closeOnConfirm: true,
                    //                 closeOnCancel: true
                    //             },
                    //             function (isConfirm) {
                    //                 if (isConfirm) {
                    //                     // Loop through roiMappings and delete mappings associated with the deleted master ROI Type
                    //                     angular.forEach($scope.roiMappings, function (map) {
                    //                         var roi = $filter('filter')($scope.request_types, {'id': map.request_type_id})[0].name;
                    //                         var index = $scope.roiMappings.indexOf(map);
                    //                         if (roi === $tag.name) {
                    //                             $scope.roiMappings.splice(index);
                    //                         }
                    //                     });
                    //                     // Loop through teamROIList and delete mappings associated with the deleted master ROI Type
                    //                     angular.forEach($scope.teamROIList, function (map) {
                    //                         var index = $scope.teamROIList.indexOf(map);
                    //                         if (map.request_type === $tag.name) {
                    //                             $scope.teamROIList.splice(index);
                    //                         }
                    //                     });
                    //                     $scope.updateROIMapping();
                    //                     return resolve();
                    //                 } else {
                    //                     return reject();
                    //                 }
                    //             });
                    //     // Otherwise, delete the ROI Type without user input
                    //     } else {
                    //         return resolve();
                    //     }
                    // });
                };

                // Prompt user to confirm before deleting master Category tag
                $scope.onCategoryRemoval = function ($tag) {
                    SweetAlert.swal({
                        title: "Cannot remove master categories.",
                        text: "Category deletion has temporarily been disabled.",
                        type: "warning",
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                    });
                    return false;
                    // return new Promise(function (resolve, reject) {
                    //     // Loop through roiMappings to determine if the category to be deleted has been mapped to any teams
                    //     $scope.mappedCategories = [];
                    //     angular.forEach($scope.roiMappings, function (map) {
                    //         angular.forEach(map.categories, function (category) {
                    //             var cat = $filter('filter')($scope.categories, {'id': category});
                    //             $scope.mappedCategories.push(cat[0].name);
                    //         });
                    //     });
                    //     // Loop through teamROIList as well in case new categories were added
                    //     angular.forEach($scope.teamROIList, function (map) {
                    //         angular.forEach(map.categories, function (category) {
                    //             $scope.mappedCategories.push(category.name);
                    //         });
                    //     });
                    //     // Show alert if the Category has been mapped
                    //     if ($scope.mappedCategories.map(function (e) {
                    //         return e;
                    //     }).indexOf($tag.name) !== -1) {
                    //         SweetAlert.swal({
                    //                 title: "Are you sure?",
                    //                 text: "Deleting a Category from the master list will also delete it from all existing team and document mappings.",
                    //                 type: "warning",
                    //                 showCancelButton: true,
                    //                 confirmButtonColor: "#DD6B55",
                    //                 confirmButtonText: "Yes, please delete",
                    //                 cancelButtonText: "Cancel",
                    //                 closeOnConfirm: true,
                    //                 closeOnCancel: true
                    //             },
                    //             function (isConfirm) {
                    //                 if (isConfirm) {
                    //                     // Delete the category from roiMappings so teams not selected are updated
                    //                     angular.forEach($scope.roiMappings, function (map) {
                    //                         angular.forEach(map.categories, function (category) {
                    //                             var cat = $filter('filter')($scope.categories, {'id': category})[0].name;
                    //                             var index = map.categories.indexOf(category);
                    //                             if (cat === $tag.name) {
                    //                                 map.categories.splice(index, 1);
                    //                             }
                    //                         });
                    //                     });
                    //                     // Delete the category from teamROIList
                    //                     angular.forEach($scope.teamROIList, function (map) {
                    //                         angular.forEach(map.categories, function (category) {
                    //                             var index = map.categories.indexOf(category);
                    //                             if (category.name === $tag.name) {
                    //                                 map.categories.splice(index, 1);
                    //                             }
                    //                         });
                    //                     });
                    //                     $scope.updateROIMapping();
                    //                     return resolve();
                    //                 } else {
                    //                     return reject();
                    //                 }
                    //             });
                    //     // Otherwise, delete the Category without user input
                    //     } else {
                    //         return resolve();
                    //     }
                    // });
                };
            });
        });
    };

    // Get documents details for practice selected
    this.loadDocumentDetails = function (practice) {
        $scope.selected_practice = practice;
        $scope.hideCategories = true;
        $scope.showPrompt = false;
        $scope.hideDocuments = false;

        // Function to get DBX document list query for selected practice
        $scope.getQuery = function (client_id) {
            if (client_id === 'APM01') {
                return 'https://dbx.healthjump.com/api/queries/408/results.json?api_key=ssb7VmA0f5bcO1W8Tp1PweOV0G2PZDh6VvNIMeP9';
            } else if (client_id === 'SEOS01') {
                return 'https://dbx.healthjump.com/api/queries/412/results.json?api_key=cjOaiXAFxsZgF5TdoBhUeT0RUNoV0fijU3mtShzp';
            } else if (client_id === 'SBOX01') {
                return 'https://dbx.healthjump.com/api/queries/447/results.json?api_key=Xb6OdOGOdZvh8igK5muJ0Ywp0poS10KFo2VTuU0i';
            } else if (client_id === 'VORTHO01') {
                return 'https://dbx.healthjump.com/api/queries/619/results.json?api_key=paX52Bo1O9sJ3bPkKZQt0rIA8IPInANlMiVUnZC5';
            } else if (client_id === 'TORTHO01') {
                return 'https://dbx.healthjump.com/api/queries/627/results.json?api_key=tv9wTN3pbCZvAWqS57ZaJRjbmby3WW45k83pPfyt';
            } else if (client_id === 'BWMC01') {
                return 'https://dbx.healthjump.com/api/queries/656/results.json?api_key=65sANSTwpdsb7lf0OHyFZE9FvNLVS1DIfrq7dMn7';
            }
        };

        // Check s3 to see if documents file exists for practice selected        
        var client_id = $scope.selected_practice.client_id;
        var doc_prefix = prefix + 'doc-mapping/' + client_id + "_" + "documents.json";
        var params = {
            Bucket: bucket,
            Key: doc_prefix
        };

        s3.getObject(params, function (err, data) {
            if (err) {
                $http.get($scope.getQuery(client_id)).then(function (response) {
                    $scope.docList = [];
                    angular.forEach(response.data.query_result.data.rows, function (doc) {
                        var docObj = {
                            type: doc.template_type || doc.document_type,
                            count: doc.doc_cnt,
                            last_generated: doc.Last_Generated,
                            categories: [],
                            preview: ''
                        };
                        $scope.docList.push(docObj);
                    });
                    var newDocs = JSON.stringify($scope.docList, function (key, value) {
                        if (key === "$$hashKey") {
                            return undefined;
                        }
                        return value;
                    });
                    var params = {
                        Bucket: bucket,
                        Key: doc_prefix,
                        Body: newDocs
                    };
                    s3.upload(params, function (err, data) {
                        console.log(err, data);
                    });
                });
            } else $scope.rawDocList = JSON.parse(data.Body);

            // Most recent doc mapping list to compare to source document list
            $scope.prevDocList = [];
            angular.forEach($scope.rawDocList, function (doc) {
                var obj = {
                    type: doc.type,
                    last_generated: doc.last_generated,
                    count: doc.count,
                    categories: doc.categories
                };
                $scope.prevDocList.push(obj);
            });

            // Run DBX query to get latest document list from source
            $http.get($scope.getQuery(client_id)).then(function (response) {
                $scope.newDocs = [];
                if (response.data === null) {
                    var docObj = {
                        type: "",
                        last_generated: "",
                        count: "",
                        categories: []
                    };
                    $scope.newDocs.push(docObj);
                } else {
                    angular.forEach(response.data.query_result.data.rows, function (doc) {
                        var docObj = {
                            type: doc.template_type || doc.document_type,
                            last_generated: doc.last_generated,
                            count: doc.doc_cnt,
                            categories: []
                        };
                        $scope.newDocs.push(docObj);
                    });
                }


                // If document type exists in prevDocList, replace it in newDocs array since it may have been mapped
                for (var i = 0, l = $scope.newDocs.length; i < l; i++) {
                    for (var j = 0, ll = $scope.prevDocList.length; j < ll; j++) {
                        if ($scope.newDocs[i].type === $scope.prevDocList[j].type) {
                            $scope.newDocs.splice(i, 1, $scope.prevDocList[j]);
                            break;
                        }
                    }
                }

                // If a master category was deleted, remove the object from current doc mappings
                $scope.docList = [];
                angular.forEach($scope.newDocs, function (doc) {
                    angular.forEach(doc.categories, function (cat) {
                        if ($scope.categories.map(function (e) {
                            return e.name;
                        }).indexOf(cat.name) === -1) {
                            var index = doc.categories.indexOf(cat);
                            doc.categories.splice(index, 1);
                        }
                    });
                    $scope.docList.push(doc);
                });

                // Check s3 for sample PDF to preview and determine if user can preview document
                var previewParams = {
                    Bucket: bucket,
                    Prefix: prefix + 'pdf/' + client_id + '/',
                };
            
                s3.listObjects(previewParams, function(err, data) {
                    var contents = data.Contents.map(function (d) {
                    return d.Key.replace(previewParams.Prefix, '');
                    });
                    angular.forEach($scope.docList, function(d) {
                        let count = 0;
                        angular.forEach(contents, function(c) {
                            if(d.type === c.replace(".pdf", "")) {
                                count++;
                            }      
                        });
                        if(count > 0) d.preview = true;
                        else d.preview = false    
                    });
                    if(err) console.log(err);
                });;

                // Percent of mapped docs for Mapped Docs chart
                $scope.chartData = function () {

                    $scope.totalDocs = $scope.docList.length;

                    $scope.unmapped_count = $scope.docList.filter(function (e) {
                        return e.categories.length === 0
                    }).length;

                    $scope.mapped = $scope.totalDocs - $scope.unmapped_count;

                    $scope.getpercentfloat = function (num, den, decimal) {
                        if (den == 0) {
                            return 0;
                        }
                        if (!decimal) {
                            return Math.floor(((num * 1.00) / (den * 1.00)) * 100);
                        } else {
                            return (((num * 1.00) / (den * 1.00)) * 100.00).toFixed(2);
                        }
                    };
                    $scope.mappedPercent = $scope.getpercentfloat($scope.mapped, $scope.totalDocs, null);

                    // Data for pie chart
                    $scope.mappedDocsChartData = [$scope.mapped, $scope.unmapped_count];

                    // Options for Mapped Docs chart
                    $scope.mappedDocsChartOptions = {
                        segmentShowStroke: true,
                        segmentStrokeColor: "#fff",
                        segmentStrokeWidth: 2,
                        percentageInnerCutout: 0, // This is 0 for Pie charts
                        animationSteps: 100,
                        animationEasing: "easeOutBounce",
                        animateRotate: true,
                        animateScale: false
                    };

                    $scope.mappedDocsChartLabels = ["Mapped", "Unmapped"];
                };

                $scope.chartData();

                // Pagination & filtering list of practice Documents
                $scope.$watch('searchDocs', function (term) {
                    var obj = term;

                    $scope.filterDocList = filterFilter($scope.docList, obj);

                    // Init array for filtering document list
                    $scope.documentTags = ['Mapped', 'Unmapped'];

                    // Toggle the tag selection and add selected tag in array
                    var selTags = [];
                    $scope.filterDocs = function (selTag) {
                        if (selTags.indexOf(selTag) === -1) {
                            selTags.push(selTag);
                            angular.element('.taggin-' + selTag).css({
                                'background-color': '#1ab394',
                                'color': '#ffffff'
                            });
                        } else {
                            selTags.splice(selTags.indexOf(selTag), 1);
                            angular.element('.taggin-' + selTag).css({
                                'background-color': '#f3f3f4',
                                'color': '#676a6c'
                            });
                        }
                        if (!$scope.documentTags.length) {
                            selTags = [];
                        }
                        tagFilter();
                    };

                    // Filter document list based on selected tag
                    function tagFilter() {
                        if (selTags.length > 0) {
                            angular.forEach(selTags, function (tag) {
                                if (tag === "Unmapped") {
                                    $scope.filterDocList = filterFilter($scope.docList.filter(function (e) {
                                        return e.categories.length === 0
                                    }), obj);
                                } else if (tag === "Mapped") {
                                    $scope.filterDocList = filterFilter($scope.docList.filter(function (e) {
                                        return e.categories.length > 0
                                    }), obj);
                                }
                            });
                        } else $scope.filterDocList = filterFilter($scope.docList, obj);

                        $scope.totalDocsFiltered = Object.keys($scope.filterDocList).length;
                    }

                    $scope.totalDocsList = $scope.filterDocList.length;

                    $scope.currentPage = 1;
                    $scope.pageSize = 10; // holds the number of items per page
                    $scope.maxSize = 10; // max number of pages to display

                    // Calculate the number of pages based on max page size
                    $scope.numPages = Math.ceil($scope.totalDocsList / $scope.pageSize);

                    $scope.allDocs = function () {
                        if ($scope.selectedAllDocs) {
                            $scope.selectedAllDocs = true;
                            $scope.filterDocList.selected = $scope.filterDocList;
                        } else {
                            $scope.selectedAllDocs = false;
                            $scope.filterDocList.selected = [];
                        }
                    };

                    $scope.checkDocStatus = function () {
                        var checkCount = 0;
                        angular.forEach($scope.filterDocList, function (doc) {
                            if (doc.selected) checkCount++;
                        });
                        $scope.selectedAllDocs = (checkCount === $scope.filterDocList.length);
                    };

                    $scope.updateDocMappings = function () {
                        toastr.info('Updating document mappings, please do not refresh or close the page', '', {
                            preventDuplicates: true
                        });
                        var newMappings = JSON.stringify($scope.docList, function (key, value) {
                            if (key === "$$hashKey") {
                                return undefined;
                            }
                            return value;
                        });
                        var params = {
                            Bucket: bucket,
                            Key: doc_prefix,
                            Body: newMappings
                        };
                        s3.upload(params, function (err, data) {
                            console.log(err, data);
                            toastr.success('Document mappings updated', 'Success', {
                                preventDuplicates: true
                            });
                        });
                    };

                    // Initialize categoriesToAdd object which will update docList
                    $scope.categoriesToAdd = {
                        categories: ""
                    };

                    // Replace document categories with selection from user
                    $scope.addCategories = function () {
                        // Loop through documents selected to update the categories
                        angular.forEach($scope.filterDocList.selected, function (doc) {
                            doc.categories = $scope.categoriesToAdd.categories.slice(0)
                        });
                        $scope.updateDocMappings();
                    };

                    // Remove mappings for multiple documents selected
                    $scope.clearAll = function () {
                        // Confirm the docs selected have existing categories to remove
                        if ($scope.filterDocList.selected.filter(function (e) {
                            return e.categories.length > 0
                        }).length > 0) {
                            angular.forEach($scope.filterDocList.selected, function (doc) {
                                doc.categories = [];
                            });
                            $scope.updateDocMappings();
                        }
                    };

                    // Function to call to get mapping_sample DBX query
                    $scope.getMappingSample = function (client_id) {
                        if (client_id === 'APM01') {
                            return 'https://dbx.healthjump.com/api/queries/415/results.json?api_key=5WOl4GLqJMbuNEtGtU8QRaLtc82gAjIQVoOtKD0f'
                        }
                        if (client_id === 'SBOX01') {
                            return 'https://dbx.healthjump.com/api/queries/454/results.json?api_key=wykQJoWnx9VcohaiGL2M6aJuarjZ89ttc4OZlPuD'
                        }
                        if (client_id === 'VORTHO01') {
                            return 'https://dbx.healthjump.com/api/queries/631/results.json?api_key=OCIrjv2Xrkp45bFdoTpxP9V3jIjmSjOQB6KwidvO'
                        }
                        if (client_id === 'TORTHO01') {
                            return 'https://dbx.healthjump.com/api/queries/629/results.json?api_key=AHNfIgg5Y7OL9tCI5tXRjVVES78AYnbk708nMlmL'
                        }
                        if (client_id === 'BWMC01') {
                            return 'https://dbx.healthjump.com/api/queries/739/results.json?api_key=OwRZwyvzyDez9j1mo50y0ia8RRC3bBDfxjrSO2Zl'
                        }
                    };

                    // Get sample PDFs list from DBX for practice
                    $http.get($scope.getMappingSample(client_id)).then(function (response) {
                        $scope.mappingSample = [];
                        angular.forEach(response.data.query_result.data.rows, function (s) {
                            var sample = {
                                type: s.document_type,
                                patientID: s.patient_id
                            };
                            $scope.mappingSample.push(sample);
                        });

                        $scope.openPDF = function (file) {
                            // Log user, doc type, patient ID accessed in PDF preview
                            angular.forEach($scope.mappingSample, function (s) {
                                if (s.type === file) {
                                    var now = new Date();
                                    var datetime = $filter('date')(now, 'yyyy-MM-dd HH:mm:ss');
                                    var fileDate = $filter('date')(now, 'yyyyMMdd');
                                    var phi_event = {
                                        user: $rootScope.userProfile.email,
                                        file: file,
                                        patient: s.patientID,
                                        date: datetime
                                    };
                                    // Read phi_log from s3
                                    var phi_prefix = prefix + 'phi-logs/' + fileDate + "/" + client_id + "_phi_log.json";
                                    var params = {
                                        Bucket: bucket,
                                        Key: phi_prefix
                                    };

                                    s3.getObject(params, function (err, data) {
                                        if (err) {
                                            // Add log file to s3 if it doesn't exist yet
                                            var data = '[]';
                                            var new_log_params = {
                                                Bucket: bucket,
                                                Key: phi_prefix,
                                                Body: data
                                            };
                                            s3.upload(new_log_params, function (err, data) {
                                                console.log(err, data);
                                            });
                                        } else $scope.phi_log = JSON.parse(data.Body);
                                        // Update log with latest event & upload to s3
                                        $scope.phi_log.push(phi_event);

                                        var data = JSON.stringify($scope.phi_log, function (key, value) {
                                            if (key === "$$hashKey") {
                                                return undefined;
                                            }
                                            return value;
                                        });

                                        var log_params = {
                                            Bucket: bucket,
                                            Key: phi_prefix,
                                            Body: data
                                        };
                                        s3.upload(log_params, function (err, data) {
                                            console.log(err, data);
                                        });
                                    });
                                }
                            });

                            // Check s3 for sample PDF to preview
                            var pdf_path = prefix + 'pdf/' + client_id + '/' + file + '.pdf';
                            var params = {
                                Bucket: bucket,
                                Key: pdf_path,
                                ResponseContentType: 'application/pdf',
                                Expires: 60
                            };
                            var url = s3.getSignedUrl('getObject', params);

                            $uibModal.open({
                                templateUrl: 'app/views/common/roi_pdfModal.html',
                                controller: pdfModalInstanceCtrl,
                                scope: $scope
                            });

                            $scope.pdfUrl = $sce.trustAsResourceUrl('pdfjs/web/viewer.html?file=' + encodeURIComponent(url));
                        }
                    });
                });
            });
        });
    };

    $scope.loadTags = function (query) {
        return $filter('filter')($scope.categories, query);
    };
}

function pdfModalInstanceCtrl($scope, $uibModalInstance) {

    $scope.cancel = function () {
        $uibModalInstance.close();
    };
}

angular.module('inspinia').filter('start', function () {
    return function (input, start) {
        if (!input || !input.length) {
            return;
        }

        start = +start;
        return input.slice(start);
    };


}).controller('ROICtrl', ROICtrl)
    .controller('pdfModalInstanceCtrl', pdfModalInstanceCtrl);
/**
 * chartJsCtrl - Controller for data for ChartJs plugin
 * used in Chart.js view
 */

// function QmCtrl() {
    
function QmCtrl($scope, $rootScope, APIService, $filter, $uibModal) {
    // $scope.filters = {"filters":{}}; // {"filters" : {"age_group":"65+","bp_last_grouping":"Prehypertensive"}}
    APIService.post('partner/cqm_data',{'_method':'GET'}).then(function(response){
        $scope.cqm_data = response.data;
        $scope.filters = {"filters":{}};
        refreshdata($scope.cqm_data);
    });

    $scope.filtered = false;
    $scope.filtering = true;
    $scope.clearingfilters = false;
    $scope.clearqmfilters = function(){
        $scope.filtered = false;
        $scope.filters = {"filters":{}};
        $scope.filtering = true;
        $scope.clearingfilters = true;
        APIService.post('partner/cqm_data',{'_method':'GET'}).then(function(response){
            $scope.cqm_data = response.data;
            $scope.filters = {"filters":{}};
            $scope.filtered = false;
            $scope.clearingfilters = false;
            refreshdata($scope.cqm_data);
        });
    }
    $scope.clearqmfilter = function(element){
        $scope.filtering = true;
        delete $scope.filters.filters[element];
        if( Object.keys($scope.filters.filters).length == 0 ){
            $scope.clearqmfilters();
        }else{
            var tfilter = $scope.filters
            tfilter['_method'] = 'GET';
            APIService.post('partner/cqm_data',tfilter).then(function(response){
                $scope.cqm_data = response.data;
                refreshdata($scope.cqm_data);
            });            
        }
    }

    $scope.filterdata = function(element,filterby){
        $scope.filtering = true;
        if(filterby && element){
            $scope.filtered = true;
            $scope.filters.filters[element] = filterby;
        }
        var tfilter = $scope.filters
        tfilter['_method'] = 'GET';
        APIService.post('partner/cqm_data',tfilter).then(function(response){
            $scope.cqm_data = response.data;
            refreshdata($scope.cqm_data);
        });
    }

    $scope.getpercentfloat = function(num,den,decimal){
        if(den==0){
            return 0;
        }
        if(!decimal){
            return Math.floor( ((num*1.00) / (den*1.00))*100 );   
        }else{
            return (((num*1.00) / (den*1.00))*100.00).toFixed(2);
        }
    }


    $scope.reorder_clientids = function(keyval){
        var clientids_ordered = {};
        if(keyval=='k'){
            Object.keys($scope.cqm_data.client_id).sort().forEach(function(key) {
              clientids_ordered[key] = $scope.cqm_data.client_id[key];
            });
        }else{
            var clientids_ordered = [];
            for (var clientid in $scope.cqm_data.client_id) {
                clientids_ordered.push([clientid, $scope.cqm_data.client_id[clientid]]);
            }
            clientids_ordered.sort(function(a, b) {
                return a[1] - b[1];
            });
            clientids_ordered.reverse();
            //console.log(clientids_ordered);
        }
        $scope.cqm_data.client_id = clientids_ordered;
    }

    function showZeros(data,element){
        var item = element['item'];
        var groupings = element['groupings'];
        var sort = element['sort'];
        var empty = {}
        for (var i = 0; i < groupings.length; i++) {
            empty[groupings[i]] = 0;
        }
        if ( !(item in data) ){
            data[item] = empty;
        }else{
            for (var i = 0; i < groupings.length; i++) {
                if ( !(groupings[i] in data[item]) ){ data[item][groupings[i]] = 0; }
            }
        }
        if(sort==1){            
            var tempdata = {};
            Object.keys(data[item]).sort().forEach(function(key) {
                          tempdata[key] = data[item][key];
                        });
            data[item] = tempdata;
        }
        return data;
    }
    
    function refreshdata(data){
        //Show 0's values
        var empties = [{'item':'client_id','groupings':[''],'sort':0}
                       ,{'item':'age_group','groupings':['< 12','12-17','18-64','65+','Unknown'],'sort':0}
                       ,{'item':'gender','groupings':['M','F','U'],'sort':0}
                       ,{'item':'bmi_code_type','groupings':['G8938','G8417 / G8418','G8422'],'sort':1}
                       ,{'item':'bmi_group','groupings':['Underweight (< 18.5)','Normal (18.5–24.9)','Overweight (25-29.9)','Obesity I (30-34.9)','Obesity II (30-34.9)','Extreme Obesity III (40+)'],'sort':0}
                       ,{'item':'bp_code_type','groupings':['G9744'],'sort':1}
                       ,{'item':'bp_last_grouping','groupings':['Normal','Prehypertensive','HTN Stage 1','HTN Stage 2'],'sort':0}
                       ,{'item':'cad_code_type','groupings':['ICD10','ICD9'],'sort':1}
                       ,{'item':'colonoscopy_code_type','groupings':['ICD10','ICD9','CPT','LOINC','SNOMED','Text'],'sort':1}
                       ,{'item':'depression_code_type','groupings':['G9717','ICD10','ICD9','CPT','LOINC','SNOMED','Text'],'sort':1}
                       ,{'item':'depression_phq2_group','groupings':['< 3','3+'],'sort':0}
                       ,{'item':'depression_phq9_group','groupings':['None-Minimal (0-4)','Mild (5-9)','Moderate (10-14)','Moderately Severe (15-19)','Severe (20-27)'],'sort':0}
                       ,{'item':'diabetic_code_type','groupings':['ICD10','ICD9'],'sort':1}
                       ,{'item':'diabeyeexam_code_type','groupings':['ICD10','ICD9','CPT','LOINC','SNOMED','Text'],'sort':1}
                       ,{'item':'fallrisk_code_type','groupings':['G9718','CPT','Text'],'sort':1}
                       ,{'item':'hba1c_code_type','groupings':['G9687','CPT'],'sort':1}
                       ,{'item':'hba1c_group','groupings':['< 7%','7-9%','> 9%','<= 9%'],'sort':0}
                       ,{'item':'hf_code_type','groupings':['ICD10','ICD9'],'sort':1}
                       ,{'item':'htn_code_type','groupings':['ICD10','ICD9'],'sort':1}
                       ,{'item':'pneumo_code_type','groupings':['G9707','CPT','CVX','Text'],'sort':1}
                      ];
        for (var i = 0; i < empties.length; i++) {
            data = showZeros(data,empties[i]);
        }
        //


        $scope.reorder_clientids('k');
        //console.log(data);
        $scope.filtering = false;
        $scope.PatientsSeenYearToDate = (data.gender.M || 0) + (data.gender.F || 0) + (data.gender.U || 0);
        //$scope.activeAgentsCount = data.agents.filter(function(value){ return value.status === "active"}).length;

        var elements = ['htn','diabetic','cad','hf','pneumo','fallrisk','bp','depression','diabeyeexam','colonoscopy','bmi','hba1c'];
        for (var i = elements.length - 1; i >= 0; i--) {
            $scope[elements[i]+'_total'] = 0;
            for (var property in data[elements[i]+'_code_type']) {
              if(property){
                $scope[elements[i]+'_total'] = $scope[elements[i]+'_total'] + data[elements[i]+'_code_type'][property];
              }
            }
            $scope[elements[i]+'_pct'] = $scope.getpercentfloat( $scope[elements[i]+'_total'], $scope.PatientsSeenYearToDate,null );
        }
        //fallrisk_code_type

    /**
     * Data for Age chart
     */
        $scope.AgeUnknown = data.age_group["Unknown"];
        $scope.Agelt12 = data.age_group["< 12"];
        $scope.Age1217 = data.age_group["12-17"];
        $scope.Age1864 = data.age_group["18-64"];
        $scope.Age65 = data.age_group["65+"];
        $scope.ageChartLabels = ["< 12", "12-17", "18-64", "65+", "Unknown"];
        $scope.ageChartData = [$scope.Agelt12, $scope.Age1217, $scope.Age1864, $scope.Age65, $scope.AgeUnknown];

    /**
     * Data for Gender chart
     */
        $scope.GenderUnknown = data.gender.U;
        $scope.GenderMale = data.gender.M;
        $scope.GenderFemale = data.gender.F;
        $scope.genderChartLabels = ["M", "F", "U"];
        $scope.genderChartData = [$scope.GenderMale, $scope.GenderFemale, $scope.GenderUnknown];
        //console.log($scope.genderChartData);


    /**
     * Data for EHR chart
     */
        // $scope.ehrChartLabels = [];
        // $scope.ehrChartData = [];
        // for (var property in data['ehr']) {
        //     if(property){
        //         $scope.ehrChartLabels.push( property )
        //         $scope.ehrChartData.push( data['ehr'][property] );
        //     }
        // }
        var ehr_ordered = [];
        for (var clientid in data['ehr']) {
            ehr_ordered.push([clientid, data['ehr'][clientid]]);
        }
        ehr_ordered.sort(function(a, b) {
            return a[1] - b[1];
        });
        ehr_ordered.reverse();

        $scope.ehrChartLabels = [];
        $scope.ehrChartData = [];
        for (var i = 0; i < ehr_ordered.length; i++) {
            $scope.ehrChartLabels.push( ehr_ordered[i][0] )
            $scope.ehrChartData.push( ehr_ordered[i][1] );
        }

    }


function graphClickEvent(element, event, array){
    //console.log(event);
    //console.log(array);
    if(array.length > 0){
        $scope.filterdata(element, array[0]._view['label']);
    }
}
    /**
     * Options for Age chart
     */
    this.ageChartOptions = {
        segmentShowStroke : true,
        segmentStrokeColor : "#fff",
        segmentStrokeWidth : 2,
        percentageInnerCutout : 45, // This is 0 for Pie charts
        animationSteps : 100,
        animationEasing : "easeOutBounce",
        animateRotate : true,
        animateScale : false,
        'onClick' : function (event, item) { graphClickEvent('age_group', event, item); },
        legend: {
            display: true,
            position: "right",
            labels: {usePointStyle: true}
        }
    };

    /**
     * Options for Gender chart
     */
    this.genderChartOptions = {
        segmentShowStroke : true,
        segmentStrokeColor : "#fff",
        segmentStrokeWidth : 2,
        percentageInnerCutout : 45, // This is 0 for Pie charts
        animationSteps : 100,
        animationEasing : "easeOutBounce",
        animateRotate : true,
        animateScale : false,
        'onClick' : function (event, item) { graphClickEvent('gender', event, item); },
        legend: {
            display: true,
            position: "right",
            labels: {usePointStyle: true}
        }
    };

    /**
     * Options for EHR chart
     */
    this.ehrChartOptions = {
        segmentShowStroke : true,
        segmentStrokeColor : "#fff",
        segmentStrokeWidth : 2,
        percentageInnerCutout : 45, // This is 0 for Pie charts
        animationSteps : 100,
        animationEasing : "easeOutBounce",
        animateRotate : true,
        animateScale : false,
        'onClick' : function (event, item) { graphClickEvent('ehr', event, item); },
        legend: {
            display: true,
            position: "right",
            labels: {usePointStyle: true}
        }
    };

}

angular.module('inspinia')
    .controller('QmCtrl', QmCtrl);
/**
 * QC Result controller to handle qcresult page related methods
 * Ravi - 19-July-2017
 */

'use strict';


function QCResultCtrl($scope, APIService, $rootScope, $filter) {
    //To fetch agent data
    APIService.getAgentList($rootScope.userProfile.customer.name).then(function(response){
        $scope.qcresult = [];
        $scope.qcresultObj = [];
        $scope.statusCount = {};
        angular.forEach(response.data.agents, function(agent, key){
            if(agent.qcresult.length > 0){
                angular.forEach(agent.qcresult, function(qcres, key){
                    $scope.qcresult.push({"agentname": agent.agentname, "emrname": agent.emr_name, "status": qcres.status, "recipe": qcres.recipe, "comment": qcres.comment, "date": qcres.date});
                    $scope.statusCount[qcres.status] = increment($scope.statusCount[qcres.status]);
                })
            }else{
                $scope.qcresult.push({"agentname": agent.agentname, "emrname": agent.emr_name, "status": "", "recipe": "", "comment": "", "date": ""});
            }
        })
        $scope.qcresultObj = $scope.qcresult;
        function increment(num) {
            if (num) {
                return num + 1;
            }
            return 1;
        }
    })
    
    //To filter the QC result list
    $scope.search = "";
    $scope.filterQCRes = function (agent) {
        if (agent) {
            var agentname = (agent.agentname) ? agent.agentname.toUpperCase().indexOf($scope.search.toUpperCase()) > -1 : false;
            var emrname = (agent.emrname) ? agent.emrname.toUpperCase().indexOf($scope.search.toUpperCase()) > -1 : false;
            var recipe = (agent.recipe) ? agent.recipe.toUpperCase().indexOf($scope.search.toUpperCase()) > -1 : false;
            var status = (agent.status) ? agent.status.toUpperCase().indexOf($scope.search.toUpperCase()) > -1 : false;

            if ($scope.search == "" || agentname || emrname || recipe || status) {
                return true;
            }
            return false;
        }
    }
    
    //To filter QC Result table data based on status selection
    $scope.filterQCResult = function(status){
        $scope.qcresult = $filter('customFilter')($scope.qcresultObj, 'status', status);
    }

    var yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    $scope.yesterday = $filter('date')(yesterday, 'yyyy-MM-dd');
}


angular.module('inspinia')
        .controller('QCResultCtrl', QCResultCtrl);
/**
 * QC Result controller to handle qcresult page related methods
 * Ravi - 19-July-2017
 */

'use strict';


function QCLatestCtrl($scope, APIService, $rootScope, $filter) {
    var yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    $scope.yesterday = $filter('date')(yesterday, 'yyyy-MM-dd');
    
    var totalLastRecieveCount = 0;
    var totalLastRecieved = 0;
    APIService.getHJDWCounts($rootScope.userProfile.customer.name).then(function(response){
        $scope.tables = response.data.tables;
        $scope.issue_tables = {},
        $scope.plotlyRowArray = {};
        angular.forEach(response.data.tables, function(table) {
            var table_name = table.name;
            $scope.issue_tables[table_name] = [];
            $scope.plotlyRowArray[table_name] = [];
            totalLastRecieved = totalLastRecieved + table.data_last_received.length;
            angular.forEach(table.data_last_received, function(data) {
                $scope.plotlyRowArray[table_name].push(data);
                totalLastRecieveCount = totalLastRecieveCount + data.count;
                if (data.date < $scope.yesterday) {
                    $scope.issue_tables[table_name].push(data);
                }
            });
        });
        //console.log($scope.issue_tables);
        generateChartData();
    })

    //To generate Plotly chart data
    function generateChartData(){

        $scope.plotylyChart = {
            "frames": [],
            "layout": {
                title: '',
                showlegend: true,
                autosize: true,
                height: 550,
                margin: {"l": 160, "r": 80, "t": 50, "b": 70, "pad": 0, "autoexpand": true},
                hovermode: 'closest',
                "xaxis": {
                    "type": "date",
                    "autorange": true,
                    "title": "Date data was last received"
                },

                "yaxis": {
                    "autorange": true,
                    "constrain": "range"
                }
            },
            "data": []
        }

        var rowChartData = {};
        var sizeRef = totalLastRecieveCount / (totalLastRecieved * 100);
        angular.forEach($scope.plotlyRowArray, function(issues, index){
            angular.forEach(issues, function(table, i){
                if (!rowChartData.hasOwnProperty(table.client_id)) {
                    rowChartData[table.client_id] = {mode: 'markers', name: table.client_id, text: [], x: [], y: [], marker: { sizemode: "area", sizeref: sizeRef, sizemin: 3, size: []}};
                }
                
                rowChartData[table.client_id].text.push(table.count);
                rowChartData[table.client_id].x.push(table.date);
                rowChartData[table.client_id].y.push(index);
                rowChartData[table.client_id].marker.size.push(table.count);
            })
        })
        
        //Sort collected chart data
        var sortedRowChartData = {};
        Object.keys(rowChartData).sort().forEach(function(key) {
          sortedRowChartData[key] = rowChartData[key];
        });
        
        angular.forEach(sortedRowChartData, function(data, i){
            $scope.plotylyChart.data.push(data);
        })
    }
}


angular.module('inspinia')
        .controller('QCLatestCtrl', QCLatestCtrl);
'use strict';


function MainController($scope, $auth, $location, $uibModal, $window, $rootScope) {
    //To logout current logged in user
    $scope.logout = function () {
        localStorage.clear();
        $auth.logout();
        $window.location.href = 'https://hjsso.auth.us-west-2.amazoncognito.com/logout?client_id=397o7c6rhbeko3to8j494v6hms&logout_uri=https://roi.healthjump.com/login'
    };

    $scope.getInitials = function () {
        var first, last;
        if ($rootScope.userProfile.first_name) {
            first = $rootScope.userProfile.first_name[0];
            last = $rootScope.userProfile.last_name != '' ? $rootScope.userProfile.last_name[0] : null;
            if (last) {
                var initials = first + last;
            } else {
                var initials = first;
            }
            return 'https://ui-avatars.com/api/?name=' + initials + '&background=f35b2b&color=fff&bold=true&font-size=0.5';
        } else {
            return false;
        }
    }

    // Open Change password modal pop-up by clicking on change password button
    $scope.changePassword = function () {
        $uibModal.open({
            templateUrl: 'modalUpdatePassword.html',
            controller: mainModalInstanceCtrl,
            scope: $scope
        });
    }

    // Open Change profile picture modal pop-up by clicking on change profile picture button
    $scope.changeProfilePicture = function () {
        $uibModal.open({
            templateUrl: 'modalUpdateProfilePicture.html',
            controller: mainModalInstanceCtrl,
            scope: $scope
        });
        $scope.photoSelected = false;
        var bucket = 'healthjump-webapps';
        var prefix = 'customer-portal/users/' + AWS.config.credentials.identityId + '/';
        var s3 = new AWS.S3({
            apiVersion: '2006-03-01'
        });

        var profilePicParams = {
            Bucket: bucket,
            Key: prefix + 'profile_pic.jpeg'
        }

        window.setTimeout(function () {
            document.querySelector('input[type="file"]').addEventListener('change', function () {
                if (this.files && this.files[0]) {
                    if (this.files[0].type.indexOf("image") == -1) {
                        toastr.error("Please select a valid jpg, png, or webp file.");
                        return false;
                    }
                    $scope.photoSelected = true;
                    var img = document.getElementById('profile-image'); // $('img')[0]
                    img.src = URL.createObjectURL(this.files[0]); // set src to blob url
                    var croppedImg = document.getElementById('cropped-image');
                    img.onload = function (e) {
                        // console.log(e.target.result);
                        var cropper = new Croppie(img, {
                            enableExif: true,
                            viewport: {
                                width: 250,
                                height: 250,
                                type: 'circle'
                            },
                            boundary: {
                                width: 300,
                                height: 300
                            },
                            customClass: 'croppie-styles',
                            update: function (data) {
                                // console.log(data);
                            }
                        });

                        $scope.requestChangeProfilePicture = function () {
                            cropper.result({
                                type: 'blob',
                                format: 'jpeg',
                                circle: true
                            }).then(function (blob) {
                                var params = {
                                    Bucket: bucket,
                                    Key: prefix + 'profile_pic.jpeg',
                                    Body: blob
                                };
                                s3.upload(params, function (data, err) {
                                    toastr.success("Your profile picture has been successfully updated.");
                                    window.setTimeout(function () {
                                        $rootScope.userProfile.profile_picture = s3.getSignedUrl('getObject', profilePicParams);
                                    }, 500)
                                });
                            });
                        }
                    };
                }
            });
        }, 500);
    }

    // Open Change password modal pop-up by clicking on change password button
    $scope.scheduleInstall = function () {
        $uibModal.open({
            templateUrl: 'modalScheduleInstall.html',
            controller: mainModalInstanceCtrl,
            scope: $scope
        });
        $scope.install = {};
    }
}

// Modal instance controller for all Main controller modals
function mainModalInstanceCtrl($scope, $uibModalInstance, APIService, $base64, $rootScope) {
    $scope.ok = function () {
        $uibModalInstance.close();
    };
    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
    $scope.cognitoUser = new AmazonCognitoIdentity.CognitoUser({
        Username: $rootScope.userProfile.email,
        Pool: new AmazonCognitoIdentity.CognitoUserPool({
            UserPoolId: 'us-west-2_kkQf9MXcm', // your user pool id here
            ClientId: '397o7c6rhbeko3to8j494v6hms' // your app client id here
        })
    });
    $scope.confirmCurrentPassword = function () {
        $scope.isProcessing = false;
        var authenticationData = {
            Username: $rootScope.userProfile.email,
            Password: $scope.currentPasswordForm.currentpassword,
        };
        $scope.cognitoUser.authenticateUser(new AmazonCognitoIdentity.AuthenticationDetails(authenticationData), {
            mfaRequired() {
                $scope.isProcessing = false;
                $scope.getChangePasswordMFA = true;
                $scope.$apply();
            },
            onFailure(err) {
                console.log(err);
                toastr.error('That password is incorrect. Please try again.');
            },
            onSuccess() {
                $scope.isProcessing = false;
                $scope.passwordConfirmed = true;
            }
        });
    };
    $scope.requestChangePassword = function () {
        $scope.isProcessing = true;

        $scope.cognitoUser.changePassword($scope.currentPasswordForm.currentpassword, $scope.changePasswordForm.newpassword, function (err, result) {
            if (err) {
                toastr.error($rootScope.toastrTranslate.WENTWRONG, $rootScope.toastrTranslate.USERPROFILE);
                console.log(err);
                return;
            }
            toastr.success($rootScope.toastrTranslate.PASSUPDATED, $rootScope.toastrTranslate.USERPROFILE);
            console.log('call result: ' + result);
            $scope.cancel();
        });
    };
    $scope.sendChangePasswordMFACode = function () {
        $scope.cognitoUser.sendMFACode($scope.changePasswordMFAForm.MFACode, {
            mfaRequired() {
                console.log('MFA required');
                $scope.isProcessing = false;
                $scope.getChangePasswordMFA = true;
                $scope.$apply();
            },
            onFailure(err) {
                console.log(err);
                toastr.error(err.message);
            },
            onSuccess() {
                $scope.passwordConfirmed = true;
                $scope.getChangePasswordMFA = false;
            }
        });
    };
    $scope.getPhoto = function () {
        profilePictureInput.click();
    }
    
    // $scope.install.shareableLink = 'schedule.healthjump.com/<customer>/1234-4567-6789';
    // $scope.install.date = 'December 27, 2019 11:00 - 1200 PM';
    // $scope.install.copyData = '';

    // $scope.getCopyData = function() {
    //     if($scope.install.scheduleType === 'createLink') $scope.install.copyData = $scope.install.shareableLink;
    //     else $scope.install.copyData = $scope.install.date; 
    // }

    // // List of EHRs
    // $scope.ehrList = ['EHR', 'Epic', 'Cerner', 'CareCloud', 'Centricity', 'AllScripts'];
    // $scope.previousConnections = [
    //     {
    //         id: 'ASD123',
    //         name: 'Smith Family Medicine',
    //         ehr: 'NextGen'
    //     },
    //     {
    //         id: 'TT0001',
    //         name: 'Total Sports Ortho',
    //         ehr: 'AllScripts'
    //     },
    // ];

    // // Give installation type buttons selected styling

    // $scope.install.progress = 0;
    // $scope.showConnections = false;
    // $scope.showConnectionsFunc = function() {
    //     $scope.showConnections = !$scope.showConnections;
    // }

    // $scope.chooseConnection = function(connection) {
    //     $scope.install.selectedConnection = connection;
    //     console.log(connection);
    // }

    // // Scnedule installation funtions
    // $scope.confirmInstallType = function(type) {
    //     $scope.install.type = type;
    //     $scope.installTypeSelected = true;
    //     $scope.install.progress = 1;
    //     console.log($scope.install.type);
    // }

    // $scope.confirmInstallParameters = function() {
    //     $scope.installParametersFilled = true;
    // }

    // $scope.chooseScheduleType = function(type) {
    //     $scope.install.scheduleType = type;
    // }

    // $scope.confirmScheduleType = function() { 
    //     $scope.install.scheduleTypeSelected = true;
    //     switch($scope.install.scheduleType) {
    //         case 'installation':
    //             $scope.install.scheduleType = 'installation';
    //             break;
    //         case 'createLink':
    //             $scope.install.scheduleType = 'createLink';
    //             break;
    //         default:
    //             alert('default');
    //     }
    //     $scope.getCopyData();
    // }

    // $scope.confirmContacts = function() {
    //     $scope.install.contactsConfirmed = true;
    // }

    // $scope.goNext = function() {
    //     $scope.install.progress ++;
    //     console.log($scope.install.progress);
    //     console.log($scope.install.type);
    //     switch($scope.install.progress) {
    //         case 2:
    //             $scope.confirmInstallParameters();
    //             break;
    //         case 3:
    //             $scope.confirmScheduleType(); 
    //             break;
    //         case 4:
    //             $scope.confirmContacts(); 
    //             break;
    //         default:
    //             alert('default');
    //     }
    // }

    // $scope.goBack = function(num) {
    //     switch(num) {
    //         case 1:
    //             $scope.installTypeSelected = false;
    //             break;
    //         case 2:
    //             $scope.installParametersFilled = false; 
    //             break;
    //         default:
    //             alert('default');
    //     }

    //     $scope.install.type = '';
    // }
}

angular.module('inspinia')
    .controller('MainController', MainController)
    .controller('mainModalInstanceCtrl', mainModalInstanceCtrl);

(function () {

    'use strict';

    angular
        .module('inspinia')
        .controller('LoginCtrl', LoginCtrl);


    function LoginCtrl($auth, $state, $rootScope, initFunction, $cacheFactory, $http, $scope) {
        $crisp.push(["safe", true]);
        var vm = this;
        initFunction.toastrTranslation();

        vm.cognitoUser = null;
        var cognitoCallbacks = {
            mfaRequired() {
                // Implement you functionality to show UI for MFA form
                vm.inProcess = false;
                vm.getMFA = true;
                $scope.$apply();
            },
            onSuccess(result) {
                vm.inProcess = false;
                var accessToken = result.getAccessToken().getJwtToken();

                /* Use the idToken for Logins Map when Federating User Pools with identity pools or when passing through an Authorization Header to an API Gateway Authorizer*/
                var idToken = result.idToken.jwtToken;

                $http.get('https://api.healthjump.com/authenticate?token=' + idToken).then(function (response) {
                    if (response.status == 200) {
                        //Remove all the Cache data on Login
                        cache = $cacheFactory.get('$http');
                        cache.removeAll();

                        $auth.setToken(response.data.token);
                        initFunction.fetchProfileData();
                        initFunction.checkUserHjChatRegis(response.data.email);

                        $state.go('index.home', {});
                    } else {
                        $auth.logout();
                        $state.go('login');
                        toastr.error('Token passthrough failed, please try again', $rootScope.toastrTranslate.LOGIN);
                    }
                });
            },
            onFailure(err) {
                console.log(err);
                if (err['code'] == 'UserNotFoundException') {
                    console.log('Cognito User Does Not Exist, Creating...');
                    legacyLogin(vm.email, vm.password);
                } else if (err['code'] == 'NotAuthorizedException') {
                    vm.inProcess = false;
                    toastr.error($rootScope.toastrTranslate.INVALIDUSRPASS, $rootScope.toastrTranslate.LOGIN);
                } else {
                    vm.inProcess = false;
                    toastr.error($rootScope.toastrTranslate.WENTWRONG, $rootScope.toastrTranslate.LOGIN);
                }
            }
        }

        vm.login = function () {
            vm.inProcess = true;        
            vm.cognitoUser = new AmazonCognitoIdentity.CognitoUser({
                Username: vm.email,
                Password: vm.password,
                Pool: new AmazonCognitoIdentity.CognitoUserPool({
                    UserPoolId: 'us-west-2_kkQf9MXcm', // your user pool id here
                    ClientId: '397o7c6rhbeko3to8j494v6hms' // your app client id here
                })
            })
            var authenticationData = {
                Username: vm.email,
                Password: vm.password,
            };
            return vm.cognitoUser.authenticateUser(new AmazonCognitoIdentity.AuthenticationDetails(authenticationData), cognitoCallbacks)
        }

        vm.sendMfaCode = function () {
            vm.cognitoUser.sendMFACode(vm.verificationCode, cognitoCallbacks)
        }

        vm.beginForgotPassword = function () {
            vm.inProcess = false;
            vm.getEmail = true;
            if(vm.email) {
                vm.forgotPasswordEmail = vm.email;
            }
        }

        vm.forgotPassword = function () {
            vm.cognitoUser = new AmazonCognitoIdentity.CognitoUser({
                Username: vm.forgotPasswordEmail,
                Pool: new AmazonCognitoIdentity.CognitoUserPool({
                    UserPoolId: 'us-west-2_kkQf9MXcm', // your user pool id here
                    ClientId: '397o7c6rhbeko3to8j494v6hms' // your app client id here
                })
            });

            vm.cognitoUser.forgotPassword({
                onSuccess: function (result) {
                    console.log('call result: ' + result);
                },
                onFailure: function (err) {
                    alert(err.message);
                },
                inputVerificationCode() {
                    vm.inProcess = false;
                    vm.getEmail = false;
                    vm.getNewPassword = true;
                    $scope.$apply();
                    // vm.cognitoUser.confirmPassword(verificationCode, newPassword, this);
                }
            });
        }

        vm.confirmPassword = function () {
            vm.cognitoUser.confirmPassword(vm.newPasswordVerificationCode, vm.newPassword, {
                onFailure(err) {
                    console.log(err);
                },
                onSuccess() {
                    toastr.success("Successfully reset password");
                    vm.getNewPassword = false;
                    $scope.$apply();

                },
            });
        }

        // This section is to handle tokens that come from cognito
        // See ticket:https://app.clickup.com/t/184p2f
        var url = location.hash;
        if (url.includes("id_token=")) {

            //let the view know not to show the login screen
            vm.hide_login = true;

            var token = url.substring(
                url.indexOf("id_token=") + 9,
                url.indexOf("&")
            );

            $http.get('https://api.healthjump.com/authenticate?token=' + token).then(function (response) {
                if (response.status == 200) {
                    //Remove all the Cache data on Login
                    cache = $cacheFactory.get('$http');
                    cache.removeAll();

                    $auth.setToken(response.data.token);
                    initFunction.fetchProfileData();
                    initFunction.checkUserHjChatRegis(response.data.email);

                    $state.go('index.home', {});
                } else {
                    $auth.logout();
                    $state.go('login');
                    toastr.error('Token passthrough failed, please try again', $rootScope.toastrTranslate.LOGIN);
                }
            });

        }

        function legacyLogin(username, password) {
            vm.inProcess = true;
            var credentials = {
                email: username,
                password: password,
                legacy: 'true'
            }

            // Use Satellizer's $auth service to login
            $auth.login(credentials).then(function (data) {
                    vm.inProcess = false;
                    if (data.status == 200) {
                        vm.login();
                    }
                })
                .catch(function (response) {
                    // Handle errors here, such as displaying a notification
                    vm.inProcess = false;
                    var errorMsg = $rootScope.toastrTranslate.INVALIDUSRPASS;
                    if (response.status == 500)
                        errorMsg = $rootScope.toastrTranslate.WENTWRONG;
                    toastr.error(errorMsg, $rootScope.toastrTranslate.LOGIN);
                });
        }
    }
})();
'use strict';


function HomeCtrl($scope, $rootScope, APIService, $filter, $uibModal) {
    $crisp.push(["safe", true]);
    // console.log($rootScope.userProfile.aws_identity_id);
    var customerName = $rootScope.userProfile.customer.name;
    $scope.customer_success_manager = $rootScope.userProfile.customer.customer_success_manager;
    //Fetch agent data
    APIService.getAgentList(customerName).then(function (response) {
        $scope.totalAgents = response.data.metadata.agent_count;
        $scope.activeAgentsCount = response.data.agents.filter(function (value) {
            return value.status === "active"
        }).length;
    });

    //Chartjs chart options
    $scope.lineChartSeries = [$rootScope.toastrTranslate.CREATED, $rootScope.toastrTranslate.MODIFIED];
    $scope.lineChatColors = ["#1ab394", "#1C84C6"];
    $scope.datasetOverride = [{
        yAxisID: 'y-axis-1'
    }, {
        yAxisID: 'y-axis-2'
    }];
    $scope.lineChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        },
        tooltips: {
            callbacks: {
                label: function (tooltipItem, data) {
                    var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    return data.datasets[tooltipItem.datasetIndex].label + ': ' + value.toLocaleString();
                }
            } // end callbacks:
        },
        scales: {
            yAxes: [{
                    id: 'y-axis-1',
                    type: 'linear',
                    display: true,
                    position: 'left',
                    ticks: {
                        callback: function (label, index, labels) {
                            if (label === 0) {
                                return label.toLocaleString();
                            } else {
                                return (label / 1000).toLocaleString() + 'k';
                            }
                        }
                    },
                    scaleLabel: {
                        display: true,
                        labelString: $rootScope.toastrTranslate.CREATEDRECORDS
                    }
                },
                {
                    id: 'y-axis-2',
                    type: 'linear',
                    display: true,
                    position: 'right',
                    ticks: {
                        callback: function (label, index, labels) {
                            if (label === 0) {
                                return label.toLocaleString();
                            } else {
                                return (label / 1000).toLocaleString() + 'k';
                            }
                        },
                    },
                    scaleLabel: {
                        display: true,
                        labelString: $rootScope.toastrTranslate.MODIFIEDRECORDS
                    }
                }
            ]
        }
    };

    //Generate Line chart data based on static JSON response data
    APIService.getHJDWCounts(customerName).then(function (response) {
        $scope.tables = response.data.tables;
        $scope.lineChartLabels = [];
        $scope.schemaSummary = response.data.schema_summary;
        $scope.lineChartData = [
            [],
            []
        ];

        $scope.totalPatients = $scope.schemaSummary[2].total_patients;
        $scope.totalEncounters = $scope.schemaSummary[3].total_encounters;

        var labels = Object.keys($scope.schemaSummary[0].created);

        //sort chart label to display sorted label on chart
        labels.sort(function (a, b) {
            a = a.split('/').reverse().join('');
            b = b.split('/').reverse().join('');
            return a > b ? 1 : a < b ? -1 : 0;
        });

        angular.forEach(labels, function (val, key) {
            $scope.lineChartLabels.push($filter('date')(val, 'dd-MMM'));
        })

        //Generate chart data based on sorted lagels
        angular.forEach(labels, function (val, key) {
            $scope.lineChartData[0].push($scope.schemaSummary[0].created[val]);
            $scope.lineChartData[1].push($scope.schemaSummary[1].modified[val]);
        })
    })

    //Function to normalize dashboard total data
    function normalizeTotalData(response) {
        var normalizeTotalData = {};
        angular.forEach(response, function (data, key) {
            normalizeTotalData[data.type] = data.count;
        })
        return normalizeTotalData;
    }

    //return color and arrow class object based on today different and previous different data
    function defineDataDiffColor(todayDiff) {
        if (todayDiff == 0) {
            return {
                'color': 'text-muted',
                'arrow': 'fa-arrow-right'
            }
        } else if (todayDiff > 0) {
            return {
                'color': 'text-success',
                'arrow': 'fa-arrow-up'
            }
        } else if (todayDiff < 0) {
            return {
                'color': 'text-danger',
                'arrow': 'fa-arrow-down'
            }
        } else {
            return {
                'color': 'text-muted',
                'arrow': 'fa-arrow-right'
            }
        }
    }

    //Define today and previous date to fetch respective static JSON
    var todayDate = moment().format('YYYYMMDD'); //ToDo: Uncomment to get today date
    // var todayDate = moment().subtract(3, 'day').format('YYYYMMDD'); //ToDo: Uncomment to get previous date
    var lastWeek = moment().subtract(1, 'weeks').format('YYYYMMDD');

    //Get Home page Total data from Dashboard static JSON
    APIService.getTotalData(customerName, todayDate).then(function (response) {
        $scope.todayTotal = normalizeTotalData(response.data.data);
        //Get last week total data
        APIService.getTotalData(customerName, lastWeek).then(function (response) {
            $scope.lastWeekTotal = normalizeTotalData(response.data.data);
            //Get today and last week data difference
            $scope.todayAppointmentsDiff = $scope.todayTotal.appointments - $scope.lastWeekTotal.appointments || 0;
            $scope.todayEncountersDiff = $scope.todayTotal.encounters - $scope.lastWeekTotal.encounters || 0;
            $scope.todayPatientsDiff = $scope.todayTotal.patients - $scope.lastWeekTotal.patients || 0;
            $scope.todayProvidersDiff = $scope.todayTotal.providers - $scope.lastWeekTotal.providers || 0;

            $scope.todayApptDiffStatus = defineDataDiffColor($scope.todayAppointmentsDiff);
            $scope.todayEncDiffStatus = defineDataDiffColor($scope.todayEncountersDiff);
            $scope.todayPtDiffStatus = defineDataDiffColor($scope.todayPatientsDiff);
            $scope.todayProvDiffStatus = defineDataDiffColor($scope.todayProvidersDiff);
        });
    });

    //To open the Add ticket modal pop-up 
    $scope.openAddTicketModal = function (ticketSummary, priority) {
        $scope.summerNoteOptions = {
            height: 300,
            focus: true,
            toolbar: []
        };
        var lowercase = $rootScope.userProfile.customer.name;
        var capitalizedCustomerName = lowercase.charAt(0).toUpperCase() + lowercase.substring(1);
        console.log(capitalizedCustomerName);
        var templateUrl = 'app/views/common/addTicketModal.html';
        if (ticketSummary == 'invite') {
            $scope.ticketsubject = 'Invitation sent';
            // $scope.ticketcontent = $rootScope.toastrTranslate.SENDINVITETEXT;
            $scope.ticketcontent = '<p>Hello,</p><p>' + capitalizedCustomerName + ' would like to schedule a call with you to install a Healthjump agent. We will be using this agent to connect and extract the data from your system. </p><p>If you are unsure of anything, we recommend having your IT contact assist you with gathering the information. Please also schedule your appointment <a href="https://go.oncehub.com/jumpSTARTInstallation?name=' + capitalizedCustomerName + '&skip=1" target="_blank">here</a>.</p><p>Although rare, sometimes technical roadblocks do come up during installation. Often we can fix the issue while we are on the webex, however it may be necessary to escalate any unresolved errors to Healthjump level 2 support to ensure that your configuration is successfully completed.</p><p>Please let me know if you have any questions, and I look forward to working with you.</p><p><br>Kind regards,</p><p>' + capitalizedCustomerName + '</p>',
                templateUrl = 'app/views/common/addTicketModalInvite.html';
            $scope.recipientemail = '';
        } else if (ticketSummary == 'csm') {
            $scope.ticketsubject = 'Contact CSM';
            $scope.ticketcontent = '';
            templateUrl = 'app/views/common/addTicketModalCsm.html';
        } else {
            $scope.ticketsubject = ticketSummary;
        }
        $scope.priority = priority;

        $uibModal.open({
            templateUrl: templateUrl,
            controller: agentModalInstanceCtrl,
            scope: $scope
        });
    }

    //Fetch Assembla tickets based on agent ID using Laravel API
    $scope.tickets = {
        high: [],
        normal: [],
        low: []
    };
    APIService.get('partner/ticket/tag/' + customerName).then(function (response) {
        if (response && response.status == 200) {
            //Push fetched ticket to Ticket array
            angular.forEach(response.data, function (ticket, index) {
                if (ticket.status.toLowerCase() != "completed" && ticket.status.toLowerCase() != "invalid") {
                    switch (ticket.priority) {
                        case 1:
                        case 2:
                            $scope.tickets.high.push(ticket);
                            break;
                        case 3:
                            $scope.tickets.normal.push(ticket);
                            break;
                        case 4:
                        case 5:
                            $scope.tickets.low.push(ticket);
                            break;
                    }
                }
            })
        }
    })

    //Call on item moved on ticket list
    $scope.dragControlListeners = {
        accept: function (source, destination) {
            return source.sortableScope.$id !== destination.$id;
        },
        itemMoved: function (event) {
            var newPosition = event.dest.index,
                currentList = event.dest.sortableScope.element[0].id,
                movedTicketData;
            switch (currentList) {
                case 'high':
                    movedTicketData = {
                        "ticketNumber": $scope.tickets.high[newPosition].number,
                        "priority": 1
                    };
                    break;
                case 'normal':
                    movedTicketData = {
                        "ticketNumber": $scope.tickets.normal[newPosition].number,
                        "priority": 3
                    };
                    break;
                case 'low':
                    movedTicketData = {
                        "ticketNumber": $scope.tickets.low[newPosition].number,
                        "priority": 5
                    };
                    break;
            }
            APIService.put('partner/ticket/' + movedTicketData.ticketNumber, movedTicketData).then(function (response) {
                toastr.clear();
                if (response.data.status == 200) {
                    toastr.success($rootScope.toastrTranslate.TICKETPRIORITYCHANGE, $rootScope.toastrTranslate.HOME);
                }
            })
        },
        containment: '#board',
        longTouch: true,
        containerPositioning: 'absolute'
    };

    //To fetch ticket details and comments and open modal pop-upaddTicketComment
    $scope.openViewTicketModal = function (ticket) {
        $scope.selectedTicket = {};
        $uibModal.open({
            templateUrl: 'app/views/common/modalViewTicket.html',
            controller: agentModalInstanceCtrl,
            scope: $scope
        });
        APIService.get('partner/ticket/' + ticket.number).then(function (response) {
            if (response.data.ticket.status == 200) {
                $scope.selectedTicket = {
                    ticket: response.data.ticket.content,
                    comments: (response.data.comments.length) ? response.data.comments : [],
                    id: ticket.number
                };
            } else {
                toastr.clear();
                toastr.error($rootScope.toastrTranslate.WENTWRONG, $rootScope.toastrTranslate.HOME);
            }
        })
    }

    var email = $rootScope.userProfile.email;
    var api = 'Lm4pV7iPMvUoapvZMwWeWMXsFPL0ZEEKbkqQGuiS';
    var user = email + '/token:' + api;
    var url = 'https://healthjump.zendesk.com/api/v2/';
    var hc = '/help_center/en-us/articles.json';

    // var xhr = new XMLHttpRequest();
    // xhr.open("GET", url + hc, true);

    // // xhr.withCredentials = true;
    // xhr.onreadystatechange = function() {
    //     if(this.readyState == 4) {
    //         if(this.status == 200) {
    //             console.log(JSON.parse(this.responseText));
    //         }
    //     }
    //     if(this.status == 404) {
    //         console.log('File or resources not found.')
    //     }
    // }
    // xhr.setRequestHeader('Content-Type', 'application/json');
    // xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
    // xhr.send();

    //     $.ajax({
    //         url: url + user,
    //         beforeSend: function(xhr) {
    //             //  xhr.setRequestHeader("Authorization", "Bearer 6QXNMEMFHNY4FJ5ELNFMP5KRW52WFXN5")
    //             console.log('yeah');
    //         }, success: function(data){
    //             console.log(data);
    //             //process the JSON data etc
    //         }
    // })

//     var options = {
//         headers: {
//             Authorization: "Bearer 6Q************"
//         }
//     };

//     fetch(url, options)
//         .then(res => res.json())
//         .then(data => console.log(data));

}


angular.module('inspinia')
    .controller('HomeCtrl', HomeCtrl);
'use strict';

function FileManagerCtrl($scope, APIService, filterFilter, $rootScope) {
    $crisp.push(["safe", true]);
    // Get s3 bucket
    var bucket = $rootScope.userProfile.customer.s3_location;
    var prefix = '';
    // var bucket = 'healthjump-webapps';
    // var prefix = 'customer-portal/customers/sandbox/file-manager/';
    var s3 = new AWS.S3({
        apiVersion: '2006-03-01'
    });

    // Set breadcrumb/navigation link and display name
    $scope.basePrefix = prefix;
    $scope.baseType = 'Folder';
    $scope.baseLink = 'All Files';

    // Get files from s3 bucket
    var params = {
        Bucket: bucket,
        Delimiter: '/',
        Prefix: prefix
    };

    // To reset files view
    $scope.resetFilesView = function () {
        s3.listObjects(params, function (err, data) {
            if (err) console.log(err, err.stack); // an error occurred
            else { // successful response
                var response = (data.Contents.concat(data.CommonPrefixes));
                // response.shift();
                $scope.contents = response;
                $scope.initFiles(params.Prefix);
            }
        });
    };

    var directoryName;

    // Make subsequent calls to s3 on directory change
    $scope.changeDirectory = function (path, name, type) {
        if (type === 'Folder') {
            params.Prefix = path;
            window.location.hash = '#' + path.replace(new RegExp("/", "g"), '_');
        }
    };

    // Make calls to s3 depending on browser url when user goes back or forward in browser history
    window.onpopstate = function () {
        getDirectory();
        setTimeout(function () {
            $scope.resetButtons();
        }, 500);
    }

    function getDirectory() {
        var locationHash = location.hash.replace(new RegExp("%20", "g"), ' ');
        var hashName = locationHash.substr(1).replace(new RegExp("_", "g"), '/');
        var hashNameNoSlash = hashName.slice(0, -1);
        params.Prefix = hashName;
        directoryName = hashNameNoSlash.substring(hashNameNoSlash.lastIndexOf("/") + 1);
        $scope.resetFilesView();
        $scope.breadcrumbs = [];
        $scope.updateBreadcrumb();
        $scope.showfileStatsFileContainer = false;
        $scope.shrinkTable = false;
    }

    // To update download button source upon file selection
    var downloadButton = document.getElementById('download-link');
    var downloadMenuOption = document.getElementById('download-menu-option');
    var statsDownloadButton = document.getElementById('stats-download-btn');
    var hiddenDownloadButton = document.getElementById('hidden-download-btn');

    $scope.addDownloadLink = function () {
        if (($scope.fileList.selected.length < 1) || ($scope.fileList.selected[0].type === 'Folder')) {
            // downloadButton.href = '#';
            // downloadButton.download = '';
            // downloadMenuOption.href = '#';
            // downloadMenuOption.download = '';
            // statsDownloadButton.href = '#';
            // statsDownloadButton.download = '';
            hiddenDownloadButton.href = '#';
            // hiddenDownloadButton.download = '';
            downloadMenuOption.classList.add('disabled-menu-option');
        } else {
            var toBeDownloaded = $scope.fileList.selected.map(function (file) {
                return {
                    Key: file.name,
                    name: file.displayName
                }
            });

            angular.forEach(toBeDownloaded, function (file) {
                var downloadParams = {
                    Bucket: bucket,
                    Key: file.Key
                }
                var url = s3.getSignedUrl('getObject', downloadParams);

                downloadMenuOption.classList.remove('disabled-menu-option');
                // downloadButton.href = url;
                // downloadMenuOption.href = url;
                // statsDownloadButton.href = url;
                hiddenDownloadButton.href = url;
                // downloadButton.download = file.name;
                // downloadMenuOption.download = file.name;
                // statsDownloadButton.download = file.name;
                // hiddenDownloadButton.download = file.name;

                setTimeout(function () {
                    hiddenDownloadButton.click();
                }, 300);
            });

            // var downloadParams = {
            //     Bucket: bucket,
            //     Key: toBeDownloaded[0].Key
            // }

            // var url = s3.getSignedUrl('getObject', downloadParams);
            // downloadMenuOption.classList.remove('disabled-menu-option');
            // downloadButton.href = url;
            // downloadMenuOption.href = url;
            // statsDownloadButton.href = url;
            // downloadButton.download = toBeDownloaded[0].name;
            // downloadMenuOption.download = toBeDownloaded[0].name;
            // statsDownloadButton.download = toBeDownloaded[0].name;
        }
        // window.URL.revokeObjectURL(url);
    };

    // To add download link to each file card's download button
    $scope.addIndividualDownloadLink = function () {
        var downloadFile = {
            Key: file.name,
            name: file.displayName
        }
    };

    // To upload files
    var uploader = document.getElementById('fileUploader');

    $scope.getFiles = function () {
        uploader.click();
    }

    $scope.uploadValue = uploader.files.length;
    $scope.displayFiles = [];

    uploader.addEventListener('input', function (e) {
        $scope.uploadValue = uploader.files.length;
        if ($scope.uploadValue >= 1) {
            $scope.fileSelected = true;
            angular.forEach(uploader.files, function (file) {
                $scope.displayFiles.push(file);
            });
        }
    });

    $scope.removeFile = function (hashkey) {
        for (var i = 0; i < $scope.displayFiles.length; i++) {
            if (hashkey === $scope.displayFiles[i].$$hashKey) {
                $scope.displayFiles.splice(i, 1);
            }
        }
        if ($scope.displayFiles.length === 0) {
            $scope.fileSelected = false;
        }
    }

    $scope.uploadFile = function () {
        $scope.isProcessing = true;
        $scope.uploadFiles = $scope.displayFiles;

        if (!$scope.uploadFiles.length) {
            return alert('Please choose a file to upload first.');
        }

        angular.forEach($scope.uploadFiles, function (uploadFile) {
            var file = uploadFile;
            var fileName = file.name;

            angular.forEach($scope.files, function (file) {
                if (fileName === file.displayName) {
                    var extension = fileName.substring(fileName.lastIndexOf("."), fileName.length);
                    var name = fileName.replace(extension, '');
                    fileName = name + '(1)' + extension;
                    // console.log(extension)
                    angular.forEach($scope.files, function (newfile) {
                        if (fileName === newfile.displayName) {
                            var oldExtension = newfile.displayName.substring(newfile.displayName.lastIndexOf("."), newfile.displayName.length);
                            var oldName = newfile.displayName.replace(oldExtension, '');
                            var oldNameNoCounter = oldName.slice(0, -3);
                            var oldCounterWithParenthesis = oldName.replace(oldNameNoCounter, '');
                            var oldCounter = Number(oldCounterWithParenthesis.replace(')', '').replace('(', ''));
                            // console.log(name);
                            // console.log(extension);
                            // extension = name.substring(name.lastIndexOf("."), name.length);
                            name = name.replace(extension, '');
                            // console.log(name);
                            // console.log(extension);
                            // var nameNoCounter = name.slice(0, -3);
                            // console.log(oldNameNoCounter);
                            if ((oldName[oldName.length - 3] === '(') && (oldName[oldName.length - 1] === ')')) {
                                // console.log(oldCounter)
                                // console.log(extension)
                                name = oldNameNoCounter + '(' + (oldCounter + 1) + ')' + extension;
                                // console.log(name)
                                fileName = name;
                            }
                        }
                    });
                }
            });

            var fileKey = params.Prefix + fileName;
            $scope.showLoader = true;
            s3.upload({
                Bucket: bucket,
                Key: fileKey,
                Body: file,
                ACL: 'bucket-owner-full-control'
            }, function (err, data) {
                if (err) { // an error occurred
                    toastr.error('There was an error uploading ' + fileName);
                    console.log(err, err.stack);
                } else { // successful response
                    $scope.showUploadFileContainerFunc();
                    toastr.success(fileName + ' was successfully uploaded.');
                    setTimeout(function () {
                        $scope.resetFilesView();
                    }, 1500);
                }
                // $scope.showUploadFileContainerFunc();
                $scope.hideUploadFileContainerFunc();
            });
        });

        setTimeout(function () {
            $scope.uploadValue = 0;
        }, 2500);


        // var file = $scope.uploadFiles[0];
        // var fileName = file.name;

        // angular.forEach($scope.files, function (file) {
        //     if (fileName === file.displayName) {
        //         var extension = fileName.substring(fileName.lastIndexOf("."), fileName.length);
        //         var name = fileName.replace(extension, '');
        //         fileName = name + '(1)' + extension;
        //         // console.log(extension)
        //         angular.forEach($scope.files, function (newfile) {
        //             if (fileName === newfile.displayName) {
        //                 var oldExtension = newfile.displayName.substring(newfile.displayName.lastIndexOf("."), newfile.displayName.length);
        //                 var oldName = newfile.displayName.replace(oldExtension, '');
        //                 var oldNameNoCounter = oldName.slice(0, -3);
        //                 var oldCounterWithParenthesis = oldName.replace(oldNameNoCounter, '');
        //                 var oldCounter = Number(oldCounterWithParenthesis.replace(')', '').replace('(', ''));
        //                 // console.log(name);
        //                 // console.log(extension);
        //                 // extension = name.substring(name.lastIndexOf("."), name.length);
        //                 name = name.replace(extension, '');
        //                 // console.log(name);
        //                 // console.log(extension);
        //                 // var nameNoCounter = name.slice(0, -3);
        //                 // console.log(oldNameNoCounter);
        //                 if ((oldName[oldName.length - 3] === '(') && (oldName[oldName.length - 1] === ')')) {
        //                     // console.log(oldCounter)
        //                     // console.log(extension)
        //                     name = oldNameNoCounter + '(' + (oldCounter + 1) + ')' + extension;
        //                     // console.log(name)
        //                     fileName = name;
        //                 }
        //             }
        //         });
        //     }
        // });

        // var fileKey = params.Prefix + fileName;
        // $scope.showLoader = true;
        // s3.upload({
        //     Bucket: bucket,
        //     Key: fileKey,
        //     Body: file,
        //     ACL: 'bucket-owner-full-control'
        // }, function (err, data) {
        //     if (err) { // an error occurred
        //         toastr.error('There was an error uploading ' + fileName);
        //         console.log(err, err.stack);
        //     } else { // successful response
        //         toastr.success(fileName + ' was successfully uploaded.');
        //         setTimeout(function () {
        //             $scope.resetFilesView();
        //         }, 1500);
        //     }
        //     $scope.showUploadFileContainerFunc();
        //     $scope.showLoader = false;
        // });
    };

    // To 'hold' parameters for copying/pasting/renaming/moving files
    var fileParams = {
        Bucket: bucket,
        CopySource: '',
        Key: ''
    };

    $scope.selectedFileList = {
        files: []
    }

    var movingParams = {
        Bucket: bucket,
        CopySource: '',
        Key: ''
    };

    $scope.movingFileList = {
        files: []
    }

    var destinationFolder;

    // To grab files for copying/pasting/renaming/moving
    $scope.getFile = function () {
        $scope.selectedFileList.files = [];
        angular.forEach($scope.fileList.selected, function (file) {
            var selectedFileObj = {
                prefix: file.name.replace(file.displayName, ''),
                name: file.name.replace(params.Prefix, ''),
                path: file.name
            }
            selectedFileObj.copySrc = bucket + '/' + selectedFileObj.path;
            $scope.selectedFileList.files.push(selectedFileObj);
        });
        fileParams.CopySource = $scope.selectedFileList.files[0].copySrc;
        pasteMenuOption.classList.remove('disabled-menu-option');
    };

    // To grab files for copying/pasting/renaming/moving
    $scope.getFileToMove = function (path) {
        $scope.movingFileList.files = [];
        angular.forEach($scope.fileList.selected, function (file) {
            var selectedFileObj = {
                prefix: file.name.replace(file.displayName, ''),
                name: file.name.replace(params.Prefix, ''),
                path: file.name
            }
            selectedFileObj.copySrc = bucket + '/' + selectedFileObj.path;
            $scope.movingFileList.files.push(selectedFileObj);
        });
        movingParams.CopySource = $scope.movingFileList.files[0].copySrc;
        destinationFolder = path;
        // console.log(path);
    };

    $scope.copyContent = [];

    // To get items as well as the items within them
    // $scope.getFolderObjects = function () {
    //     $scope.folderObjects = [];
    //     var copyItemsParams = [];
    //     var copyContentsArr = [];

    //     angular.forEach($scope.fileList.selected, function (file) {
    //         $scope.folderObjects.push(file);
    //     });

    //     angular.forEach($scope.folderObjects, function (file) {
    //         copyItemsParams.push({
    //             Bucket: bucket,
    //             Prefix: file.name,
    //         });
    //     });

    //     angular.forEach(copyItemsParams, function (parameter) {
    //         s3.listObjects(parameter, function (err, data) {
    //             if (err) console.log(err, err.stack); // an error occurred
    //             else { // successful response
    //                 var copyResponse = data.Contents;
    //                 $scope.copyContent.push(copyResponse);
    //                 angular.forEach($scope.copyContent, function(file) {
    //                     copyContentsArr.push({
    //                         Bucket: bucket,
    //                         CopySource: bucket + '/' + file.Key,
    //                         Key: file.Key
    //                     });
    //                     // console.log(file);
    //                     // console.log(copyContentsArr);
    //                 });
    //             }
    //         });
    //     });
    //     console.log($scope.copyContent);
    // }

    $scope.folderObjects = [];

    var folderParams = {
        Bucket: bucket,
        Prefix: ''
    }

    var folderParamsArr = [];
    var folderContentsArr = [];

    var folderItemsParams = {
        Bucket: bucket,
        CopySource: '',
        Key: ''
    }

    var copiedFolderParams = {
        Bucket: bucket,
        CopySource: '',
        Key: ''
    }

    // To grab a folder and its contents for renaming
    $scope.getFolderObject = function () {
        $scope.folderObjects = [];
        $scope.folder = $scope.fileList.selected[0];
        folderParams.Prefix = $scope.folder.name;
        s3.listObjects(folderParams, function (err, data) {
            if (err) console.log(err, err.stack); // an error occurred
            else { // successful response
                var folderResponse = (data.Contents);
                $scope.folderContents = folderResponse;
                angular.forEach($scope.folderContents, function (file) {
                    var folderObj = {
                        name: file.Key.substring(file.Key.lastIndexOf("/") + 1, file.Key.length),
                        path: file.Key
                    }
                    $scope.folderObjects.push(folderObj);
                    folderObj.copySrc = bucket + '/' + folderObj.path;
                });
                copiedFolderParams.CopySource = bucket + '/' + folderParams.Prefix;
            }
        });
    }

    // To delete items as well as the items within them
    $scope.deleteFolderObjects = function () {

        $scope.folderObjects = [];
        folderParamsArr = [];
        folderContentsArr = [];

        angular.forEach($scope.fileList.selected, function (file) {
            $scope.folderObjects.push(file);
        });

        angular.forEach($scope.folderObjects, function (folder) {
            folderParamsArr.push({
                Bucket: bucket,
                Prefix: folder.name
            });
        });

        angular.forEach(folderParamsArr, function (parameter) {
            s3.listObjects(parameter, function (err, data) {
                if (err) console.log(err, err.stack); // an error occurred
                else { // successful response
                    var content = data.Contents;
                    folderContentsArr = content.map(function (file) {
                        return {
                            Key: file.Key
                        }
                    });
                    var deleteParams = {
                        Bucket: bucket,
                        Delete: {
                            Objects: folderContentsArr
                        }
                    };
                    s3.deleteObjects(deleteParams, function (err, data) {
                        if (err) {
                            alert(err, err.stack);
                            toastr.error(err, err.stack);
                        } else {
                            setTimeout(function () {
                                $scope.resetFilesView();
                            }, 1500);
                        }
                    });
                }
            });
        });
        toastr.success('File(s) successfully deleted');
        $scope.resetButtons();
    }

    // Files copied notification
    $scope.copyFilesToastr = function () {
        angular.forEach($scope.fileList.selected, function (file) {
            toastr.info('Successfully copied: ' + file.displayName + '.');
        })
    };

    // To paste files
    $scope.pasteFile = function () {
        angular.forEach($scope.selectedFileList.files, function (file) {
            var fileName = file.name;
            angular.forEach($scope.files, function (oldfile) {
                if (file.name === oldfile.displayName) {
                    var extension = file.name.substring(file.name.lastIndexOf("."), file.name.length);
                    var name = file.name.replace(extension, '');
                    fileName = name + '(1)' + extension;

                    angular.forEach($scope.files, function (newfile) {
                        if (fileName === newfile.displayName) {
                            var oldExtension = newfile.displayName.substring(newfile.displayName.lastIndexOf("."), newfile.displayName.length);
                            var oldName = newfile.displayName.replace(oldExtension, '');
                            var oldNameNoCounter = oldName.slice(0, -3);
                            var oldCounterWithParenthesis = oldName.replace(oldNameNoCounter, '');
                            var oldCounter = Number(oldCounterWithParenthesis.replace(')', '').replace('(', ''));
                            name = name.replace(extension, '');
                            var nameNoCounter = name.slice(0, -3);
                            if ((oldName[oldName.length - 3] === '(') && (oldName[oldName.length - 1] === ')')) {
                                // console.log(oldCounter)
                                name = oldNameNoCounter + '(' + (oldCounter + 1) + ')' + extension;
                                fileName = name;
                            }
                        }
                    });
                }
            });
            fileParams.Key = params.Prefix + fileName;
            fileParams.CopySource = file.copySrc;
            s3.copyObject(fileParams, function (err, data) {
                if (err) console.log(err, err.stack); // an error occurred
                else { // successful response
                    // console.log(data);
                    toastr.info('Successfully pasted: ' + fileName + '.');
                }
            })
        });
        setTimeout(function () {
            $scope.resetFilesView();
        }, 1500);
    };

    // To paste files
    $scope.moveFile = function () {
        angular.forEach($scope.movingFileList.files, function (file) {
            movingParams.Key = destinationFolder + file.name;
            movingParams.CopySource = file.copySrc;
            s3.copyObject(movingParams, function (err, data) {
                if (err) console.log(err, err.stack); // an error occurred
                else { // successful response
                    // console.log(data);
                    toastr.info('Successfully moved: ' + file.name + '.');
                    $scope.deleteFile();
                }
            })
        });
    };

    // To paste folder files
    $scope.pasteFolderFiles = function () {
        fileParams.Key = params.Prefix + $scope.filename + '/';
        //console.log('1. Newly created folder: ' + fileParams.Key);
        //console.log($scope.folder.displayName)
        var holder = params.Prefix + $scope.folder.displayName;
        angular.forEach($scope.folderObjects, function (file) {
            var splitPath = file.path.split('/');
            splitPath.shift();
            splitPath.shift();
            var oldFolderName = splitPath[splitPath.length - 2];
            //console.log(oldFolderName);
            var oldPath = file.copySrc.replace(bucket, '');
            var endOfPath = file.path.replace(holder, '').substr(1);
            //console.log(endOfPath);
            if (splitPath[splitPath.length - 1] === '') {
                // console.log(splitPath);
                // console.log('Old Folder Name: ' + oldFolderName);
                //console.log('2. Old Folder Path: ' + file.path);
                folderItemsParams.Key = fileParams.Key + endOfPath;
                //console.log('3. New Folder Path: ' + folderItemsParams.Key);
            } else {
                if (oldFolderName === $scope.folder.displayName) {
                    folderItemsParams.Key = fileParams.Key + file.path.substring(file.path.lastIndexOf("/") + 1, file.path.length);
                } else {
                    folderItemsParams.Key = fileParams.Key + endOfPath;
                }
                var testString = file.path.replace(params.Prefix, '');
                //console.log('4. Old File Path: ' + file.path);
                //console.log('TEST: ' + testString)
                //console.log('5. New File Path: ' + folderItemsParams.Key);
                //console.log('6. Copy Source: ' + oldPath);
            }
            folderItemsParams.CopySource = file.copySrc;
            s3.copyObject(folderItemsParams, function (err, data) {
                if (err) console.log(err, err.stack); // an error occurred
                else { // successful response
                    // console.log(data);
                    $scope.deleteFolderItems();
                }
            });
        });
    };

    // To rename files
    $scope.renameFile = function () {
        var doubleName = false;

        if (!$scope.filename) {
            $scope.filename = '';
            return toastr.error('Names must contain at least one non-space character.');
        }
        if ($scope.filename.indexOf('/') !== -1) {
            $scope.filename = '';
            return toastr.error('Names cannot contain slashes.');
        }
        angular.forEach($scope.files, function (file) {
            if ($scope.filename === file.displayName) {
                $scope.filename = '';
                doubleName = true;
            }
        });
        if (doubleName === true) return toastr.error('There is already a file with that name in this directory. Please try a new name.');
        else {
            if ($scope.fileList.selected[0].type === 'Folder') {
                $scope.pasteFolderFiles();
                $scope.showRenameContainerFunc();
                $scope.filename = '';
                setTimeout(function () {
                    $scope.resetFilesView();
                }, 1500);
            } else {
                fileParams.Key = params.Prefix + $scope.filename;
                s3.copyObject(fileParams, function (err, data) {
                    if (err) console.log(err, err.stack); // an error occurred
                    else { // successful response
                        // console.log(data);
                        toastr.info('File successfully renamed.');
                        $scope.showRenameContainerFunc();
                        $scope.filename = '';
                        $scope.deleteFile();
                        setTimeout(function () {
                            $scope.resetFilesView();
                        }, 1500);
                    }
                });
            }
            $scope.selectedFileList.files = [];
        }
    };

    // To delete files
    $scope.deleteFile = function () {
        var toBeDeleted = $scope.fileList.selected.map(function (file) {
            return {
                Key: file.name
            }
        });

        var deleteParams = {
            Bucket: bucket,
            Delete: {
                Objects: toBeDeleted
            }
        };

        s3.deleteObjects(deleteParams, function (err, data) {
            if (err) {
                alert(err, err.stack);
                toastr.error(err, err.stack);
            } else {
                setTimeout(function () {
                    $scope.resetFilesView();
                }, 1500);
            }
        });
    };

    // To delete files within folders
    $scope.deleteFolderItems = function () {
        var toBeDeleted = $scope.folderObjects.map(function (file) {
            return {
                Key: file.path
            }
        });

        var deleteParams = {
            Bucket: bucket,
            Delete: {
                Objects: toBeDeleted
            }
        };

        s3.deleteObjects(deleteParams, function (err, data) {
            if (err) {
                alert(err, err.stack);
                toastr.error(err, err.stack);
            } else {
                // console.log(data);
            }
        });
    };

    // To delete files with toastr notification
    $scope.deleteFileWithToastr = function () {
        var toBeDeleted = $scope.fileList.selected.map(function (file) {
            return {
                Key: file.name
            }
        });

        var deleteParams = {
            Bucket: bucket,
            Delete: {
                Objects: toBeDeleted
            }
        };

        s3.deleteObjects(deleteParams, function (err, data) {
            if (err) {
                alert(err, err.stack);
                toastr.error(err, err.stack);
            } else {
                angular.forEach(toBeDeleted, function (deleted) {
                    toastr.success(deleted.Key.substring(deleted.Key.lastIndexOf("/") + 1, deleted.Key.length) + ' was deleted');
                });
                setTimeout(function () {
                    $scope.resetFilesView();
                }, 1500);
            }
        });
    };

    // To create new folders
    $scope.createFolder = function () {
        var doubleName = false;
        if (!$scope.foldername) {
            $scope.foldername = '';
            return toastr.error('Folder names must contain at least one non-space character.');
        }
        if ($scope.foldername.indexOf('/') !== -1) {
            $scope.foldername = '';
            return toastr.error('Folder names cannot contain slashes.');
        }
        angular.forEach($scope.files, function (file) {
            if (file.type === 'Folder') {
                if ($scope.foldername === file.displayName) {
                    $scope.foldername = '';
                    doubleName = true;
                }
            }
        });
        if (doubleName === true) return toastr.error('There is already a folder with that name in this directory. Please try a new name.');
        else {
            var folderKey = $scope.foldername + '/';
            s3.putObject({
                Bucket: bucket,
                Key: params.Prefix + folderKey
            }, function (err, data) {
                if (err) {
                    return toastr.error('There was an error creating your folder: ' + err.message);
                } else {
                    toastr.success('Folder: ' + $scope.foldername + ' was created');
                    $scope.showNewFolderContainerFunc();

                    setTimeout(function () {
                        $scope.foldername = '';
                    }, 500);
                }
            });
        }
        setTimeout(function () {
            $scope.resetFilesView();
        }, 1500);
    };

    // Init breadcrumb array
    $scope.breadcrumbsList = [];

    var prevPrefix = {
        prefix: ''
    };

    var currentPrefix = {
        exists: true,
        prefix: ''
    };

    // To add navigation links to breadcrumb
    // $scope.addToBreadcrumb = function (newPrefix, name) {
    //     prevPrefix.prefix = currentPrefix.prefix;
    //     var breadcrumbLink = name;

    //     var breadcrumbObj2 = {
    //         prefix: newPrefix,
    //         link: breadcrumbLink,
    //         type: 'Folder'
    //     };
    //     var prefixSlashcount = (prefix.split('/').length - 1);

    //     if (currentPrefix.exists === true) {
    //         if (newPrefix === currentPrefix.prefix) {
    //             return
    //         } else if (newPrefix.includes(currentPrefix.prefix)) {
    //             $scope.breadcrumbList.push(breadcrumbObj2);
    //         } else {
    //             var currentPrefixSlashcount = (currentPrefix.prefix.split('/').length - 1);
    //             var newPrefixSlashcount = (newPrefix.split('/').length - 1);
    //             var slashCountDifference = currentPrefixSlashcount - newPrefixSlashcount;
    //             $scope.breadcrumbList.splice(($scope.breadcrumbList.length - slashCountDifference), slashCountDifference);
    //         }
    //     } else {
    //         $scope.breadcrumbList.push(breadcrumbObj2);
    //     }
    //     currentPrefix.exists = true;
    //     currentPrefix.prefix = newPrefix;
    // };

    $scope.updateBreadcrumb = function () {
        $scope.breadcrumbPrefix = [];
        $scope.breadcrumbArr = params.Prefix.split('/');
        $scope.breadcrumbArr.pop();

        setTimeout(function () {
            angular.forEach($scope.breadcrumbArr, function (breadcrumb) {
                var breadcrumbPrefix = '';
                var breadcrumbObj = {
                    link: breadcrumb,
                    type: 'Folder'
                }
                $scope.breadcrumbPrefix.push(breadcrumb + '/');
                angular.forEach($scope.breadcrumbPrefix, function (string) {
                    breadcrumbPrefix += string;
                });
                breadcrumbObj.prefix = breadcrumbPrefix;
                $scope.breadcrumbs.push(breadcrumbObj);
            });

            var difference;

            if ($scope.breadcrumbs.length > $scope.breadcrumbsList.length) {
                difference = $scope.breadcrumbs.length - $scope.breadcrumbsList.length;
                for (var i = 0; i < difference; i++) {
                    $scope.breadcrumbsList.push($scope.breadcrumbs[$scope.breadcrumbsList.length]);
                }
            } else if ($scope.breadcrumbs.length < $scope.breadcrumbsList.length) {
                difference = $scope.breadcrumbsList.length - $scope.breadcrumbs.length;
                for (var i = difference; i > 0; i--) {
                    $scope.breadcrumbsList.pop();
                }
            }
        }, 100);
    }

    // To show 'New Folder' prompt
    $scope.focusNewFolderInput = function () {
        document.getElementById('foldername-input').focus();
    }
    $scope.showNewFolderContainer = false;
    $scope.showNewFolderContainerFunc = function () {
        $scope.showNewFolderContainer = !$scope.showNewFolderContainer;
        if ($scope.showNewFolderContainer) {
            document.body.style.overflowY = 'hidden';
            setTimeout(function () {
                $scope.focusNewFolderInput();
            }, 50);
        } else {
            document.body.style.overflowY = 'scroll';
        }
    };

    // To show 'Rename' prompt
    $scope.focusRenameInput = function () {
        document.getElementById('rename-input').focus();
    }
    $scope.showRenameContainer = false;
    $scope.showRenameContainerFunc = function () {
        $scope.showRenameContainer = !$scope.showRenameContainer;
        if ($scope.showRenameContainer) {
            document.body.style.overflowY = 'hidden';
            $scope.filename = $scope.fileList.selected[0].displayName;
            setTimeout(function () {
                $scope.focusRenameInput();
            }, 50);
            if ($scope.fileList.selected[0].type === 'Folder') {
                $scope.getFolderObject();
            }
        } else {
            document.body.style.overflowY = 'scroll';
        }
    };

    // To show 'File Uploader' prompt
    $scope.showUploadFileContainer = false;
    $scope.showUploadFileContainerFunc = function () {
        $scope.displayFiles = [];
        $scope.showUploadFileContainer = !$scope.showUploadFileContainer;
        if ($scope.showUploadFileContainer) {
            document.body.style.overflowY = 'hidden';
        } else {
            document.body.style.overflowY = 'scroll';
        }
        $scope.showLoader = false;
        setTimeout(function () {
            uploader.value = '';
        }, 800);
        $scope.fileSelected = false;
        $scope.isProcessing = false;
    };

    $scope.hideUploadFileContainerFunc = function () {
        $scope.showUploadFileContainer = false;
        document.body.style.overflowY = 'scroll';
        $scope.showLoader = false;
        setTimeout(function () {
            uploader.value = '';
        }, 400);
    };

    // To show 'Delete File' prompt
    $scope.showDeletePromptContainer = false;
    $scope.showDeletePromptContainerFunc = function () {
        $scope.showDeletePromptContainer = !$scope.showDeletePromptContainer;
        if ($scope.showDeletePromptContainer) {
            document.body.style.overflowY = 'hidden';
        } else {
            document.body.style.overflowY = 'scroll';
        }
    };

    // To show 'Move File' prompt
    $scope.showMovePromptContainer = false;
    $scope.showMovePromptContainerFunc = function () {
        $scope.folderList.selected = [];
        $scope.showMovePromptContainer = !$scope.showMovePromptContainer;
        if ($scope.showMovePromptContainer) {
            document.body.style.overflowY = 'hidden';
        } else {
            document.body.style.overflowY = 'scroll';
        }
    };

    // To get file for fileStats viewer
    $scope.fileStatsFile = {};
    $scope.getfileStatsFile = function () {
        if ($scope.fileList.selected.length === 1) {
            $scope.fileStatsFile = $scope.fileList.selected[0];
            $scope.fileStatsFile.fileStatsIcon = $scope.fileStatsFile.icon.replace('-o', '');
        }
    };

    var tableContainer = document.getElementById('table-container');
    $scope.windowWidth = window.innerWidth;

    window.addEventListener('load', function (e) {
        $scope.windowWidth = e.target.innerWidth;
        if ($scope.shrinkTable === true) {
            tableContainer.classList.add('shrink-with-table');
            if ($scope.windowWidth <= 1500) {
                tableContainer.style.width = 'calc(100% - 350px)';
            }
            if ($scope.windowWidth <= 1150) {
                tableContainer.style.width = 'calc(100% - 250px)';
            }
        } else {
            tableContainer.classList.remove('shrink-with-table');
        }
    });

    window.addEventListener('resize', function (e) {
        $scope.windowWidth = e.target.innerWidth;
        if ($scope.shrinkTable === true) {
            tableContainer.classList.add('shrink-with-table');
            if ($scope.windowWidth <= 1500) {
                tableContainer.style.width = 'calc(100% - 350px)';
            }
            if ($scope.windowWidth <= 1150) {
                tableContainer.style.width = 'calc(100% - 250px)';
            }
        } else {
            tableContainer.classList.remove('shrink-with-table');
        }
    });

    // To show 'fileStats Viewer'
    $scope.showfileStatsFileContainer = false;
    $scope.shrinkTable = false;
    $scope.showfileStatsFileContainerFunc = function () {
        if ($scope.fileList.selected.length === 1) {
            $scope.showfileStatsFileContainer = !$scope.showfileStatsFileContainer;
            if ($scope.showfileStatsFileContainer === true) {
                $scope.shrinkTable = true;
            } else {
                $scope.shrinkTable = false;
            }
        } else {
            $scope.showfileStatsFileContainer = false;
        }
    };

    // Context Menu
    $scope.showContextMenu = true;

    // To track context menu to cursor and adjust according to sidebar width
    window.addEventListener('mousemove', function (e) {
        var offset;

        if (angular.element(window).width() < 769) {
            offset = 55;
        } else {
            offset = 215;
        }
        var origin = {
            left: e.pageX - offset,
            top: e.pageY,
            updated: false
        };

        var cursorPosition = e.clientY;

        $scope.showContextMenuFunc = function () {
            $scope.showContextMenu = true;
            if (origin.updated === false) {
                setPosition(origin, cursorPosition);
            }
            origin.updated = true;
        };
        return false;
    });

    var folderMenu = document.getElementById("folder-menu");

    // To show context menu upon right click
    var menu = document.querySelector(".context-menu");
    var menuVisible = false;

    var moveToOption = document.querySelector("#move-to-menu-option");

    moveToOption.addEventListener('mouseenter', function (e) {
        folderMenu.style.display = 'block';
    });
    folderMenu.addEventListener('mouseenter', function (e) {
        folderMenu.style.display = 'block';
    });
    moveToOption.addEventListener('mouseleave', function (e) {
        folderMenu.style.display = 'none';
    });
    folderMenu.addEventListener('mouseleave', function (e) {
        folderMenu.style.display = 'none';
    });

    var toggleMenu = function (command) {
        menu.style.display = command === "show" ? "flex" : "none";
        menuVisible = !menuVisible;
        menu.style.animation = command === "show" ? "menuScroll ease-in forwards 0.2s" : "none";

        setTimeout(function () {
            menu.style.animation = "none";
        }, 300);
    };

    // To change context menu orientatio according to cursor position in window
    var windowHeight = window.innerHeight;

    var setPosition = function (origin, cursorPosition) {
        if (cursorPosition >= 0.65 * windowHeight) {
            menu.style.left = origin.left + 'px';
            menu.style.top = (origin.top - 250) + 'px';
        } else {
            menu.style.left = origin.left + 'px';
            menu.style.top = origin.top + 'px';
        }
        toggleMenu("show");
    };

    window.addEventListener("click", function (e) {
        toggleMenu("hide");
    });

    // Initialize files array
    $scope.initFiles = function (updatedPrefix) {
        $scope.files = [];
        $scope.filesObj = [];

        // To grab either Keys or Prefixes from s3 to use as file names
        function getFileName(name) {
            if (name) return name;
        }

        // To create a display name without s3 prefix
        function setFileName(name) {
            var newName = name.replace([updatedPrefix], '');
            newName = newName.replace('/', '');
            newName = newName.replace('%20', ' ');
            return newName;
        }

        // To get file owner
        function getFileOwner(owner) {
            if (owner) {
                return owner.DisplayName;
            } else {
                return '---'
            }
        }

        // To grab and display dates from s3 objects depending on whether they exist
        function getFileDate(date) {
            if (date) return date;
            else return '---'
        }

        // To set file size
        function setFileSize(size) {
            var fileSize;
            if (size < 1000) {
                fileSize = size + ' B';
            } else if (size >= 1000 && size < 1000000) {
                fileSize = (size / 1000).toFixed(2) + ' KB';
            } else if (size >= 1000000 && size < 1000000000) {
                fileSize = (size / 1000000).toFixed(2) + ' MB';
            } else if (size >= 1000000000 && size < 1000000000000) {
                fileSize = (size / 1000000000).toFixed(2) + ' GB';
            } else {
                fileSize = '---';
            }
            return fileSize;
        }

        // Create file objects
        angular.forEach($scope.contents, function (f) {
            var fileObj = {
                name: getFileName(f.Key || f.Prefix),
                displayName: setFileName(f.Key || f.Prefix),
                owner: getFileOwner(f.Owner),
                date: getFileDate(f.LastModified),
                size: setFileSize(f.Size),
                selected: false,
            };

            // To add file type to file objects
            function setFileType() {
                if (f.Prefix) {
                    fileObj.type = 'Folder';
                } else {
                    var extension = fileObj.name.substring(fileObj.name.lastIndexOf(".") + 1, fileObj.name.length);
                    var fileType = '';
                    switch (extension) {
                        case 'doc':
                            fileType = 'Document';
                            break;
                        case 'xls':
                            fileType = 'Spreadsheet';
                            break;
                        case 'pdf':
                            fileType = 'PDF';
                            break;
                        case 'txt':
                        case 'txt000':
                        case 'rtf':
                            fileType = 'Text';
                            break;
                        case 'json':
                            fileType = 'JSON';
                            break;
                        case 'zip':
                            fileType = 'Archive';
                            break;
                        case 'png':
                        case 'jpg':
                        case 'bmp':
                        case 'jpeg':
                        case 'webp':
                        case 'tiff':
                        case 'raw':
                        case 'heif':
                        case 'jpeg2000':
                        case 'svg':
                            fileType = 'Image';
                            break;
                        case 'gif':
                            fileType = 'GIF';
                            break;
                        case 'wav':
                        case 'mp3':
                            fileType = 'Audio';
                            break;
                        case 'wav':
                        case 'mp4':
                            fileType = 'Video';
                            break;
                        default:
                            fileType = '---'
                    }
                    fileObj.type = fileType;
                }
            }

            // To set file icons
            function setFileIcon() {
                var icon;
                switch (fileObj.type) {
                    case 'Document':
                        icon = 'fa-file-text-o';
                        break;
                    case 'PDF':
                        icon = 'fa-file-pdf';
                        break;
                    case 'Folder':
                        icon = 'fa-folder-o';
                        break;
                    case 'Archive':
                        icon = 'fa-file-archive';
                        break;
                    case 'Spreadsheet':
                        icon = 'fa-file-excel';
                        break;
                    case 'Image':
                    case 'GIF':
                        icon = 'fa-file-image';
                        break;
                    case 'Audio':
                        icon = 'fa-file-audio';
                        break;
                    case 'Video':
                        icon = 'fa-file-video';
                        break;
                    case 'JSON':
                        icon = 'fa-file-code';
                        break;
                    default:
                        icon = 'fa-file-o'
                }
                fileObj.icon = icon;
            }

            // To set file download link
            function setDownloadLink() {
                var downloadFile = {
                    Key: fileObj.name,
                    name: fileObj.displayName
                }

                var downloadFileParams = {
                    Bucket: bucket,
                    Key: downloadFile.Key
                }

                fileObj.url = s3.getSignedUrl('getObject', downloadFileParams);
            }

            // To set file location
            function setLocation() {
                var locationArr = fileObj.name.split('/');
                var location;
                if (locationArr.length <= 2) {
                    if ((locationArr.length === 2) && (locationArr[locationArr.length - 1] !== '')) {
                        location = locationArr[locationArr.length - 2]
                    } else {
                        location = 'All files';
                    }
                } else {
                    if (locationArr[locationArr.length - 1] === '') {
                        location = locationArr[locationArr.length - 3];
                    } else {
                        location = locationArr[locationArr.length - 2];
                    }
                }
                fileObj.location = location;
            }

            setFileType();
            setFileIcon();
            setDownloadLink();
            setLocation();

            if (fileObj.displayName !== '') {
                $scope.files.push(fileObj);
            }
        });

        // To store folders for context menu
        $scope.folderFiles = [];
        angular.forEach($scope.files, function (file) {
            if (file.type === 'Folder') {
                $scope.folderFiles.push(file);
            }
            // console.log($scope.folderFiles);
        });

        // To search files
        $scope.$watch('searchFiles', function (term) {
            var obj = {
                displayName: term
            };
            $scope.filterFiles = filterFilter($scope.files, obj);
            $scope.currentPage = 1;
            $scope.showfileStatsFileContainer = false;
            $scope.shrinkTable = false;
        });

        // To update filterFiles
        $scope.updateFilterFiles = function () {
            $scope.filterFiles = $scope.files;
        };

        // To change the sorting order
        $scope.reverse = true;
        $scope.myOrderBy = 'type === Folder';
        $scope.orderByMe = function (x) {
            $scope.myOrderBy = x;
            $scope.reverse = !$scope.reverse;
        };

        // Initializing array to store the files selected
        $scope.fileList = {
            selected: [],
        };

        // To select all files
        $scope.allFiles = function () {
            if ($scope.selectedAllFiles) {
                $scope.selectedAllFiles = true;
                angular.forEach($scope.files, function (file) {
                    file.selected = true;
                });
                $scope.fileList.selected = angular.copy($scope.files);
            } else {
                $scope.selectedAllFiles = false;
                angular.forEach($scope.files, function (file) {
                    file.selected = false;
                });
                $scope.fileList.selected = [];
            }
        };

        $scope.clearAllFiles = function () {
            $scope.fileList.selected = [];
        };

        // To track selected files
        $scope.checkFileStatus = function () {
            angular.forEach($scope.fileList.selected, function (selected) {
                selected.selected = true;
            });
            angular.forEach($scope.files, function (file) {
                if ($scope.fileList.selected.length < 1) {
                    file.selected = false;
                } else {
                    file.selected = false;
                    angular.forEach($scope.fileList.selected, function (selected) {
                        if (selected.name === file.name) {
                            file.selected = true;
                        }
                    });
                }
            });
            $scope.selectedAllFiles = ($scope.fileList.selected.length === $scope.files.length);
            $scope.showfileStatsFileContainer = false;
            $scope.shrinkTable = false;
            // $scope.addDownloadLink();
        };

        // Pagination & filtering list of Clinics
        $scope.totalFilesList = $scope.files.length;
        $scope.pageSize = 15; // holds the number of items per page
    };

    $scope.resetButtons = function () {
        downloadButton.setAttribute('disabled', '');
        $scope.showCopyButton = false;
        $scope.showMoveButton = false;
        $scope.showDeleteButton = false;
        $scope.showNewFolderButton = true;
        $scope.showInfoButton = false;
    }

    // To show buttons according to selected status
    $scope.showCopyButton = false;
    $scope.showMoveButton = false;
    $scope.showDeleteButton = false;
    $scope.showNewFolderButton = true;
    $scope.showInfoButton = false;
    var infoMenuOption = document.getElementById('info-menu-option');
    var copyMenuOption = document.getElementById('copy-menu-option');
    var pasteMenuOption = document.getElementById('paste-menu-option');
    var deleteMenuOption = document.getElementById('delete-menu-option');
    var renameMenuOption = document.getElementById('rename-menu-option');
    var downloadMenuOptionLi = document.getElementById('download-menu-option-li');
    var statsCopyButton = document.getElementById('stats-copy-btn');
    var statsRenameButton = document.getElementById('stats-rename-btn');
    var statsMoveButton = document.getElementById('stats-move-btn');
    var statsDeleteButton = document.getElementById('stats-delete-btn');

    $scope.showOptionsFunc = function () {
        // If no files are selected...
        if ($scope.fileList.selected.length < 1) {

            // Disable download button
            downloadButton.setAttribute('disabled', '');

            // Hide all buttons except 'Create New Folder' button
            $scope.showCopyButton = false;
            $scope.showMoveButton = false;
            $scope.showDeleteButton = false;
            $scope.showNewFolderButton = true;
            $scope.showInfoButton = false;

            // Disable all menu options
            infoMenuOption.classList.add('disabled-menu-option');
            downloadMenuOptionLi.classList.add('disabled-menu-option');
            copyMenuOption.classList.add('disabled-menu-option');
            deleteMenuOption.classList.add('disabled-menu-option');
            pasteMenuOption.classList.add('disabled-menu-option');
            moveToOption.classList.add('disabled-menu-option');
            renameMenuOption.classList.add('disabled-menu-option');

            // If there are no files in the 'clipboard' disable pasting
            if ($scope.selectedFileList.files.length < 1) {
                pasteMenuOption.classList.add('disabled-menu-option');
            } else {
                pasteMenuOption.classList.remove('disabled-menu-option');
            }
        } else if ($scope.fileList.selected.length > 1) { // If multiple files are selected...

            // Disable download button and menu option
            downloadButton.setAttribute('disabled', '');
            downloadMenuOptionLi.classList.add('disabled-menu-option');

            // If a selected file is a folder hide Copy/Download/Move To buttons
            var found = false;
            for (var i = 0; i < $scope.fileList.selected.length; i++) {
                if ($scope.fileList.selected[i].type == 'Folder') {
                    found = true;
                    break;
                }
            }
            if (found === true) {
                $scope.showCopyButton = false;
                $scope.showMoveButton = false;
                downloadButton.setAttribute('disabled', '');
                $scope.showDeleteButton = true;
                copyMenuOption.classList.add('disabled-menu-option');
                moveToOption.classList.add('disabled-menu-option');
            } else {
                $scope.showCopyButton = true;
                $scope.showMoveButton = true;
                copyMenuOption.classList.remove('disabled-menu-option');
                moveToOption.classList.remove('disabled-menu-option');
            }
            $scope.showInfoButton = false;
            $scope.showNewFolderButton = false;
            infoMenuOption.classList.add('disabled-menu-option');
            deleteMenuOption.classList.remove('disabled-menu-option');
            renameMenuOption.classList.add('disabled-menu-option');

            // Show 'Delete' button; hide 'New Folder', and 'Info' buttons
            $scope.showDeleteButton = true;
            $scope.showNewFolderButton = false;
            $scope.showInfoButton = false;
        } else { // If only one file is selected...
            angular.forEach($scope.fileList.selected, function (file) {
                if (file.type === 'Folder') { // If a selected file is a folder, disable copying/downloading/moving
                    $scope.showCopyButton = false;
                    $scope.showMoveButton = false;
                    copyMenuOption.classList.add('disabled-menu-option');
                    downloadButton.setAttribute('disabled', '');
                    downloadMenuOptionLi.classList.add('disabled-menu-option');
                    statsDownloadButton.classList.add('disabled');
                    statsCopyButton.classList.add('disabled');
                    statsMoveButton.classList.add('disabled');
                    moveToOption.classList.add('disabled-menu-option');
                } else {
                    $scope.showCopyButton = true;
                    $scope.showMoveButton = true;
                    copyMenuOption.classList.remove('disabled-menu-option');
                    moveToOption.classList.remove('disabled-menu-option');
                    statsDownloadButton.classList.remove('disabled');
                    statsCopyButton.classList.remove('disabled');
                    statsRenameButton.classList.remove('disabled');
                    statsMoveButton.classList.remove('disabled');
                    statsDeleteButton.classList.remove('disabled');
                    downloadButton.removeAttribute('disabled');
                    downloadMenuOptionLi.classList.remove('disabled-menu-option');
                }
                $scope.showNewFolderButton = false;
                $scope.showInfoButton = true;
                infoMenuOption.classList.remove('disabled-menu-option');
                $scope.showDeleteButton = true;
                deleteMenuOption.classList.remove('disabled-menu-option');
                renameMenuOption.classList.remove('disabled-menu-option');
            });
        }
        if ($scope.selectedFileList.files.length < 1) { // If there are no files in the 'clipboard' disable pasting
            pasteMenuOption.classList.add('disabled-menu-option');
        } else {
            pasteMenuOption.classList.remove('disabled-menu-option');
        }
    };

    $scope.rightClickSelect = function (file) {
        // $scope.fileList.selected = [];
        // $scope.fileList.selected.push(file);
        $scope.checkFileStatus();
        $scope.showOptionsFunc();
    };

    // Make initial call to s3
    getDirectory();

    // Paramters for moving files interface
    var allFolderParams = {
        Bucket: bucket,
        Delimiter: '/',
        Prefix: prefix
    }

    // Store all folders to be moved
    $scope.moveFoldersArr = [];

    // Make call to s3 to display folders only
    $scope.getAllFolders = function () {
        s3.listObjects(allFolderParams, function (err, data) {
            if (err) console.log(err, err.stack); // an error occurred
            else { // successful response
                var allFolders = (data.Contents.concat(data.CommonPrefixes));
                $scope.allFolders = allFolders;
                $scope.initFolders();
            }
        });
    }

    $scope.getAllFolders();

    // Show initial folders only
    $scope.initialFolders = [];

    $scope.initFolders = function () {
        $scope.moveFoldersArr = [];
        angular.forEach($scope.allFolders, function (item) {
            if (item.Prefix) {
                var pathArr = item.Prefix.split('/');
                var itemObj = {
                    name: item.Prefix,
                    displayName: pathArr[pathArr.length - 2],
                    type: 'Folder',
                    selected: false
                }
                $scope.moveFoldersArr.push(itemObj);
            }
        });

        // angular.forEach($scope.moveFoldersArr, function (folder) {
        //     angular.forEach($scope.moveFoldersArr, function (outerFolder) {
        //         folder.innerFolders = [];
        //         if ((folder.name.includes(outerFolder.name)) && (folder.name !== outerFolder.name)) {
        //             outerFolder.innerFolders.push(folder);
        //         }
        //     });
        //     if ((folder.name.split('/')).length <= 2) {
        //         $scope.initialFolders.push(folder);
        //     }
        // });

        // console.log($scope.moveFoldersArr);
        // console.log($scope.initialFolders);

        // angular.forEach($scope.moveFoldersArr, function (folder) {
        //     if ((folder.name.split('/')).length <= 2) {
        //         folder.innerFolders = [];
        //         $scope.initialFolders.push(folder);
        //     }
        //     angular.forEach($scope.initialFolders, function(outerFolder) {
        //         if((folder.name.includes(outerFolder.name)) && (folder.name !== outerFolder.name)) {
        //             outerFolder.innerFolders.push(folder);
        //             console.log($scope.initialFolders)
        //         }
        //     })
        // });
    }

    // Store folder objects for moving
    $scope.folderList = {
        selected: [],
    }

    $scope.onlyOne = function (checkbox) {
        var checkboxes = document.querySelectorAll('.select-folder');
        $scope.folderList.selected = [];
        checkboxes.forEach(function (item) {
            if (item.name !== checkbox) item.checked = false;
            if (item.checked === true) {
                angular.forEach($scope.moveFoldersArr, function (folder) {
                    if (folder.name === item.name) {
                        folder.selected = true;
                        $scope.folderList.selected.push(folder);
                    } else {
                        folder.selected = false;
                    }
                });
            }
            if ($scope.folderList.selected.length === 0) {
                angular.forEach($scope.moveFoldersArr, function (folder) {
                    folder.selected = false;
                });
            }
        })
        // console.log(checkbox);
        // console.log(checkboxes);
        // console.log($scope.folderList.selected);
        // console.log($scope.moveFoldersArr);
    }

    $scope.getMovingDirectory = function (name) {
        allFolderParams.Prefix = name;
        $scope.getAllFolders();
        $scope.movingBreadcrumbs = [];
        $scope.updateMovingBreadcrumb();
        // console.log(name);
    }

    $scope.movingBreadcrumbsList = [];
    $scope.movingBreadcrumbs = []

    $scope.updateMovingBreadcrumb = function () {
        $scope.movingBreadcrumbPrefix = [];
        $scope.movingBreadcrumbArr = allFolderParams.Prefix.split('/');
        $scope.movingBreadcrumbArr.pop();

        setTimeout(function () {
            angular.forEach($scope.movingBreadcrumbArr, function (breadcrumb) {
                var movingBreadcrumbPrefix = '';
                var breadcrumbObj = {
                    link: breadcrumb,
                    type: 'Folder'
                }
                $scope.movingBreadcrumbPrefix.push(breadcrumb + '/');
                angular.forEach($scope.movingBreadcrumbPrefix, function (string) {
                    movingBreadcrumbPrefix += string;
                });
                breadcrumbObj.prefix = movingBreadcrumbPrefix;
                $scope.movingBreadcrumbs.push(breadcrumbObj);
            });

            var difference;

            if ($scope.movingBreadcrumbs.length > $scope.movingBreadcrumbsList.length) {
                difference = $scope.movingBreadcrumbs.length - $scope.movingBreadcrumbsList.length;
                for (var i = 0; i < difference; i++) {
                    $scope.movingBreadcrumbsList.push($scope.movingBreadcrumbs[$scope.movingBreadcrumbsList.length]);
                }
            } else if ($scope.movingBreadcrumbs.length < $scope.movingBreadcrumbsList.length) {
                difference = $scope.movingBreadcrumbsList.length - $scope.movingBreadcrumbs.length;
                for (var i = difference; i > 0; i--) {
                    $scope.movingBreadcrumbsList.pop();
                }
            }
        }, 100);
    }

    // To track selected files
    // $scope.checkFolderStatus = function (name) {

    //     angular.forEach($scope.folderList.selected, function (selected) {
    //         if(selected.name === name) {
    //             selected.selected = true;
    //         } else {
    //             selected.selected = false;
    //         }
    //     });

    //     angular.forEach($scope.allFolders, function (folder) {
    //         if ($scope.folderList.selected.length < 1) {
    //             folder.selected = false;
    //         } else {
    //             folder.selected = false;
    //             angular.forEach($scope.folderList.selected, function (selected) {
    //                 if ((selected.selected === true) && (selected.name === folder.name)) {
    //                     folder.selected = true;
    //                 } else {
    //                     folder.selected = false; 
    //                 }
    //             });
    //         }
    //     });
    //     console.log($scope.folderList.selected)
    // };
}

angular.module('inspinia')
    .controller('FileManagerCtrl', FileManagerCtrl);
/**
 * DbexplorerCtrl - Controller for launching redash
 */

    
function DbexplorerCtrl($scope, $rootScope, $window, $cookies, $auth) {
    var vm = this;
    vm.launchdbexplorer = function() {
        var today = new Date();
        var expiresValue = new Date(today);
        expiresValue.setSeconds(today.getSeconds() + 5); //Set 'expires' option in 5 seconds
        $cookies.put('hjjwt', $auth.getToken(), {'domain': '.healthjump.com', 'expires' : expiresValue});
        $window.open('https://dbx.healthjump.com', '_blank');
    };
}

angular.module('inspinia')
    .controller('DbexplorerCtrl', DbexplorerCtrl);
/**
 * @description Analyze controller to manage all the Analyze related methods.
 * @author Ravi
 * @createddate Jun-16-2016
 */

'use strict';

//Define global variables to use it in out of controller
var numberofFilters = 0;
var searchFilterObj = {groupOp: "AND", rules: []};

angular.module('inspinia')
        .controller('analyzeController', function($scope, $location, $stateParams, $filter, $timeout, $compile, $uibModal, $rootScope, APIService, UserPreferenceService, $state) {
    //Set current page title
    var currentPage = $state.current.data.tablename || "Analyze";
    if (currentPage == 'metrics') {
        currentPage = 'quality metrics';
    }
    
    //Define global variables
    $scope.isFetchingColumnData = true;
    $scope.userArray = $rootScope.userProfile;
    $scope.isEditChart = false;
    $scope.isSavedPage = false;
    $scope.clearChartFilters;
    var countUserGraphs = 0;
    var customUserGraphParam = [];
    $scope.columnList = [];
    var getGridDataParams = '';
    var selectedDates = {'start': moment(moment().format('YYYY-MM-DD')).subtract(1,'months').format('YYYYMMDD'), 'end': moment().format('YYYYMMDD')};
    $scope.allFiltersObject = {'gridFilter': '', 'chartFilter': '', 'dashboard_title': '', 'pagename': '', 'userid': $scope.userArray.id, 'pageid': '', 'dashaction': '', 'dateColumnToFilter': ''};
    var dateColumnToFilter = "";
    var savedPageId = '';
    $scope.hideGettingStarted = true;

    //User Preferences
    $rootScope.$watch('user_preferences', function () {
        if ($rootScope.user_preferences.$resolved) {
            if ($rootScope.user_preferences.analyze_jumbotron != "hide") {
                $scope.hideGettingStarted = false;
            }
            if ($rootScope.user_preferences[currentPage + "_column_order"]) {
                $scope.orderedColumnList = JSON.parse($rootScope.user_preferences[currentPage + "_column_order"]);
            } else {
                APIService.getDefaultOrderColumn().then(function (resData) {
                    $scope.orderedColumnList = resData.data[currentPage];
                });
            }
        }
    })

    //Hide Getting Started Jumbotron
    $scope.hideJumbotron = function () {
        $scope.hideGettingStarted = true;
        var prefs = {"preference": "analyze_jumbotron", "value": "hide"};
        UserPreferenceService.save(prefs);
        $rootScope.user_preferences.analyze_jumbotron = "hide";
    }

    //check for saved dashboard or not
    if ($state.current.data.tablename == 'saveddashboard') {
        $scope.isSavedPage = true;        
        savedPageId = $stateParams.pageId;
        var loadDashboardParam = {pageid: savedPageId, dashaction: 'load'};
        APIService.post('savedashboard', loadDashboardParam).then(function(resData) {
            if(resData.data.length <= 0 || resData.status == 403 || resData.status == 500){
                toastr.error($rootScope.toastrTranslate.REQPAGENOTFOUND,$rootScope.toastrTranslate.ANALYZE);
                $location.path('/index/home');
                return false;
            }
             
            currentPage = resData.data.gridFilter.table;
            //Check for columns order prefences and set if found otherwise set from Static json
            if ($rootScope.user_preferences[currentPage + "_column_order"]) {
                $scope.orderedColumnList = JSON.parse($rootScope.user_preferences[currentPage + "_column_order"]);
            } else {
                APIService.getDefaultOrderColumn().then(function (resData) {
                    $scope.orderedColumnList = resData.data[currentPage];
                });
            }
    
            $scope.fetchColumns();
            $scope.currentPage = $filter('camelize')(resData.data.dashboard_title);
            dateColumnToFilter = resData.data.dateColumnToFilter;

            getGridDataParams = resData.data.gridFilter;
            $scope.allFiltersObject.gridFilter = resData.data.gridFilter;
            // console.log('Data Grid Request on saved Page load, Params: ', getGridDataParams);
            $scope.renderDataGrid(getGridDataParams);

            /**
             * @description : Function to render all the chart on saved page load.
             * Chart render by saved filters.
             * Function call recursive on set time limit untill all chart render
             */
            var counter = 0;
            var chartData = resData.data.chartFilter;
            function renderChartRec() {
                $timeout(function() {
                    if (chartData[counter] !== null && chartData.length > 0)
                    {
                        $scope.chartFilterCategory = chartData[counter].category;
                        $scope.chartFilterMeasurement = chartData[counter].measurement;
                        $scope.chartFilterCalculation = chartData[counter].calculation;
                        $scope.chartFilterMeasurement2 = chartData[counter].measurement2 || [];
                        $scope.chartFilterCalculation2 = chartData[counter].calculation2 || [];
                        selectedDates = chartData[counter].dateFilter;
                        $scope.createCustomChart(chartData[counter].type);
                    }
                    counter++;
                    if (counter < resData.data.chartFilter.length) {
                        renderChartRec();
                    }
                }, 3000);
            }
            renderChartRec();
        });
    } else {
        $scope.currentPage = $filter('camelize')(currentPage); //convert current page to Camel case.
        //Define column for date filter according to analyze pages.
        switch (currentPage) {
            case "transactions":
                dateColumnToFilter = 'post_date';
                break;
            case "charges":
                dateColumnToFilter = 'beginning_date_of_service';
                break;
            case "claims":
                dateColumnToFilter = 'begin_date_of_service';
                break;
            case "appointments":
                dateColumnToFilter = 'date';
                break;
            case "quality metrics":
                dateColumnToFilter = 'observation_date';
                break;
            case "demographics":
                dateColumnToFilter = 'dob';
                break;
            case "diagnosis":
                dateColumnToFilter = 'diagnosed_date';
                break;
            case "encounters":
                dateColumnToFilter = 'encounter_date';
                break;
        }
        //fetch columns list.
        $timeout(function() {
            $scope.fetchColumns();
        })
    }

    /**
     * @description To generate API request param according to different actions,
     * like (Get column, fetch chart data, fetch gird data, etc.)
     * @param requestFor : specify the type of request to generate the request param
     * @param options : Other request param options to add in request according to request action.
     * @returns generated request JSON object.
     */
    //generate request parameters as per event types
    $scope.requestParams = function(requestFor, options) {
        if (requestFor == 'getColumns') {
            return {'table': currentPage, 'hjdw_type': 'getColumns'};
        } else if (requestFor == 'dataGridOnDate') {
            return {
                'table': currentPage,
                'hjdw_type': 'hjdw_grid',
                '_search': true,
                'nd': '',
                'rows': 10,
                'page': 1,
                'sidx': '',
                'sord': 'asc',
                'filters': {
                    'groupOp': 'AND',
                    'rules': [
                        {
                            'field': dateColumnToFilter,
                            'op': 'ge',
                            'data': options.start
                        }, {
                            'field': dateColumnToFilter,
                            'op': 'le',
                            'data': options.end
                        }
                    ]
                }
            };
        } else if (requestFor == 'pieChart') {
            return {
                'table': currentPage,
                'Category': options.category,
                'Measurement': options.measurement,
                'Calculation': options.calculation,
                'hjdw_type': 'pieGraph',
                'filters': {
                    'groupOp': 'AND',
                    'rules': [
                        {
                            'field': dateColumnToFilter,
                            'op': 'ge',
                            'data': options.dateFilter.start
                        }, {
                            'field': dateColumnToFilter,
                            'op': 'le',
                            'data': options.dateFilter.end
                        }
                    ]
                }
            };
        } else if (requestFor == 'singleChart') {
            return {
                'table': currentPage,
                'series': 'Single',
                'Category': options.category,
                'Calculation': options.calculation,
                'Measurement': options.measurement,
                'hjdw_type': 'barGraph',
                'filters': {
                    'groupOp': 'AND',
                    'rules': [
                        {
                            'field': dateColumnToFilter,
                            'op': 'ge',
                            'data': options.dateFilter.start
                        }, {
                            'field': dateColumnToFilter,
                            'op': 'le',
                            'data': options.dateFilter.end
                        }
                    ]
                }
            };
        } else if (requestFor == 'multiChart') {
            return {
                'table': currentPage,
                'series': 'Multi',
                'Category': options.category,
                'Calculation': options.calculation,
                'Measurement': options.measurement,
                'Calculation2': options.calculation2,
                'Measurement2': options.measurement2,
                'hjdw_type': 'barGraph',
                'filters': {
                    'groupOp': 'AND',
                    'rules': [
                        {
                            'field': dateColumnToFilter,
                            'op': 'ge',
                            'data': options.dateFilter.start
                        }, {
                            'field': dateColumnToFilter,
                            'op': 'le',
                            'data': options.dateFilter.end
                        }
                    ]
                }
            };
        }
    }
    
    // function for Visual validation
    $scope.visualValidation = function(){
        var numericTypes = ["smallint", "integer", "bigint", "decimal", "numeric", "real", "double precision", "smallserial", "serial", "bigserial"];
        var category_type = '', measurement_type = '', measurement2_type = '';
        angular.forEach($scope.columnList, function(value, key) {
            if (value['id'] == $scope.chartFilterCategory)
                category_type = value['type'];
            if (value['id'] == $scope.chartFilterMeasurement)
                measurement_type = value['type'];
            if (value['id'] == $scope.chartFilterMeasurement2)
                measurement2_type = value['type'];
        });
        
        if(numericTypes.indexOf(measurement_type) > -1) {
            $scope.filterCalculation = [{"id":"Sum","name":"Sum"},{"id":"Avg","name":"Average"},{"id":"Count","name":"Count"},{"id":"CountDistinct","name":"Count Distinct"}];
        }else {
            $scope.filterCalculation = [{"id":"Count","name":"Count"},{"id":"CountDistinct","name":"Count Distinct"}];
        }
        if(numericTypes.indexOf(measurement2_type) > -1) {
            $scope.filterCalculation2 = [{"id":"Sum","name":"Sum"},{"id":"Avg","name":"Average"},{"id":"Count","name":"Count"},{"id":"CountDistinct","name":"Count Distinct"}];
        }else {
            $scope.filterCalculation2 = [{"id":"Count","name":"Count"},{"id":"CountDistinct","name":"Count Distinct"}];
        }
    }
    
    //Define and reset the Chart filter model on page load and on selecting chart button.    
    $scope.clearChartFilters = function(chartType) {
        $scope.chartFilterCategory = [];
        $scope.chartFilterMeasurement = [];
        $scope.chartFilterCalculation = [];
        $scope.chartFilterMeasurement2 = [];
        $scope.chartFilterCalculation2 = [];
        $scope.isEditChart = false; //flag to determine request for edit chart.


        if (chartType == 'pie') {
            $('#addBarGraphBox, #addLineGraphBox, #addAreaGraphBox').hide();
            $('#addPieGraphBox').toggle('slow');
        } else if (chartType == 'line') {
            $('#addPieGraphBox, #addBarGraphBox , #addAreaGraphBox').hide();
            $('#addLineGraphBox').toggle('slow');
        } else if (chartType == 'bar') {
            $('#addPieGraphBox, #addLineGraphBox, #addAreaGraphBox').hide();
            $('#addBarGraphBox').toggle('slow');
        } else if (chartType == 'area') {
            $('#addPieGraphBox, #addBarGraphBox , #addLineGraphBox').hide();
            $('#addAreaGraphBox').toggle('slow');
        }

        chartType = $filter('camelize')(chartType);
        angular.element('#custom' + chartType + 'Title').html('Create Custom ' + chartType + ' Graph');
    }

    //Fetch columns list using API request.
    $scope.fetchColumns = function() {
        var getColumnReqParam = $scope.requestParams('getColumns'); //generate the API request param
        // console.log('Get columns list Request on Page load, Params: ', getColumnReqParam); //Console API request parma for columns list request.
        APIService.post('getallcolumns', getColumnReqParam)
                .then(function(resData) {
            if (resData) {
                $scope.columnList = resData.data;
                $scope.filterCalculation = [{"id":"Count","name":"Count"},{"id":"CountDistinct","name":"Count Distinct"}];
                $scope.filterCalculation2 = $scope.filterCalculation;
                //enable all chart buttons after getting all coulumns
                $scope.isFetchingColumnData = false;              
            }
        });
    }

    /**
     * @description - Function used to render the chart on chart request, and to handle click on chart element event.
     * @param chartType - chart type to generate the specific chart.
     */
    $scope.createCustomChart = function(chartType) {
        var canvasDivId = "chart_" + countUserGraphs + "_Div";
        var canvasChartId = "chart_" + countUserGraphs + "_chart";
        var loadChartGif = "chart_" + countUserGraphs + "_Gif";
        var newTitle = "chart_" + countUserGraphs + "_title";
        var poundNewLoadChartGif = "#" + loadChartGif;
        var category = $scope.chartFilterCategory;
        var statusDiv = angular.element('#' + chartType + 'statusDiv');
        var getChartDataReqParam = '';
        var myChart = '';

        //Define chart series is Single or Multi
        $scope.series = 'Multi';
        if ($scope.chartFilterMeasurement2.length == 0) {
            $scope.series = 'Single';
        }
        
        // Collect and Store parameter to customUserGraphParam
        var newCustomParam = {
            "id": countUserGraphs,
            "type": chartType,
            "series": $scope.series,
            "category": category,
            "measurement": $scope.chartFilterMeasurement,
            "calculation": $scope.chartFilterCalculation,
            "measurement2": $scope.chartFilterMeasurement2,
            "calculation2": $scope.chartFilterCalculation2,
            "dateFilter": selectedDates
        }
        customUserGraphParam.push(newCustomParam);

        //Generate chart HTML 
        var newGraphBox = '<div id="chart_' + countUserGraphs + '" class="col-lg-6 ui-sortable">'
                + '<div class="ibox">'
                + '<div class="ibox-title">'
                + '<div><h5 id="' + newTitle + '">{{ "LOADGRAPH" |translate }}</h5>'
                + '<div class="ibox-tools">'
                + '<a ng-click="fullscreen(\'' + countUserGraphs + '\')">'
                + '<i class="fa fa-expand"></i>'
                + '</a>'
                + '<a class="dropdown-toggle" data-toggle="dropdown" ng-click="editChart(\'' + countUserGraphs + '\', \'' + chartType + '\', false);">'
                + '<i class="fa fa-wrench"></i>'
                + '</a>'
                + '<a ng-click="removeChart(\'' + countUserGraphs + '\');">'
                + '<i class="fa fa-times"></i>'
                + '</a>'
                + '</div>'
                + '</div>'
                + '</div>'
                + '<div class="ibox-content" align="center">'
                + '<div id="' + canvasDivId + '">'
                + '<img id="' + loadChartGif + '" src="../assets/images/loading_slides.gif" style="float: left;"/>'
                + '<canvas id="' + canvasChartId + '" height="150" height="300"><canvas>'
                + '</div>'
                + '</div>'
                + '</div>'
                + '</div>';
        var tempHTML = $compile(newGraphBox)($scope); //Compile HTML to apply angular function.
        $("#userGraphs").prepend(tempHTML); // Append chart

        $(poundNewLoadChartGif).fadeIn(100);
        statusDiv.html($rootScope.toastrTranslate.MAKEGRAPH);
        var ctx2 = document.getElementById(canvasChartId).getContext("2d"); // get the Chart canvas element
        var chartTitle = '';

        //Code to get the chart API request params
        if (chartType === 'pie') {
            getChartDataReqParam = $scope.requestParams('pieChart', newCustomParam);
        } else {
            if ($scope.series == 'Single') {
                getChartDataReqParam = $scope.requestParams('singleChart', newCustomParam);
            } else {
                getChartDataReqParam = $scope.requestParams('multiChart', newCustomParam);
            }
        }
        
        
        if(searchFilterObj['rules'].length > 0){
            angular.forEach(searchFilterObj['rules'], function(val, key) {
                if(val.field != dateColumnToFilter)
                    getChartDataReqParam.filters.rules.push(val); // Update chart request filter with search filters.
            });
        }
        
        //console.log(chartType + ' Chart Request, Params: ', getChartDataReqParam);
        //Disable buttons in Analyze section till fetching Column
        $scope.isFetchingColumnData = true;
        //Generate random color to set in chart
        var charColors = ['#3366CC','#DC3912','#FF9900','#109618','#990099','#3B3EAC','#0099C6','#DD4477','#66AA00','#B82E2E','#316395','#994499','#22AA99','#AAAA11','#6633CC','#E67300','#8B0707','#329262','#5574A6','#3B3EAC',"#A6CEE3", "#1F78B4", "#B2DF8A", "#33A02C", "#FB9A99", "#E31A1C", "#FDBF6F", "#FF7F00", "#CAB2D6", "#6A3D9A", "#B4B482", "#B15928","#CEF6FF", "#47A0DC", "#DAFFB2", "#5BC854", "#FFC2C1", "#FF4244", "#FFE797", "#FFA728", "#F2DAFE", "#9265C2", "#DCDCAA", "#D98150"];
        
        //API request to get the chart data
        APIService.post('getgraphdata', getChartDataReqParam)
            .then(function(response) {
            var resData = response.data;
            if (response.data.hasOwnProperty("status") && response.data.status == "failure") {
                resData = [];
               toastr.warning($rootScope.toastrTranslate.NOGRAPHFOUND, $rootScope.toastrTranslate.ANALYZE);
            }
            $timeout(function() {
                $scope.isFetchingColumnData = false;
                //Render Pie chart
                if (chartType === 'pie') {
                    //Pie chart Optios
                    var chartOptions = {
                        responsive: true,
                        borderWidth: 2,
                        cutoutPercentage: 45,
                        animation: {
                            easing: "easeOutBounce",
                            animateRotate: true
                        }
                    };
                    
                    // Generate Data from API response
                    var pieData = resData.map(function(a) {
                        return a.value;
                    });
                    
                    // Generate chart labels from API response
                    var pieLabel = resData.map(function(a) {
                        return a.label;
                    });
                    
                    
                    // Generate chart title as per filter selection
                    if (newCustomParam.calculation == "Sum") {
                        chartTitle = newCustomParam.calculation + ' of ' + newCustomParam.measurement + ' by ' + newCustomParam.category
                    } else {
                        chartTitle = newCustomParam.calculation + ' ' + newCustomParam.measurement + ' by ' + newCustomParam.category;
                    }
                    
                    //Render chart
                    myChart = new Chart(ctx2, {
                                        type: 'doughnut',
                                        data: {
                                            datasets: [{
                                                    data: pieData,
                                                    backgroundColor: charColors
                                                }],
                                            labels: pieLabel
                                        },
                                        options: chartOptions
                                    });
                } else if (chartType === 'bar') { //Code to render bar chart
                    //Bar chart Options
                    var chartOptions = {
                        responsive: true
                    };
                    //fetch the list of lables from Bar chart data.
                    var barLabels = resData.map(function(a) {
                        return a.category;
                    });

                    if ($scope.series == 'Single') {
                        //Code to render single series bar chart

                        //fetch bars from bar data
                        var barData1 = resData.map(function(a) {
                            return a.line;
                        });
                        //generate bar chart data object
                        var barData = {
                            labels: barLabels,
                            datasets: [
                                {
                                    label: barLabels,
                                    backgroundColor: "rgba(26,179,148,0.5)",
                                    borderColor: "rgba(26,179,148,0.8)",
                                    hoverBackgroundColor: "rgba(26,179,148,0.75)",
                                    hoverBorderColor: "rgba(26,179,148,1)",
                                    data: barData1
                                }
                            ]
                        };
                        
                        //Generate the title for barchart accoeding to selected filters
                        if (newCustomParam.calculation == "Sum") {
                            chartTitle = newCustomParam.calculation + ' of ' + newCustomParam.measurement + ' by ' + newCustomParam.category;
                        } else {
                            chartTitle = newCustomParam.calculation + ' ' + newCustomParam.measurement + ' by ' + newCustomParam.category;
                        }
                    } else {
                        //render Multi series bar barChart code
                        //fetch bars from bar chart data
                        var barData1 = resData.map(function(a) {
                            return a.line1;
                        });
                        var barData2 = resData.map(function(a) {
                            return a.line2;
                        });
                        //generate Multi seris bar chart data object
                        var barData = {
                            labels: barLabels,
                            datasets: [
                                {
                                    label: newCustomParam.calculation + ' ' + newCustomParam.measurement,
                                    backgroundColor: "rgba(220,220,220,0.5)",
                                    borderColor: "rgba(220,220,220,0.8)",
                                    hoverBackgroundColor: "rgba(220,220,220,0.75)",
                                    hoverBorderColor: "rgba(220,220,220,1)",
                                    data: barData1
                                },
                                {
                                    label: newCustomParam.calculation2 + ' ' + newCustomParam.measurement2,
                                    backgroundColor: "rgba(26,179,148,0.5)",
                                    borderColor: "rgba(26,179,148,0.8)",
                                    hoverBackgroundColor: "rgba(26,179,148,0.75)",
                                    hoverBorderColor: "rgba(26,179,148,1)",
                                    data: barData2
                                }
                            ]
                        };
                        //create Multi series bar chart title according to selected filters.
                        if (newCustomParam.calculation == "Sum") {
                            chartTitle = newCustomParam.calculation + ' of ' + newCustomParam.measurement + '  -VS-  ' + newCustomParam.calculation2 + ' of ' + newCustomParam.measurement2;
                        } else {
                            chartTitle = newCustomParam.calculation + ' ' + newCustomParam.measurement + '  -VS-  ' + newCustomParam.calculation2 + ' ' + newCustomParam.measurement2;
                        }
                    }
                    
                    //Render bar chart
                    myChart = new Chart(ctx2, {
                        type: 'bar',
                        data: barData,
                        options: chartOptions
                    });
                } else if (chartType === 'line' || chartType === 'area') {
                    //Render Line/Area chart
                    var areafill = false; //define the chart request for area or line.
                    if (chartType === 'area') {
                        areafill = true;
                    }
                    //Chart options for area/line
                    var chartOptions = {
                        responsive: true,
                        borderWidth: 1,
                        lineTension: 0.4,
                        pointRadius: 4,
                        pointBorderWidth: 1,
                        pointHitRadius: 20
                    };
                    //Fetch lables from response chart data
                    var lineLabels = resData.map(function(a) {
                        return a.category;
                    });

                    if ($scope.series == 'Single') {
                        //Render single series line / area chart
                        //Fetch lines from response data
                        var lineData1 = resData.map(function(a) {
                            return a.line;
                        });
                        //generate chart data object
                        var lineData = {
                            labels: lineLabels,
                            datasets: [
                                {
                                    backgroundColor: "rgba(151,187,205,0.5)",
                                    borderColor: "rgba(151,187,205,1)",
                                    pointBackgroundColor: "rgba(26,179,148,0.8)",
                                    pointHoverBorderColor: "#fff",
                                    pointHoverBackgroundColor: "rgba(26,179,148,1)",
                                    data: lineData1,
                                    fill: areafill,
                                }
                            ]
                        };
                        //Create title for line /area chart according to selected filters.
                        if (newCustomParam.calculation == "Sum") {
                            chartTitle = newCustomParam.calculation + ' of ' + newCustomParam.measurement + ' by ' + newCustomParam.category;
                        } else {
                            chartTitle = newCustomParam.calculation + ' ' + newCustomParam.measurement + ' by ' + newCustomParam.category;
                        }
                    } else {
                        //Render multi series line / area chart
                        //fetch data for multi series line/area chart
                        var lineData1 = resData.map(function(a) {
                            return a.line1;
                        });
                        var lineData2 = resData.map(function(a) {
                            return a.line2;
                        });
                        //make chart data for multi series line/area chart
                        var lineData = {
                            labels: lineLabels,
                            datasets: [
                                {
                                    label: newCustomParam.calculation + ' ' + newCustomParam.measurement,
                                    backgroundColor: "rgba(220,220,220,0.5)",
                                    borderColor: "rgba(220,220,220,1)",
                                    pointBackgroundColor: "rgba(220,220,220,0.8)",
                                    pointBorderColor: "#fff",
                                    pointHighlightFill: "#fff",
                                    pointHighlightStroke: "rgba(220,220,220,1)",
                                    data: lineData1,
                                    fill: areafill,
                                },
                                {
                                    label: newCustomParam.calculation2 + ' ' + newCustomParam.measurement2,
                                    backgroundColor: "rgba(26,179,148,0.5)",
                                    borderColor: "rgba(26,179,148,1)",
                                    pointBackgroundColor: "rgba(26,179,148,0.8)",
                                    pointBorderColor: "#fff",
                                    pointHighlightFill: "#fff",
                                    pointHighlightStroke: "rgba(26,179,148,1)",
                                    data: lineData2,
                                    fill: areafill,
                                }
                            ]
                        };
                        //create chart title according to selected filters
                        if (newCustomParam.calculation == "Sum") {
                            chartTitle = newCustomParam.calculation + ' of ' + newCustomParam.measurement + '  -VS-  ' + newCustomParam.calculation2 + ' of ' + newCustomParam.measurement2;
                        } else {
                            chartTitle = newCustomParam.calculation + ' ' + newCustomParam.measurement + '  -VS-  ' + newCustomParam.calculation2 + ' ' + newCustomParam.measurement2;
                        }
                    }
                    
                    // Render line/area chart
                    myChart = new Chart(ctx2, {
                        type: 'line',
                        data: lineData,
                        options: chartOptions
                    });
                }
                statusDiv.html($rootScope.toastrTranslate.GRAPHCOMPLETE);
                angular.element('#' + loadChartGif).css("display", "none"); //Hide loader image
                angular.element('#' + newTitle).html(chartTitle); //Set title for the chart
            }, 2000);
        });

        //Filter all chart and grid by click on chart
        angular.element('#' + canvasChartId).click(function(evt) {
            var activePoints = myChart.getElementsAtEvent(evt);
            var firstPoint = activePoints[0];            
            if(!activePoints.length){
                return false;
            }
            var selectedLabel = myChart.data.labels[firstPoint._index];
            var myfilter = [{"field": category, "op": "eq", "data": selectedLabel}];
            $scope.renderChartGridOnFilter(myfilter);
            
        });
        countUserGraphs++;
    }
    
    //Function to delete/remove generated chart
    $scope.removeChart = function(chartId) {
        $('#chart_' + chartId).remove();
        delete customUserGraphParam[chartId];
    };

    // Function for full screen
    $scope.fullscreen = function (chartId) {
        $('body').toggleClass('fullscreen-ibox-mode');
        $('#chart_' + chartId + '> .ibox').toggleClass('fullscreen');
        setTimeout(function() {
            $(window).trigger('resize');
        }, 100);
    };
            

    //function to edit the chart
    $scope.editChart = function(chartId, chartType, isDateChange) {
        $timeout(function() {
            angular.element('#' + chartType + '-button').trigger('click'); //trigger click on specific chart button to refresh the chart filters
            $scope.isEditChart = true;

            //set Old chart filters to view in edit chart view.
            $scope.chartFilterCategory = customUserGraphParam[chartId].category;
            $scope.chartFilterMeasurement = customUserGraphParam[chartId].measurement;
            $scope.chartFilterCalculation = customUserGraphParam[chartId].calculation;
            $scope.chartFilterMeasurement2 = customUserGraphParam[chartId].measurement2;
            $scope.chartFilterCalculation2 = customUserGraphParam[chartId].calculation2;
            
            if(customUserGraphParam[chartId].series == 'Multi'){
                angular.element('#linktoShow' + chartType + 'MultiSeries').hide();
                angular.element('#' + chartType + 'MultiSeriesDiv').show();
            }
            else{
                angular.element('#linktoShow' + chartType + 'MultiSeries').show();
                angular.element('#' + chartType + 'MultiSeriesDiv').hide();
            }
            angular.element('#' + chartType + 'statusDiv').html(''); //clear status DIV
            angular.element('#custom' + chartType + 'Title').html('Edit ' + $filter('camelize')(chartType) + ' Graph');
            //Bind click event on chart create/preview button
            angular.element('#create' + chartType + 'Graph').on('click', function() {
                if ($scope.isEditChart) {
                    $scope.removeChart(chartId);
                }
                angular.element('#custom' + chartType + 'Title').html('Create Custom ' + $filter('camelize')(chartType) + ' Graph');
            });
            //when date change the chart will render with selected date ranges
            if (isDateChange) {
                angular.element('#create' + chartType + 'Graph').trigger('click');
            }
        }, 100);
    }

    //function to toggle the Multi seriese options.
    $scope.multiSeriesDivToggle = function(type) {
        $scope.chartFilterMeasurement2 = [];
        $scope.chartFilterCalculation2 = [];
        angular.element('#linktoShow' + type + 'MultiSeries').toggle();
        angular.element('#' + type + 'MultiSeriesDiv').toggle();
    }

    //Define date range lable date and ranges.
    $scope.datesRanges = {startDate: moment().subtract(30, 'day').format('MMMM D, YYYY'), endDate: moment().format('MMMM D, YYYY')};
    $scope.ranges = {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
    };
    
    //Define date range locale options
    $scope.locale = {
        'applyLabel': 'Submit',
        'cancelLabel': 'Cancel',
        'fromLabel': 'From',
        'toLabel': 'To',
        'customRangeLabel': 'Custom',
        'daysOfWeek': ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        'monthNames': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        'firstDay': 1
    }
    
    //Open date range filter on clicking on calender icon
    $scope.openDateRange = function(){
        angular.element('#daterange').click();
    }

    /**
     * Call on date change event,
     * Fetch the selected data and update the request filter with new data.
     * Render all the chart and data grid by API request with all selected filters.
     */
    angular.element('#daterange').on('apply.daterangepicker', function(ev, picker) {
        //fetch changed data from date picker
        selectedDates = {'start': picker.startDate.format('YYYYMMDD'), 'end': picker.endDate.format('YYYYMMDD')};
        //remove previous selected date from filter object
        angular.forEach(searchFilterObj['rules'], function(val, key) {
            if (val.field === dateColumnToFilter) {
                delete searchFilterObj['rules'][key];
            }
        })
        //Add current selected date in filter object
        searchFilterObj['rules'].push({"field": dateColumnToFilter, "op": "ge", "data": selectedDates.start});
        searchFilterObj['rules'].push({"field": dateColumnToFilter, "op": "le", "data": selectedDates.end});
        getGridDataParams = $scope.requestParams('dataGridOnDate', selectedDates); //generate grid API request param
        getGridDataParams.filters.rules = searchFilterObj['rules']; //Update grid request filter with updated filters.
        $scope.allFiltersObject.gridFilter = getGridDataParams; //add filter to grid filter.
        // console.log('Data Grid Request on Date change, Params: ', getGridDataParams);
        $scope.renderDataGrid(getGridDataParams); //render data grid with filters
        
        //Render all charts on date change
        var tempChartParam = [];
        var counter = 0;
        angular.forEach(customUserGraphParam, function(value, key) {
            tempChartParam.push(value);
        });
        //recursive call of chart edit function to render all chart with specific time interval
        function editChartOnDate() {
            $timeout(function() {
                $scope.editChart(tempChartParam[counter].id, tempChartParam[counter].type, true);
                counter++;
                if (counter < tempChartParam.length) {
                    editChartOnDate();
                }
            }, 3000);
        }
        if (customUserGraphParam.length > 0) {
            editChartOnDate()
        }
    });

    // DataGrid Code start
    //set data grid options
    $scope.dataGridOptions = {
        enableSorting: true,
        enableFiltering: true,
        paginationPageSizes: [25, 50, 75],
        paginationPageSize: 25,
        enableGridMenu: true,
        showColumnFooter: true,
        flatEntityAccess: true,
        fastWatch: true,
        enableColumnResizing: true,
        enableColumnReordering: true,
        onRegisterApi: function(gridApi) {
            $scope.gridApi = gridApi;
            $scope.gridApi.colMovable.on.columnPositionChanged($scope, saveUserdefienColumnOrder);
        }
    };
    
    //To store user define columns order in user preferences
    function saveUserdefienColumnOrder() {
        var state = $scope.gridApi.saveState.save(); // get updated columns
        $scope.savedColumns = [];
        angular.forEach(state.columns, function(val, index){
            $scope.savedColumns[index] = val.name; // gnerate simple arra for columns to store in redis
        })
        var colmnOrderPrefs = {"preference": currentPage+"_column_order", "value": JSON.stringify($scope.savedColumns)};
        UserPreferenceService.save(colmnOrderPrefs); //store columns with changed order
    }

    $scope.dataGridOptions.columnDefs = []; //define grid columns defination
    //add columns width
    $timeout(function() {
        $scope.setColumnDef();
    });
    $scope.setColumnDef = function() {
        if ($scope.columnList && $scope.columnList.length > 0 && $scope.orderedColumnList) {
            for (var i = 0; i < $scope.orderedColumnList.length; i++) {
                $scope.dataGridOptions.columnDefs.push({
                    field: $scope.orderedColumnList[i],
                    width: 150, maxWidth: 200, minWidth: 70
                });
            }
        } else {
            $timeout(function() {
                $scope.setColumnDef();
            }, 2000);
        }
    }

 
    //fetch grid data from static JSON    
    $scope.renderDataGrid = function(getGridDataParams) {
        toastr.warning(currentPage, $rootScope.toastrTranslate.RECEVING);
        APIService.post('getgriddata', getGridDataParams).then(function (resData) {
            if(resData.status == 200){
                if (resData) {
                    if (resData.data.hasOwnProperty("status")) {
                        $scope.dataGridOptions.data = [];
                    } else {
                        $scope.setGridData(resData.data);
                    }
                }
            }
            else{
                toastr.error($rootScope.toastrTranslate.WENTWRONG, $rootScope.toastrTranslate.LOGIN);
                return false;
            }
        });
    }
    
    $scope.setGridData = function(resData) {
        if ($scope.dataGridOptions.columnDefs.length > 0) {
            $scope.dataGridOptions.data = resData;
        } else {
            $timeout(function() {
                $scope.setGridData(resData);
            }, 3000);
        }
    }

    //Call render grid function on page load if page not saved page
    if (!$scope.isSavedPage) {
        $timeout(function() {
            getGridDataParams = $scope.requestParams('dataGridOnDate', selectedDates); //fetch API request param
            $scope.allFiltersObject.gridFilter = getGridDataParams;
            // console.log('Data Grid Request on Page load, Params: ', getGridDataParams);
            $scope.renderDataGrid(getGridDataParams); //call grid render function
        });
    }

    //Open the Pop up modal for save dashbord function
    $scope.openSaveDashModal = function(size) {
        $scope.items = $scope.currentPage;
        var modalInstance = $uibModal.open({
            templateUrl: 'saveDashModal.html',
            controller: 'ModalCtrl',
            size: size,
            resolve: {
                items: function() {
                    return $scope.items;
                }
            }
        });
        //Callback function to for modal button action.
        modalInstance.result.then(function(savedDashName) {
            $scope.saveDashboard(savedDashName);
        });
    };

    //generate chart and grrid on search filter apply and click on chart event
    $scope.renderChartGridOnFilter = function(filterObj) {
        getGridDataParams = $scope.requestParams('dataGridOnDate', selectedDates); //fetch request param for grid API

        //fill global filter object
        angular.forEach(filterObj, function(val, key) {
            searchFilterObj['rules'].push(val);
        });
        
        angular.forEach(searchFilterObj['rules'], function(val, key) {
            if(val.field != dateColumnToFilter)
                getGridDataParams.filters.rules.push(val); //assign all filters to grid request param
        });

        //remove previous selected date filters
        /*angular.forEach(getGridDataParams.filters.rules, function(val, key) {
            if (val.field === dateColumnToFilter && val.data === "") {
                delete getGridDataParams.filters.rules[key];
            }
        })*/
        $scope.allFiltersObject.gridFilter = getGridDataParams;
        // console.log('Data Grid Request on Apply Filter, Params: ', getGridDataParams);
        $scope.renderDataGrid(getGridDataParams); //render grid

        //Render all charts on date change
        var tempChartParam = [];
        var counter = 0;
        angular.forEach(customUserGraphParam, function(value, key) {
            tempChartParam.push(value);
        });
        function editChartOnFilter() {
            $timeout(function() {
                if (!$scope.isFetchingColumnData) {
                    $scope.editChart(tempChartParam[counter].id, tempChartParam[counter].type, true);
                    counter++;
                }
                if (counter < tempChartParam.length) {
                    editChartOnFilter();
                }
            }, 3000);
        }
        if (customUserGraphParam.length > 0) {
            editChartOnFilter()
        }
    }

    //Load HTML on search filter open
    $scope.loadSearchFilterHTML = function(objFilters, counter) {
        //assign old filter value to it's respected model
        $scope['culumnName' + numberofFilters] = objFilters.field;
        $scope['calculation' + numberofFilters] = objFilters.op;
        $scope['culumnValue' + numberofFilters] = objFilters.data;

        var categoryOptions = '<option selected="selected"></option>';
        angular.forEach($scope.columnList, function(value, key) {
            categoryOptions += '<option value="' + value.id + '">' + value.name + '</option>';
        });
        //make filter elements HTML
        var newFilterInputs = '<div id="colfilter_' + numberofFilters + '"><select ng-model="culumnName' + numberofFilters + '" id="column_name_' + numberofFilters + '" ng-change="filterchange(' + numberofFilters + ');">'
                + categoryOptions
                + '</select>'
                + '<select ng-model="calculation' + numberofFilters + '" id="calc_' + numberofFilters + '" ng-change="filterchange(' + numberofFilters + ');">'
                + '<option value="eq" selected="selected">{{"EQUAL" | translate}}</option>'
                + '<option value="ne">{{"NOTEQUAL" | translate}}</option>'
                + '<option value="lt"> < </option>'
                + '<option value="le"> <= </option>'
                + '<option value="gt"> > </option>'
                + '<option value="ge"> >= </option>'
                + '<option value="bw">{{"BEGINSWITH" | translate}}</option>'
                + '<option value="bn">{{"DOESNOTBEGINWITH" | translate}}</option>'
                + '<option value="ew">{{"ENDSWITH" | translate}}</option>'
                + '<option value="en">{{"DOESNOTENDWITH" | translate}}</option>'
                + '<option value="cn">{{"CONTAINS" | translate}}</option>'
                + '<option value="nc">{{"DOESNOTCONTAIN" | translate}}</option>'
                + '<option value="nu">{{"ISNULL" | translate}}</option>'
                + '<option value="nn">{{"ISNOTNULL" | translate}}</option>'
                + '<option value="in">{{"ISIN" | translate}}</option>'
                + '<option value="ni">{{"ISNOTIN" | translate}}</option>'
                + '</select>'
                + '<input type="text" ng-model="culumnValue' + numberofFilters + '" id="column_value_' + numberofFilters + '"  ng-change="filterchange(' + numberofFilters + ');" role="textbox" class="input-elm" style="width: 18%;">'
                + '<input type="button" value="-" ng-click="removeFilter(' + numberofFilters + ', \'#colfilter_' + numberofFilters + '\', \'#query_' + numberofFilters + '\')" title="Delete rule" class="delete-rule ui-del"></div>';
        var tempHTML = $compile(newFilterInputs)($scope);
        $("#tab1").append(tempHTML);

        //array for calculation keywords
        var calulationSymbols = {eq: " = ", ne: " <> ", lt: " < ", le: " <= ", gt: " > ", ge: " >= ", bw: " LIKE ", bn: " NOT LIKE ", in: " IN ", ni: " NOT IN ", ew: " LIKE ", en: " NOT LIKE ", cn: " LIKE ", nc: " NOT LIKE ", nu: " IS NULL ", nn: " IS NOT NULL "};

        var query = '<div id="query_' + numberofFilters + '"><font size=2>AND (' + objFilters.field + ' ' + calulationSymbols[objFilters.op] + ' "' + objFilters.data + '")</font></div>';
        if (counter == 0) {
            query = '<div id="query_' + numberofFilters + '"><font size=2>(' + objFilters.field + ' ' + calulationSymbols[objFilters.op] + ' "' + objFilters.data + '")</font></div>';
        }
        $("#query").append(query);
        numberofFilters++;
    }

    // emit the filterchange to call from modal controller
    $scope.filterchange = function(filterID) {
        $rootScope.$emit("filterchange", filterID);
    }

    // emit the removeFilter to call from modal controller
    $scope.removeFilter = function(id, filterDivID, queryDivID) {
        $rootScope.$emit("removeFilter", {id: id, filterDivID: filterDivID, queryDivID: queryDivID});
    }

    // Open the Pop up modal for save dashbord function
    $scope.openSearchFilterModal = function(size) {
        //code to load selected filter on filter pop up open
        searchFilterObj['rules'].removeNull(undefined);
        if (searchFilterObj['rules'].length > 0) {
            $timeout(function() {
                for (var i = 0; i < searchFilterObj['rules'].length; i++) {
                    $scope.loadSearchFilterHTML(searchFilterObj['rules'][i], i);
                    numberofFilters++;
                }
            }, 1000);
        }
        //Code to open search filter modal
        var modalInstance = $uibModal.open({
            templateUrl: 'searchFilterModal.html',
            controller: 'ModalCtrl',
            size: size,
            resolve: {
                items: function() {
                    return $scope.columnList;
                }
            }
        });
        //Callback function to for modal button action.
        modalInstance.result.then(function(filterObj) {
            $scope.renderChartGridOnFilter(filterObj);
        });
    };  
    
    //Prototype to remove the Null vlaue from the filter array
    Array.prototype.removeNull = function(deleteValue) {
        for (var i = 0; i < this.length; i++) {
            if (this[i] == deleteValue) {
                this.splice(i, 1);
                i--;
            }
        }
        return this;
    };
    
    // function for save the dashbord JSON data.
    $scope.saveDashboard = function(pageName) {
        $scope.allFiltersObject.pageid = savedPageId;
        $scope.allFiltersObject.userid = $scope.userArray.id;
        $scope.allFiltersObject.dashaction = 'save';
        if(savedPageId){
            $scope.allFiltersObject.dashaction = 'update';
        }
        $scope.allFiltersObject.pagename = currentPage;
        $scope.allFiltersObject.dashboard_title = pageName;
        $scope.allFiltersObject.dateColumnToFilter = dateColumnToFilter;
        customUserGraphParam.removeNull(undefined);
        $scope.allFiltersObject.chartFilter = customUserGraphParam;
        
        // console.log('Save Dashboard JSON data to store via API JSONData: ', $scope.allFiltersObject);
        APIService.post('savedashboard', $scope.allFiltersObject)
                .then(function(res) {
                if (res && res.data.status == 'success') {
                    toastr.clear();
                    if (savedPageId) {
                        toastr.success($rootScope.toastrTranslate.DASHBOARDUPDATED, $rootScope.toastrTranslate.ANALYZE);
                    } else {
                        $rootScope.savedDashMenuHTML.push({page: res.data.dashboard_title, id: res.data.pageid});
                        toastr.success($rootScope.toastrTranslate.DASHBOARDSAVED, $rootScope.toastrTranslate.ANALYZE);
                    }
                } else {
                    toastr.error($rootScope.toastrTranslate.WENTWRONG, $rootScope.toastrTranslate.ANALYZE);
                }
        });
    }
}) //analyzeController end -----------------------------------------


        //Controller for handle the modal actions
        .controller('ModalCtrl', function($scope, $uibModalInstance, $compile, $rootScope, items) {
    $scope.items = items;

    //Validate string with page.
    function validateCustomName(string) {
        var re = /^[a-zA-Z0-9_-\s]+$/;
        return re.test(string);
    }

    //function to handle save dashboard button click
    $scope.saveDashboard = function() {
        var validated = validateCustomName($scope.items);
        if (validated === true) {
            $uibModalInstance.close($scope.items);
        } else {
            toastr.error("Enter valid page name", "Analyze");
        }
    };

    //function to handle close button click
    $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };

    //code to add filters in search filter pop-up dynamicallyr numberofFilters = 0;
    $scope.addFilterInput = function() {
        var categoryOptions = '<option selected="selected"></option>';
        angular.forEach($scope.items, function(value, key) {
            categoryOptions += '<option value="' + value.id + '">' + value.name + '</option>';
        });
        //make filter elements HTML
        var newFilterInputs = '<div id="colfilter_' + numberofFilters + '"><select ng-model="culumnName' + numberofFilters + '" id="column_name_' + numberofFilters + '" ng-change="filterchange(' + numberofFilters + ');">'
                + categoryOptions
                + '</select>'
                + '<select ng-model="calculation' + numberofFilters + '" id="calc_' + numberofFilters + '" ng-change="filterchange(' + numberofFilters + ');">'
                + '<option value="eq" selected="selected">{{"EQUAL"|translate}}</option>'
                + '<option value="ne">{{"NOTEQUAL"|translate}}</option>'
                + '<option value="lt"> < </option>'
                + '<option value="le"> <= </option>'
                + '<option value="gt"> > </option>'
                + '<option value="ge"> >= </option>'
                + '<option value="bw">{{"BEGINSWITH"|translate}}</option>'
                + '<option value="bn">{{"DOESNOTBEGINWITH"|translate}}</option>'
                + '<option value="ew">{{"ENDSWITH"|translate}}</option>'
                + '<option value="en">{{"DOESNOTENDWITH"|translate}}</option>'
                + '<option value="cn">{{"CONTAINS"|translate}}</option>'
                + '<option value="nc">{{"DOESNOTCONTAIN"|translate}}</option>'
                + '<option value="nu">{{"ISNULL"|translate}}</option>'
                + '<option value="nn">{{"ISNOTNULL"|translate}}</option>'
                + '<option value="in">{{"ISIN"|translate}}</option>'
                + '<option value="ni">{{"ISNOTIN"|translate}}</option>'
                + '</select>'
                + '<input type="text" ng-model="culumnValue' + numberofFilters + '" id="column_value_' + numberofFilters + '"  ng-change="filterchange(' + numberofFilters + ');" role="textbox" class="input-elm" style="width: 18%;">'
                + '<input type="button" value="-" ng-click="removeFilter(' + numberofFilters + ', \'#colfilter_' + numberofFilters + '\', \'#query_' + numberofFilters + '\')" title="Delete rule" class="delete-rule ui-del"></div>';
        var tempHTML = $compile(newFilterInputs)($scope);
        $("#tab1").append(tempHTML);
        var query = '<div id="query_' + numberofFilters + '"><font size=2>AND (client_id = "")</font></div>';
        if (numberofFilters == 0) {
            query = '<div id="query_' + numberofFilters + '"><font size=2>(client_id = "")</font></div>';
        }
        $("#query").append(query);
        numberofFilters++;
    };

    //code to call filterchange function while filterchange emitted from parent controller.
    $rootScope.$on("filterchange", function(event, filterID) {
        $scope.filterchange(filterID);
    });

    //call function filter change event
    $scope.filterchange = function(filterID)
    {
        var column_name = angular.element('#column_name_' + filterID).val(); //get columns name
        var column_value = angular.element('#column_value_' + filterID).val(); //get column value
        var selectCalc = 'eq'; //set default calculation value
        if (angular.element('#calc_' + filterID).val().length == 2) {
            selectCalc = angular.element('#calc_' + filterID).val();
        }

        //array for calculation keywords
        var calulationSymbols = {eq: " = ", ne: " <> ", lt: " < ", le: " <= ", gt: " > ", ge: " >= ", bw: " LIKE ", bn: " NOT LIKE ", in: " IN ", ni: " NOT IN ", ew: " LIKE ", en: " NOT LIKE ", cn: " LIKE ", nc: " NOT LIKE ", nu: " IS NULL ", nn: " IS NOT NULL "};

        //generate query from selected filters
        if (filterID == 0) {
            angular.element("#query_" + filterID + "").html('<font size=2>(' + column_name + ' ' + calulationSymbols[selectCalc] + ' "' + column_value + '")</font>');
        } else {
            angular.element("#query_" + filterID + "").html('<font size=2>AND (' + column_name + ' ' + calulationSymbols[selectCalc] + ' "' + column_value + '")</font>');
        }
    }

    //code to call remove filter function while removeFilter emitted from parent controller.
    $rootScope.$on("removeFilter", function(event, args) {
        $scope.removeFilter(args.id, args.filterDivID, args.queryDivID);
    });

    //Call function on remove filter
    $scope.removeFilter = function(id, filterDivID, queryDivID) {
        //remove filter query and inputs from HTML
        $(filterDivID).remove();
        $(queryDivID).remove();
        //clear all models, created with filter inputs
        $scope['culumnName' + id] = '';
        $scope['calculation' + id] = '';
        $scope['culumnValue' + id] = '';

        var i = 0;
        while (i < numberofFilters) {
            if (document.getElementById("colfilter_" + i + "")) {
                var column_name = angular.element('#column_name_' + i).val();
                var column_value = angular.element('#column_value_' + i).val();
                var selectCalc = 'eq';
                if (angular.element('#calc_' + i).val().length == 2) {
                    selectCalc = angular.element('#calc_' + i).val();
                }
                //calculation keyword array
                var calulationSymbols = {eq: " = ", ne: " <> ", lt: " < ", le: " <= ", gt: " > ", ge: " >= ", bw: " LIKE ", bn: " NOT LIKE ", in: " IN ", ni: " NOT IN ", ew: " LIKE ", en: " NOT LIKE ", cn: " LIKE ", nc: " NOT LIKE ", nu: " IS NULL ", nn: " IS NOT NULL "};
                //make query from selected filters
                angular.element("#query_" + i + "").html('<font size=2>(' + column_name + ' ' + calulationSymbols[selectCalc] + ' "' + column_value + '")</font>');
                i = numberofFilters;
            }
            i++;
        }
        //set 0 to number of filter if there is no more filters
        if (angular.element('#query').html().length == 0) {
            numberofFilters = 0;
        }
    }

    //function to clear/reset all the selected filters
    $scope.clearFilters = function() {
        var i = 0;
        while (i < numberofFilters) {
            if (angular.element("#colfilter_" + i)) {
                $("#colfilter_" + i).remove();
                $("#query_" + i).remove();
                $scope['culumnName' + i] = '';
                $scope['calculation' + i] = '';
                $scope['culumnValue' + i] = '';
            }
            i++;
        }
        numberofFilters = 0;
        $scope.applyFilters();
    }

    //call function on apply filter button click
    var searchFilterObjLocal = [];
    $scope.applyFilters = function() {
        searchFilterObj = {groupOp: "AND", rules: []};
        var i = 0;
        //fetch all the selected filters and generate object
        while (i < numberofFilters) {
            if ($('#column_name_' + i).val() && $('#calc_' + i).val() && $('#column_value_' + i).val()) {
                searchFilterObjLocal.push({"field": $('#column_name_' + i).val(), "op": $('#calc_' + i).val(), "data": $('#column_value_' + i).val()});
            }
            i++;
        }
        $uibModalInstance.close(searchFilterObjLocal); //close the modal and pass filter object to modal callback function
    }
});
/**
 * Agent controller to handle agent page related methods
 * Ravi - 11-July-2017
 */

'use strict';


function AgentCtrl($scope, APIService, $filter, $uibModal, $rootScope, $http) {
    var customerName = $rootScope.userProfile.customer.name;

    $scope.showSidebar = false;
    $scope.connectionTags = [];
    $scope.sourceSystemButton = {}; //defined a model object
    var allTags = [];
    
    //To fetch agent data
    APIService.getAgentList(customerName).then(function(response){
        $rootScope.agentListObj = $rootScope.agentListObj || response.data.agents;
        $scope.agentMetaData = response.data.metadata;

        //Set logo based on EHR
        angular.forEach($rootScope.agentListObj, function(obj, index){
            obj.index = index;
            //Count the statuses to display in the summary
            obj.statusCount = {};
            angular.forEach(obj.qcresult, function(qcresult){
                obj.statusCount[qcresult.status] = increment(obj.statusCount[qcresult.status]);
            });

            //Set logo based on EHR if no logo is included from MC
            if (obj.logo) {
                //do nothing
            }
            else if (obj.emr_name) {
                switch (obj.emr_name.toLowerCase()) {
                    case 'advancedmd':
                        obj.logo = "/img/advancedmd.png";
                        break;
                    case 'allscripts pm':
                        obj.logo = "/img/allscripts.jpg";
                        break;
                    case 'allscripts pro':
                        obj.logo = "/img/allscripts.jpg";
                        break;
                    case 'allscripts touchworks':
                        obj.logo = "/img/allscripts.jpg";
                        break;
                    case 'altapoint':
                        obj.logo = "/img/altapoint.png";
                        break;
                    case 'amazing charts':
                        obj.logo = "/img/amazingcharts.png";
                        break;
                    case 'ams':
                        obj.logo = "/img/ams.png";
                        break;
                    case 'aprima':
                        obj.logo = "/img/aprima.png";
                        break;
                    case 'athena':
                        obj.logo = "/img/athena.jpg";
                        break;
                    case 'centricity':
                        obj.logo = "/img/centricity.png";
                        break;
                    case 'chart logic':
                        obj.logo = "/img/chart-logic.png";
                        break;
                    case 'drchrono':
                        obj.logo = "/img/drchrono.png";
                        break;
                    case 'eaglesoft':
                        obj.logo = "/img/eaglesoft.jpg";
                        break;
                    case 'eclinicalworks':
                        obj.logo = "/img/eclinicalworks.png";
                        break;
                    case 'emds':
                        obj.logo = "/img/emds.png";
                        break;
                    case 'epic':
                        obj.logo = "/img/epic.png";
                        break;
                    case 'exscribe':
                        obj.logo = "/img/exscribe.png";
                        break;
                    case 'glostream':
                        obj.logo = "/img/glostream.png";
                        break;
                    case 'greenway':
                        obj.logo = "/img/greenway.svg";
                        break;
                    case 'intergy':
                        obj.logo = "/img/intergy.png";
                        break;
                    case 'luna':
                        obj.logo = "/img/luna.png";
                        break;
                    case 'mckesson integreat':
                        obj.logo = "/img/mckesson-medisoft.svg";
                        break;
                    case 'mckesson medisoft':
                        obj.logo = "/img/mckesson-medisoft.svg";
                        break;
                    case 'mckesson practicepartner':
                        obj.logo = "/img/mckesson-medisoft.svg";
                        break;
                    case 'meditab':
                        obj.logo = "/img/meditab.png";
                        break;
                    case 'meditech':
                        obj.logo = "/img/meditech.png";
                        break;
                    case 'medent':
                        obj.logo = "/img/medent.png";
                        break;
                    case 'misys tiger':
                        obj.logo = "/img/misys-tiger.png";
                        break;
                    case 'nextgen':
                        obj.logo = "/img/nextgen.png";
                        break;
                    case 'opacs':
                        obj.logo = "/img/opacs.jpg";
                        break;
                    case 'pds cortex':
                        obj.logo = "/img/pds-cortex.png";
                        break;
                    case 'phoenix ortho':
                        obj.logo = "/img/phoenix-ortho.gif";
                        break;
                    case 'soapware':
                        obj.logo = "/img/soapware.jpg";
                        break;
                    case 'srs soft':
                        obj.logo = "/img/srs-soft.png";
                        break;
                    case 'sti':
                        obj.logo = "/img/sti.png";
                        break;
                    case 'systemmedex':
                        obj.logo = "/img/systemmedex.jpg";
                        break;
                    case 'urochartehr':
                        obj.logo = "/img/urochartehr.png";
                        break;
                    default:
                        obj.logo = "/img/header-profile-skin-3.png";
                }
            } else {
                obj.logo = "/img/header-profile-skin-3.png";
            }

            if(!obj.hasOwnProperty('tag')){
                obj.tag = [];
            }

            if(obj.status !== ""){
                allTags.push(obj.status);
                if ($scope.connectionTags.indexOf(obj.status) === -1) {
                    $scope.connectionTags.push(obj.status);
                }
            }

            angular.forEach(obj.tag, function (tag, index) {
                var tag = (tag.hasOwnProperty('text')) ? tag.text : tag;
                allTags.push(tag);
                if ($scope.connectionTags.indexOf(tag) === -1) {
                    $scope.connectionTags.push(tag);
                }
            })
        });

        $scope.agents = $rootScope.agentListObj;
        $scope.totalagents = Object.keys($rootScope.agentListObj).length;

        function increment(num) {
            if (num) {
                return num + 1;
            }
            return 1;
        }
    })
    
    $scope.loadTags = function (query) {
        return $scope.connectionTags;
    };

    // Toggle the tag selection and add selected tag in JSON object
    var selTags = [];
    $scope.filterAgent = function(selTag){
        if(selTags.indexOf(selTag) === -1){
            selTags.push(selTag);
            angular.element('.taggin-' + selTag).css({'background-color': '#1ab394', 'color': '#ffffff'});
        }else {
            selTags.splice(selTags.indexOf(selTag), 1);
            angular.element('.taggin-'+selTag).css({'background-color' : '#f3f3f4', 'color' : '#676a6c'});
        }
        
        if(!$scope.connectionTags.length){
            selTags = [];
        }
        tagFilter();
    }
    
    // To filter the connection JSON object based on tag selection
    function tagFilter(){
        $scope.agents = [];
        if (selTags.length > 0) {
            $rootScope.agentListObj.filter(function(agent, key){
                agent.tag.filter(function(tag, i){
                    if(selTags.indexOf(tag.text) !== -1 || selTags.indexOf(tag) !== -1){
                        if($scope.agents.indexOf(agent) === -1){
                            $scope.agents.push(agent);
                        }
                    }
                })
                if (selTags.indexOf(agent.status) !== -1) {
                    if ($scope.agents.indexOf(agent) === -1) {
                        $scope.agents.push(agent);
                    }
                }
            })
        } else {
            $scope.agents = $rootScope.agentListObj;
        }
        if ($scope.agents.indexOf($scope.agentDetails) === -1) {
            $scope.showSidebar = false;
        }
        $scope.totalagents = Object.keys($scope.agents).length;
    }
    
    // Filter agent list based on serch text
    $scope.searchAgent = function() {
        var search = $scope.searchText;
        $scope.agents = $filter("filter")($rootScope.agentListObj, search);
        $scope.showSidebar = false;
    };

    $scope.getSchedule = function(agentid, agentcode, extract) {
        //I couldn't use the API Service because that caches the results
        $http.get('https://api.healthjump.com/partner/jsemrsettings/' + agentcode + '/' + agentid + '/queries/' + extract.id, {cache: false}).then(function(response){
            extract.last_execution_time = response.data.last_execution_time;
            extract.execution_interval = response.data.execution_interval;
        });
    };

    $scope.updateSchedule = function(agentid, agentcode, extract) {
        var updateSchedulePutData = {"execution_interval": extract.execution_interval, "active_ind": extract.active_ind};
        APIService.put('partner/jsemrsettings/' + agentcode + '/' + agentid + '/queries/' + extract.id, updateSchedulePutData).then(function(response){
            extract.last_execution_time = response.data.last_execution_time;
            extract.execution_interval = response.data.execution_interval;
            toastr.success('Schedule updated!', 'Success');
        });
    };
    
    // To set selected agent details in sidebar
    $scope.loadAgentDetails = function(agent){
        // Hack to get the buttons to activate and deactivate properly when opening the side bar
        var buttons = document.querySelectorAll(".source-system-button");
        buttons.forEach(function(element) {
          element.classList.remove("active");
        });

        if(!$scope.sourceSystemButton.selected) {
            $scope.sourceSystemButton.selected = 'details';  //if the user hasn't clicked a button yet, default to info
        }

        var btn = document.getElementById(agent.index + '-' + $scope.sourceSystemButton.selected);

        btn.classList.add("active");
        // End of hack

        $scope.showSidebar = true;
        $scope.fetchingDetails = true;
        $scope.agentDetails = agent;

        //Get list of extracts for the agent selected
        //TODO: add functionality to get extracts for cloud systems and ja_feed_queries
        APIService.getJSEMRSettings(customerName, agent.agentcode).then(function (response) {
            $scope.agentDetails.extract_elements = response.data;
        })
        
        //Fetch Assembla tickets based on Client ID using Laravel API
        APIService.get('partner/ticket/tag/' + agent.agentcode).then(function(response){
            $scope.fetchingDetails = false;
            if (response && response.status == 200) {
                //Fetch existing ticket numbers
                var ticketIds = $scope.agentDetails.tickets.map(function (item) {
                    return item.id
                });
                //Push fetched ticket to Ticket array
                angular.forEach(response.data, function (ticket, index) {
                    if (ticketIds.indexOf(ticket.number) == -1) {
                        var addedTicket = {id: ticket.number, date: ticket.created_on, ticketsubject: ticket.summary, ticketcontent: ticket.description};
                        $scope.agentDetails.tickets.unshift(addedTicket);
                    }
                })
            }
        })
    }
    
    //Function to Add tag by requesting Laravel API
    $scope.addNewTag = function(tag){
        allTags.push(tag.text);
        if ($scope.connectionTags.indexOf(tag.text) === -1) {
            $scope.connectionTags.push(tag.text);
        }
        var addTagPostRequest = {"agentcode": $scope.agentDetails.agentcode, "tag": tag.text};
        APIService.post('partner/tag', addTagPostRequest).then(function(response){})
    }
    
    //Function to remove tag by requesting Laravel API
    $scope.removeTag = function(tag){
        allTags.splice(allTags.indexOf(tag.text), 1);
        $scope.connectionTags = [];
        angular.forEach(allTags, function(tag, index){
            if ($scope.connectionTags.indexOf(tag) === -1) {
                $scope.connectionTags.push(tag);
            }
        })
        if($scope.connectionTags.indexOf(tag.text) === -1){
            selTags.splice(selTags.indexOf(tag.text), 1);
        }
        tagFilter();
        var removeTagPostRequest = {"agentcode": $scope.agentDetails.agentcode, "tag": tag.text};
        APIService.remove('partner/tag', removeTagPostRequest).then(function(response){})
    }
    
    //To open the Add / Edit ticket modal pop-up 
    $scope.openAddTicketModal = function(index){
        $uibModal.open({
            templateUrl: 'app/views/common/addTicketModal.html',
            controller: agentModalInstanceCtrl,
            scope: $scope
        });
    }
    
    //To fetch ticket details and comments and open modal pop-upaddTicketComment
    $scope.openViewTicketModal = function(ticket){
        $scope.selectedTicket = {};
        $uibModal.open({
            templateUrl: 'app/views/common/modalViewTicket.html',
            controller: agentModalInstanceCtrl,
            scope: $scope
        });
        
        APIService.get('partner/ticket/' + ticket.id).then(function(response){
            if(response.data.ticket.status == 200){
                $scope.selectedTicket = {
                    ticket: response.data.ticket.content,
                    comments: (response.data.comments.length) ? response.data.comments : [],
                    id: ticket.id
                };
            }else{
               toastr.clear();
               toastr.error($rootScope.toastrTranslate.WENTWRONG, $rootScope.toastrTranslate.AGENT); 
            }
        })
    }
    
    $scope.updateExtract = function(extract){
        var requestParam = {'value': extract.active_ind};
        APIService.put('partner/jsemrsettings/' + extract['id'], requestParam).then(function(response){});
    }
}

// agent modal instance controller to handle all modal events
function agentModalInstanceCtrl($scope, $uibModalInstance, APIService, $rootScope){
    var customerName = $rootScope.userProfile.customer.name;
    $scope.ok = function () {
        $uibModalInstance.close();
    };
    $scope.cancel = function () {
        $scope.$parent.ticketsubject = '';
        $scope.$parent.ticketcontent = '';
        $uibModalInstance.dismiss('cancel');
    };
    
    //To Add assembla ticket via Larave API
    $scope.addTicket = function(){
        $scope.isProcessing = true;
        var agentCode = ($scope.$parent.agentDetails) ? $scope.$parent.agentDetails.agentcode : '';
        var priority = $scope.$parent.priority || 3;
        var description = ($scope.$parent.ticketcontent) ? $scope.$parent.ticketcontent.replace(/<\/p>/gi, "\n").replace(/<br\/?>/gi, "\n").replace(/<\/?[^>]+(>|$)/g, "") : "";
        var postData = {"summary": $scope.$parent.ticketsubject, "description": description, "priority": priority, "tags": [agentCode, customerName, $rootScope.userProfile.email] };
        
        APIService.post('partner/ticket', postData).then(function(response){
            toastr.clear();
            
            if(response.data.status == 200 || response.data.status == 201 || response.data.status == 204){
                cache.remove(APIBase + 'partner/ticket/tag/' + agentCode);
                cache.remove(APIBase + 'partner/ticket/tag/' + customerName);
                
                if($scope.$parent.ticketsubject == 'Invitation sent'){
                    toastr.success($rootScope.toastrTranslate.INVITATIONSENT, $rootScope.toastrTranslate.HOME);
                    var meailData = {receiver_email: $scope.$parent.recipientemail, subject: 'Invitation sent', msg: $scope.$parent.ticketcontent};
                    APIService.post('email', meailData).then(function(response){});
                }else if($scope.$parent.ticketsubject == 'Contact CSM'){
                    toastr.success($rootScope.toastrTranslate.MESSAGESENT, $rootScope.toastrTranslate.HOME);
                }else{
                    toastr.success($rootScope.toastrTranslate.TICKETADDED, $rootScope.toastrTranslate.AGENT);
                }
                
                var ticket = response.data.content;
                var addedTicket = {id: ticket.number, date: ticket.created_on, ticketsubject: ticket.summary, ticketcontent: ticket.description};
                
                if($scope.$parent.agentDetails){
                    $scope.$parent.agentDetails.tickets.unshift(addedTicket);
                }else{
                    switch (priority) {
                        case 1:
                        case 2:
                            $scope.$parent.tickets.high.unshift(ticket);
                            $scope.$parent.ticketsubjectHigh = '';
                            break;
                        case 3:
                            $scope.$parent.tickets.normal.unshift(ticket);
                            $scope.$parent.ticketsubjectNew = '';
                            break;
                        case 4:
                        case 5:
                            $scope.$parent.tickets.low.unshift(ticket);
                            $scope.$parent.ticketsubjectLow = '';
                            break;
                    }
                }
            }else{
                toastr.error($rootScope.toastrTranslate.WENTWRONG, $rootScope.toastrTranslate.AGENT);
            }
            
            $scope.isProcessing = false;
            $scope.$parent.ticketsubject = '';
            $scope.$parent.ticketcontent = '';
            $scope.$parent.recipientemail = '';
            $scope.ok();
        })
    }
    
    //Post request to Laravel API to add comment
    $scope.addTicketComment = function(){
        $scope.isProcessing = true;
        var postData = {"comment": $scope.$parent.ticketcomment, "ticket_id": $scope.$parent.selectedTicket.id}
        APIService.post('partner/ticket/comment/'+postData.ticket_id, postData).then(function(response){
            toastr.clear();
            cache.remove(APIBase + 'partner/ticket/' + $scope.$parent.selectedTicket.id);
            if(response.data.status == 200 || response.data.status == 201 || response.data.status == 204){
                toastr.success($rootScope.toastrTranslate.COMMENTADDED, $rootScope.toastrTranslate.AGENT);
                $scope.$parent.selectedTicket.comments.unshift(response.data.content);
            }else{
                toastr.error($rootScope.toastrTranslate.WENTWRONG, $rootScope.toastrTranslate.AGENT);
            }
            $scope.$parent.ticketcomment = '';
            $scope.isProcessing = false;
        })
    }
}
        
        
angular.module('inspinia')
        .controller('AgentCtrl', AgentCtrl)
        .controller('agentModalInstanceCtrl', agentModalInstanceCtrl);
/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(a){"use strict";var b=a.fn.jquery.split(" ")[0].split(".");if(b[0]<2&&b[1]<9||1==b[0]&&9==b[1]&&b[2]<1||b[0]>3)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")}(jQuery),+function(a){"use strict";function b(){var a=document.createElement("bootstrap"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}a.fn.emulateTransitionEnd=function(b){var c=!1,d=this;a(this).one("bsTransitionEnd",function(){c=!0});var e=function(){c||a(d).trigger(a.support.transition.end)};return setTimeout(e,b),this},a(function(){a.support.transition=b(),a.support.transition&&(a.event.special.bsTransitionEnd={bindType:a.support.transition.end,delegateType:a.support.transition.end,handle:function(b){if(a(b.target).is(this))return b.handleObj.handler.apply(this,arguments)}})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var c=a(this),e=c.data("bs.alert");e||c.data("bs.alert",e=new d(this)),"string"==typeof b&&e[b].call(c)})}var c='[data-dismiss="alert"]',d=function(b){a(b).on("click",c,this.close)};d.VERSION="3.3.7",d.TRANSITION_DURATION=150,d.prototype.close=function(b){function c(){g.detach().trigger("closed.bs.alert").remove()}var e=a(this),f=e.attr("data-target");f||(f=e.attr("href"),f=f&&f.replace(/.*(?=#[^\s]*$)/,""));var g=a("#"===f?[]:f);b&&b.preventDefault(),g.length||(g=e.closest(".alert")),g.trigger(b=a.Event("close.bs.alert")),b.isDefaultPrevented()||(g.removeClass("in"),a.support.transition&&g.hasClass("fade")?g.one("bsTransitionEnd",c).emulateTransitionEnd(d.TRANSITION_DURATION):c())};var e=a.fn.alert;a.fn.alert=b,a.fn.alert.Constructor=d,a.fn.alert.noConflict=function(){return a.fn.alert=e,this},a(document).on("click.bs.alert.data-api",c,d.prototype.close)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof b&&b;e||d.data("bs.button",e=new c(this,f)),"toggle"==b?e.toggle():b&&e.setState(b)})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.isLoading=!1};c.VERSION="3.3.7",c.DEFAULTS={loadingText:"loading..."},c.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),setTimeout(a.proxy(function(){d[e](null==f[b]?this.options[b]:f[b]),"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c).prop(c,!0)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c).prop(c,!1))},this),0)},c.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")?(c.prop("checked")&&(a=!1),b.find(".active").removeClass("active"),this.$element.addClass("active")):"checkbox"==c.prop("type")&&(c.prop("checked")!==this.$element.hasClass("active")&&(a=!1),this.$element.toggleClass("active")),c.prop("checked",this.$element.hasClass("active")),a&&c.trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active")),this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=b,a.fn.button.Constructor=c,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(c){var d=a(c.target).closest(".btn");b.call(d,"toggle"),a(c.target).is('input[type="radio"], input[type="checkbox"]')||(c.preventDefault(),d.is("input,button")?d.trigger("focus"):d.find("input:visible,button:visible").first().trigger("focus"))}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(b){a(b.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(b.type))})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.carousel"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),g="string"==typeof b?b:f.slide;e||d.data("bs.carousel",e=new c(this,f)),"number"==typeof b?e.to(b):g?e[g]():f.interval&&e.pause().cycle()})}var c=function(b,c){this.$element=a(b),this.$indicators=this.$element.find(".carousel-indicators"),this.options=c,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on("keydown.bs.carousel",a.proxy(this.keydown,this)),"hover"==this.options.pause&&!("ontouchstart"in document.documentElement)&&this.$element.on("mouseenter.bs.carousel",a.proxy(this.pause,this)).on("mouseleave.bs.carousel",a.proxy(this.cycle,this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=600,c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0,keyboard:!0},c.prototype.keydown=function(a){if(!/input|textarea/i.test(a.target.tagName)){switch(a.which){case 37:this.prev();break;case 39:this.next();break;default:return}a.preventDefault()}},c.prototype.cycle=function(b){return b||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(a.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(a){return this.$items=a.parent().children(".item"),this.$items.index(a||this.$active)},c.prototype.getItemForDirection=function(a,b){var c=this.getItemIndex(b),d="prev"==a&&0===c||"next"==a&&c==this.$items.length-1;if(d&&!this.options.wrap)return b;var e="prev"==a?-1:1,f=(c+e)%this.$items.length;return this.$items.eq(f)},c.prototype.to=function(a){var b=this,c=this.getItemIndex(this.$active=this.$element.find(".item.active"));if(!(a>this.$items.length-1||a<0))return this.sliding?this.$element.one("slid.bs.carousel",function(){b.to(a)}):c==a?this.pause().cycle():this.slide(a>c?"next":"prev",this.$items.eq(a))},c.prototype.pause=function(b){return b||(this.paused=!0),this.$element.find(".next, .prev").length&&a.support.transition&&(this.$element.trigger(a.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){if(!this.sliding)return this.slide("next")},c.prototype.prev=function(){if(!this.sliding)return this.slide("prev")},c.prototype.slide=function(b,d){var e=this.$element.find(".item.active"),f=d||this.getItemForDirection(b,e),g=this.interval,h="next"==b?"left":"right",i=this;if(f.hasClass("active"))return this.sliding=!1;var j=f[0],k=a.Event("slide.bs.carousel",{relatedTarget:j,direction:h});if(this.$element.trigger(k),!k.isDefaultPrevented()){if(this.sliding=!0,g&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var l=a(this.$indicators.children()[this.getItemIndex(f)]);l&&l.addClass("active")}var m=a.Event("slid.bs.carousel",{relatedTarget:j,direction:h});return a.support.transition&&this.$element.hasClass("slide")?(f.addClass(b),f[0].offsetWidth,e.addClass(h),f.addClass(h),e.one("bsTransitionEnd",function(){f.removeClass([b,h].join(" ")).addClass("active"),e.removeClass(["active",h].join(" ")),i.sliding=!1,setTimeout(function(){i.$element.trigger(m)},0)}).emulateTransitionEnd(c.TRANSITION_DURATION)):(e.removeClass("active"),f.addClass("active"),this.sliding=!1,this.$element.trigger(m)),g&&this.cycle(),this}};var d=a.fn.carousel;a.fn.carousel=b,a.fn.carousel.Constructor=c,a.fn.carousel.noConflict=function(){return a.fn.carousel=d,this};var e=function(c){var d,e=a(this),f=a(e.attr("data-target")||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""));if(f.hasClass("carousel")){var g=a.extend({},f.data(),e.data()),h=e.attr("data-slide-to");h&&(g.interval=!1),b.call(f,g),h&&f.data("bs.carousel").to(h),c.preventDefault()}};a(document).on("click.bs.carousel.data-api","[data-slide]",e).on("click.bs.carousel.data-api","[data-slide-to]",e),a(window).on("load",function(){a('[data-ride="carousel"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery),+function(a){"use strict";function b(b){var c,d=b.attr("data-target")||(c=b.attr("href"))&&c.replace(/.*(?=#[^\s]+$)/,"");return a(d)}function c(b){return this.each(function(){var c=a(this),e=c.data("bs.collapse"),f=a.extend({},d.DEFAULTS,c.data(),"object"==typeof b&&b);!e&&f.toggle&&/show|hide/.test(b)&&(f.toggle=!1),e||c.data("bs.collapse",e=new d(this,f)),"string"==typeof b&&e[b]()})}var d=function(b,c){this.$element=a(b),this.options=a.extend({},d.DEFAULTS,c),this.$trigger=a('[data-toggle="collapse"][href="#'+b.id+'"],[data-toggle="collapse"][data-target="#'+b.id+'"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};d.VERSION="3.3.7",d.TRANSITION_DURATION=350,d.DEFAULTS={toggle:!0},d.prototype.dimension=function(){var a=this.$element.hasClass("width");return a?"width":"height"},d.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var b,e=this.$parent&&this.$parent.children(".panel").children(".in, .collapsing");if(!(e&&e.length&&(b=e.data("bs.collapse"),b&&b.transitioning))){var f=a.Event("show.bs.collapse");if(this.$element.trigger(f),!f.isDefaultPrevented()){e&&e.length&&(c.call(e,"hide"),b||e.data("bs.collapse",null));var g=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded",!0),this.$trigger.removeClass("collapsed").attr("aria-expanded",!0),this.transitioning=1;var h=function(){this.$element.removeClass("collapsing").addClass("collapse in")[g](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return h.call(this);var i=a.camelCase(["scroll",g].join("-"));this.$element.one("bsTransitionEnd",a.proxy(h,this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])}}}},d.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var b=a.Event("hide.bs.collapse");if(this.$element.trigger(b),!b.isDefaultPrevented()){var c=this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",!1),this.$trigger.addClass("collapsed").attr("aria-expanded",!1),this.transitioning=1;var e=function(){this.transitioning=0,this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")};return a.support.transition?void this.$element[c](0).one("bsTransitionEnd",a.proxy(e,this)).emulateTransitionEnd(d.TRANSITION_DURATION):e.call(this)}}},d.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()},d.prototype.getParent=function(){return a(this.options.parent).find('[data-toggle="collapse"][data-parent="'+this.options.parent+'"]').each(a.proxy(function(c,d){var e=a(d);this.addAriaAndCollapsedClass(b(e),e)},this)).end()},d.prototype.addAriaAndCollapsedClass=function(a,b){var c=a.hasClass("in");a.attr("aria-expanded",c),b.toggleClass("collapsed",!c).attr("aria-expanded",c)};var e=a.fn.collapse;a.fn.collapse=c,a.fn.collapse.Constructor=d,a.fn.collapse.noConflict=function(){return a.fn.collapse=e,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(d){var e=a(this);e.attr("data-target")||d.preventDefault();var f=b(e),g=f.data("bs.collapse"),h=g?"toggle":e.data();c.call(f,h)})}(jQuery),+function(a){"use strict";function b(b){var c=b.attr("data-target");c||(c=b.attr("href"),c=c&&/#[A-Za-z]/.test(c)&&c.replace(/.*(?=#[^\s]*$)/,""));var d=c&&a(c);return d&&d.length?d:b.parent()}function c(c){c&&3===c.which||(a(e).remove(),a(f).each(function(){var d=a(this),e=b(d),f={relatedTarget:this};e.hasClass("open")&&(c&&"click"==c.type&&/input|textarea/i.test(c.target.tagName)&&a.contains(e[0],c.target)||(e.trigger(c=a.Event("hide.bs.dropdown",f)),c.isDefaultPrevented()||(d.attr("aria-expanded","false"),e.removeClass("open").trigger(a.Event("hidden.bs.dropdown",f)))))}))}function d(b){return this.each(function(){var c=a(this),d=c.data("bs.dropdown");d||c.data("bs.dropdown",d=new g(this)),"string"==typeof b&&d[b].call(c)})}var e=".dropdown-backdrop",f='[data-toggle="dropdown"]',g=function(b){a(b).on("click.bs.dropdown",this.toggle)};g.VERSION="3.3.7",g.prototype.toggle=function(d){var e=a(this);if(!e.is(".disabled, :disabled")){var f=b(e),g=f.hasClass("open");if(c(),!g){"ontouchstart"in document.documentElement&&!f.closest(".navbar-nav").length&&a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click",c);var h={relatedTarget:this};if(f.trigger(d=a.Event("show.bs.dropdown",h)),d.isDefaultPrevented())return;e.trigger("focus").attr("aria-expanded","true"),f.toggleClass("open").trigger(a.Event("shown.bs.dropdown",h))}return!1}},g.prototype.keydown=function(c){if(/(38|40|27|32)/.test(c.which)&&!/input|textarea/i.test(c.target.tagName)){var d=a(this);if(c.preventDefault(),c.stopPropagation(),!d.is(".disabled, :disabled")){var e=b(d),g=e.hasClass("open");if(!g&&27!=c.which||g&&27==c.which)return 27==c.which&&e.find(f).trigger("focus"),d.trigger("click");var h=" li:not(.disabled):visible a",i=e.find(".dropdown-menu"+h);if(i.length){var j=i.index(c.target);38==c.which&&j>0&&j--,40==c.which&&j<i.length-1&&j++,~j||(j=0),i.eq(j).trigger("focus")}}}};var h=a.fn.dropdown;a.fn.dropdown=d,a.fn.dropdown.Constructor=g,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=h,this},a(document).on("click.bs.dropdown.data-api",c).on("click.bs.dropdown.data-api",".dropdown form",function(a){a.stopPropagation()}).on("click.bs.dropdown.data-api",f,g.prototype.toggle).on("keydown.bs.dropdown.data-api",f,g.prototype.keydown).on("keydown.bs.dropdown.data-api",".dropdown-menu",g.prototype.keydown)}(jQuery),+function(a){"use strict";function b(b,d){return this.each(function(){var e=a(this),f=e.data("bs.modal"),g=a.extend({},c.DEFAULTS,e.data(),"object"==typeof b&&b);f||e.data("bs.modal",f=new c(this,g)),"string"==typeof b?f[b](d):g.show&&f.show(d)})}var c=function(b,c){this.options=c,this.$body=a(document.body),this.$element=a(b),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=300,c.BACKDROP_TRANSITION_DURATION=150,c.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},c.prototype.toggle=function(a){return this.isShown?this.hide():this.show(a)},c.prototype.show=function(b){var d=this,e=a.Event("show.bs.modal",{relatedTarget:b});this.$element.trigger(e),this.isShown||e.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){d.$element.one("mouseup.dismiss.bs.modal",function(b){a(b.target).is(d.$element)&&(d.ignoreBackdropClick=!0)})}),this.backdrop(function(){var e=a.support.transition&&d.$element.hasClass("fade");d.$element.parent().length||d.$element.appendTo(d.$body),d.$element.show().scrollTop(0),d.adjustDialog(),e&&d.$element[0].offsetWidth,d.$element.addClass("in"),d.enforceFocus();var f=a.Event("shown.bs.modal",{relatedTarget:b});e?d.$dialog.one("bsTransitionEnd",function(){d.$element.trigger("focus").trigger(f)}).emulateTransitionEnd(c.TRANSITION_DURATION):d.$element.trigger("focus").trigger(f)}))},c.prototype.hide=function(b){b&&b.preventDefault(),b=a.Event("hide.bs.modal"),this.$element.trigger(b),this.isShown&&!b.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(c.TRANSITION_DURATION):this.hideModal())},c.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(a){document===a.target||this.$element[0]===a.target||this.$element.has(a.target).length||this.$element.trigger("focus")},this))},c.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",a.proxy(function(a){27==a.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},c.prototype.resize=function(){this.isShown?a(window).on("resize.bs.modal",a.proxy(this.handleUpdate,this)):a(window).off("resize.bs.modal")},c.prototype.hideModal=function(){var a=this;this.$element.hide(),this.backdrop(function(){a.$body.removeClass("modal-open"),a.resetAdjustments(),a.resetScrollbar(),a.$element.trigger("hidden.bs.modal")})},c.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},c.prototype.backdrop=function(b){var d=this,e=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var f=a.support.transition&&e;if(this.$backdrop=a(document.createElement("div")).addClass("modal-backdrop "+e).appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(a){return this.ignoreBackdropClick?void(this.ignoreBackdropClick=!1):void(a.target===a.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide()))},this)),f&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!b)return;f?this.$backdrop.one("bsTransitionEnd",b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):b()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var g=function(){d.removeBackdrop(),b&&b()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):g()}else b&&b()},c.prototype.handleUpdate=function(){this.adjustDialog()},c.prototype.adjustDialog=function(){var a=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&a?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!a?this.scrollbarWidth:""})},c.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},c.prototype.checkScrollbar=function(){var a=window.innerWidth;if(!a){var b=document.documentElement.getBoundingClientRect();a=b.right-Math.abs(b.left)}this.bodyIsOverflowing=document.body.clientWidth<a,this.scrollbarWidth=this.measureScrollbar()},c.prototype.setScrollbar=function(){var a=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"",this.bodyIsOverflowing&&this.$body.css("padding-right",a+this.scrollbarWidth)},c.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad)},c.prototype.measureScrollbar=function(){var a=document.createElement("div");a.className="modal-scrollbar-measure",this.$body.append(a);var b=a.offsetWidth-a.clientWidth;return this.$body[0].removeChild(a),b};var d=a.fn.modal;a.fn.modal=b,a.fn.modal.Constructor=c,a.fn.modal.noConflict=function(){return a.fn.modal=d,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(c){var d=a(this),e=d.attr("href"),f=a(d.attr("data-target")||e&&e.replace(/.*(?=#[^\s]+$)/,"")),g=f.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(e)&&e},f.data(),d.data());d.is("a")&&c.preventDefault(),f.one("show.bs.modal",function(a){a.isDefaultPrevented()||f.one("hidden.bs.modal",function(){d.is(":visible")&&d.trigger("focus")})}),b.call(f,g,this)})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tooltip"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.tooltip",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.inState=null,this.init("tooltip",a,b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},c.prototype.init=function(b,c,d){if(this.enabled=!0,this.type=b,this.$element=a(c),this.options=this.getOptions(d),this.$viewport=this.options.viewport&&a(a.isFunction(this.options.viewport)?this.options.viewport.call(this,this.$element):this.options.viewport.selector||this.options.viewport),this.inState={click:!1,hover:!1,focus:!1},this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error("`selector` option must be specified when initializing "+this.type+" on the window.document object!");for(var e=this.options.trigger.split(" "),f=e.length;f--;){var g=e[f];if("click"==g)this.$element.on("click."+this.type,this.options.selector,a.proxy(this.toggle,this));else if("manual"!=g){var h="hover"==g?"mouseenter":"focusin",i="hover"==g?"mouseleave":"focusout";this.$element.on(h+"."+this.type,this.options.selector,a.proxy(this.enter,this)),this.$element.on(i+"."+this.type,this.options.selector,a.proxy(this.leave,this))}}this.options.selector?this._options=a.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.getOptions=function(b){return b=a.extend({},this.getDefaults(),this.$element.data(),b),b.delay&&"number"==typeof b.delay&&(b.delay={show:b.delay,hide:b.delay}),b},c.prototype.getDelegateOptions=function(){var b={},c=this.getDefaults();return this._options&&a.each(this._options,function(a,d){c[a]!=d&&(b[a]=d)}),b},c.prototype.enter=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusin"==b.type?"focus":"hover"]=!0),c.tip().hasClass("in")||"in"==c.hoverState?void(c.hoverState="in"):(clearTimeout(c.timeout),c.hoverState="in",c.options.delay&&c.options.delay.show?void(c.timeout=setTimeout(function(){"in"==c.hoverState&&c.show()},c.options.delay.show)):c.show())},c.prototype.isInStateTrue=function(){for(var a in this.inState)if(this.inState[a])return!0;return!1},c.prototype.leave=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);if(c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusout"==b.type?"focus":"hover"]=!1),!c.isInStateTrue())return clearTimeout(c.timeout),c.hoverState="out",c.options.delay&&c.options.delay.hide?void(c.timeout=setTimeout(function(){"out"==c.hoverState&&c.hide()},c.options.delay.hide)):c.hide()},c.prototype.show=function(){var b=a.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(b);var d=a.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(b.isDefaultPrevented()||!d)return;var e=this,f=this.tip(),g=this.getUID(this.type);this.setContent(),f.attr("id",g),this.$element.attr("aria-describedby",g),this.options.animation&&f.addClass("fade");var h="function"==typeof this.options.placement?this.options.placement.call(this,f[0],this.$element[0]):this.options.placement,i=/\s?auto?\s?/i,j=i.test(h);j&&(h=h.replace(i,"")||"top"),f.detach().css({top:0,left:0,display:"block"}).addClass(h).data("bs."+this.type,this),this.options.container?f.appendTo(this.options.container):f.insertAfter(this.$element),this.$element.trigger("inserted.bs."+this.type);var k=this.getPosition(),l=f[0].offsetWidth,m=f[0].offsetHeight;if(j){var n=h,o=this.getPosition(this.$viewport);h="bottom"==h&&k.bottom+m>o.bottom?"top":"top"==h&&k.top-m<o.top?"bottom":"right"==h&&k.right+l>o.width?"left":"left"==h&&k.left-l<o.left?"right":h,f.removeClass(n).addClass(h)}var p=this.getCalculatedOffset(h,k,l,m);this.applyPlacement(p,h);var q=function(){var a=e.hoverState;e.$element.trigger("shown.bs."+e.type),e.hoverState=null,"out"==a&&e.leave(e)};a.support.transition&&this.$tip.hasClass("fade")?f.one("bsTransitionEnd",q).emulateTransitionEnd(c.TRANSITION_DURATION):q()}},c.prototype.applyPlacement=function(b,c){var d=this.tip(),e=d[0].offsetWidth,f=d[0].offsetHeight,g=parseInt(d.css("margin-top"),10),h=parseInt(d.css("margin-left"),10);isNaN(g)&&(g=0),isNaN(h)&&(h=0),b.top+=g,b.left+=h,a.offset.setOffset(d[0],a.extend({using:function(a){d.css({top:Math.round(a.top),left:Math.round(a.left)})}},b),0),d.addClass("in");var i=d[0].offsetWidth,j=d[0].offsetHeight;"top"==c&&j!=f&&(b.top=b.top+f-j);var k=this.getViewportAdjustedDelta(c,b,i,j);k.left?b.left+=k.left:b.top+=k.top;var l=/top|bottom/.test(c),m=l?2*k.left-e+i:2*k.top-f+j,n=l?"offsetWidth":"offsetHeight";d.offset(b),this.replaceArrow(m,d[0][n],l)},c.prototype.replaceArrow=function(a,b,c){this.arrow().css(c?"left":"top",50*(1-a/b)+"%").css(c?"top":"left","")},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle();a.find(".tooltip-inner")[this.options.html?"html":"text"](b),a.removeClass("fade in top bottom left right")},c.prototype.hide=function(b){function d(){"in"!=e.hoverState&&f.detach(),e.$element&&e.$element.removeAttr("aria-describedby").trigger("hidden.bs."+e.type),b&&b()}var e=this,f=a(this.$tip),g=a.Event("hide.bs."+this.type);if(this.$element.trigger(g),!g.isDefaultPrevented())return f.removeClass("in"),a.support.transition&&f.hasClass("fade")?f.one("bsTransitionEnd",d).emulateTransitionEnd(c.TRANSITION_DURATION):d(),this.hoverState=null,this},c.prototype.fixTitle=function(){var a=this.$element;(a.attr("title")||"string"!=typeof a.attr("data-original-title"))&&a.attr("data-original-title",a.attr("title")||"").attr("title","")},c.prototype.hasContent=function(){return this.getTitle()},c.prototype.getPosition=function(b){b=b||this.$element;var c=b[0],d="BODY"==c.tagName,e=c.getBoundingClientRect();null==e.width&&(e=a.extend({},e,{width:e.right-e.left,height:e.bottom-e.top}));var f=window.SVGElement&&c instanceof window.SVGElement,g=d?{top:0,left:0}:f?null:b.offset(),h={scroll:d?document.documentElement.scrollTop||document.body.scrollTop:b.scrollTop()},i=d?{width:a(window).width(),height:a(window).height()}:null;return a.extend({},e,h,i,g)},c.prototype.getCalculatedOffset=function(a,b,c,d){return"bottom"==a?{top:b.top+b.height,left:b.left+b.width/2-c/2}:"top"==a?{top:b.top-d,left:b.left+b.width/2-c/2}:"left"==a?{top:b.top+b.height/2-d/2,left:b.left-c}:{top:b.top+b.height/2-d/2,left:b.left+b.width}},c.prototype.getViewportAdjustedDelta=function(a,b,c,d){var e={top:0,left:0};if(!this.$viewport)return e;var f=this.options.viewport&&this.options.viewport.padding||0,g=this.getPosition(this.$viewport);if(/right|left/.test(a)){var h=b.top-f-g.scroll,i=b.top+f-g.scroll+d;h<g.top?e.top=g.top-h:i>g.top+g.height&&(e.top=g.top+g.height-i)}else{var j=b.left-f,k=b.left+f+c;j<g.left?e.left=g.left-j:k>g.right&&(e.left=g.left+g.width-k)}return e},c.prototype.getTitle=function(){var a,b=this.$element,c=this.options;return a=b.attr("data-original-title")||("function"==typeof c.title?c.title.call(b[0]):c.title)},c.prototype.getUID=function(a){do a+=~~(1e6*Math.random());while(document.getElementById(a));return a},c.prototype.tip=function(){if(!this.$tip&&(this.$tip=a(this.options.template),1!=this.$tip.length))throw new Error(this.type+" `template` option must consist of exactly 1 top-level element!");return this.$tip},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},c.prototype.enable=function(){this.enabled=!0},c.prototype.disable=function(){this.enabled=!1},c.prototype.toggleEnabled=function(){this.enabled=!this.enabled},c.prototype.toggle=function(b){var c=this;b&&(c=a(b.currentTarget).data("bs."+this.type),c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c))),b?(c.inState.click=!c.inState.click,c.isInStateTrue()?c.enter(c):c.leave(c)):c.tip().hasClass("in")?c.leave(c):c.enter(c)},c.prototype.destroy=function(){var a=this;clearTimeout(this.timeout),this.hide(function(){a.$element.off("."+a.type).removeData("bs."+a.type),a.$tip&&a.$tip.detach(),a.$tip=null,a.$arrow=null,a.$viewport=null,a.$element=null})};var d=a.fn.tooltip;a.fn.tooltip=b,a.fn.tooltip.Constructor=c,a.fn.tooltip.noConflict=function(){return a.fn.tooltip=d,this}}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.popover"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.popover",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.init("popover",a,b)};if(!a.fn.tooltip)throw new Error("Popover requires tooltip.js");c.VERSION="3.3.7",c.DEFAULTS=a.extend({},a.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),c.prototype=a.extend({},a.fn.tooltip.Constructor.prototype),c.prototype.constructor=c,c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle(),c=this.getContent();a.find(".popover-title")[this.options.html?"html":"text"](b),a.find(".popover-content").children().detach().end()[this.options.html?"string"==typeof c?"html":"append":"text"](c),a.removeClass("fade top bottom left right in"),a.find(".popover-title").html()||a.find(".popover-title").hide()},c.prototype.hasContent=function(){return this.getTitle()||this.getContent()},c.prototype.getContent=function(){var a=this.$element,b=this.options;return a.attr("data-content")||("function"==typeof b.content?b.content.call(a[0]):b.content)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")};var d=a.fn.popover;a.fn.popover=b,a.fn.popover.Constructor=c,a.fn.popover.noConflict=function(){return a.fn.popover=d,this}}(jQuery),+function(a){"use strict";function b(c,d){this.$body=a(document.body),this.$scrollElement=a(a(c).is(document.body)?window:c),this.options=a.extend({},b.DEFAULTS,d),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",a.proxy(this.process,this)),this.refresh(),this.process()}function c(c){return this.each(function(){var d=a(this),e=d.data("bs.scrollspy"),f="object"==typeof c&&c;e||d.data("bs.scrollspy",e=new b(this,f)),"string"==typeof c&&e[c]()})}b.VERSION="3.3.7",b.DEFAULTS={offset:10},b.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},b.prototype.refresh=function(){var b=this,c="offset",d=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),a.isWindow(this.$scrollElement[0])||(c="position",d=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var b=a(this),e=b.data("target")||b.attr("href"),f=/^#./.test(e)&&a(e);return f&&f.length&&f.is(":visible")&&[[f[c]().top+d,e]]||null}).sort(function(a,b){return a[0]-b[0]}).each(function(){b.offsets.push(this[0]),b.targets.push(this[1])})},b.prototype.process=function(){var a,b=this.$scrollElement.scrollTop()+this.options.offset,c=this.getScrollHeight(),d=this.options.offset+c-this.$scrollElement.height(),e=this.offsets,f=this.targets,g=this.activeTarget;if(this.scrollHeight!=c&&this.refresh(),b>=d)return g!=(a=f[f.length-1])&&this.activate(a);if(g&&b<e[0])return this.activeTarget=null,this.clear();for(a=e.length;a--;)g!=f[a]&&b>=e[a]&&(void 0===e[a+1]||b<e[a+1])&&this.activate(f[a])},b.prototype.activate=function(b){
this.activeTarget=b,this.clear();var c=this.selector+'[data-target="'+b+'"],'+this.selector+'[href="'+b+'"]',d=a(c).parents("li").addClass("active");d.parent(".dropdown-menu").length&&(d=d.closest("li.dropdown").addClass("active")),d.trigger("activate.bs.scrollspy")},b.prototype.clear=function(){a(this.selector).parentsUntil(this.options.target,".active").removeClass("active")};var d=a.fn.scrollspy;a.fn.scrollspy=c,a.fn.scrollspy.Constructor=b,a.fn.scrollspy.noConflict=function(){return a.fn.scrollspy=d,this},a(window).on("load.bs.scrollspy.data-api",function(){a('[data-spy="scroll"]').each(function(){var b=a(this);c.call(b,b.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tab");e||d.data("bs.tab",e=new c(this)),"string"==typeof b&&e[b]()})}var c=function(b){this.element=a(b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.prototype.show=function(){var b=this.element,c=b.closest("ul:not(.dropdown-menu)"),d=b.data("target");if(d||(d=b.attr("href"),d=d&&d.replace(/.*(?=#[^\s]*$)/,"")),!b.parent("li").hasClass("active")){var e=c.find(".active:last a"),f=a.Event("hide.bs.tab",{relatedTarget:b[0]}),g=a.Event("show.bs.tab",{relatedTarget:e[0]});if(e.trigger(f),b.trigger(g),!g.isDefaultPrevented()&&!f.isDefaultPrevented()){var h=a(d);this.activate(b.closest("li"),c),this.activate(h,h.parent(),function(){e.trigger({type:"hidden.bs.tab",relatedTarget:b[0]}),b.trigger({type:"shown.bs.tab",relatedTarget:e[0]})})}}},c.prototype.activate=function(b,d,e){function f(){g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),h?(b[0].offsetWidth,b.addClass("in")):b.removeClass("fade"),b.parent(".dropdown-menu").length&&b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),e&&e()}var g=d.find("> .active"),h=e&&a.support.transition&&(g.length&&g.hasClass("fade")||!!d.find("> .fade").length);g.length&&h?g.one("bsTransitionEnd",f).emulateTransitionEnd(c.TRANSITION_DURATION):f(),g.removeClass("in")};var d=a.fn.tab;a.fn.tab=b,a.fn.tab.Constructor=c,a.fn.tab.noConflict=function(){return a.fn.tab=d,this};var e=function(c){c.preventDefault(),b.call(a(this),"show")};a(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',e).on("click.bs.tab.data-api",'[data-toggle="pill"]',e)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.affix"),f="object"==typeof b&&b;e||d.data("bs.affix",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.options=a.extend({},c.DEFAULTS,d),this.$target=a(this.options.target).on("scroll.bs.affix.data-api",a.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",a.proxy(this.checkPositionWithEventLoop,this)),this.$element=a(b),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};c.VERSION="3.3.7",c.RESET="affix affix-top affix-bottom",c.DEFAULTS={offset:0,target:window},c.prototype.getState=function(a,b,c,d){var e=this.$target.scrollTop(),f=this.$element.offset(),g=this.$target.height();if(null!=c&&"top"==this.affixed)return e<c&&"top";if("bottom"==this.affixed)return null!=c?!(e+this.unpin<=f.top)&&"bottom":!(e+g<=a-d)&&"bottom";var h=null==this.affixed,i=h?e:f.top,j=h?g:b;return null!=c&&e<=c?"top":null!=d&&i+j>=a-d&&"bottom"},c.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a=this.$target.scrollTop(),b=this.$element.offset();return this.pinnedOffset=b.top-a},c.prototype.checkPositionWithEventLoop=function(){setTimeout(a.proxy(this.checkPosition,this),1)},c.prototype.checkPosition=function(){if(this.$element.is(":visible")){var b=this.$element.height(),d=this.options.offset,e=d.top,f=d.bottom,g=Math.max(a(document).height(),a(document.body).height());"object"!=typeof d&&(f=e=d),"function"==typeof e&&(e=d.top(this.$element)),"function"==typeof f&&(f=d.bottom(this.$element));var h=this.getState(g,b,e,f);if(this.affixed!=h){null!=this.unpin&&this.$element.css("top","");var i="affix"+(h?"-"+h:""),j=a.Event(i+".bs.affix");if(this.$element.trigger(j),j.isDefaultPrevented())return;this.affixed=h,this.unpin="bottom"==h?this.getPinnedOffset():null,this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix","affixed")+".bs.affix")}"bottom"==h&&this.$element.offset({top:g-b-f})}};var d=a.fn.affix;a.fn.affix=b,a.fn.affix.Constructor=c,a.fn.affix.noConflict=function(){return a.fn.affix=d,this},a(window).on("load",function(){a('[data-spy="affix"]').each(function(){var c=a(this),d=c.data();d.offset=d.offset||{},null!=d.offsetBottom&&(d.offset.bottom=d.offsetBottom),null!=d.offsetTop&&(d.offset.top=d.offsetTop),b.call(c,d)})})}(jQuery);
/**
 * Created by Ravi Verve on 10-July-2017.
 */

/**
 * INSPINIA - Responsive Admin Theme
 *
 */
function config($translateProvider) {

    $translateProvider
            .translations('en', {

                // Define all menu elements
                LOGOUT: 'Log out',
                HOME: 'Home',
                AGENTS: 'Agents',
                QUALITYCONTROL: 'Quality Control',
                LATEST: 'Timeline',
                RESULTS: 'Results',
                SCHEDULE: 'Schedule',
                RECIPES: 'Recipes',
                INSIGHT: 'Insight',
                LANGUAGE: 'Language',
                CHAT: 'Chat',
                ANALYZE: 'Analyze',
                FINANCIAL: 'Financial',
                CHARGES: 'Charges',
                TRANSACTIONS: 'Transactions',
                CLINICAL: 'Clinical',
                APPOINTMENTS: 'Appointments',
                ENCOUNTERS: 'Encounters',
                QUALITY: 'Quality',
                QUALITYMETRICS: 'Quality Metrics',
                SAVEDDASHBOARDS: 'Saved Dashboards',
                DEMOGRAPHICS: 'Demographics',
                DIAGNOSIS: 'Diagnosis',
                
                // Define some custom text
                WENTWRONG: 'Something went wrong...',
                PROFILEPICTURE: 'Profile Picture',
                USERPROFILE: 'User profile',
                PASSUPDATED: 'Password updated successfully',
                UPDATE: 'Update',
                CHANGEPASSWORD: 'Change password',
                NEWPASSWORD: 'New password',
                NEWPASSWORDPLACE: 'Enter new password',
                CURRENTPASSWORD: 'Current password',
                CURRENTPASSWORDPLACE: 'Enter current password',
                PASSVALIDMSG: 'Password length must be at least 8 characters and must contain alphanumeric with at least one capital letter and symbol (@#$%^&*)',
                CONFIRMPASSWORD: 'Confirm password',
                CONFPASSWORDPLACE: 'Re-enter new password',
                PASSNOTMATCH: 'Passwords do not match.',

                //Login page
                WELCOMETOHEALTHJUMP: 'Welcome to the Healthjump Customer Portal',
                WELCOMEMSG: 'A view of your data like you haven\'t seen before',
                WELCOME: 'Hello',
                LOGINSATE: 'Login in to see it in action.',
                LOGIN: 'Login',
                PASSWORD: "Password",
                FORGOTPASS: 'Forgot password?',
                DONOTHAVEACCOUNT: 'Do not have an account? Please contact your partner administrator.',
                LOGINSUCCESS: 'Logged in successfully',
                INVALIDUSRPASS: 'Invalid email / password',
                USERACCBLOCKED:'Your account has been locked due to many failed attempts, Please try login after 1 Hour',
                PARTNERPORTAL: 'Partner Portal',
                HEALTHJUMP: 'Healthjump',
                EMAIL: 'Email',
                SEND: 'Send',
                CANCEL: 'Cancel',
                OK: 'Ok',
                FETCHINGDATA: 'Fetching data...',
                
                //Home
                LASTDATALOAD: 'Last Data Loads (By Agent)',
                MESSAGEINFO: 'Here are some stats from the JumpCONNECT data warehouse.',
                JUMPCONNECT: 'JumpCONNECT',
                DATAWAREHOUSE: 'data warehouse',
                TOTALAPPTS: 'Total Appts',
                TOTALENCOUNTERS: 'Total Encounters',
                FROMLASTWEEK: 'from last week',
                TOTALPATIENTS: 'Total Patients',
                TOTALPROVIDERS: 'Total Providers',
                JUMPSTART: 'JumpSTART',
                EHRCONNECTOR: 'EHR connector',
                CONNECTIONS: 'Connections',
                ACTIVE: 'active',
                NEWPRACTICETOCONNECT: 'New practice ready to connect?',
                SCHEDULEJUMPSTARTINSTALL: 'Invite them to schedule a JumpSTART install with one of our engineers.',
                SENDINVITE: 'Send Invite',
                OR: 'OR',
                ACCESSTODB: 'Already have access to the DB?',
                GORIGHTTOINSTALLATIONWIZARD: 'Skip the invite process and go right to the installation wizard.',
                LAUNCHWIZARD: 'Launch Wizard',
                CLIENTSUCCESSMANAGER: 'Client Success Manager',
                CLIENTSERVICESDIRECTOR: 'Director Of Client Services',
                CSMISBRIDGE: 'The client success manager (CSM) is the bridge between {{customername}} & Healthjump.',
                CSMENSURINGTHEPARTNERSHIP: 'Responsible for ensuring the partnership between our organizations is efficient and effective.',
                CONTACTCSM: 'Contact CSM',
                DIRECTOROFOPERATIONS: 'Director Of Operations',
                SRSOLUTIONSENG: 'Senior Solutions Engineer',
                CSMNOTYETASSIGNED: 'Client Success Manager not yet assigned.',
                TASKS: 'Tasks',
                LISTOFOPENTASKS: 'Below you will find a list of <strong>open tasks</strong> that Healthjump has in queue for {{customername}} organized by priority.',
                DRAGTASK: 'Drag task between list',
                ADDTASK: 'Add task',
                HIGH: 'High',
                ADDHIGHTASK: 'Add high priority task.',
                NORMAL: 'Normal',
                ADDNEWTASK: 'Add new task.',
                LOW: 'Low',
                ADDLOWTASK: 'Add low priority task.',
                TICKETPRIORITYCHANGE: 'Ticket priority changed',
                CREATED: 'Created',
                MODIFIED: 'Modified',
                CREATEDRECORDS: 'Created Records',
                MODIFIEDRECORDS: 'Modified Records',
                SENDINVITETEXT: '<p>Hello,</p><p>I\'m Stacy from Healthjump and I will be your point of contact for the installation of jumpSTART at your practice. In order to move forward, we\'ll need you to fill out the form here https://docs.google.com/a/healthjump.com/forms/d/1e64c35Z9yoM-W76FePF5NKQ41AgkvuWkwHyEPkgjkHE. If you are unsure of anything, I recommend having your IT contact assist you with gathering the information. Please also schedule your appointment at the following link: https://calendly.com/healthjump-install/agent.</p><p>Once your information has been submitted and you have scheduled an appointment, I’ll provide you with the webex information. During the call I will provide a link to our web form where you will be able to create a secret key, download and install jumpSTART.</p><p>I’ll be available to provide basic guidance on installing and configuring the agent. Although rare, sometimes technical roadblocks do come up during installation. Often we can fix the issue while we are on the webex. However, it may be necessary to escalate any unresolved errors to Healthjump level 2 support to ensure that your configuration is successfully completed.</p><p>Please let me know if you have any questions, and I look forward to working with you.</p><p>Kind regards,</p><p>Stacy</p>',
                RECIPIENT: 'Recipient',
                RECIPIENTEMAIL: 'Enter recipient email',
                INVITETEXT: 'Invite Text',
                MESSAGEDETAILS: 'Message Details',
                MESSAGEDETAILSPLACE: 'Enter message details',
                
                //Agent
                AGENT: 'Agent',
                SOURCES: 'Sources',
                TICKETADDED: 'Ticket added successfully',
                INVITATIONSENT: 'Invitation sent successfully',
                MESSAGESENT: 'Message Sent',
                TICKETUPDATED: 'Ticket updated successfully',
                COMMENTADDED: 'Comment added successfully',
                LASTUPDATED: 'Last updated',
                PRACTICES: 'Practices',
                THISISINSTALLEDPRACTICES: 'This is a list of all practices that currently have jumpSTART installed.',
                SEARCHAGENTPLACE: 'Search agents',
                SEARCH: 'Search',
                ALL : 'All',
                DOWN: 'Down',
                WAITING: 'Waiting',
                ARCHIVED: 'Archived',
                NEWINSTALL: 'New install',
                SHOWPARTENERFORM: 'If there is a partner agreement, show the form.',
                SHOWUPGRADETOPRO: 'If not, show "Upgrade to Pro, for self service installs"',
                AGENTPAGELOADHERE: 'The agent form should load here...',
                CLICKAGENTFORDETAIL: 'Click on a practice\'s name to view details here',
                CREATETICKET: 'Create Ticket',
                QCSUMMARY: 'QC Summary',
                RELATEDTICKETS: 'Related Tickets',
                TICKET: 'Ticket',
                QCDETAIL: 'QC Detail',
                COMMENT: 'Comment',
                NEWTICKET: 'New Ticket',
                TICKETSUBJECT: 'Ticket subject',
                TICKETDESC: 'Ticket Description',
                TICKETDESCPLACE: 'Enter the content of the Ticket',
                COMMENTS: 'Comments',
                ADDCOMENTPLACE: 'Add comment...',
                LASTCONNECTED: 'Last connected',
                NOCLIENTQCDETAIL: 'Quality Control details are not yet available for this client.',
                CLICKCREATETICKET: 'If you feel this is in error, please click "Create Ticket" above.',
                NOTES: 'Notes',
                TAGS: 'Tags',
                EXTRACTS: 'Extracts',
                NOEXTRACTSCONFIG: 'No extracts have been configured for this agent',
                
                //QC Result
                QCRESULTS: 'QC - Results',
                RESULTDATA: 'Result Details',
                FILTERAGENT: 'Filter agent details',
                GO: 'Go',
                AGENTNAME: 'Agent name',
                EMRNAME: 'EMR name',
                RECIPE: 'Recipe',
                STATUS: 'Status',
                DATE: 'Date',
                LATESTDATA: 'Timeline',
                TABLEMISSINGLASTNIGHT: 'Tables missing last night\'s upload from one or more agents',
                
                // Analyze Page
                
                SAVECUSTOMDASHBOARD:'Save Custom Dashboard',
                SAVECURDASHTOVIEWLATER:'Save this current dashboard to View and Publish another time.',
                USEALPHANUMCHAR:'Please use only alphanumeric characters.',
                SAVEDASHBOARD:'Save Dashboard',
                UPDATEDASHBOARD:'Update Dashboard',
                CUSTOMDASHNAME:'Custom Dashboard Name',
                GETTINGSTARTANALYZE:'Getting Started with Analyze',
                VIEWDATAAVAILINTABLE:'<strong> View</strong> the {{ currentPage }} data available in the table below',
                SEEDATERANGE:'Select the <strong>date range</strong> you\'d like to see',
                ADDANYADDITION:'Add any additional <strong>filters</strong>',
                VISUALIZERESLCHARTMEASRCALC:'<strong> Visualize</strong> the results by selecting a <strong>chart type</strong> and selecting a category, measurement & calculation',
                ADDVISUAL:' Add Visual:',
                PIE:'Pie',
                LINE:'Line',
                BAR:'Bar',
                AREA:'Area',
                APPLYFILTER:'Apply Filters:',
                DATERANGE:'Date Range',
                COLUMN:'Column',
                BUILDCUSTFILTER:'Build Custom Filters',
                CUSTOMPIEGRAPH:'Create Custom Pie Graph',
                CATEGORY:'Category',
                MEASUREMENT:'Measurement',
                CALCULATION:'Calculation',
                CUSTOMBARGRAPH:'Create Custom Bar Graph',
                CREATEMULSERIESBARGRAPH:' Create MultiSeries Bar Graph',
                COMPARETO:'Compare To:',
                OF:'Of',
                CREATECUSTLINEGRAPH:'Create Custom Line Graph',
                CATEGORYX:'Category (X-axis)',
                CREATEMULLINEGRAPH:'Create MultiSeries Line Graph',
                CREATE:'Create',
                CREATECUSTAREAGRAPH:'Create Custom Area Graph',
                RAWDATA:'Raw {{currentPage}} Data',
                SEARCHFILTERS:'Search filters',
                ADDRULE:'Add rule',
                APPLY:'Apply',
                CLEARFILTERS:'Clear Filters',
                GOTIT:'Got it!',
                DASHBOARDUPDATED:'Your dashboard updated!',
                DASHBOARDSAVED:'Your dashboard saved!',
                EQUAL:'equal',
                NOTEQUAL: 'not equal',
                BEGINSWITH:'begins with',
                DOESNOTBEGINWITH:'does not begin with',
                ENDSWITH:'ends with',
                DOESNOTENDWITH:'does not end with',
                CONTAINS:'contains',
                DOESNOTCONTAIN:'does not contain',
                ISNULL:'is null',
                ISNOTNULL:'is not null',
                ISIN:'is in',
                ISNOTIN:'is not in',
                PREVIEW:'Preview',
                CLOSE:'close',
                CREATEMULAREAGRAPH:'Create MultiSeries area Graph',
                CREATEMULAREAGRAPH: 'Create MultiSeries area Graph',
                NOGRAPHFOUND: 'No Graph data found',
                RECEVING: 'Receiving...',
                LOADGRAPH: 'Loading Graph...',
                MAKEGRAPH: '&emsp;...Making Graph',
                GRAPHCOMPLETE: '&emsp; Graph Complete!',
                REQPAGENOTFOUND:'Requested page not found',
               
            })
            .translations('es', {

            });

    $translateProvider.preferredLanguage('en');
}

angular
        .module('inspinia')
        .config(config)


/**
 * INSPINIA - Responsive Admin Theme
 * 2.7
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeight = angular.element('nav.navbar-default').height();
    var wrapperHeigh = angular.element('#page-wrapper').height();

    if(navbarHeight > wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
    }

    if(navbarHeight < wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeight > wrapperHeigh) {
        angular.element('#page-wrapper').css("min-height", navbarHeight  + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

/**
 * Common function file to define all helper functions like filter, services
 * @author: Ravi
 * @createddate: July-10-2017
 */


/**
 * Service initFunction used perform some actions on user logged in and page refresh
 */
function initFunction($rootScope, $translate, Idle, APIService, $auth, $cacheFactory, $filter, $base64, UserPreferenceService, $timeout, $analytics) {
    cache = $cacheFactory.get('$http'); //Assgine cache factory object to cache globale variable
    //To fetch logged in user profile data
    this.fetchProfileData = function () {
        $rootScope.userProfile = $auth.getPayload(); //get the user details from the token

        $analytics.setUsername($rootScope.userProfile.email); //set the Matomo (usage tracking) user id to the email

        // Authenticate to cognito identity pool from the user pool
        AWS.config.update({
            region: 'us-west-2'
        });
        var poolData = {
            UserPoolId: 'us-west-2_kkQf9MXcm', // your user pool id here
            ClientId: '397o7c6rhbeko3to8j494v6hms' // your app client id here
        };
        var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
        var userData = {
            Username: $rootScope.userProfile.email,
            Pool: userPool
        };
        var cognitoUser = userPool.getCurrentUser();
        if (cognitoUser != null) {
            cognitoUser.getSession(function (err, result) {
                if (result) {
                    console.log('You are now logged in.');

                    // Add the User's Id Token to the Cognito credentials login map.
                    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                        IdentityPoolId: 'us-west-2:fe1f96d6-c7eb-46a4-91ce-55853986c4c6',
                        Logins: {
                            'cognito-idp.us-west-2.amazonaws.com/us-west-2_kkQf9MXcm': result.getIdToken().getJwtToken()
                        }
                    });
                }
            });
        }

        // Refresh AWS credentials to prevent CORB issues and undefined identityId
        AWS.config.credentials.refresh(function () {
            //Recording the last time the user accessed this app
            //NOTE: The s3 subdirectory is the aws_identity_id, not their email address so we can lock their access
            //down via a IAM policy, this way one user cannot access another user's login history
            var bucket = 'healthjump-webapps';
            var prefix = 'customer-portal/users/' + AWS.config.credentials.identityId + '/';
            var s3 = new AWS.S3({
                apiVersion: '2006-03-01'
            });

            $(function () {
                $.getJSON("https://api.ipify.org?format=jsonp&callback=?",
                    function (json) {
                        var data = {};
                        data.ip = json.ip;
                        data.login_time = moment().format();
                        var params = {
                            Bucket: bucket,
                            Key: prefix + 'login.json',
                            Body: JSON.stringify(data)
                        };
                        s3.upload(params, function (data, err) {
                            console.log(data)
                            if (err) console.log(err.message);
                        });
                    }
                );
            });

            //Fetch logged in user profile picture from s3 user bucket
            if ($rootScope.userProfile.avatar == "" || $rootScope.userProfile.avatar == "default_avatar.jpg") {
                var profilePicParams = {
                    Bucket: bucket,
                    Key: prefix + 'profile_pic.jpeg'
                }
                s3.listObjects({
                    Bucket: bucket,
                    Prefix: prefix
                }, function (err, data) {
                    if (err) console.log(err, err.stack); // an error occurred
                    else { // successful response
                        var contents = data.Contents;
                        angular.forEach(contents, function (file) {
                            if (file.Key === prefix + 'profile_pic.jpeg') {
                                $rootScope.userProfile.profile_picture = s3.getSignedUrl('getObject', profilePicParams);
                                return;
                            } else { //If not "profile_pic.jpeg exists in the bucket, display the user's initials instead"
                                (function () {
                                    var first, last;
                                    if ($rootScope.userProfile.first_name) {
                                        first = $rootScope.userProfile.first_name[0];
                                        last = $rootScope.userProfile.last_name != '' ? $rootScope.userProfile.last_name[0] : null;
                                        if (last) {
                                            var initials = first + last;
                                        } else {
                                            var initials = first;
                                        }
                                        $rootScope.userProfile.profile_picture = 'https://ui-avatars.com/api/?name=' + initials + '&background=f35b2b&color=fff&bold=true&font-size=0.5';
                                    } else {
                                        return false;
                                    }
                                })()
                            }
                        });
                    }
                });
            } else {
                $rootScope.userProfile.profile_picture = $rootScope.userProfile.avatar;
            }
        });

        $rootScope.agentListObj = ""; //Clear connection list data on user login

        //Get user preferences and store it into rootscope to use controller to controller
        var UserPreference = UserPreferenceService.get(function () {
            $rootScope.user_preferences = UserPreference;
        });

        Idle.watch(); // start user idle time.

    }

    //Check logged in user is register with HJChat and fetch user team list
    this.checkUserHjChatRegis = function (emailId) {
        var emailId = $base64.encode(emailId);
        APIService.get('partner/user/' + emailId).then(function (response) {
            if (response && response.data.status == 200) {
                $rootScope.hjChatTeamList = response.data.result;
            }
        })
    }

    //To set translations for all the toastr
    this.toastrTranslation = function () {
        $translate(['LOGINSUCCESS', 'LOGIN', 'INVALIDUSRPASS', 'WENTWRONG', 'AGENT', 'TICKETADDED', 'TICKETUPDATED', 'COMMENTADDED', 'USERPROFILE', 'PASSUPDATED', 'TICKETPRIORITYCHANGE', 'HOME', 'CREATED', 'MODIFIED', 'CREATEDRECORDS', 'MODIFIEDRECORDS', 'SENDINVITETEXT', 'INVITATIONSENT', 'MESSAGESENT', 'USERACCBLOCKED', 'ANALYZE', 'DASHBOARDUPDATED', 'DASHBOARDSAVED', 'RECEVING', 'NOGRAPHFOUND', 'MAKEGRAPH', 'GRAPHCOMPLETE', 'REQPAGENOTFOUND']).then(function (translations) {
            $rootScope.toastrTranslate = translations;
        });
    }

    //To get saved dashboard list
    // this.fetchSavedDashboard = function(){
    //     $rootScope.savedDashMenuHTML = [];
    //     APIService.post('saveddashboardlist').then(function(resData) {
    //         if(resData && resData.data.total > 0){
    //             var savedDash  = resData.data;
    //             angular.forEach(savedDash.data, function(value, key) {
    //                 $rootScope.savedDashMenuHTML.push({page: value.name, id: value.id});
    //             })
    //         }
    //     });
    // }
}

/**
 * APIInterceptor - factory use to handle all HTTP request and response
 * Check user authentication on all API request
 * If token expire then it will redirect user to Login page
 */
function APIInterceptor($location, $injector) {
    return {
        request: function (config) {
            var $auth = $injector.get('$auth');
            if (!$auth.isAuthenticated() && $location.path() != '/login') {
                $auth.logout();
                $location.path("/login");
            }
            return config;
        },
        requestError: function (config) {
            return config;
        },
        response: function (response) {
            return response;
        },
        responseError: function (res) {
            return res;
        }
    }
}

/**
 * customFilter - filter the passed dataArray by passed key and value
 * @author Ravi
 * @param dataArray - JSON object to search the vlaue to filter
 * @param findKey - key name to find it from passed dataArray
 * @param findValue - vlaue for filter the array
 * @returns filtered dataArray if findValue is passed else return dataArray without filter
 */
function customFilter() {
    return function (dataArray, findKey, findValue) {
        var out = [];
        if (findValue == '')
            return dataArray;

        angular.forEach(dataArray, function (value, key) {
            if (value[findKey] == findValue)
                out.push(value)
        })
        return out;
    }
}

/**
 * camelize - convert the passed string to CamelCase
 * @author Ravi
 * @param str - string to convert
 * @returns Camelize string
 */
function camelize() {
    return function (str) {
        return (str || '').toLowerCase().replace(/(\b|-)\w/g, function (m) {
            return m.toUpperCase().replace(/-/, '');
        });
    }
}

angular
    .module('inspinia')
    .service('initFunction', initFunction)
    .factory('APIInterceptor', APIInterceptor)
    .filter('customFilter', customFilter)
    .filter('camelize', camelize);
(function () {
    'use strict';

    angular
            .module('inspinia')
            .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $state, $auth, initFunction, Idle, $window, $location, $cookies, $uibModal) {
        $rootScope.$state = $state;
        $rootScope.user_preferences = {};
        
        if ($auth.isAuthenticated()) {
            initFunction.fetchProfileData();
            initFunction.toastrTranslation();
            initFunction.checkUserHjChatRegis($rootScope.userProfile.email); // To check user is register with HJChat
            // initFunction.fetchSavedDashboard();
        }

        //This redirects a user to the login page if they do not have a valid JWT token
        $rootScope.$on('$stateChangeStart', function (event, toState) {
            document.body.scrollTop = document.documentElement.scrollTop = 0; //To scroll main vew and content view to the top on view change
            if (!$auth.isAuthenticated() && toState['name'] != 'login') {
                event.preventDefault();
                $state.go('login');
            }
            if ($auth.isAuthenticated() && toState['name'] == 'login') {
                event.preventDefault();
                $state.go('index.home');
            }
        });
        toastr.options = {
            "closeButton": true,
            "debug": false,
            "progressBar": true,
            "preventDuplicates": false,
            "positionClass": "toast-top-right",
            "onclick": null,
            "showDuration": "400",
            "hideDuration": "1000",
            "timeOut": "7000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        };
        
        $rootScope.timeoutStarted = false;

          function closeModals() {
            if ($rootScope.warning) {
              $rootScope.warning.close();
              $rootScope.warning = null;
            }

            if ($rootScope.timedout) {
              $rootScope.timedout.close();
              $rootScope.timedout = null;
            }
          }

          $rootScope.$on('IdleStart', function() {
            closeModals();

            $rootScope.warning = $uibModal.open({
              templateUrl: 'app/views/common/warning-dialog.html',
              windowClass: 'modal-danger'
            });
          });

          $rootScope.$on('IdleEnd', function() {
            closeModals();
          });

          $rootScope.$on('IdleTimeout', function() {
            closeModals();
            $auth.logout();
            $window.location.reload();
            $location.path("/login");
          });        

        /**
         * Call user idle timeout
         * Check user logged in session expire, if expire than display logout screen
         */ 
        // $rootScope.$on('IdleTimeout', function() {
        //     Idle.unwatch();
        //     if($auth.isAuthenticated()){
        //         console.log('here');
        //         Idle.watch();
        //     }else{
        //         if($location.path() != '/login'){
        //             $auth.logout();
        //             $window.location.reload();
        //             $location.path("/login");
        //         }
        //     }
        // });

        // $rootScope.$on('IdleStart', function() {
        //     $rootScope.warning = $uibModal.open({
        //       templateUrl: 'app/views/common/addTicketModal.html',
        //       windowClass: 'modal-danger'
        //     });
        // });
    }

})();

(function () {
    'use strict';

    angular
            .module('inspinia')
            .config(routerConfig)
    
            //uibModel Popup default option
            .config(function ($uibModalProvider){
                 $uibModalProvider.options = {
                    animation: true,
                    backdrop: true,
                    windowClass: (canAnimate) ? "animated bounceInRight" : ""
                };
            });

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider, $authProvider, IdleProvider, KeepaliveProvider, TitleProvider, $httpProvider, $locationProvider) {
        
        // Satellizer configuration that specifies which API
        // route the JWT should be retrieved from
        $authProvider.loginUrl = APIBase + 'authenticate';
        
        $stateProvider
                .state('login', {
                    url: '/login',
                    templateUrl: 'app/views/login.html',
                    controller: 'LoginCtrl as login',
                    data: {pageTitle: 'Login', specialClass: 'gray-bg'}
                })
                .state('index', {
                    abstract: true,
                    url: "/index",
                    templateUrl: "app/views/common/content.html"
                })
                .state('index.home', {
                    url: "/home",
                    templateUrl: "app/views/home.html",
                    controller: 'HomeCtrl as home',
                    data: {pageTitle: 'Example view'}
                })

                .state('fileManager', {
                    abstract: true,
                    url: "",
                    templateUrl: "app/views/common/content.html"
                })

                .state('fileManager.fileManager', {
                    url: "/filemanager",
                    templateUrl: "app/views/filemanager.html",
                    controller: "FileManagerCtrl as filemanager",
                    data: {pageTitle: 'File Manager'}
                })

                .state('agent', {
                    abstract: true,
                    url: "",
                    templateUrl: "app/views/common/content.html"
                })

                .state('agent.agents', {
                    url: "/sources",
                    templateUrl: "app/views/agents.html",
                    controller: "AgentCtrl as agent",
                    data: {pageTitle: 'Practice Agent'}
                })

                .state('roi', {
                    abstract: true,
                    url: "",
                    templateUrl: "app/views/common/content.html"
                })

                .state('roi.roi', {
                    url: "/roi",
                    templateUrl: "app/views/roi.html",
                    controller: "ROICtrl as roi",
                    data: {pageTitle: 'ROI Mapping'}
                })


                .state('dbexplorer', {
                    abstract: true,
                    url: "",
                    templateUrl: "app/views/common/content.html"
                })

                .state('dbexplorer.dbexplorer', {
                    url: "/dbexplorer",
                    templateUrl: "app/views/dbexplorer.html",
                    controller: "DbexplorerCtrl as dbexplorer",
                    data: {pageTitle: 'DB Explorer'}
                })

                .state('advisor', {
                    abstract: true,
                    url: "",
                    templateUrl: "app/views/common/content.html"
                })

                .state('advisor.qm', {
                    url: "/qm",
                    templateUrl: "app/views/qm.html",
                    controller: "QmCtrl as qm",
                    data: {pageTitle: 'QM Analysis'}
                })

                .state('qc', {
                    abstract: true,
                    url: "/qc",
                    templateUrl: "app/views/common/content.html"
                })
                .state('qc.recipies', {
                    url: "/recipies",
                    templateUrl: "app/views/qc/recipies.html",
                    data: {pageTitle: 'Example view'}
                })
                .state('qc.results', {
                    url: "/results",
                    templateUrl: "app/views/qc/results.html",
                    controller: "QCResultCtrl as result",
                    data: {pageTitle: 'Example view'}
                })
                .state('qc.results/:client_id', {
                    url: "/results",
                    templateUrl: "app/views/qc/results.html",
                    data: {pageTitle: 'Example view'}
                })
                .state('qc.latest', {
                    url: "/latest",
                    templateUrl: "app/views/qc/latest.html",
                    controller: "QCLatestCtrl as latest",
                    data: {pageTitle: 'Example view'}
                })
                /** 
                 *************** Analyze section reoutes ******************
                 * Financial
                 */
                .state('financial', {
                    abstract: true,
                    url: "/analyze",
                    templateUrl: "app/views/common/content.html"
                })

                .state('financial.charges', {
                    url: "/financial/charges",
                    templateUrl: "app/views/analyze.html",
                    data: {pageTitle: 'Analyze', tablename: 'charges'}
                })

                .state('financial.claims', {
                    url: "/financial/claims",
                    templateUrl: "app/views/analyze.html",
                    data: {pageTitle: 'Analyze', tablename: 'claims'}
                })

                .state('financial.transactions', {
                    url: "/financial/transactions",
                    templateUrl: "app/views/analyze.html",
                    data: {pageTitle: 'Analyze', tablename: 'transactions'}
                })

                // Clinical
                .state('clinical', {
                    abstract: true,
                    url: "/analyze",
                    templateUrl: "app/views/common/content.html"
                })

                .state('clinical.appointments', {
                    url: "/clinical/appointments",
                    templateUrl: "app/views/analyze.html",
                    data: {pageTitle: 'Analyze', tablename: 'appointments'}
                })

                .state('clinical.demographics', {
                    url: "/clinical/demographics",
                    templateUrl: "app/views/analyze.html",
                    data: {pageTitle: 'Analyze', tablename: 'demographics'}
                })

                .state('clinical.diagnosis', {
                    url: "/clinical/diagnosis",
                    templateUrl: "app/views/analyze.html",
                    data: {pageTitle: 'Analyze', tablename: 'diagnosis'}
                })
                .state('clinical.encounters', {
                    url: "/clinical/encounters",
                    templateUrl: "app/views/analyze.html",
                    data: {pageTitle: 'Analyze', tablename: 'encounters'}
                })
                // Quality
                .state('quality', {
                    abstract: true,
                    url: "/analyze",
                    templateUrl: "app/views/common/content.html"
                })

                .state('quality.qualitymetrics', {
                    url: "/quality/metrics",
                    templateUrl: "app/views/analyze.html",
                    data: {pageTitle: 'Analyze', tablename: 'metrics'}
                })

                // Routes for saved dashboard
                .state('analyzesaved', {
                    abstract: true,
                    url: "/analyze",
                    templateUrl: "app/views/common/content.html"
                })
                .state('analyzesaved.saveddashboard', {
                    url: "/saveddashboard/:pageId",
                    templateUrl: 'app/views/analyze.html',
                    data: {pageTitle: 'Analyze', tablename: 'saveddashboard'}
                });
                
        $urlRouterProvider.otherwise('/index/home');
        
        IdleProvider.idle(900); // Set user idle time duration
        IdleProvider.timeout(60); // set user timeout duration after idle time
        KeepaliveProvider.interval(1); // set alive time after time out
        TitleProvider.enabled(true); // Disable title of timeout countdown
        
        $httpProvider.interceptors.push('APIInterceptor');
        $locationProvider.html5Mode(true);
        
    }

})();

'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('inspinia')
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

                // Colapse menu in mobile mode after click on element
                var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
                menuElement.click(function(){
                  if (angular.element(window).width() < 769) {
                    angular.element("body").toggleClass("mini-navbar");
                  }
                });

                // Enable initial fixed sidebar
                if (angular.element("body").hasClass('fixed-sidebar')) {
                  var sidebar = element.parent();
                  sidebar.slimScroll({
                    height: '100%',
                    railOpacity: 0.9
                  });
                }

            }
        };
    })
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    })
    .directive('rightClick', function ($parse) {
        return function(scope, element, attrs) {
            var fn = $parse(attrs.rightClick);
            element.bind('contextmenu', function(event) {
              scope.$apply(function() {
                event.preventDefault();
                fn(scope, {
                  $event: event
                });
              });
            });
          };
    });

/**
 * fullScroll - Directive for slimScroll with 100%
 */
function fullScroll($timeout){
    return {
        restrict: 'A',
        link: function(scope, element) {
            $timeout(function(){
                element.slimscroll({
                    height: '100%',
                    railOpacity: 0.9
                });

            });
        }
    };
}

/**
 * slimScroll - Directive for slimScroll with custom height
 */
function slimScroll($timeout){
    return {
        restrict: 'A',
        scope: {
            boxHeight: '@'
        },
        link: function(scope, element) {
            $timeout(function(){
                element.slimscroll({
                    height: scope.boxHeight,
                    railOpacity: 0.9
                });

            });
        }
    };
}

/**
* @description To set default image in case of image not found or not exist
* @author Ravi
* @createddate 10-July-2016
*/
function defaultImage() {
    return {
        restrict: 'EA',
        scope: {
            defimageurl: '@'
        },
        link: function (scope, element, attrs) {
            var noImageurl = 'assets/images/no-image.jpg';
            if (scope.defimageurl)
                noImageurl = scope.defimageurl;
            scope.$watch(function () {
                return attrs.ngSrc;
            }, function (value) {
                if (!value) {
                    element.attr('src', noImageurl);
                }
            });
            element.bind('error', function () {
                element.attr('src', noImageurl);
            });
        }
    };
}

/**
* agentStatus - Directive for change the status lable in agent listing
* @author: Ravi - 2017-July-11
*/
function agentStatus($timeout) {
    return {
        link: function($scope, element, $attrs, ngModel) {
            $timeout(function() {
                if (element.hasClass('active')) {
                    element.addClass('text-success');
                    element.html('<i class="fa fa-check-circle-o fa-lg"></i>');
                }else if (element.hasClass('waiting')) {
                    element.addClass('text-warning');
                    element.html('<i class="fa fa-warning fa-lg"></i>');
                }else if (element.hasClass('archived')) {
                    element.addClass('text-info');
                    element.html('<i class="fa fa-ban fa-lg"></i>');
                }else if (element.hasClass('down')) {
                    element.addClass('text-danger');
                    element.html('<i class="fa fa-times-circle fa-lg"></i>');
                }else{
                    element.addClass('text-info');
                    element.html('<i class="fa fa-question-circle fa-lg"></i>');
                }
            });
        }
    }
}

function tagIcon($timeout) {
    return {
        link: function($scope, element, $attrs, ngModel) {
            $timeout(function() {
                if (element.hasClass('taggin-active')) {
                    element.html('<i class="fa fa-check-circle-o"></i> active');
                }else if (element.hasClass('taggin-waiting')) {
                    element.html('<i class="fa fa-warning"></i> waiting');
                }else if (element.hasClass('taggin-archived')) {
                    element.html('<i class="fa fa-ban"></i> archived');
                }else if (element.hasClass('taggin-down')) {
                    element.html('<i class="fa fa-times-circle"></i> down');
                }
            });
        }
    }
}

function extractHelp($timeout, $templateCache) {
    return {
        link: function($scope, element, $attrs, ngModel) {
            $timeout(function() {
                element[0].innerText = element[0].innerText.replace(/\s+/g, '-');
                switch (element[0].innerText) {
                    case 'ALLERGY':
                        var helptexthtml = '' +
                           ' <script>' +
                           ' $(document).ready(function(){' +
                           '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                           '     $("#' + element[0].innerText + 'Help").toggle();' +
                           '   });' +
                           ' });' +
                           ' </script>' +
                             element[0].innerText +
                           ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                           ' <div class="panel panel-info collapse m-t-sm" id="'+ element[0].innerText + 'Help">' +
                           '     <div class="panel-heading">' +
                           '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                           '     </div>' +
                           '     <div class="panel-body">' +
                           '         <p>These are the fields that will be extracted:</p>' +
                           '         <table class="table table-striped">' +
                           '         <tr><td><strong>Patient ID</strong></td>' +
                           '         <td>Related to demographic data. patient_id = demographic.patient_id</td></tr>' +
                           '         <tr><td><strong>Allergy ID</strong></td>' +
                           '         <td>The ID used by the source system to identify the allergy.</td></tr>' +
                           '         <tr><td><strong>Encounter ID</strong></td>' +
                           '         <td>The encounter ID from when this allergy was first recorded.</td></tr>' +
                           '         <tr><td><strong>Allergen Type</strong></td>' +
                           '         <td>Allergen type. See Table 006 for cross-reference.</td></tr>' +
                           '         <tr><td><strong>Allergy Description</strong></td>' +
                           '         <td>Description of allergy.</td></tr>' +
                           '         <tr><td><strong>Onset Date</strong></td>' +
                           '         <td>Format: YYYYMMDD</td></tr>' +
                           '         <tr><td><strong>Resolved Date</strong></td>' +
                           '         <td>Format: YYYYMMDD</td></tr>' +
                           '         <tr><td><strong>Allergy Severity</strong></td>' +
                           '         <td>Allergy severity description.</td></tr>' +
                           '         <tr><td><strong>Reaction Code</strong></td>' +
                           '         <td>Code describing the reaction based on HITSP C80 Section 2.2.3.4.1</td></tr>' +
                           '         <tr><td><strong>Allergy Reaction</strong></td>' +
                           '         <td>Allergy reaction description</td></tr>' +
                           '         <tr><td><strong>Product Code</strong></td>' +
                           '         <td>Code describing the product, HITSP C80 Section(s): 2.2.3.3.9, 2.2.3.3.11, 2.2.3.3.7, 2.2.3.3.8)</td></tr>' +
                           '         <tr><td><strong>Comment</strong></td>' +
                           '         <td>Allergy comments from the source system.</td></tr>' +
                           '         </table>' +
                           '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                           '     </div>' +
                           ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'APPOINTMENT':
                        var helptexthtml = '' +
                           ' <script>' +
                           ' $(document).ready(function(){' +
                           '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                           '     $("#' + element[0].innerText + 'Help").toggle();' +
                           '   });' +
                           ' });' +
                           ' </script>' +
                             element[0].innerText +
                           ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                           ' <div class="panel panel-info collapse m-t-sm" id="'+ element[0].innerText + 'Help">' +
                           '     <div class="panel-heading">' +
                           '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                           '     </div>' +
                           '     <div class="panel-body">' +
                           '         <p>These are the fields that will be extracted:</p>' +
						   '         <table class="table table-striped">' +
						   '         <tr><td><strong>Patient ID</strong></td>' +
						   '         <td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
						   '         <tr><td><strong>Appointment Date</strong></td>' +
						   '         <td>Date of the appointment. Format: YYYYMMDD</td></tr>' +
						   '         <tr><td><strong>Begin Time</strong></td>' +
						   '         <td>Beginning time of appointment. Format: HHMM</td></tr>' +
						   '         <tr><td><strong>End Time</strong></td>' +
						   '         <td>Ending time of appointment. Format: HHMM</td></tr>' +
						   '         <tr><td><strong>Appointment Duration</strong></td>' +
						   '         <td>Duration in minutes.</td></tr>' +
						   '         <tr><td><strong>Resource</strong></td>' +
						   '         <td>This could be the doctor\'s name, room number, equipment, etc.</td></tr>' +
						   '         <tr><td><strong>Appointment Reason</strong></td>' +
						   '         <td>Reason for the appointment.</td></tr>' +
						   '         <tr><td><strong>Appointment Type</strong></td>' +
						   '         <td>Type of appointment.</td></tr>' +
						   '         <tr><td><strong>Appointment Detail</strong></td>' +
						   '         <td>Appointment details.</td></tr>' +
						   '         <tr><td><strong>Provider ID</strong></td>' +
						   '         <td>Rendering provider\'s NPI</td></tr>' +
						   '         <tr><td><strong>Provider Name</strong></td>' +
						   '         <td>Full name of rendering provider.</td></tr>' +
						   '         <tr><td><strong>Client Appointment ID</strong></td>' +
						   '         <td>This is the appointment ID from the source system</td></tr>' +
						   '         <tr><td><strong>Delete Indicator</strong></td>' +
						   '         <td>Whether appointment was marked for deletion: Y or N</td></tr>' +
						   '         </table>' +
                           '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                           '     </div>' +
                           ' </div>';
                         element.html(helptexthtml);
                        break;
                    case 'DEMOGRAPHIC':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Client Patient ID (Patient ID)</strong></td>' +
                            '<td>Patient ID acquired from the source system.</td></tr>' +
                            '<tr><td><strong>First Name</strong></td>' +
                            '<td>Patient\'s first name.</td></tr>' +
                            '<tr><td><strong>Middle Name</strong></td>' +
                            '<td>Patient\'s middle name.</td></tr>' +
                            '<tr><td><strong>Last Name</strong></td>' +
                            '<td>Patient\'s last name.</td></tr>' +
                            '<tr><td><strong>Name Prefix</strong></td>' +
                            '<td>Mr. / Mrs. / Ms., etc.</td></tr>' +
                            '<tr><td><strong>Name Suffix</strong></td>' +
                            '<td>MD / LNP / Sr. / Jr., etc.</td></tr>' +
                            '<tr><td><strong>Social Security Number</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Date of Birth</strong></td>' +
                            '<td>Format: YYYYMMDD</td></tr>' +
                            '<tr><td><strong>Patient Other ID</strong></td>' +
                            '<td>Source System MRN, Medicare #, etc.</td></tr>' +
                            '<tr><td><strong>Account ID</strong></td>' +
                            '<td>Account ID acquired by the source system.</td></tr>' +
                            '<tr><td><strong>Gender</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Race</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Ethnic Group</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Primary Language</strong></td>' +
                            '<td>Spoken, written or understood primary language, HITSPC80 Section 2.2.1.2.9 value set, http://www.ietf.org/rfc/rfc4646.txt</td></tr>' +
                            '<tr><td><strong>Primary Phone Number</strong></td>' +
                            '<td>Patient\'s primary phone number.</td></tr>' +
                            '<tr><td><strong>Primary Phone Ext</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Primary Phone Type</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Secondary Phone Number</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Secondary Phone Ext</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Secondary Phone Type</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>First Email</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Second Email</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Death Indication</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Death Date</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Address Type</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Address Line 1</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Address Line 2</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>City</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>State</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Zip</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>PCP ID</strong></td>' +
                            '<td></td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'DIAGNOSIS':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic data. patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>ICD9 Code</strong></td>' +
                            '<td>The actual ICD9, 10 or SNOMED code</td></tr>' +
                            '<tr><td><strong>ICD10 Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>LOINC Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>SNOMED Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Diagnosis Description</strong></td>' +
                            '<td>Includes diagnoses from the problem list.</td></tr>' +
                            '<tr><td><strong>Diagnosis Date</strong></td>' +
                            '<td>Format: YYYYMMDD</td></tr>' +
                            '<tr><td><strong>Onset Date</strong></td>' +
                            '<td>Format: YYYYMMDD</td></tr>' +
                            '<tr><td><strong>Resolved Date</strong></td>' +
                            '<td>Format: YYYYMMDD</td></tr>' +
                            '<tr><td><strong>Diagnosis Status Text</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Diagnosis Severity Text</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Clinician</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Encounter Unique ID</strong></td>' +
                            '<td>Encounter ID obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Confidentiality Indicator</strong></td>' +
                            '<td>Y or N</td></tr>' +
                            '<tr><td><strong>Diagnosis Classification</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Chronic Indicator</strong></td>' +
                            '<td>Y or N</td></tr>' +
                            '<tr><td><strong>Diagnosis ID</strong></td>' +
                            '<td>The ID issued in the source system to uniquely identify the diagnosis</td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'IMMUNIZATION':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Service Date</strong></td>' +
                            '<td>Format: YYYYMMDD (Administration Date)</td></tr>' +
                            '<tr><td><strong>Service Time</strong></td>' +
                            '<td>Format: HH:MM:SS</td></tr>' +
                            '<tr><td><strong>CPT Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>CVX Code</strong></td>' +
                            '<td>Must have CVX or RxNorm. Cannot use CPT, SNOMED or LOINC.</td></tr>' +
                            '<tr><td><strong>Immunization Description</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Immunization Dose</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Immunization Units</strong></td>' +
                            '<td>Describes the dose, ex. mg</td></tr>' +
                            '<tr><td><strong>Route Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Route Description</strong></td>' +
                            '<td>Ex. Oral / Intramuscular</td></tr>' +
                            '<tr><td><strong>Performing Clinician NPI</strong></td>' +
                            '<td>NPI of the provider that administered the immunization (NPI)</td></tr>' +
                            '<tr><td><strong>Performing Clinician</strong></td>' +
                            '<td>The name of the provider that administered the immunization</td></tr>' +
                            '<tr><td><strong>Lot Number</strong></td>' +
                            '<td>The manufacturer\'s lot number for the product administered</td></tr>' +
                            '<tr><td><strong>Encounter Unique ID</strong></td>' +
                            '<td>Identifies the encounter during which this was performed</td></tr>' +
                            '<tr><td><strong>LOINC Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>SNOMEDCode</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Exception Reason Code</strong></td>' +
                            '<td>Coded exception reason for not administering the immunization (patient refusal, not available), SNOMED</td></tr>' +
                            '<tr><td><strong>Immunization ID</strong></td>' +
                            '<td>Immunization ID from the client\'s source system</td></tr>' +
                            '</table>' +

                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'LAB ORDER':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText.replace(' ', '') + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText.replace(' ', '') + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText.replace(' ', '') + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText.replace(' ', '') + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Order Number</strong></td>' +
                            '<td>Unique ID for this lab order obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Service Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Service Description</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Ordering Provider ID</strong></td>' +
                            '<td>NPI</td></tr>' +
                            '<tr><td><strong>Ordering Provider Name</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Service Coding System Name</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Encounter Unique ID</strong></td>' +
                            '<td>Unique encounter ID obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Order Date</strong></td>' +
                            '<td>Format: YYYYMMDD</td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'LAB RESULT':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText.replace(' ', '') + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText.replace(' ', '') + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText.replace(' ', '') + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText.replace(' ', '') + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Order Number</strong></td>' +
                            '<td>Unique ID for this lab order obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Observation Date</strong></td>' +
                            '<td>Format: YYYYMMDD</td></tr>' +
                            '<tr><td><strong>Observation Time</strong></td>' +
                            '<td>HH:MM:SS</td></tr>' +
                            '<tr><td><strong>Observation Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Observation Value</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Observation Units</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Reference Range</strong></td>' +
                            '<td>The upper and lower bounds that define a normal value</td></tr>' +
                            '<tr><td><strong>Abnormal Indicator Flag</strong></td>' +
                            '<td>Abnormal Flat returned from lab (ex H, L, HH, LL, ABN)</td></tr>' +
                            '<tr><td><strong>Result Comment</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Observation Coding System</strong></td>' +
                            '<td>Ex. \'LOINC\'</td></tr>' +
                            '<tr><td><strong>Observation Description</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Status</strong></td>' +
                            '<td>Whether or not the lab result was reviewed by the provider</td></tr>' +
                            '<tr><td><strong>Client Lab Result ID</strong></td>' +
                            '<td></td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'MEDICATION':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Medication ID - NDC</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Medication ID - RxNorm</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Medication ID - Other</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Medication Type</strong></td>' +
                            '<td>Prescription or OTC HITSP C80 Section 2.2.3.3.5</td></tr>' +
                            '<tr><td><strong>Medication Name</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Medication Dose</strong></td>' +
                            '<td>Use HITSP C80 Section 2.2.6.6 value set</td></tr>' +
                            '<tr><td><strong>Medication Form</strong></td>' +
                            '<td>Use HITSP C80 Section 2.2.3.3 value set</td></tr>' +
                            '<tr><td><strong>Medication Route</strong></td>' +
                            '<td>How the medication is to be taken. (Intramuscular, Oral, Etc.)</td></tr>' +
                            '<tr><td><strong>Medication SIGCode</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Medication SIG</strong></td>' +
                            '<td>The medication instructions.</td></tr>' +
                            '<tr><td><strong>Duration</strong></td>' +
                            '<td>Length of time medication should be continued.</td></tr>' +
                            '<tr><td><strong>Frequency</strong></td>' +
                            '<td>How often the medication is to be administered.</td></tr>' +
                            '<tr><td><strong>Start Date</strong></td>' +
                            '<td>Date medication was dispensed. Format: YYYYMMDD</td></tr>' +
                            '<tr><td><strong>Stop Date</strong></td>' +
                            '<td>Format: YYYYMMDD</td></tr>' +
                            '<tr><td><strong>Comment</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Quantity</strong></td>' +
                            '<td>How much of the medication is prescribed per refill.</td></tr>' +
                            '<tr><td><strong>Refills</strong></td>' +
                            '<td>The number of refills remaining / allowed for the medication.</td></tr>' +
                            '<tr><td><strong>Fill Status</strong></td>' +
                            '<td>completed, never dispensed, etc.</td></tr>' +
                            '<tr><td><strong>Sample Indicator</strong></td>' +
                            '<td>Y = this prescription is a sample, N = this prescription is not a sample</td></tr>' +
                            '<tr><td><strong>Generic Allowed Indicator</strong></td>' +
                            '<td>Y = generic version may be dispensed, N = generic version is not allowed</td></tr>' +
                            '<tr><td><strong>Brand Name Code</strong></td>' +
                            '<td>HITSP C80 Section 2.2.3.3.7, 2.2.3.3.10</td></tr>' +
                            '<tr><td><strong>Prescribed By NPI</strong></td>' +
                            '<td>The NPI of the provider that prescribed the medication.</td></tr>' +
                            '<tr><td><strong>Status Description</strong></td>' +
                            '<td>Active, Inactive, etc.</td></tr>' +
                            '<tr><td><strong>Encounter Unique ID</strong></td>' +
                            '<td>Identifies the encounter during which this medication was prescribed.</td></tr>' +
                            '<tr><td><strong>Client Medication ID</strong></td>' +
                            '<td></td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'PROCEDURE':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>CPT4/HCPCS Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Procedure Description</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Procedure Date</strong></td>' +
                            '<td>Format: YYYYMMDD</td></tr>' +
                            '<tr><td><strong>Units</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Modifier Code 1</strong></td>' +
                            '<td>CPT-4 or HCPCS modifier code</td></tr>' +
                            '<tr><td><strong>Modifier Code 2</strong></td>' +
                            '<td>CPT-4 or HCPCS modifier code</td></tr>' +
                            '<tr><td><strong>Modifier Code 3</strong></td>' +
                            '<td>CPT-4 or HCPCS modifier code</td></tr>' +
                            '<tr><td><strong>Modifier Code 4</strong></td>' +
                            '<td>CPT-4 or HCPCS modifier code</td></tr>' +
                            '<tr><td><strong>Place of Service</strong></td>' +
                            '<td>CMS place of service. Needs to be the actual name of the location.</td></tr>' +
                            '<tr><td><strong>Performed by Clinician</strong></td>' +
                            '<td>Must be NPI</td></tr>' +
                            '<tr><td><strong>Ordered by Clinician</strong></td>' +
                            '<td>Must be NPI</td></tr>' +
                            '<tr><td><strong>Encounter Unique ID</strong></td>' +
                            '<td>Identifies the encounter during which this was performed from the source system.</td></tr>' +
                            '<tr><td><strong>Internal Charge Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Total Charges</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>LINC Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>SNOMEDCode</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Procedure Result</strong></td>' +
                            '<td>Any result data associated with the performed procedure such as PHQ9, HCPCS, LOINC, SNOMED (mammogram, colonoscopy, diabetic eye exam results, etc.)</td></tr>' +
                            '<tr><td><strong>Dx1 Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Dx2 Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Dx3 Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Dx4 Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Dx5 Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Dx6 Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Dx7 Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Dx8 Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Client Procedure ID</strong></td>' +
                            '<td></td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'SOCIAL':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Smoking Status</strong></td>' +
                            '<td>SNOMED smoking indicator code defined by CMS.</td></tr>' +
                            '<tr><td><strong>Marital Status</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Employment Status</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Transportation Indicator</strong></td>' +
                            '<td>Y = has available transportation, N = does not have transportation available</td></tr>' +
                            '<tr><td><strong>Living Arrangement</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Alcohol User</strong></td>' +
                            '<td>Y = Uses alcohol, N = Does not use alcohol, SNOMED219006 (Y), SNOMED 105542008 (N)</td></tr>' +
                            '<tr><td><strong>Drug User</strong></td>' +
                            '<td>Y = Uses drugs, N = Does not use drugs</td></tr>' +
                            '<tr><td><strong>Caffeine User</strong></td>' +
                            '<td>Y = Uses caffeine, N = does not use caffeine, SNOMED67961000119106 (Y)</td></tr>' +
                            '<tr><td><strong>Sexually Active</strong></td>' +
                            '<td>Y = Is sexually active, N = Is not sexually active, SNOMED228453005 (Y), SNOMED 162171002 (N)</td></tr>' +
                            '<tr><td><strong>Hours of Exercise per Week</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Level of Education</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>First Encounter ID</strong></td>' +
                            '<td>The encounter ID from when the social history was first recorded</td></tr>' +
                            '<tr><td><strong>Client Social ID</strong></td>' +
                            '<td></td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'VITAL':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Service Date</strong></td>' +
                            '<td>Format: YYYYMMDD</td></tr>' +
                            '<tr><td><strong>Service Time</strong></td>' +
                            '<td>Format: HH:MM:SS</td></tr>' +
                            '<tr><td><strong>Height - CM</strong></td>' +
                            '<td>Height in centimeters.</td></tr>' +
                            '<tr><td><strong>Height - IN</strong></td>' +
                            '<td>Height in inches.</td></tr>' +
                            '<tr><td><strong>Height Comment</strong></td>' +
                            '<td>e.g. SNOMED 50373000</td></tr>' +
                            '<tr><td><strong>Weight - KG</strong></td>' +
                            '<td>Weight in kilograms.</td></tr>' +
                            '<tr><td><strong>Weight - LBS</strong></td>' +
                            '<td>Weight in pounds.</td></tr>' +
                            '<tr><td><strong>Weight Comment</strong></td>' +
                            '<td>e.g. SNOMED 27113001</td></tr>' +
                            '<tr><td><strong>Temperature - C</strong></td>' +
                            '<td>Temperature in Celsius.</td></tr>' +
                            '<tr><td><strong>Temperature - F</strong></td>' +
                            '<td>Temperature in Fahrenheit.</td></tr>' +
                            '<tr><td><strong>Temperature Comment</strong></td>' +
                            '<td>e.g. Temporal, SNOMED 386725007 Body Temp, SNOMED 276885007 Core Temp</td></tr>' +
                            '<tr><td><strong>Pulse</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Pulse Comment</strong></td>' +
                            '<td>Regular, SNOMED 78564009 Pulse Rate</td></tr>' +
                            '<tr><td><strong>Respiration</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Respiration Comment</strong></td>' +
                            '<td>Unlabored, SNOMED 86290005 Respiratory Rate</td></tr>' +
                            '<tr><td><strong>Blood Pressure - Systolic</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Blood Pressure - Diastolic</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Blood Pressure Comment</strong></td>' +
                            '<td>Patient position, cuff location, cuff size, SNOMED271649006 Systolic, SNOMED 271650006 Diastolic</td></tr>' +
                            '<tr><td><strong>Oxygen Saturation - SpO2</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Oxygen Saturation - Comment</strong></td>' +
                            '<td>SNOMED 431314004 Peripheral</td></tr>' +
                            '<tr><td><strong>BMI</strong></td>' +
                            '<td>LOINC 39256-5</td></tr>' +
                            '<tr><td><strong>BMI Comment</strong></td>' +
                            '<td>Above Normal Range, Below Normal Range, SNOMED238131007 Overweight, SNOMED 248342006 Underweight</td></tr>' +
                            '<tr><td><strong>Clinician</strong></td>' +
                            '<td>The name of the provider that took the vital readings</td></tr>' +
                            '<tr><td><strong>Encounter Unique ID</strong></td>' +
                            '<td>Identifies the encounter during which this was performed obtained by the source system.</td></tr>' +
                            '<tr><td><strong>Vitals Comment</strong></td>' +
                            '<td>SNOMED 46680005 Vital Signs</td></tr>' +
                            '<tr><td><strong>Client Vitals ID</strong></td>' +
                            '<td></td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'MEDSURG':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Med/Surg History Date</strong></td>' +
                            '<td>Format: YYYYMMDD</td></tr>' +
                            '<tr><td><strong>Med/Surg History Code</strong></td>' +
                            '<td>Type of medical/surgical history observation. (SNOMED, ICD9 or ICD10)</td></tr>' +
                            '<tr><td><strong>Med/Surg History Description</strong></td>' +
                            '<td>Value describing the medical/surgical history. (CABG, AMI, Colectomy, etc.)</td></tr>' +
                            '<tr><td><strong>Med/Surg History Comments</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Client Med/Surg ID</strong></td>' +
                            '<td></td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'ENCOUNTER':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Visit ID</strong></td>' +
                            '<td>When available, this should be an alternate human readable encounter id (e.g. encounter number (enc_nbr)). When not available, this should be the same as the unique encounter id.</td></tr>' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Encounter Type</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Encounter Date</strong></td>' +
                            '<td>Format: YYYYMMDD</td></tr>' +
                            '<tr><td><strong>Encounter Time</strong></td>' +
                            '<td>Format: HHMMSS</td></tr>' +
                            '<tr><td><strong>Location</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Comment</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Encounter Unique ID</strong></td>' +
                            '<td>Encounter ID from the source system. Related in other tables by client_encounter_ID.</td></tr>' +
                            '<tr><td><strong>Reason for Visit - ICD9</strong></td>' +
                            '<td>ICD-9 describing the patient\'s stated reason for seeking care.</td></tr>' +
                            '<tr><td><strong>Clinician</strong></td>' +
                            '<td>The name of the rendering provider</td></tr>' +
                            '<tr><td><strong>Reason for Visit - ICD10</strong></td>' +
                            '<td>ICD-10 describing the patient\'s stated reason for seeking care.</td></tr>' +
                            '<tr><td><strong>Reason for Visit \'- LOINC</strong></td>' +
                            '<td>LOINC describing the patient\'s stated reason for seeking care.</td></tr>' +
                            '<tr><td><strong>Reason for Visit \'- SNOMED</strong></td>' +
                            '<td>SNOMED describing the patient\'s stated reason for seeking care.</td></tr>' +
                            '<tr><td><strong>Member / Subscriber ID</strong></td>' +
                            '<td>Identifier assigned to patient by health plan.</td></tr>' +
                            '<tr><td><strong>Insurance Type</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Status</strong></td>' +
                            '<td>Ex. Filed, Pushed, Signed \'Y\' = Locked; \'N\' = Not Locked</td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'CQM-BMI':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Encounter ID</strong></td>' +
                            '<td>Related to encounter</td></tr>' +
                            '<tr><td><strong>Item Name</strong></td>' +
                            '<td>Name of the quality data being captured.</td></tr>' +
                            '<tr><td><strong>Value</strong></td>' +
                            '<td>The value obtained / recorded for the test / procedure performed.</td></tr>' +
                            '<tr><td><strong>Observation Date</strong></td>' +
                            '<td>Format: MM/DD/YYYY HH:MM:SS AM/PM</td></tr>' +
                            '<tr><td><strong>Code</strong></td>' +
                            '<td>Value only exists if it is obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Code Type</strong></td>' +
                            '<td>LOINC, SNOMED, etc.</td></tr>' +
                            '<tr><td><strong>EMR Section</strong></td>' +
                            '<td>HPI, Lab, Etc. This is the module from the EMRsystem where the data is pulled.</td></tr>' +
                            '<tr><td><strong>Recorded Elsewhere in Extracts</strong></td>' +
                            '<td>Y = is recorded elsewhere in the data captured by jumpSTART.</td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'CHARGE':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Client Charge ID</strong></td>' +
                            '<td>Charge ID obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Encounter ID</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Primary Payer ID</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Primary Financial Class</strong></td>' +
                            '<td>Name of financial class.</td></tr>' +
                            '<tr><td><strong>Primary Insurance Payer</strong></td>' +
                            '<td>Name of primary insurance payer.</td></tr>' +
                            '<tr><td><strong>Secondary Payer ID</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Secondary Financial Class</strong></td>' +
                            '<td>Name of financial class.</td></tr>' +
                            '<tr><td><strong>Secondary Insurance Payer</strong></td>' +
                            '<td>Name of secondary insurance payer.</td></tr>' +
                            '<tr><td><strong>Tertiary Payer ID</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Tertiary Financial Class</strong></td>' +
                            '<td>Name of tertiary financial class.</td></tr>' +
                            '<tr><td><strong>Tertiary Insurance Payer</strong></td>' +
                            '<td>Name of the tertiary insurance payer.</td></tr>' +
                            '<tr><td><strong>CPT Code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>CPT Modifiers</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Place of Service</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Location of Service</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Beginning Date of Service</strong></td>' +
                            '<td>Format: YYYYMMDD</td></tr>' +
                            '<tr><td><strong>Ending Date of Service</strong></td>' +
                            '<td>Format: YYYYMMDD</td></tr>' +
                            '<tr><td><strong>Posting Date of Charge</strong></td>' +
                            '<td>Format: YYYYMMDD</td></tr>' +
                            '<tr><td><strong>Entered Date of Charge</strong></td>' +
                            '<td>Format: YYYYMMDD</td></tr>' +
                            '<tr><td><strong>Units</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Charge Amount</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Allowed Amount</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Primary Payer Amount Paid</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Secondary Payer Amount Paid</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Tertiary Payer Amount Paid</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Patient Amount Paid</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Primary Payer Adjusted Amount</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Secondary Payer Adjusted Amount</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Tertiary Payer Adjusted Amount</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Patient Adjusted Amount</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Rendering Provider ID</strong></td>' +
                            '<td>Rendering provider ID obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Rendering Provider NPI</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Rendering Provider Name</strong></td>' +
                            '<td>Rendering providers full name.</td></tr>' +
                            '<tr><td><strong>dx1 Code</strong></td>' +
                            '<td>Diagnosis Code #1</td></tr>' +
                            '<tr><td><strong>dx2 Code</strong></td>' +
                            '<td>Diagnosis Code #2</td></tr>' +
                            '<tr><td><strong>dx3 Code</strong></td>' +
                            '<td>Diagnosis Code #3</td></tr>' +
                            '<tr><td><strong>dx4 Code</strong></td>' +
                            '<td>Diagnosis Code #4</td></tr>' +
                            '<tr><td><strong>dx5 Code</strong></td>' +
                            '<td>Diagnosis Code #5</td></tr>' +
                            '<tr><td><strong>dx6 Code</strong></td>' +
                            '<td>Diagnosis Code #6</td></tr>' +
                            '<tr><td><strong>dx7 Code</strong></td>' +
                            '<td>Diagnosis Code #7</td></tr>' +
                            '<tr><td><strong>dx8 Code</strong></td>' +
                            '<td>Diagnosis Code #8</td></tr>' +
                            '</table>' +

                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'ATTRIBUTION':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '        <table class="table table-striped">' +
                            '       <tr><td><strong>Patient ID</strong></td>' +
                            '       <td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '       <tr><td><strong>Source Provider Identifier</strong></td>' +
                            '       <td>The source system identifier for the provider this patient is attributed to</td></tr>' +
                            '       <tr><td><strong>Provider NPI</strong></td>' +
                            '       <td></td></tr>' +
                            '       <tr><td><strong>Provider First Name</strong></td>' +
                            '       <td></td></tr>' +
                            '       <tr><td><strong>Provider Last Name</strong></td>' +
                            '       <td></td></tr>' +
                            '       <tr><td><strong>Program Name</strong></td>' +
                            '       <td>The program, or group, that this patient is part of</td></tr>' +
                            '       <tr><td><strong>Location ID</strong></td>' +
                            '       <td>The source system identifier for the location this patient is attributed to</td></tr>' +
                            '       <tr><td><strong>Location Name</strong></td>' +
                            '       <td></td></tr>' +
                            '       <tr><td><strong>Comment</strong></td>' +
                            '       <td></td></tr>' +
                            '       </table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'PROVIDER':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Source Provider Identifier</strong></td>' +
                            '<td>The unique identifier from the source system for this provider record.</td></tr>' +
                            '<tr><td><strong>NPI</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Provider SSN</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>TIN</strong></td>' +
                            '<td>The provider tax ID.</td></tr>' +
                            '<tr><td><strong>Provider\'s first name</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Provider\'s middle name</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Provider\'s last name</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Degree</strong></td>' +
                            '<td>MD, PA, etc.</td></tr>' +
                            '<tr><td><strong>Address Line 1</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Address Line 2</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>City</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>State</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Zip</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Phone 1</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Phone 1 Description</strong></td>' +
                            '<td>Home, Work, Mobile, etc</td></tr>' +
                            '<tr><td><strong>Phone 2</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Phone 2 Description</strong></td>' +
                            '<td>Home, Work, Mobile, etc</td></tr>' +
                            '<tr><td><strong>Specialty 1</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>Specialty 2</strong></td>' +
                            '<td></td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'CQM-BP':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Encounter ID</strong></td>' +
                            '<td>Related to encounter</td></tr>' +
                            '<tr><td><strong>Item Name</strong></td>' +
                            '<td>Name of the quality data being captured.</td></tr>' +
                            '<tr><td><strong>Value</strong></td>' +
                            '<td>The value obtained / recorded for the test / procedure performed.</td></tr>' +
                            '<tr><td><strong>Observation Date</strong></td>' +
                            '<td>Format: MM/DD/YYYY HH:MM:SS AM/PM</td></tr>' +
                            '<tr><td><strong>Code</strong></td>' +
                            '<td>Value only exists if it is obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Code Type</strong></td>' +
                            '<td>LOINC, SNOMED, etc.</td></tr>' +
                            '<tr><td><strong>EMR Section</strong></td>' +
                            '<td>HPI, Lab, Etc. This is the module from the EMRsystem where the data is pulled.</td></tr>' +
                            '<tr><td><strong>Recorded Elsewhere in Extracts</strong></td>' +
                            '<td>Y = is recorded elsewhere in the data captured by jumpSTART.</td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'CQM-COLONOSCOPY':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Encounter ID</strong></td>' +
                            '<td>Related to encounter</td></tr>' +
                            '<tr><td><strong>Item Name</strong></td>' +
                            '<td>Name of the quality data being captured.</td></tr>' +
                            '<tr><td><strong>Value</strong></td>' +
                            '<td>The value obtained / recorded for the test / procedure performed.</td></tr>' +
                            '<tr><td><strong>Observation Date</strong></td>' +
                            '<td>Format: MM/DD/YYYY HH:MM:SS AM/PM</td></tr>' +
                            '<tr><td><strong>Code</strong></td>' +
                            '<td>Value only exists if it is obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Code Type</strong></td>' +
                            '<td>LOINC, SNOMED, etc.</td></tr>' +
                            '<tr><td><strong>EMR Section</strong></td>' +
                            '<td>HPI, Lab, Etc. This is the module from the EMRsystem where the data is pulled.</td></tr>' +
                            '<tr><td><strong>Recorded Elsewhere in Extracts</strong></td>' +
                            '<td>Y = is recorded elsewhere in the data captured by jumpSTART.</td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'CQM-DEPRESSION':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Encounter ID</strong></td>' +
                            '<td>Related to encounter</td></tr>' +
                            '<tr><td><strong>Item Name</strong></td>' +
                            '<td>Name of the quality data being captured.</td></tr>' +
                            '<tr><td><strong>Value</strong></td>' +
                            '<td>The value obtained / recorded for the test / procedure performed.</td></tr>' +
                            '<tr><td><strong>Observation Date</strong></td>' +
                            '<td>Format: MM/DD/YYYY HH:MM:SS AM/PM</td></tr>' +
                            '<tr><td><strong>Code</strong></td>' +
                            '<td>Value only exists if it is obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Code Type</strong></td>' +
                            '<td>LOINC, SNOMED, etc.</td></tr>' +
                            '<tr><td><strong>EMR Section</strong></td>' +
                            '<td>HPI, Lab, Etc. This is the module from the EMRsystem where the data is pulled.</td></tr>' +
                            '<tr><td><strong>Recorded Elsewhere in Extracts</strong></td>' +
                            '<td>Y = is recorded elsewhere in the data captured by jumpSTART.</td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'CQM-DIABEYEEXAM':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Encounter ID</strong></td>' +
                            '<td>Related to encounter</td></tr>' +
                            '<tr><td><strong>Item Name</strong></td>' +
                            '<td>Name of the quality data being captured.</td></tr>' +
                            '<tr><td><strong>Value</strong></td>' +
                            '<td>The value obtained / recorded for the test / procedure performed.</td></tr>' +
                            '<tr><td><strong>Observation Date</strong></td>' +
                            '<td>Format: MM/DD/YYYY HH:MM:SS AM/PM</td></tr>' +
                            '<tr><td><strong>Code</strong></td>' +
                            '<td>Value only exists if it is obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Code Type</strong></td>' +
                            '<td>LOINC, SNOMED, etc.</td></tr>' +
                            '<tr><td><strong>EMR Section</strong></td>' +
                            '<td>HPI, Lab, Etc. This is the module from the EMRsystem where the data is pulled.</td></tr>' +
                            '<tr><td><strong>Recorded Elsewhere in Extracts</strong></td>' +
                            '<td>Y = is recorded elsewhere in the data captured by jumpSTART.</td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'CQM-FALLRISK':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Encounter ID</strong></td>' +
                            '<td>Related to encounter</td></tr>' +
                            '<tr><td><strong>Item Name</strong></td>' +
                            '<td>Name of the quality data being captured.</td></tr>' +
                            '<tr><td><strong>Value</strong></td>' +
                            '<td>The value obtained / recorded for the test / procedure performed.</td></tr>' +
                            '<tr><td><strong>Observation Date</strong></td>' +
                            '<td>Format: MM/DD/YYYY HH:MM:SS AM/PM</td></tr>' +
                            '<tr><td><strong>Code</strong></td>' +
                            '<td>Value only exists if it is obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Code Type</strong></td>' +
                            '<td>LOINC, SNOMED, etc.</td></tr>' +
                            '<tr><td><strong>EMR Section</strong></td>' +
                            '<td>HPI, Lab, Etc. This is the module from the EMRsystem where the data is pulled.</td></tr>' +
                            '<tr><td><strong>Recorded Elsewhere in Extracts</strong></td>' +
                            '<td>Y = is recorded elsewhere in the data captured by jumpSTART.</td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'CQM-HBA1C':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Encounter ID</strong></td>' +
                            '<td>Related to encounter</td></tr>' +
                            '<tr><td><strong>Item Name</strong></td>' +
                            '<td>Name of the quality data being captured.</td></tr>' +
                            '<tr><td><strong>Value</strong></td>' +
                            '<td>The value obtained / recorded for the test / procedure performed.</td></tr>' +
                            '<tr><td><strong>Observation Date</strong></td>' +
                            '<td>Format: MM/DD/YYYY HH:MM:SS AM/PM</td></tr>' +
                            '<tr><td><strong>Code</strong></td>' +
                            '<td>Value only exists if it is obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Code Type</strong></td>' +
                            '<td>LOINC, SNOMED, etc.</td></tr>' +
                            '<tr><td><strong>EMR Section</strong></td>' +
                            '<td>HPI, Lab, Etc. This is the module from the EMRsystem where the data is pulled.</td></tr>' +
                            '<tr><td><strong>Recorded Elsewhere in Extracts</strong></td>' +
                            '<td>Y = is recorded elsewhere in the data captured by jumpSTART.</td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'CQM-INFLUENZA':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Encounter ID</strong></td>' +
                            '<td>Related to encounter</td></tr>' +
                            '<tr><td><strong>Item Name</strong></td>' +
                            '<td>Name of the quality data being captured.</td></tr>' +
                            '<tr><td><strong>Value</strong></td>' +
                            '<td>The value obtained / recorded for the test / procedure performed.</td></tr>' +
                            '<tr><td><strong>Observation Date</strong></td>' +
                            '<td>Format: MM/DD/YYYY HH:MM:SS AM/PM</td></tr>' +
                            '<tr><td><strong>Code</strong></td>' +
                            '<td>Value only exists if it is obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Code Type</strong></td>' +
                            '<td>LOINC, SNOMED, etc.</td></tr>' +
                            '<tr><td><strong>EMR Section</strong></td>' +
                            '<td>HPI, Lab, Etc. This is the module from the EMRsystem where the data is pulled.</td></tr>' +
                            '<tr><td><strong>Recorded Elsewhere in Extracts</strong></td>' +
                            '<td>Y = is recorded elsewhere in the data captured by jumpSTART.</td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'CQM-LVEF':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Encounter ID</strong></td>' +
                            '<td>Related to encounter</td></tr>' +
                            '<tr><td><strong>Item Name</strong></td>' +
                            '<td>Name of the quality data being captured.</td></tr>' +
                            '<tr><td><strong>Value</strong></td>' +
                            '<td>The value obtained / recorded for the test / procedure performed.</td></tr>' +
                            '<tr><td><strong>Observation Date</strong></td>' +
                            '<td>Format: MM/DD/YYYY HH:MM:SS AM/PM</td></tr>' +
                            '<tr><td><strong>Code</strong></td>' +
                            '<td>Value only exists if it is obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Code Type</strong></td>' +
                            '<td>LOINC, SNOMED, etc.</td></tr>' +
                            '<tr><td><strong>EMR Section</strong></td>' +
                            '<td>HPI, Lab, Etc. This is the module from the EMRsystem where the data is pulled.</td></tr>' +
                            '<tr><td><strong>Recorded Elsewhere in Extracts</strong></td>' +
                            '<td>Y = is recorded elsewhere in the data captured by jumpSTART.</td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'CQM-MAMMOGRAM':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Encounter ID</strong></td>' +
                            '<td>Related to encounter</td></tr>' +
                            '<tr><td><strong>Item Name</strong></td>' +
                            '<td>Name of the quality data being captured.</td></tr>' +
                            '<tr><td><strong>Value</strong></td>' +
                            '<td>The value obtained / recorded for the test / procedure performed.</td></tr>' +
                            '<tr><td><strong>Observation Date</strong></td>' +
                            '<td>Format: MM/DD/YYYY HH:MM:SS AM/PM</td></tr>' +
                            '<tr><td><strong>Code</strong></td>' +
                            '<td>Value only exists if it is obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Code Type</strong></td>' +
                            '<td>LOINC, SNOMED, etc.</td></tr>' +
                            '<tr><td><strong>EMR Section</strong></td>' +
                            '<td>HPI, Lab, Etc. This is the module from the EMRsystem where the data is pulled.</td></tr>' +
                            '<tr><td><strong>Recorded Elsewhere in Extracts</strong></td>' +
                            '<td>Y = is recorded elsewhere in the data captured by jumpSTART.</td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'CQM-MEDREC':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Encounter ID</strong></td>' +
                            '<td>Related to encounter</td></tr>' +
                            '<tr><td><strong>Item Name</strong></td>' +
                            '<td>Name of the quality data being captured.</td></tr>' +
                            '<tr><td><strong>Value</strong></td>' +
                            '<td>The value obtained / recorded for the test / procedure performed.</td></tr>' +
                            '<tr><td><strong>Observation Date</strong></td>' +
                            '<td>Format: MM/DD/YYYY HH:MM:SS AM/PM</td></tr>' +
                            '<tr><td><strong>Code</strong></td>' +
                            '<td>Value only exists if it is obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Code Type</strong></td>' +
                            '<td>LOINC, SNOMED, etc.</td></tr>' +
                            '<tr><td><strong>EMR Section</strong></td>' +
                            '<td>HPI, Lab, Etc. This is the module from the EMRsystem where the data is pulled.</td></tr>' +
                            '<tr><td><strong>Recorded Elsewhere in Extracts</strong></td>' +
                            '<td>Y = is recorded elsewhere in the data captured by jumpSTART.</td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'CQM-PNEUMO':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Encounter ID</strong></td>' +
                            '<td>Related to encounter</td></tr>' +
                            '<tr><td><strong>Item Name</strong></td>' +
                            '<td>Name of the quality data being captured.</td></tr>' +
                            '<tr><td><strong>Value</strong></td>' +
                            '<td>The value obtained / recorded for the test / procedure performed.</td></tr>' +
                            '<tr><td><strong>Observation Date</strong></td>' +
                            '<td>Format: MM/DD/YYYY HH:MM:SS AM/PM</td></tr>' +
                            '<tr><td><strong>Code</strong></td>' +
                            '<td>Value only exists if it is obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Code Type</strong></td>' +
                            '<td>LOINC, SNOMED, etc.</td></tr>' +
                            '<tr><td><strong>EMR Section</strong></td>' +
                            '<td>HPI, Lab, Etc. This is the module from the EMRsystem where the data is pulled.</td></tr>' +
                            '<tr><td><strong>Recorded Elsewhere in Extracts</strong></td>' +
                            '<td>Y = is recorded elsewhere in the data captured by jumpSTART.</td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'CQM-TOBACCO':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Encounter ID</strong></td>' +
                            '<td>Related to encounter</td></tr>' +
                            '<tr><td><strong>Item Name</strong></td>' +
                            '<td>Name of the quality data being captured.</td></tr>' +
                            '<tr><td><strong>Value</strong></td>' +
                            '<td>The value obtained / recorded for the test / procedure performed.</td></tr>' +
                            '<tr><td><strong>Observation Date</strong></td>' +
                            '<td>Format: MM/DD/YYYY HH:MM:SS AM/PM</td></tr>' +
                            '<tr><td><strong>Code</strong></td>' +
                            '<td>Value only exists if it is obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Code Type</strong></td>' +
                            '<td>LOINC, SNOMED, etc.</td></tr>' +
                            '<tr><td><strong>EMR Section</strong></td>' +
                            '<td>HPI, Lab, Etc. This is the module from the EMRsystem where the data is pulled.</td></tr>' +
                            '<tr><td><strong>Recorded Elsewhere in Extracts</strong></td>' +
                            '<td>Y = is recorded elsewhere in the data captured by jumpSTART.</td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'CQM-IMPORT':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>Patient ID</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>Encounter ID</strong></td>' +
                            '<td>Related to encounter</td></tr>' +
                            '<tr><td><strong>Item Name</strong></td>' +
                            '<td>Name of the quality data being captured.</td></tr>' +
                            '<tr><td><strong>Value</strong></td>' +
                            '<td>The value obtained / recorded for the test / procedure performed.</td></tr>' +
                            '<tr><td><strong>Observation Date</strong></td>' +
                            '<td>Format: MM/DD/YYYY HH:MM:SS AM/PM</td></tr>' +
                            '<tr><td><strong>Code</strong></td>' +
                            '<td>Value only exists if it is obtained from the source system.</td></tr>' +
                            '<tr><td><strong>Code Type</strong></td>' +
                            '<td>LOINC, SNOMED, etc.</td></tr>' +
                            '<tr><td><strong>EMR Section</strong></td>' +
                            '<td>HPI, Lab, Etc. This is the module from the EMRsystem where the data is pulled.</td></tr>' +
                            '<tr><td><strong>Recorded Elsewhere in Extracts</strong></td>' +
                            '<td>Y = is recorded elsewhere in the data captured by jumpSTART.</td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'CLAIM-TRANSACTION':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>claim_id</strong></td>' +
                            '<td>Unique claim ID</td></tr>' +
                            '<tr><td><strong>transaction_id</strong></td>' +
                            '<td>Unique transaction ID</td></tr>' +
                            '<tr><td><strong>transaction_date</strong></td>' +
                            '<td>Format: YYYYMMDD</td></tr>' +
                            '<tr><td><strong>amount</strong></td>' +
                            '<td>Dollar amount of transaction</td></tr>' +
                            '<tr><td><strong>transaction_type</strong></td>' +
                            '<td>Charge, Payment, Adjustment, Refund</td></tr>' +
                            '<tr><td><strong>units</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>procedure_code</strong></td>' +
                            '<td>CPT Code</td></tr>' +
                            '<tr><td><strong>procedure_description</strong></td>' +
                            '<td>CPT Description</td></tr>' +
                            '<tr><td><strong>modifier_1</strong></td>' +
                            '<td>Procedure modifier</td></tr>' +
                            '<tr><td><strong>modifier_2</strong></td>' +
                            '<td>Procedure modifier</td></tr>' +
                            '<tr><td><strong>modifier_3</strong></td>' +
                            '<td>Procedure modifier</td></tr>' +
                            '<tr><td><strong>modifier_4</strong></td>' +
                            '<td>Procedure modifier</td></tr>' +
                            '<tr><td><strong>dx_1</strong></td>' +
                            '<td>Diagnosis code 1</td></tr>' +
                            '<tr><td><strong>dx_2</strong></td>' +
                            '<td>Diagnosis code 2</td></tr>' +
                            '<tr><td><strong>dx_3</strong></td>' +
                            '<td>Diagnosis code 3</td></tr>' +
                            '<tr><td><strong>dx_4</strong></td>' +
                            '<td>Diagnosis code 4</td></tr>' +
                            '<tr><td><strong>dx_5</strong></td>' +
                            '<td>Diagnosis code 5</td></tr>' +
                            '<tr><td><strong>dx_6</strong></td>' +
                            '<td>Diagnosis code 6</td></tr>' +
                            '<tr><td><strong>dx_7</strong></td>' +
                            '<td>Diagnosis code 7</td></tr>' +
                            '<tr><td><strong>dx_8</strong></td>' +
                            '<td>Diagnosis code 8</td></tr>' +
                            '<tr><td><strong>dx_9</strong></td>' +
                            '<td>Diagnosis code 9</td></tr>' +
                            '<tr><td><strong>dx_10</strong></td>' +
                            '<td>Diagnosis code 10</td></tr>' +
                            '<tr><td><strong>dx_11</strong></td>' +
                            '<td>Diagnosis code 11</td></tr>' +
                            '<tr><td><strong>dx_12</strong></td>' +
                            '<td>Diagnosis code 12</td></tr>' +
                            '<tr><td><strong>payer_id</strong></td>' +
                            '<td>Insurance Policy ID</td></tr>' +
                            '<tr><td><strong>payer_type</strong></td>' +
                            '<td>Primary, Secondary, Tertiary, or Self-Pay as 1, 2, 3, or P</td></tr>' +
                            '<tr><td><strong>parent_transaction_id</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>rendering_provider_id</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>rendering_provider_name</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>rendering_provider_npi</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>billing_provider_taxonomy_code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>billing_provider_id</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>billing_provider_name</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>rendering_provider_npi</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>referring_provider_npi</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>supervising_provider_npi</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>service_facility_npi</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>rendering_provider_name</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>referring_provider_name</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>supervising_provider_name</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>service_facility_name</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>service_facility_address1</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>service_facility_address2</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>service_facility_city</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>service_facility_state</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>service_facility_zip</strong></td>' +
                            '<td></td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'CLAIM':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>claim_id</strong></td>' +
                            '<td>Unique identifier for claim</td></tr>' +
                            '<tr><td><strong>patient_id</strong></td>' +
                            '<td>Related to demographic.patient_id = demographic.patient_id</td></tr>' +
                            '<tr><td><strong>relation_to_insured</strong></td>' +
                            '<td>Patient relationship to policy holder</td></tr>' +
                            '<tr><td><strong>insured_last_name</strong></td>' +
                            '<td>Last name of policy holder</td></tr>' +
                            '<tr><td><strong>insured_first_name</strong></td>' +
                            '<td>First name of policy holder</td></tr>' +
                            '<tr><td><strong>insured_mi</strong></td>' +
                            '<td>Middle name of policy holder</td></tr>' +
                            '<tr><td><strong>insured_dob</strong></td>' +
                            '<td>Valid values: M, F, U, O</td></tr>' +
                            '<tr><td><strong>insured_gender</strong></td>' +
                            '<td>Gender of policy holder</td></tr>' +
                            '<tr><td><strong>insured_address1</strong></td>' +
                            '<td>Policy holder\'s address line 1</td></tr>' +
                            '<tr><td><strong>insured_address2</strong></td>' +
                            '<td>Policy holder\'s address line 2</td></tr>' +
                            '<tr><td><strong>insured_city</strong></td>' +
                            '<td>Policy holder city</td></tr>' +
                            '<tr><td><strong>insured_state</strong></td>' +
                            '<td>Policy holder state</td></tr>' +
                            '<tr><td><strong>insured_zip</strong></td>' +
                            '<td>Policy holder zip</td></tr>' +
                            '<tr><td><strong>insured_telephone</strong></td>' +
                            '<td>Policy holder telephone</td></tr>' +
                            '<tr><td><strong>subscriber_id</strong></td>' +
                            '<td>Primary insurance\'s subscriber_id</td></tr>' +
                            '<tr><td><strong>group_id</strong></td>' +
                            '<td>Primary insurance\'s group_id</td></tr>' +
                            '<tr><td><strong>primary_payer_id</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>primary_financial_class</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>primary_insurer_name</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>secondary_payer_id</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>secondary_financial_class</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>secondary_insurer_name</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>accident_related</strong></td>' +
                            '<td>Y or N</td></tr>' +
                            '<tr><td><strong>accident_type</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>accident_date</strong></td>' +
                            '<td>Format: YYYYMMDD</td></tr>' +
                            '<tr><td><strong>billing_service_date</strong></td>' +
                            '<td>Format: YYYYMMDD</td></tr>' +
                            '<tr><td><strong>pos_code</strong></td>' +
                            '<td>Place of Service code.</td></tr>' +
                            '<tr><td><strong>encounter_id</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>total</strong></td>' +
                            '<td>Total claim amount.</td></tr>' +
                            '<tr><td><strong>tin</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>billing_provider_taxonomy_code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>billing_provider_id</strong></td>' +
                            '<td>Location/Practice\'s NPI.</td></tr>' +
                            '<tr><td><strong>billing_provider_name</strong></td>' +
                            '<td>Location/Practice\'s name</td></tr>' +
                            '<tr><td><strong>rendering_provider_npi</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>referring_provider_npi</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>supervising_provider_npi</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>service_facility_npi</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>rendering_provider_name</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>referring_provider_name</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>supervising_provider_name</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>service_facility_name</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>service_facility_address1</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>service_facility_address2</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>service_facility_city</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>service_facility_state</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>service_facility_zip</strong></td>' +
                            '<td></td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'CLAIM-DIAGNOSIS':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>claim_id</strong></td>' +
                            '<td>Unique claim ID</td></tr>' +
                            '<tr><td><strong>seq_number</strong></td>' +
                            '<td>Diagnosis number (1-12)</td></tr>' +
                            '<tr><td><strong>diagnosis_id</strong></td>' +
                            '<td>Unique diagnosis ID</td></tr>' +
                            '<tr><td><strong>diagnosis_category</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>diagnosis_codeset</strong></td>' +
                            '<td>Valid values: ICD9, ICD10, SNOMED, LOINC</td></tr>' +
                            '<tr><td><strong>diagnosis_code</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>diagnosis_description</strong></td>' +
                            '<td>Description associated with diagnosis code, as found in source data</td></tr>' +
                            '<tr><td><strong>delete_ind</strong></td>' +
                            '<td>Y or N</td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    case 'PAYER':
                        var helptexthtml = '' +
                            ' <script>' +
                            ' $(document).ready(function(){' +
                            '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                            '     $("#' + element[0].innerText + 'Help").toggle();' +
                            '   });' +
                            ' });' +
                            ' </script>' +
                            element[0].innerText +
                            ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                            ' <div class="panel panel-info collapse m-t-sm" id="' + element[0].innerText + 'Help">' +
                            '     <div class="panel-heading">' +
                            '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                            '     </div>' +
                            '     <div class="panel-body">' +
                            '         <p>These are the fields that will be extracted:</p>' +
                            '<table class="table table-striped">' +
                            '<tr><td><strong>payer_id</strong></td>' +
                            '<td>Source system unique payer ID</td></tr>' +
                            '<tr><td><strong>payer_name</strong></td>' +
                            '<td>Insurance Payer name</td></tr>' +
                            '<tr><td><strong>payer_financial_class</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>address_line_1</strong></td>' +
                            '<td>Insurance Address</td></tr>' +
                            '<tr><td><strong>address_line_2</strong></td>' +
                            '<td></td></tr>' +
                            '<tr><td><strong>city</strong></td>' +
                            '<td>Insurance City</td></tr>' +
                            '<tr><td><strong>state</strong></td>' +
                            '<td>Insurance State</td></tr>' +
                            '<tr><td><strong>zip</strong></td>' +
                            '<td>Insurance zip code</td></tr>' +
                            '<tr><td><strong>phone</strong></td>' +
                            '<td>Insurance phone number</td></tr>' +
                            '<tr><td><strong>fax</strong></td>' +
                            '<td>Insurance fax number</td></tr>' +
                            '<tr><td><strong>create_timestamp</strong></td>' +
                            '<td>Source record create timestamp</td></tr>' +
                            '<tr><td><strong>modify_timestamp</strong></td>' +
                            '<td>Source record modified or updated timestamp</td></tr>' +
                            '</table>' +
                            '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                            '     </div>' +
                            ' </div>';
                        element.html(helptexthtml);
                        break;
                    default:
                        var helptexthtml = '' +
                           ' <script>' +
                           ' $(document).ready(function(){' +
                           '   $("#' + element[0].innerText + 'HelpIcon").click(function(){' +
                           '     $("#' + element[0].innerText + 'Help").toggle();' +
                           '   });' +
                           ' });' +
                           ' </script>' +
                             element[0].innerText +
                           ' <i class="fa fa-info-circle" id="' + element[0].innerText + 'HelpIcon"></i>' +
                           ' <div class="panel panel-info collapse m-t-sm" id="'+ element[0].innerText + 'Help">' +
                           '     <div class="panel-heading">' +
                           '         <i class="fa fa-info-circle"></i> Data Extracts:' +
                           '     </div>' +
                           '     <div class="panel-body">' +
                           '         <p>These are the fields that will be extracted:</p>' +
                           '         <table class="table table-striped">' +
                           '         <tr><td><strong>Patient ID</strong></td>' +
                           '         <td>Related to demographic data. patient_id = demographic.patient_id</td></tr>' +
                           '         <tr><td><strong>Allergy ID</strong></td>' +
                           '         <td>The ID used by the source system to identify the allergy.</td></tr>' +
                           '         <tr><td><strong>Encounter ID</strong></td>' +
                           '         <td>The encounter ID from when this allergy was first recorded.</td></tr>' +
                           '         <tr><td><strong>Allergen Type</strong></td>' +
                           '         <td>Allergen type. See Table 006 for cross-reference.</td></tr>' +
                           '         <tr><td><strong>Allergy Description</strong></td>' +
                           '         <td>Description of allergy.</td></tr>' +
                           '         <tr><td><strong>Onset Date</strong></td>' +
                           '         <td>Format: YYYYMMDD</td></tr>' +
                           '         <tr><td><strong>Resolved Date</strong></td>' +
                           '         <td>Format: YYYYMMDD</td></tr>' +
                           '         <tr><td><strong>Allergy Severity</strong></td>' +
                           '         <td>Allergy severity description.</td></tr>' +
                           '         <tr><td><strong>Reaction Code</strong></td>' +
                           '         <td>Code describing the reaction based on HITSP C80 Section 2.2.3.4.1</td></tr>' +
                           '         <tr><td><strong>Allergy Reaction</strong></td>' +
                           '         <td>Allergy reaction description</td></tr>' +
                           '         <tr><td><strong>Product Code</strong></td>' +
                           '         <td>Code describing the product, HITSP C80 Section(s): 2.2.3.3.9, 2.2.3.3.11, 2.2.3.3.7, 2.2.3.3.8)</td></tr>' +
                           '         <tr><td><strong>Comment</strong></td>' +
                           '         <td>Allergy comments from the source system.</td></tr>' +
                           '         </table>' +
                           '         <p>For more information checkout our <a href="https://support.healthjump.com/hc/en-us/articles/360003890452-jumpCONNECT-Standard-Data-Model">help guide</a></p>' +
                           '     </div>' +
                           ' </div>';
                        element.html(helptexthtml);
                        break;
                }
            });
        }
    }
}

/**
* @description: setActivityFlag - Directive use to set the Dashboard Activity flag based on Activity type
* It accept type paramerter as Activity type
* @author : Ravi
* @datecreated : 17-Nov-2016
*/
function setActivityIcon() {
    return {
        restrict: 'EA',
        scope: {
            type: '='
        },
        link: function (scope, element, attrs) {
            if (scope.type == "Passed - Verified in source, see comments") {
                element.addClass('bg-success');
                element.children('i').addClass('fa-thumbs-up');
            } else if(scope.type == "Passed - No Issues") {
                element.addClass('bg-success');
                element.children('i').addClass('fa-thumbs-up');
            } else {
                element.addClass('bg-warning');
                element.children('i').addClass('fa-exclamation-triangle');
            }
        }
    };
}

/**
* @description: setDateFormat - To convert inputed date to provided format
* It will convert date to given format and replace it as current element HTML
* @param {strdate} string date format , {dateformat} moment date format i.e. dddd, mmm , yyyy etc.
* @author : Ravi
* @datecreated : 19-July-2017
*/
function setDateFormat() {
   return {
       restrict: 'EA',
       scope: {
           strdate: '=',
           dateformat: '@'
       },
       link: function(scope, element){
           scope.$watch('strdate', function(){
               var formatedDate = new moment(new Date(scope.strdate)).format(scope.dateformat);
               element.html(formatedDate);
           })
       }
   };
}

/**
 * @description validPassword - directive to match the password and confirm password
 * @author Ravi
 * @date 10-Aug-2017
 */
function validPassword() {
    return {
        require: 'ngModel',
        scope: {
            reference: '=validPassword'
        },
        link: function (scope, elm, attrs, ctrl) {
            ctrl.$parsers.unshift(function (viewValue, $scope) {

                var noMatch = viewValue != scope.reference
                ctrl.$setValidity('noMatch', !noMatch);
                return (noMatch) ? noMatch : !noMatch;
            });

            scope.$watch("reference", function (value) {
                ctrl.$setValidity('noMatch', value === ctrl.$viewValue);
            });
        }
    }
}

/**
* ticketStatus - Directive to set color based on the ticket status
* @author: Ravi - 2017-Aug-29
*/
function ticketStatus() {
    return {
        link: function(scope, element, attrs) {
            switch(attrs.id){
                case 'New':
                    element.addClass('');
                    break;
                case 'Planning':
                    element.addClass('warning-element');
                    break;
                case 'Doing':
                    element.addClass('success-element');
                    break;
                case 'Waiting':
                    element.addClass('danger-element');
                    break;
                case 'Verifying':
                    element.addClass('info-element');
                    break;
            }
        }
    }
}

// To check application browser and set animation valriable according to browser

// Opera 8.0+
var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
// Firefox 1.0+
var isFirefox = typeof InstallTrigger !== 'undefined';
// Safari 3.0+ "[object HTMLElementConstructor]"
var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
// Internet Explorer 6-11
var isIE = /*@cc_on!@*/false || !!document.documentMode;
// Edge 20+
var isEdge = !isIE && !!window.StyleMedia;
// Chrome 1+
var isChrome = !!window.chrome && !!window.chrome.webstore;
// Blink engine detection
var isBlink = (isChrome || isOpera) && !!window.CSS;

var canAnimate = true;
if(isIE || isEdge || isSafari){
   canAnimate =  false;
}

/**
 *
 * Pass all functions into module
 */
angular
    .module('inspinia')
    .directive('fullScroll', fullScroll)
    .directive('slimScroll', slimScroll)
    .directive('defaultImage', defaultImage)
    .directive('agentStatus', agentStatus)
    .directive('setActivityIcon', setActivityIcon)
    .directive('setDateFormat', setDateFormat)
    .directive('validPassword', validPassword)
    .directive('ticketStatus', ticketStatus)
    .directive('tagIcon', tagIcon)
    .directive('extractHelp', extractHelp)
/**
 * @description: API service file to define all API request / response related functions
 * It will request the Laravel API and return response.
 * @author: Ravi
 * @createddate: July-10-2017
 *
 */


APIService.$inject = ['$http']; //Inject APIService Factory into module scope

/*
 * @description: APIService factory will request the API and get the response from there as per requested
 * It returns data on success and return error message on error in response
 * @author: Ravi
 */

var APIBase = 'https://api.healthjump.com/';
// var APIBase = 'http://homestead.app/';
// var APIBase = 'http://hjapi.development/';

var cache = ''; // Define cache global variable, no need to define in every controllers

function APIService($http) {
    var service = {};

    service.get = get;
    service.post = post;
    service.put = put;
    service.remove = remove;
    service.fetchUserProfileImage = fetchUserProfileImage;

    //Agent page static JSON functions
    service.getAgentList = getAgentList;
    service.getHJDWCounts = getHJDWCounts;
    service.getTotalData = getTotalData;
    service.getJSEMRSettings = getJSEMRSettings;

    //Analyze section Static JSON function
    service.getDefaultOrderColumn = getDefaultOrderColumn;

    return service;

    //////// Methods to fetch data from Static JSON

    function getAgentList(customer){
        if (customer != 'sandbox') {
            return get('partner/dashboard_agents');
        } else {
            return $http.get('../assets/static-json/sample/agents.json').then(handleSuccess, handleError('Error getting data'));
        }
    }

    function getHJDWCounts(customer){
        if (customer != 'sandbox') {
            return get('partner/dashboard_counts');
        } else {
            return $http.get('../assets/static-json/sample/hjdw_counts.json').then(handleSuccess, handleError('Error getting data'));
        }
    }

    function getTotalData(customer, dataDate){
        if (customer != 'sandbox') {
            return get('partner/dashboard_data/'+dataDate);
        } else {
            var lastWeek = moment().subtract(1, 'weeks').format('YYYYMMDD');

            if (dataDate != lastWeek) {
                return $http.get('../assets/static-json/sample/dashboard/20181210.json').then(handleSuccess, handleError('Error getting data'));
            } else {
                return $http.get('../assets/static-json/sample/dashboard/20181206.json').then(handleSuccess, handleError('Error getting data'));
            }
        }
    }

    function getJSEMRSettings(customer, agentcode){
        if (customer != 'sandbox') {
            return get('partner/jsemrsettings/' + agentcode);
        } else {
            return $http.get('../assets/static-json/sample/extracts.json').then(handleSuccess, handleError('Error getting data'));
        }
    }

    //########################## Do not change below methods as it fetch data from Larave API ##########

    //function to get data from API using get methos
    function get(action) {
        return $http.get(APIBase + action, {cache: true}).then(handleSuccess, handleError('Error getting data'));
    }

    //function to get data from API using post methos
    function post(action, postData) {
        return $http.post(APIBase + action, postData).then(handleSuccess, handleError('Error getting data'));
    }

    //function to get data from API using put methos
    function put(action, postData) {
        return $http.put(APIBase + action, postData).then(function success(res) {
            return res;
        }, function error(error) {
            return { success: false, message: error };
        });
    }

    //function to remove data from API using delete method
    function remove(action, postData) {
        return $http.delete(APIBase + action, postData).then(function success(res) {
            return res;
        }, function error(error) {
            return { success: false, message: error };
        });
    }

    //To fetch user details from static JSON
    function fetchUserProfileImage(email){
        return $http.get('../assets/static-json/profiles/'+email+'.json').then(handleSuccess, handleError('Error getting data'));
    }

    // function to get defailt ordered columns list from static JSON
    function getDefaultOrderColumn() {
        return $http.get('../assets/static-json/analyze/defaultColumnsOrder.json').then(handleSuccess, handleError('Error getting data'));
    }

    /*
     * @description: handleSuccess function used to handle the success response.
     */
    function handleSuccess(res) {
        return res;
    }

    /*
     * @description: handleError function used to handle the error response.
     */
    function handleError(error) {
        return { success: false, message: error };
    }
}

//To get user define settings
function UserPreferenceService($resource) {
    return $resource(APIBase + 'userprefs/:pref', {pref: '@pref'},
    {
        'get':    { method: 'GET' },
        'query':  { method: 'GET', isArray: true },
        'save':   { method: 'POST' }
    });
}

angular
    .module('inspinia')
    .factory('APIService', APIService)
    .factory('UserPreferenceService', UserPreferenceService);
angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("app/views/agents.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>{{ \'SOURCES\' | translate}}</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li class=\"active\"><strong>{{ \'SOURCES\' | translate}}</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-sm-8\"><div class=\"ibox\"><div class=\"ibox-content\"><span class=\"text-muted small pull-right\">{{ \'LASTUPDATED\' | translate}}: <i class=\"fa fa-clock-o\"></i><set-date-format strdate=\"agentMetaData.execution_time\" dateformat=\"HH:mm a - MM.DD.YYYY\"></set-date-format></span><div class=\"clearfix\"></div><div class=\"input-group m-t\"><input type=\"text\" placeholder=\"{{ \'SEARCHAGENTPLACE\' | translate}}\" ng-model=\"searchText\" ng-keyup=\"searchAgent()\" class=\"input form-control\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn btn-info\" ng-click=\"searchAgent()\"><i class=\"fa fa-search\"></i> {{ \'SEARCH\' | translate}}</button></span></div><div class=\"clients-list\"><ul class=\"tag-list no-padding\"><li ng-repeat=\"tag in connectionTags\" ng-click=\"filterAgent(tag)\"><a href=\"\" class=\"taggin-{{tag}}\" tag-icon=\"\"><i class=\"fa fa-tag\"></i> {{tag}}</a></li></ul><div class=\"clearfix\"></div><span class=\"pull-right small text-muted\">{{totalagents}} {{ \'AGENTS\' | translate}}</span><div class=\"tab-content m-t-md\"><div id=\"tab-1\" class=\"tab-pane active\"><div class=\"full-height-scroll\" full-scroll=\"\"><div class=\"table-responsive\"><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"agent in agents\" class=\"clickable-row\" data-href=\"url://\" ng-click=\"loadAgentDetails(agent)\"><td class=\"client-status\"><span class=\"{{agent.status}}\" agent-status=\"\">&nbsp;</span></td><td><img class=\"b-r-xl p-w-xs\" style=\"width: auto; max-height: 100%; background-color: white;\" alt=\"image\" ng-src=\"{{agent.logo}}\"></td><td class=\"client-link\">{{agent.agentname}}</td><td>{{agent.agentcode}}</td><td data-toggle=\"buttons\" class=\"btn-group btn-group-toggle pull-right\" style=\"display: flex\" role=\"group\"><label class=\"btn btn-secondary btn-info btn-outline btn-sm source-system-button\" id=\"{{agent.index}}-details\" ng-click=\"sourceSystemButton.selected = \'details\'\"><input type=\"radio\" value=\"Info\" autocomplete=\"off\"> Details</label> <label class=\"btn btn-secondary btn-info btn-outline btn-sm source-system-button\" id=\"{{agent.index}}-qc\" ng-click=\"sourceSystemButton.selected = \'qc\'\"><input type=\"radio\" value=\"QC\" autocomplete=\"off\"> QC</label></td></tr></tbody></table></div></div></div></div></div></div></div></div><div ng-hide=\"showSidebar\" class=\"col-sm-4\"><p class=\"text-center\"><i class=\"fa fa-list-alt big-icon\"></i></p><h2 class=\"text-center\">{{ \'CLICKAGENTFORDETAIL\' | translate }}</h2><p></p></div><div ng-show=\"showSidebar\" class=\"col-sm-4 fadeInRight animated\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"tab-content\"><div id=\"contact-1\" class=\"tab-pane active\"><div class=\"row m-b-md\"><div class=\"col-lg-4 text-center\"><div class=\"\" layout=\"row\" layout-align=\"center center\"><img alt=\"image\" class=\"b-r-xl m-t-md\" ng-src=\"{{agentDetails.logo}}\" style=\"width: 100%\"></div></div><div class=\"col-lg-8\"><h2>{{agentDetails.agentname}}</h2><p class=\"text-muted small\">{{ \'LASTCONNECTED\' | translate }}: {{agentDetails.last_heartbeat}}</p><button type=\"button\" class=\"btn btn-info btn-sm btn-block\" ng-click=\"openAddTicketModal(\'new\')\"><i class=\"fa fa-envelope\"></i> {{ \'CREATETICKET\' | translate}}</button></div></div><div class=\"client-detail\"><div class=\"full-height-scroll\" full-scroll=\"\"><span id=\"sourceDetails\" ng-if=\"sourceSystemButton.selected == \'details\'\"><strong>{{ \'TAGS\' | translate}}</strong><tags-input class=\"m-b\" ng-model=\"agentDetails.tag\" on-tag-removed=\"removeTag($tag)\" on-tag-added=\"addNewTag($tag)\"><auto-complete source=\"loadTags($query)\" min-length=\"1\" select-first-match=\"false\"></auto-complete></tags-input><span ng-if=\"agentDetails.notes\"><strong>{{ \'NOTES\' | translate }}</strong><p>{{agentDetails.notes}}</p><hr></span><div><strong>{{ \'RELATEDTICKETS\' | translate}}</strong></div><span ng-hide=\"agentDetails.tickets[0]\"><p class=\"m-t-sm\">Good news! There are no tickets for this practice.</p></span><ul ng-if=\"agentDetails.tickets[0]\" class=\"list-group clear-list\"><li class=\"list-group-item fist-item\" ng-repeat=\"tickets in agentDetails.tickets\"><span class=\"pull-right\" set-date-format=\"\" strdate=\"tickets.date\" dateformat=\"MM.DD.YYYY HH:mm\"></span> <a href=\"\" ng-click=\"openViewTicketModal(tickets)\">{{ \'TICKET\' | translate}} #{{tickets.id}}</a></li></ul><hr><strong>{{ \'EXTRACTS\' | translate }}</strong><ul class=\"list-group\"><li class=\"m-t-sm no-borders\" ng-if=\"!agentDetails.extract_elements.length && !fetchingDetails\"><span>{{ \'NOEXTRACTSCONFIG\' | translate }}</span></li><li class=\"m-t-sm no-borders\" ng-repeat=\"extract in agentDetails.extract_elements | orderBy:\'function_name\'\"><div class=\"switch pull-left m-r-sm\"><div class=\"onoffswitch\"><input type=\"checkbox\" ng-model=\"extract.active_ind\" ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" ng-change=\"updateExtract(extract)\" class=\"onoffswitch-checkbox\" id=\"{{extract.function_name}}\"> <label class=\"onoffswitch-label\" for=\"{{extract.function_name}}\"><span class=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div><span extract-help=\"\">{{extract.function_name.replace(\'DW_\', \'\').replace(\'_\',\' \')}}</span> <span class=\"pull-right\"><a class=\"text-primary\" ng-click=\"getSchedule(agentDetails.agentid, agentDetails.agentcode, extract); scheduleToggle = !scheduleToggle; closeSchedule = false\"><i class=\"fa fa-clock-o\" id=\"scheduleIcon\"></i> Schedule</a></span><div class=\"panel panel-info m-t-sm animated\" ng-show=\"scheduleToggle\" ng-class=\"{bounceOut: closeSchedule}\"><div class=\"panel-heading\"><i class=\"fa fa-clock-o\"></i> Schedule:</div><div class=\"panel-body\"><p><strong>Last Ran:</strong> {{extract.last_execution_time}} UTC</p><div class=\"row\"><div class=\"col-lg-4\"><strong>Scheduled</strong>to run every:</div><div class=\"col-lg-5\"><input type=\"text\" ng-model=\"extract.execution_interval\" class=\"form-control\" ng-value=\"extract.execution_interval\"></div><div class=\"col-lg-3 m-t-xs\">minutes</div></div><div class=\"row m-t\"><div class=\"col-lg-6\"><button class=\"btn btn-info btn-block btn-outline btn-sm\" ng-click=\"closeSchedule = true;scheduleToggle = !scheduleToggle\">Close</button></div><div class=\"col-lg-6\"><button class=\"btn btn-info btn-block btn-sm\" ng-click=\"updateSchedule(agentDetails.agentid, agentDetails.agentcode, extract);\">Save</button></div></div></div></div></li></ul></span><div class=\"sk-spinner-three-bounce text-center\" ng-show=\"fetchingDetails\"><p>{{ \'FETCHINGDATA\' | translate }}</p><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div><span id=\"sourceQC\" ng-if=\"sourceSystemButton.selected == \'qc\'\"><strong>{{ \'QCSUMMARY\'| translate}}</strong><ul class=\"list-group clear-list m-t\"><li class=\"list-group-item fist-item\" ng-if=\"!agentDetails.qcresult.length && !fetchingDetails\"><span>{{ \'NOCLIENTQCDETAIL\' | translate }}</span> <span>{{ \'CLICKCREATETICKET\' | translate }}</span></li><li class=\"list-group-item\" ng-switch=\"status\" ng-class=\"{\'fist-item\':$first}\" ng-repeat=\"(status, count) in agentDetails.statusCount\"><span ng-switch-when=\"Passed - No Issues\" class=\"badge badge-success\">{{count}}</span> <span ng-switch-when=\"Passed - Verified in source, see comments\" class=\"badge badge-warning\">{{count}}</span> <span ng-switch-default=\"\" class=\"badge badge-primary\">{{count}}</span> {{status ? status : \'No Status\'}}</li></ul><strong ng-if=\"agentDetails.qcresult.length && !fetchingDetails\">{{ \'QCDETAIL\' | translate }}</strong><div id=\"vertical-timeline\" class=\"vertical-container dark-timeline\" ng-if=\"agentDetails.qcresult.length && !fetchingDetails\"><div class=\"vertical-timeline-block\" ng-repeat=\"qcresult in agentDetails.qcresult\"><div class=\"vertical-timeline-icon\" set-activity-icon=\"\" type=\"qcresult.status\"><i class=\"fa\"></i></div><div class=\"vertical-timeline-content\"><strong><div ng-bind-html=\"qcresult.recipe\"></div></strong><div ng-if=\"qcresult.status\" class=\"m-t-sm small\" ng-bind-html=\"qcresult.status\"></div><div ng-if=\"qcresult.comment\" class=\"m-t-sm small font-italic\">{{ \'COMMENT\' | translate }}:</div><div ng-if=\"qcresult.comment\" class=\"well white-bg small\" ng-bind-html=\"qcresult.comment\"></div><div class=\"vertical-date small text-muted\">{{qcresult.date.split(\' \')[0]}}</div></div></div></div></span></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/views/analyze.html","<div ng-controller=\"analyzeController\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-sm-6\"><h2>{{currentPage}}</h2></div><div class=\"col-sm-6 m-t-md\" id=\"savePageButtonDiv\" ng-hide=\"isSavedPage\"><button type=\"button\" class=\"btn btn-outline btn-primary pull-right\" ng-click=\"openSaveDashModal()\"><i class=\"fa fa-bookmark\"></i>&nbsp;&nbsp;{{ \'SAVEDASHBOARD\' | translate }}</button><script type=\"text/ng-template\" id=\"saveDashModal.html\"><div class=\"modal-header\"> <button type=\"button\" class=\"close\" ng-click=\"cancel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">{{ \'CLOSE\' | translate }}</span></button> <h4 class=\"modal-title\">{{ \'SAVECUSTOMDASHBOARD\' | translate }}</h4> <small class=\"font-bold\">{{ \'SAVECURDASHTOVIEWLATER\'|translate }}</small> </div> <div class=\"modal-body\"> <div class=\"form-group\" id=\"customDashforminput\"> <label>{{ \'CUSTOMDASHNAME\'|translate }}</label> <input title=\"{{ \'USEALPHANUMCHAR\' | translate }}\" type=\"text\" ng-model=\"items\" value=\"{{items}}\" class=\"form-control\" id=\"customDashBoardName\"> </div> </div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">{{ \'CLOSE\' | translate }}</button> <button id=\"submitCustomDashName\" class=\"btn btn-primary pull-right\" type=\"button\" ng-click=\"saveDashboard()\"><i class=\"fa fa-bookmark\"></i>&nbsp;&nbsp;{{ \'SAVEDASHBOARD\' | translate }}</button> </div></script><div id=\"saveStatusDiv\"></div></div><div class=\"col-sm-6 m-t-md\" id=\"savePageButtonDiv\" ng-show=\"isSavedPage\"><button type=\"button\" class=\"btn btn-outline btn-primary pull-right\" ng-click=\"saveDashboard(currentPage)\"><i class=\"fa fa-bookmark\"></i>&nbsp;&nbsp;{{ \'UPDATEDASHBOARD\' | translate }}</button></div></div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"col-lg-12\" id=\"gettingStarted\" ng-hide=\"hideGettingStarted\"><div class=\"jumbotron\"><h2>{{ \'GETTINGSTARTANALYZE\' | translate }}</h2><ul class=\"list-unstyled\"><li><span class=\"badge badge-primary\">1</span> <span ng-bind-html=\"\'VIEWDATAAVAILINTABLE\' | translate: {currentPage }\"></span></li><li><span class=\"badge badge-info\">2</span> <span ng-bind-html=\"\'SEEDATERANGE\' | translate\"></span></li><li><span class=\"badge badge-danger\">3</span> <span ng-bind-html=\"\'ADDANYADDITION\' | translate\"></span></li><li><span class=\"badge badge-success\">4</span> <span ng-bind-html=\"\'VISUALIZERESLCHARTMEASRCALC\' | translate\"></span></li></ul><p><a role=\"button\" class=\"btn btn-primary btn-lg\" ng-click=\"hideJumbotron()\">{{ \'GOTIT\' | translate }}</a></p></div></div><div class=\"row\"><div class=\"col-lg-5\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>{{ \'ADDVISUAL\' | translate }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"form-horizontal\"><div class=\"form-group\"><div class=\"col-lg-6\"><button id=\"pie-button\" class=\"btn btn-success btn-md btn-block\" ng-click=\"clearChartFilters(\'pie\');\" type=\"button\" ng-disabled=\"isFetchingColumnData\"><i ng-class=\"isFetchingColumnData ? \'fa fa-spinner fa-spin\' : \'fa fa-pie-chart\'\"></i> &nbsp;&nbsp; <span class=\"bold\">{{ \'PIE\' | translate }}</span></button></div><div class=\"col-lg-6\"><button id=\"line-button\" class=\"btn btn-success btn-md btn-block\" ng-click=\"clearChartFilters(\'line\');\" type=\"button\" ng-disabled=\"isFetchingColumnData\"><i ng-class=\"isFetchingColumnData ? \'fa fa-spinner fa-spin\' : \'fa fa-line-chart\'\"></i>&nbsp;&nbsp;<span class=\"bold\">{{ \'LINE\' | translate }}</span></button></div></div><div class=\"form-group\"><div class=\"col-lg-6\"><button id=\"bar-button\" class=\"btn btn-success btn-md btn-block\" ng-click=\"clearChartFilters(\'bar\');\" type=\"button\" ng-disabled=\"isFetchingColumnData\"><i ng-class=\"isFetchingColumnData ? \'fa fa-spinner fa-spin\' : \'fa fa-bar-chart\'\"></i>&nbsp;&nbsp;<span class=\"bold\">{{ \'BAR\' | translate }}</span></button></div><div class=\"col-lg-6\"><button id=\"area-button\" class=\"btn btn-success btn-md btn-block\" ng-click=\"clearChartFilters(\'area\');\" type=\"button\" ng-disabled=\"isFetchingColumnData\"><i ng-class=\"isFetchingColumnData ? \'fa fa-spinner fa-spin\' : \'fa fa-area-chart\'\"></i>&nbsp;&nbsp;<span class=\"bold\">{{ \'Area\' | translate }}</span></button></div></div></div><div class=\"clearfix\"></div></div></div></div><div class=\"col-lg-7\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>{{ \'APPLYFILTER\' | translate }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"form-horizontal\"><div class=\"form-group\"><label class=\"control-label col-sm-3\" for=\"reportrange\">{{ \'DATERANGE\' | translate }}</label><div id=\"reportrange\" class=\"col-sm-7 input-group\"><input id=\"daterange\" type=\"daterange\" ng-model=\"datesRanges\" ranges=\"ranges\" format=\"MMMM DD, YYYY\" startdate=\"01/01/2000\" enddate=\"moment()\" mindate=\"01/01/2000\" maxdate=\"12/31/2020\" opens=\"left\" drops=\"down\" locale=\"locale\" applyclass=\"btn-primary\" cancelclass=\"btn-default\" class=\"form-control\"> <span class=\"input-group-addon\"><i class=\"fa fa-calendar\" ng-click=\"openDateRange()\"></i></span></div></div><div id=\"filterButton\" class=\"form-group\"><label class=\"control-label col-sm-3\" for=\"openSearchFilterModal\">{{ \'COLUMN\' | translate }}</label> <button ng-click=\"openSearchFilterModal()\" id=\"openSearchFilterModal\" ng-disabled=\"isFetchingColumnData\" type=\"button\" class=\"btn btn-primary btn-md\"><i ng-class=\"isFetchingColumnData ? \'fa fa-spinner fa-spin\' : \'fa fa-filter\'\"></i>&nbsp;&nbsp;{{ \'BUILDCUSTFILTER\' | translate }}</button></div><div class=\"clearfix\"></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div id=\"addPieGraphBox\" class=\"ibox\" style=\"display:none;\"><div class=\"ibox-title\"><h5 id=\"custompieTitle\">{{ \'CUSTOMPIEGRAPH\' | translate }}</h5><div class=\"ibox-tools\"><a ng-click=\"clearChartFilters(\'pie\');\"><i class=\"fa fa-times\"></i></a></div></div><div class=\"ibox-content\"><form class=\"form-inline\"><div class=\"form-group m-r-sm\"><label for=\"donutCategory\">{{ \'CATEGORY\' | translate }}</label><select class=\"form-control\" type=\"text\" id=\"donutCategory\" name=\"donutCategory\" ng-model=\"chartFilterCategory\" ng-change=\"visualValidation()\"><option ng-repeat=\"option in columnList\" value=\"{{option.id}}\">{{option.name}}</option></select></div><div class=\"form-group m-r-sm\"><label for=\"donutMeasurement\">{{ \'MEASUREMENT\' | translate }}</label><select class=\"form-control\" type=\"text\" id=\"donutMeasurement\" name=\"donutMeasurement\" ng-model=\"chartFilterMeasurement\" ng-disabled=\"chartFilterCategory.length==0\" ng-change=\"visualValidation()\"><option ng-repeat=\"option in columnList\" value=\"{{option.id}}\">{{option.name}}</option></select></div><div class=\"form-group\"><label for=\"donutCalculation\">{{ \'CALCULATION\' | translate }}</label><select class=\"form-control\" type=\"text\" id=\"donutCalculation\" name=\"donutCalculation\" ng-model=\"chartFilterCalculation\" ng-disabled=\"chartFilterMeasurement.length==0\" ng-require=\"\"><option ng-repeat=\"option in filterCalculation\" value=\"{{option.id}}\">{{option.name}}</option></select></div><button id=\"createpieGraph\" class=\"btn btn-primary\" ng-click=\"createCustomChart(\'pie\')\" ng-disabled=\"chartFilterCalculation.length==0 || isFetchingColumnData\"><i ng-class=\"isFetchingColumnData ? \'fa fa-spinner fa-spin\' : \'\'\"></i> {{ \'CREATE\' | translate }}</button><div class=\"form-group\" id=\"piestatusDiv\"></div></form></div></div><div id=\"addBarGraphBox\" class=\"ibox\" style=\"display:none;\"><div class=\"ibox-title\"><h5 id=\"custombarTitle\">{{ \'CUSTOMBARGRAPH\' | translate }}</h5></div><div class=\"ibox-content\"><form class=\"form-inline\"><div class=\"form-group m-r-sm\"><label for=\"barCategory\">{{ \'CATEGORY\' | translate }}</label><select class=\"form-control\" type=\"text\" id=\"barCategory\" name=\"barCategory\" ng-model=\"chartFilterCategory\" ng-change=\"visualValidation()\"><option ng-repeat=\"option in columnList\" value=\"{{option.id}}\">{{option.name}}</option></select></div><div class=\"form-group m-r-sm\"><label for=\"barMeasurement\">{{ \'MEASUREMENT\' | translate }}</label><select class=\"form-control\" type=\"text\" id=\"barMeasurement\" name=\"barMeasurement\" ng-model=\"chartFilterMeasurement\" ng-disabled=\"chartFilterCategory.length==0\" ng-change=\"visualValidation()\"><option ng-repeat=\"option in columnList\" value=\"{{option.id}}\">{{option.name}}</option></select></div><div class=\"form-group\"><label for=\"barCalculation\">{{ \'CALCULATION\' | translate }}</label><select class=\"form-control\" type=\"text\" id=\"barCalculation\" name=\"barCalculation\" ng-model=\"chartFilterCalculation\" ng-disabled=\"chartFilterCategory.length==0\"><option ng-repeat=\"option in filterCalculation\" value=\"{{option.id}}\">{{option.name}}</option></select></div></form></div><div class=\"ibox-content\"><div id=\"linktoShowbarMultiSeries\"><a ng-click=\"multiSeriesDivToggle(\'bar\');\" style=\"display:block;\"><i class=\"fa fa-plus\"></i> {{ \'CREATEMULSERIESBARGRAPH\' | translate }}</a></div><form class=\"form-inline\" id=\"barMultiSeriesDiv\" style=\"display:none;\"><div class=\"form-group\" style=\"padding: 0px 20px 0px 0px;\"><label>{{ \'COMPARETO\' | translate }}</label></div><div class=\"form-group m-r-sm\"><label for=\"barCalculation2\">{{ \'CALCULATION\' | translate }}</label><select class=\"form-control\" type=\"text\" id=\"barCalculation2\" name=\"barCalculation2\" ng-model=\"chartFilterCalculation2\" ng-disabled=\"chartFilterMeasurement.length==0\"><option ng-repeat=\"option in filterCalculation2\" value=\"{{option.id}}\">{{option.name}}</option></select></div><div class=\"form-group\"><label for=\"barMeasurement2\">{{ \'OF\' | translate }}</label><select class=\"form-control\" type=\"text\" id=\"barMeasurement2\" name=\"barMeasurement2\" ng-model=\"chartFilterMeasurement2\" ng-change=\"visualValidation()\"><option ng-repeat=\"option in columnList\" value=\"{{option.id}}\">{{option.name}}</option></select></div><div class=\"form-group\"><div align=\"right\"><a ng-click=\"multiSeriesDivToggle(\'bar\')\"><i class=\"fa fa-times\"></i></a></div></div></form><br><div class=\"form-group\" id=\"barstatusDiv\" style=\"display:inline;\"></div>&emsp; <button id=\"createbarGraph\" class=\"btn btn-primary\" ng-click=\"createCustomChart(\'bar\')\" ng-disabled=\"chartFilterMeasurement.length==0 || isFetchingColumnData\"><i ng-class=\"isFetchingColumnData ? \'fa fa-spinner fa-spin\' : \'\'\"></i> {{ \'CREATE\' | translate }}</button></div></div><div id=\"addLineGraphBox\" class=\"ibox\" style=\"display:none;\"><div class=\"ibox-title\"><h5 id=\"customlineTitle\">{{ \'CREATECUSTLINEGRAPH\' | translate }}</h5></div><div class=\"ibox-content\"><form class=\"form-inline\"><div class=\"form-group m-r-sm\"><label for=\"lineCategory\">{{ \'CATEGORYX\' | translate }}</label><select class=\"form-control\" type=\"text\" id=\"lineCategory\" name=\"lineCategory\" ng-model=\"chartFilterCategory\" ng-change=\"visualValidation()\"><option ng-repeat=\"option in columnList\" value=\"{{option.id}}\">{{option.name}}</option></select></div><div class=\"form-group m-r-sm\"><label for=\"lineMeasurement\">{{ \'MEASUREMENT\' | translate }}</label><select class=\"form-control\" type=\"text\" id=\"lineMeasurement\" name=\"lineMeasurement\" ng-model=\"chartFilterMeasurement\" ng-disabled=\"chartFilterCategory.length==0\" ng-change=\"visualValidation()\"><option ng-repeat=\"option in columnList\" value=\"{{option.id}}\">{{option.name}}</option></select></div><div class=\"form-group\"><label for=\"lineCalculation\">{{ \'CALCULATION\' | translate }}</label><select class=\"form-control\" type=\"text\" id=\"lineCalculation\" name=\"lineCalculation\" ng-model=\"chartFilterCalculation\" ng-disabled=\"chartFilterCategory.length==0\"><option ng-repeat=\"option in filterCalculation\" value=\"{{option.id}}\">{{option.name}}</option></select></div></form></div><div class=\"ibox-content\"><div id=\"linktoShowlineMultiSeries\"><a ng-click=\"multiSeriesDivToggle(\'line\')\" style=\"display:block;\"><i class=\"fa fa-plus\"></i> {{ \'CREATEMULLINEGRAPH\' | translate }}</a></div><form class=\"form-inline\" id=\"lineMultiSeriesDiv\" style=\"display:none;\"><div class=\"form-group\" style=\"padding: 0px 20px 0px 0px;\"><label>{{ \'COMPARETO\' | translate }}</label></div><div class=\"form-group m-r-sm\"><label for=\"lineCalculation2\">{{ \'CALCULATION\' | translate }}</label><select class=\"form-control\" type=\"text\" id=\"lineCalculation2\" name=\"lineCalculation2\" ng-model=\"chartFilterCalculation2\"><option ng-repeat=\"option in filterCalculation2\" value=\"{{option.id}}\">{{option.name}}</option></select></div><div class=\"form-group\"><label for=\"lineMeasurement2\">{{ \'OF\' | translate }}</label><select class=\"form-control\" type=\"text\" id=\"lineMeasurement2\" name=\"lineMeasurement2\" ng-model=\"chartFilterMeasurement2\" ng-disabled=\"chartFilterCalculation2.length==0\" ng-change=\"visualValidation()\"><option ng-repeat=\"option in columnList\" value=\"{{option.id}}\">{{option.name}}</option></select></div><div class=\"form-group\"><div align=\"right\"><a ng-click=\"multiSeriesDivToggle(\'line\')\"><i class=\"fa fa-times\"></i></a></div></div></form><br><div class=\"form-group\" id=\"linestatusDiv\" style=\"display:inline;\"></div>&emsp; <button id=\"createlineGraph\" class=\"btn btn-primary\" ng-click=\"createCustomChart(\'line\')\" ng-disabled=\"chartFilterMeasurement.length==0 || isFetchingColumnData\"><i ng-class=\"isFetchingColumnData ? \'fa fa-spinner fa-spin\' : \'\'\"></i> {{ \'CREATE\' | translate }}</button></div></div><div id=\"addAreaGraphBox\" class=\"ibox\" style=\"display:none;\"><div class=\"ibox-title\"><h5 id=\"customareaTitle\">{{ \'CREATECUSTAREAGRAPH\' | translate }}</h5></div><div class=\"ibox-content\"><form class=\"form-inline\"><div class=\"form-group m-r-sm\"><label for=\"areaCategory\">{{ \'CATEGORYX\' | translate }}</label><select class=\"form-control\" type=\"text\" id=\"areaCategory\" name=\"areaCategory\" ng-model=\"chartFilterCategory\" ng-change=\"visualValidation()\"><option ng-repeat=\"option in columnList\" value=\"{{option.id}}\">{{option.name}}</option></select></div><div class=\"form-group m-r-sm\"><label for=\"areaMeasurement\">{{ \'MEASUREMENT\' | translate }}</label><select class=\"form-control\" type=\"text\" id=\"areaMeasurement\" name=\"areaMeasurement\" ng-model=\"chartFilterMeasurement\" ng-disabled=\"chartFilterCategory.length==0\" ng-change=\"visualValidation()\"><option ng-repeat=\"option in columnList\" value=\"{{option.id}}\">{{option.name}}</option></select></div><div class=\"form-group\"><label for=\"areaCalculation\">{{ \'CALCULATION\' | translate }}</label><select class=\"form-control\" type=\"text\" id=\"areaCalculation\" name=\"areaCalculation\" ng-model=\"chartFilterCalculation\" ng-disabled=\"chartFilterCategory.length==0\"><option ng-repeat=\"option in filterCalculation\" value=\"{{option.id}}\">{{option.name}}</option></select></div></form></div><div class=\"ibox-content\"><div id=\"linktoShowareaMultiSeries\"><a ng-click=\"multiSeriesDivToggle(\'area\');\" style=\"display:block;\"><i class=\"fa fa-plus\"></i> {{ \'CREATEMULAREAGRAPH\' | translate }}</a></div><form class=\"form-inline\" id=\"areaMultiSeriesDiv\" style=\"display:none;\"><div class=\"form-group\" style=\"padding: 0px 20px 0px 0px;\"><label>{{ \'COMPARETO\' | translate }}</label></div><div class=\"form-group m-r-sm\"><label for=\"areaMeasurement2\">{{ \'MEASUREMENT\' | translate }}</label><select class=\"form-control\" type=\"text\" id=\"areaMeasurement2\" name=\"areaMeasurement2\" ng-model=\"chartFilterMeasurement2\" ng-change=\"visualValidation()\"><option ng-repeat=\"option in columnList\" value=\"{{option.id}}\">{{option.name}}</option></select></div><div class=\"form-group\"><label for=\"areaCalculation2\">{{ \'CALCULATION\' | translate }}</label><select class=\"form-control\" type=\"text\" id=\"areaCalculation2\" name=\"areaCalculation2\" ng-model=\"chartFilterCalculation2\" ng-disabled=\"chartFilterMeasurement.length==0\"><option ng-repeat=\"option in filterCalculation2\" value=\"{{option.id}}\">{{option.name}}</option></select></div><div class=\"form-group\"><div align=\"right\"><a ng-click=\"multiSeriesDivToggle(\'area\');\"><i class=\"fa fa-times\"></i></a></div></div></form><br><div class=\"form-group\" id=\"areastatusDiv\" style=\"display:inline;\"></div>&emsp; <button id=\"createareaGraph\" class=\"btn btn-primary\" ng-click=\"createCustomChart(\'area\')\" ng-disabled=\"chartFilterMeasurement.length==0 || isFetchingColumnData\"><i ng-class=\"isFetchingColumnData ? \'fa fa-spinner fa-spin\' : \'\'\"></i> {{ \'CREATE\' | translate }}</button></div></div></div></div><div class=\"row\"><div id=\"userGraphs\" compile-data=\"\" template=\"\" class=\"userGraphs\"></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>{{ \'RAWDATA\' | translate:{currentPage} }}</h5><div ibox-tools-full-screen=\"\"></div></div><div class=\"ibox-content\"><div class=\"jqGrid_wrapper\"><script type=\"text/ng-template\" id=\"searchFilterModal.html\"><div class=\"modal-header\" style=\"text-align:center;\"> <h3>{{ \'SEARCHFILTERS\' | translate }}</h3> </div> <div class=\"modal-body\"> <div id=\"query\"></div> <div id=\"tab1\"></div> <br/> <input type=\"button\" value=\"+ {{ \'ADDRULE\' | translate }}\" ng-click=\"addFilterInput()\" title=\"{{ \'ADDRULE\' | translate }}\" class=\"add-rule ui-add\"> </div> <div class=\"modal-footer\"> <div id=\"applyfiltersDiv\"> <button ng-click=\"clearFilters()\" id=\"submitCustomDashName\" class=\"btn btn-warning\" type=\"button\"><i class=\"fa fa-undo\"></i>&nbsp;&nbsp;{{ \'CLEARFILTERS\' | translate }}</button>&nbsp; <button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">{{ \'CANCEL\' | translate }}</button> <button ng-click=\"applyFilters()\" id=\"submitCustomDashName\" class=\"btn btn-primary pull-right\" type=\"button\"><i class=\"fa fa-search\"></i>&nbsp;&nbsp;{{ \'APPLY\' | translate }}</button> </div> </div></script><div id=\"dataGrid\" ui-grid=\"dataGridOptions\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\" ui-grid-move-columns=\"\" ui-grid-save-state=\"\" class=\"grid\"></div></div></div></div></div></div><div id=\"hiddenDiv\"></div></div></div>");
$templateCache.put("app/views/dbexplorer.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>DBExplorer</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li class=\"active\"><strong>DBExplorer</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-5 text-center\"><div class=\"row\"><img src=\"/img/dbexplorer.png\" height=\"128\" width=\"128\"></div><div class=\"row\"><h1>DBExplorer helps you make sense of your data</h1></div><div class=\"row\"><div class=\"well white-bg m-t-md m-b-lg\"><p>Connect and query your data sources, build dashboards to visualize data and share them with your company. Click <a href=\"https://support.healthjump.com/hc/en-us/articles/360016096692-Using-DBExplorer\">here</a> to access our knowledge base article for more information.</p></div></div><div class=\"row\"><button type=\"button\" class=\"btn btn-primary btn-lg m-b-lg\" ng-click=\"dbexplorer.launchdbexplorer()\"><i class=\"fa fa-external-link\" aria-hidden=\"true\"></i> Launch DBExplorer</button></div></div><div class=\"col-lg-7\"><div style=\"width: 720px;-webkit-box-shadow: 0 6px 18px -5px rgba(175,175,175,.5);-moz-box-shadow: 0 6px 18px -5px rgba(175,175,175,.5);box-shadow: 0 6px 18px -5px rgba(175,175,175,.5);\" class=\"hidden-xs\"><video width=\"100%\" height=\"100%\" autoplay=\"\" loop=\"\" muted=\"\" id=\"main-video\"><source src=\"https://healthjump-public.s3.amazonaws.com/videos/dbx-intro.mp4\" type=\"video/mp4\"><source src=\"https://redash.io/assets/images/elements/redash-intro-720.ogv\" type=\"video/ogg\"><source src=\"https://redash.io/assets/images/elements/redash-intro-720.webm\" type=\"video/webm\">Your browser does not support the video tag.</video><p class=\"pull-right text-muted\">Healthjump\'s DBExplorer - powered by redash</p></div></div></div></div>");
$templateCache.put("app/views/filemanager.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>File Manager</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li class=\"active\"><strong>File Manager</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight\" style=\"padding-top: 0;\"><div class=\"context-menu\" ng-show=\"showContextMenu\"><ul class=\"menu-options\" id=\"menu-options\"><li class=\"menu-option info-option disabled-menu-option\" id=\"info-menu-option\" ng-click=\"showfileStatsFileContainerFunc();\"><span class=\"info-icon\">i</span>View Details</li><a id=\"download-menu-option\" ng-click=\"addDownloadLink();\"><li class=\"menu-option disabled-menu-option\" id=\"download-menu-option-li\"><i class=\"fa fa-arrow-down\"></i>Download</li></a><li ng-click=\"getFile();copyFilesToastr();\" id=\"copy-menu-option\" class=\"menu-option disabled-menu-option\"><i class=\"fa fa-files-o\"></i>Copy</li><li ng-click=\"pasteFile()\" id=\"paste-menu-option\" class=\"menu-option disabled-menu-option\"><i class=\"fa fa-paste\"></i>Paste</li><li ng-click=\"getFile();showRenameContainerFunc();\" id=\"rename-menu-option\" class=\"menu-option disabled-menu-option\"><i class=\"fa fa-pencil\"></i>Rename</li><li ng-click=\"showDeletePromptContainerFunc();\" id=\"delete-menu-option\" style=\"border-top: 1px solid rgba(161, 157, 157, 0.603); padding-top: 15px;\" class=\"menu-option disabled-menu-option\"><i class=\"fa fa-trash-o\"></i>Delete</li><li id=\"move-to-menu-option\" class=\"menu-option disabled-menu-option\"><i class=\"fa fa-long-arrow-right\"></i>Move To ...</li></ul><div id=\"folder-menu\" style=\"border-left: 1px solid rgba(161, 157, 157, 0.603);\"><ul class=\"menu-options\"><li class=\"menu-option\" ng-click=\"showMovePromptContainerFunc();\"><i class=\"fa fa-external-link\"></i> See all folders</li><li class=\"menu-option\" ng-click=\"getFileToMove(d.name);moveFile();\" ng-repeat=\"d in folderFiles | orderBy:myOrderBy:reverse | start: (currentPage - 1) * pageSize | limitTo: pageSize\"><i class=\"fa fa-folder\"></i> {{d.displayName}}</li></ul></div></div><div class=\"file-manager row\" id=\"file-manager-height-container\"><div class=\"col-12\" id=\"table-flex-container\"><div id=\"table-container\" ng-style=\"{\'width\':shrinkTable === true ? \'calc(100% - 350px)\' : \'100%\' }\"><div class=\"row options-bar\"><div class=\"col-xs-4 col-sm-4 col-md-6 no-padding section-1\"><button type=\"button\" ng-click=\"showUploadFileContainerFunc();\" class=\"btn btn-md btn-primary upload-btn\"><i class=\"fa fa-plus\"></i>Upload</button></div></div><div class=\"row search-bar\"><div class=\"col-lg-12\"><input type=\"text\" placeholder=\"Search Files\" ng-model=\"searchFiles\" ng-change=\"filterFiles()\" class=\"input-lg form-control rounded\"></div></div><div class=\"\"><div id=\"file-manager-window\" right-click=\"showContextMenuFunc();showOptionsFunc();\" class=\"col-12 table table-striped table-hover\"><div class=\"row universal-options-bar\"><section class=\"breadcrumb-header\"><div class=\"logo-and-nav-wrap\"><div class=\"site-nav-wrap\"><nav class=\"breadcrumb-nav\"><div class=\"single-breadcrumb-wrap\"><span class=\"sep\"><i class=\"fa fa-caret-right\"></i></span> <span class=\"breadcrumb-link\"><a class=\"breadcrumb-anchor\" ng-click=\"changeDirectory(basePrefix, baseLink, baseType)\">{{baseLink}}</a></span></div><div class=\"single-breadcrumb-wrap\" ng-repeat=\"b in breadcrumbsList\"><span class=\"sep\"><i class=\"fa fa-caret-right\"></i></span> <span class=\"breadcrumb-link\"><a class=\"breadcrumb-anchor\" ng-click=\"changeDirectory(b.prefix, b.link, b.type)\">{{b.link}}</a></span></div></nav></div></div></section><div class=\"options-buttons-row no-padding\"><span class=\"options-span\" ng-show=\"showInfoButton\"><button ng-click=\"showfileStatsFileContainerFunc();\" class=\"btn btn-sm btn-primary options-btn\" data-toggle=\"tooltip\" data-placement=\"bottom\" title=\"Get File Info\"><div class=\"info-icon\">i</div></button></span> <span ng-show=\"showDeleteButton\" class=\"options-span\"><button ng-click=\"showDeletePromptContainerFunc();\" class=\"btn btn-sm btn-primary options-btn\" data-toggle=\"tooltip\" data-placement=\"bottom\" title=\"Delete Files\"><i class=\"fa fa-trash-o\"></i></button></span> <span ng-show=\"showCopyButton\" class=\"options-span\"><button type=\"button\" ng-click=\"getFile();copyFilesToastr();\" class=\"btn btn-sm btn-primary options-btn\" data-toggle=\"tooltip\" data-placement=\"bottom\" title=\"Copy Files\"><i class=\"fa fa-files-o\"></i></button></span> <span ng-show=\"showMoveButton\" class=\"options-span\"><button type=\"button\" ng-click=\"showMovePromptContainerFunc();\" class=\"btn btn-sm btn-primary options-btn\" data-toggle=\"tooltip\" data-placement=\"bottom\" title=\"Move Files\"><i class=\"fa fa-long-arrow-right\"></i></button></span> <span class=\"options-span\" id=\"new-folder-span\" ng-show=\"showNewFolderButton\"><button type=\"button\" ng-click=\"showNewFolderContainerFunc();\" class=\"btn btn-sm btn-primary options-btn\" data-toggle=\"tooltip\" data-placement=\"bottom\" title=\"Create New Folder\"><i class=\"fa fa-folder-o\"></i></button></span> <a disabled=\"\" type=\"button\" id=\"download-link\" class=\"btn btn-md btn-primary download-btn\" ng-click=\"addDownloadLink();\"><i class=\"fa fa-arrow-down\"></i> <span class=\"download-span\">Download</span></a></div></div><div><div class=\"file-headers col-12\"><div class=\"select-header col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1\"><input class=\"i-checks\" type=\"checkbox\" ng-model=\"selectedAllFiles\" ng-click=\"allFiles();showOptionsFunc();\" style=\"cursor: pointer;\" ng-style=\"{\'opacity\': \'0\', \'position\': \'absolute\', \'top\': \'3px\' }\"> <i class=\"fa\" ng-style=\"{\'opacity\':f.type === \'Folder\' ? \'0\' : \'1\', \'font-size\': \'16px\' }\" ng-class=\"selectedAllFiles === true ? \'fa-check-square-o\' : \'fa-square-o\'\"></i></div><div class=\"name-header\"><i class=\"fa fa-file\"></i>Name <button type=\"button\" class=\"sort-btn\" ng-click=\"orderByMe(\'[type === Folder, name]\')\" ng-class=\"{reverse: reverse}\"><i class=\"fa fa-sort\"></i></button></div><div class=\"type-header\">Type <button type=\"button\" class=\"sort-btn\" ng-click=\"orderByMe(\'[type===Folder]\')\" ng-class=\"{reverse: reverse}\"><i class=\"fa fa-sort\"></i></button></div><div class=\"date-header\">Last Modified <button type=\"button\" class=\"sort-btn\" ng-click=\"orderByMe(\'date\')\" ng-class=\"{reverse: reverse}\"><i class=\"fa fa-sort\"></i></button></div><div class=\"size-header\">Size</div><div class=\"options-header\"><div class=\"header-options\"><button type=\"button\" class=\"btn btn-sm btn-primary data-btn\"><i class=\"fa fa-arrow-circle-o-down\"></i></button></div></div></div></div><label class=\"file-data col-12\" right-click=\"showContextMenuFunc();rightClickSelect(f);getfileStatsFile(f);\" ng-dblclick=\"changeDirectory(f.name, f.displayName, f.type)\" ng-style=\"{\'border\':f.selected === true ? \'2px solid #F35B2B\' : \'1px solid rgba(165, 162, 162, 0.301)\', \'transition\': \'border linear 0.07s\', \'cursor\': \'default\' }\" ng-repeat=\"f in filterFiles | orderBy:myOrderBy:reverse | start: (currentPage - 1) * pageSize | limitTo: pageSize\"><div class=\"select-data col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1\"><input type=\"checkbox\" ng-style=\"{\'display\': \'none\' }\" class=\"i-checks\" checklist-model=\"fileList.selected\" checklist-value=\"f\" ng-click=\"checkFileStatus();showOptionsFunc();getfileStatsFile();\"> <i class=\"fa\" style=\"cursor: pointer;\" ng-style=\"{\'opacity\':f.type === \'Folder\' ? \'0\' : \'1\', \'font-size\': \'16px\' }\" ng-class=\"f.selected === true ? \'fa-check-square-o\' : \'fa-square-o\'\"></i></div><div class=\"name-data\"><i class=\"fa\" ng-class=\"f.icon\"></i> <span class=\"name-container\" ng-class=\"{\'folder-name\':f.type === \'Folder\'}\" ng-style=\"{\'cursor\':f.type ===\'Folder\' ? \'pointer\' : \'default\'}\" ng-click=\"changeDirectory(f.name, f.displayName, f.type)\" data-toggle=\"tooltip\" data-placement=\"bottom\" title=\"Open Folder\">{{f.displayName | limitTo: 75}}{{f.displayName.length > 75 ? \'...\' : \'\'}}</span></div><div class=\"type-data\">{{f.type}}</div><div class=\"date-data\">{{f.date | date: \'MM/dd/yyyy\'}}</div><div class=\"size-data\">{{f.size}}</div><div class=\"data-options\"><button type=\"button\" class=\"btn btn-sm btn-primary data-btn\" ng-style=\"{\'opacity\':f.type === \'Folder\' ? \'0\' : \'1\', \'pointer-events\':f.type === \'Folder\' ? \'none\' : \'initial\' }\" data-toggle=\"tooltip\" data-placement=\"bottom\" title=\"Download File\"><a href=\"{{f.url}}\" download=\"\"><i class=\"fa fa-arrow-circle-o-down\"></i></a></button></div></label><uib-pagination total-items=\"totalFilesList\" ng-model=\"currentPage\" max-size=\"15\" boundary-links=\"true\" items-per-page=\"pageSize\" class=\"pagination-sm\"></uib-pagination></div></div></div><div class=\"fileStats-container\" ng-show=\"showfileStatsFileContainer\"><div class=\"top-row\"><a type=\"button\" ng-click=\"showfileStatsFileContainerFunc();\" class=\"btn no-padding\"><i class=\"fa fa-times\"></i></a></div><div class=\"fileStats-title\"><div class=\"stats-title-container\"><i class=\"fa\" ng-class=\"fileStatsFile.fileStatsIcon\"></i><h3>{{fileStatsFile.displayName}}</h3></div></div><div class=\"details-header\">Details</div><div class=\"fileStats-details\"><table class=\"fileStats-table\"><tr><th>Type</th><td>{{fileStatsFile.type}}</td></tr><tr><th>Size</th><td>{{fileStatsFile.size}}</td></tr><tr><th>Last Modified</th><td>{{fileStatsFile.date | date: \'MM/dd/yyyy\'}}</td></tr><tr><th>Owner</th><td>Me</td></tr><tr><th>Location</th><td><i class=\"fa fa-folder\"></i>{{fileStatsFile.location}}</td></tr></table></div><div class=\"preview-header\">Preview</div><div class=\"preview-container\" ng-style=\"{\'background\':fileStatsFile.type === \'Image\' ? \'white\' : \' rgba(165, 162, 162, 0.596)\'}\"><img src=\"{{fileStatsFile.url}}\" ng-style=\"{\'display\':fileStatsFile.type === \'Image\' ? \'initial\' : \'none\'}\"> <i class=\"jumbo-icon fa\" ng-class=\"fileStatsFile.fileStatsIcon\" ng-style=\"{\'display\':fileStatsFile.type === \'Image\' ? \'none\' : \'block\'}\"></i></div><div class=\"actions-header\">Actions</div><div class=\"actions-container\"><button class=\"btn btn-primary btn-md\" id=\"stats-copy-btn\" ng-click=\"getFile();copyFilesToastr();\"><i class=\"fa fa-files-o\"></i> Copy</button> <button class=\"btn btn-primary btn-md\" id=\"stats-rename-btn\" ng-click=\"getFile();showRenameContainerFunc();\"><i class=\"fa fa-pencil\"></i> Rename</button> <button class=\"btn btn-primary btn-md\" id=\"stats-move-btn\" ng-click=\"showMovePromptContainerFunc();\"><i class=\"fa fa-long-arrow-right\"></i> Move</button> <a class=\"btn btn-primary btn-md\" id=\"stats-download-btn\" ng-click=\"addDownloadLink();\"><i class=\"fa fa-arrow-down\"></i> Download</a> <button class=\"btn btn-primary btn-md\" id=\"stats-delete-btn\" ng-click=\"showDeletePromptContainerFunc();\"><i class=\"fa fa-trash-o\"></i> Delete</button></div></div></div></div></div><div class=\"new-folder-prompt-container\" ng-show=\"showNewFolderContainer\"><div class=\"input-container\"><div class=\"top-row\"><h3>Create new folder</h3><a type=\"button\" ng-click=\"showNewFolderContainerFunc();\" class=\"btn no-padding\"><i class=\"fa fa-times\"></i></a></div><form id=\"new-folder-input\" ng-submit=\"createFolder();\"><input type=\"text\" id=\"foldername-input\" placeholder=\"Untitled folder\" ng-model=\"foldername\" ng-focus=\"true\" class=\"input-md form-control rounded\"> <button type=\"submit\" style=\"visibility: hidden\">hidden submit</button></form><div class=\"bottom-row\"><button type=\"button\" class=\"btn btn-warning\" ng-click=\"showNewFolderContainerFunc();\">Cancel</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"createFolder();\">Create</button></div></div></div><div class=\"rename-prompt-container\" ng-show=\"showRenameContainer\"><div class=\"input-container\"><div class=\"top-row\"><h3>Rename File</h3><a type=\"button\" ng-click=\"showRenameContainerFunc();\" class=\"btn no-padding\"><i class=\"fa fa-times\"></i></a></div><form ng-submit=\"renameFile();\"><input id=\"rename-input\" type=\"text\" ng-model=\"filename\" ng-focus=\"true\" class=\"input-md form-control rounded\"> <button type=\"submit\" style=\"visibility: hidden\">hidden submit</button></form><div class=\"bottom-row\"><button type=\"button\" class=\"btn btn-warning\" ng-click=\"showRenameContainerFunc();\">Cancel</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"renameFile();\">Submit</button></div></div></div><div class=\"file-upload-prompt-container\" ng-show=\"showUploadFileContainer\"><div class=\"input-container\" style=\"display: none;\"><form ng-submit=\"showUploadFileContainerFunc();\"><div class=\"top-row\"><h3>Select File(s) to Upload</h3><a type=\"button\" ng-click=\"showUploadFileContainerFunc();\" class=\"btn no-padding\" ng-style=\"{\'pointer-events\': showLoader === true ? \'none\' : \'auto\', \'opacity\': showLoader === true ? \'0.5\' : \'1\'}\"><i class=\"fa fa-times\"></i></a></div><div class=\"bottom-row\"><input type=\"file\" ng-model=\"uploadInput\" name=\"...\" class=\"fileinput-new\" id=\"fileUploader\" multiple=\"\"><div ng-show=\"showLoader\" class=\"loader\"></div><button type=\"button\" id=\"upload-button\" class=\"btn btn-primary\" ng-click=\"uploadFile();\" ng-class=\"{\'disabled\': uploadValue === 0}\">Upload</button></div></form></div><div class=\"inmodal\" style=\"padding: 10px 40px; position: relative; background: white; border-radius: 5px;\"><div style=\"z-index: 2000;\"><img src=\"\" id=\"profile-image\" width=\"270px\"></div><div class=\"modal-header\" style=\"padding: 10px 0 20px 0; border: none\"><h6 class=\"modal-title\" style=\"float: left; font-size: 18px;\">{{ \'Upload files\' | translate }}</h6></div><div ng-show=\"fileSelected\" style=\"position: absolute; top: 90px; z-index: 3000; width: 370px; height: 370px; margin: 0 auto; display: flex; flex-direction: column; align-items: center; outline: none; overflow-y: scroll;\"><div ng-repeat=\"d in displayFiles\" ng-hide=\"!fileSelected\" style=\"border: 0.1em solid #F35B2B; border-radius: 5px; background: white; width: 360px; padding: 10px 15px; margin: 5px; opacity: 0;\" ng-style=\"{\'animation\': \'fade-in forwards 0.3s 0.{{$index}}s\'}\"><span style=\"outline: none; font-weight: 400; font-size: 18px; margin-right: 5px;\" ng-click=\"removeFile(d.$$hashKey)\">x</span> {{d.name}}</div></div><div class=\"modal-body\" id=\"file-container\" ng-model=\"fileContainer\" ng-click=\"getFiles();\" style=\"border: none; width: 370px; height: 370px; margin: 0 auto; display: flex; flex-direction: column; align-items: center; cursor: pointer; outline: none; overflow-y: scroll;\"><p class=\"text-center\" ng-hide=\"fileSelected\" style=\"align-self: center; justify-self: center;\">Click to choose files to upload</p></div><div class=\"modal-footer\" style=\"border:none; margin-top: 20px;\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"showUploadFileContainerFunc();\" ng-disabled=\"isProcessing\">{{ \'CANCEL\' | translate }}</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"uploadFile();\" ng-disabled=\"!fileSelected\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"isProcessing\"></i> {{ \'Upload\' | translate }}</button></div></div></div><div class=\"delete-prompt-container\" ng-show=\"showDeletePromptContainer\"><div class=\"input-container\"><form><div class=\"top-row\"><h3>Are you sure you want to delete?</h3><a type=\"button\" ng-click=\"showDeletePromptContainerFunc();\" class=\"btn no-padding\"><i class=\"fa fa-times\"></i></a></div><div class=\"bottom-row\"><button type=\"button\" id=\"confirm-delete-button\" class=\"btn btn-warning\" ng-click=\"showDeletePromptContainerFunc();deleteFolderObjects();\">Confirm</button> <button type=\"button\" id=\"confirm-cancel-button\" class=\"btn btn-primary\" ng-click=\"showDeletePromptContainerFunc();\">Cancel</button></div></form></div></div><div class=\"move-prompt-container\" ng-show=\"showMovePromptContainer\"><div class=\"input-container\"><div class=\"top-row\"><h3>Choose a folder</h3><a type=\"button\" ng-click=\"showMovePromptContainerFunc();\" class=\"btn no-padding\"><i class=\"fa fa-times\"></i></a></div><section class=\"breadcrumb-header moving-breadcrumb-header\"><div class=\"logo-and-nav-wrap\"><div class=\"site-nav-wrap\"><nav class=\"breadcrumb-nav\"><div class=\"single-breadcrumb-wrap\"><span class=\"sep\"><i class=\"fa fa-caret-right\"></i></span> <span class=\"breadcrumb-link\"><a class=\"breadcrumb-anchor\" ng-click=\"getMovingDirectory(basePrefix, baseLink, baseType)\">{{baseLink}}</a></span></div><div class=\"single-breadcrumb-wrap\" ng-repeat=\"m in movingBreadcrumbsList\"><span class=\"sep\"><i class=\"fa fa-caret-right\"></i></span> <span class=\"breadcrumb-link\"><a class=\"breadcrumb-anchor\" ng-click=\"getMovingDirectory(m.prefix, m.link, m.type)\">{{m.link}}</a></span></div></nav></div></div></section><div class=\"directory-list\"><ul id=\"outer-window\"><label class=\"menu-option\" ng-repeat=\"f in moveFoldersArr\" ng-dblclick=\"getMovingDirectory(f.name);\" ng-style=\"{\'border\':f.selected === true ? \'2px solid #F35B2B\' : \'none\', \'transition\': \'border linear 0.07s\', \'cursor\': \'default\'}\"><div><input class=\"select-folder\" name=\"{{f.name}}\" type=\"checkbox\" checklist-model=\"folderList.selected\" checklist-value=\"f\" ng-click=\"onlyOne(f.name)\"></div><i class=\"fa fa-folder-o\"></i><span ng-click=\"getMovingDirectory(f.name);\" data-toggle=\"tooltip\" data-placement=\"bottom\" title=\"Open Folder\">{{f.displayName}} ...</span></label></ul></div><div class=\"bottom-row\"><button type=\"button\" id=\"confirm-move-button\" class=\"btn btn-primary\" ng-class=\"{\'disabled\': folderList.selected.length == 0}\" ng-click=\"getFileToMove(folderList.selected[0].name);moveFile();showMovePromptContainerFunc();\">Move</button></div></div></div><a href=\"#\" id=\"hidden-download-btn\" class=\"hidden\" download=\"\"></a>");
$templateCache.put("app/views/home.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h1>{{ \'WELCOME\' | translate }} {{userProfile.first_name}}!</h1><h2 class=\"m-t-n text-muted\"><small>{{ \'WELCOMETOHEALTHJUMP\' | translate }}</small></h2></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5><i class=\"fa fa-database\" aria-hidden=\"true\"></i> &nbsp;{{ \'JUMPCONNECT\' | translate }} <small>{{ \'DATAWAREHOUSE\' | translate }}</small></h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"flot-chart\" style=\"height: 180px\"><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"lineChartData\" chart-labels=\"lineChartLabels\" chart-series=\"lineChartSeries\" chart-options=\"lineChartOptions\" chart-dataset-override=\"datasetOverride\" chart-colors=\"lineChatColors\"></canvas></div></div></div><div class=\"row m-t\"><div class=\"col-lg-3 col-sm-6 m-t\"><div class=\"p-sm border-top-bottom border-left-right b-r-lg text-center\"><div class=\"row vertical-align\"><div class=\"col-lg-3 text-primary m-t-sm\"><i class=\"fa fa-calendar fa-3x\"></i></div><div class=\"col-lg-9 text-right\"><p class=\"no-margins small font-bold\">{{ \'TOTALAPPTS\' | translate }}</p><h2 class=\"no-margins\">{{todayTotal.appointments | number}}</h2><p class=\"no-margins small {{todayApptDiffStatus.color}}\"><i class=\"fa {{todayApptDiffStatus.arrow}}\" aria-hidden=\"true\"></i> {{todayAppointmentsDiff | number}} ({{ \'FROMLASTWEEK\' | translate }})</p></div></div></div></div><div class=\"col-lg-3 col-sm-6 m-t\"><div class=\"p-sm border-top-bottom border-left-right b-r-lg text-center\"><div class=\"row vertical-align\"><div class=\"col-lg-3 text-primary m-t-sm\"><i class=\"fa fa-calendar-check-o fa-3x\"></i></div><div class=\"col-lg-9 text-right\"><p class=\"no-margins small font-bold\">{{ \'TOTALENCOUNTERS\' | translate }}</p><h2 class=\"no-margins\">{{todayTotal.encounters | number}}</h2><p class=\"no-margins small {{todayEncDiffStatus.color}}\"><i class=\"fa {{todayEncDiffStatus.arrow}}\" aria-hidden=\"true\"></i> {{todayEncountersDiff | number}} ({{ \'FROMLASTWEEK\' | translate }})</p></div></div></div></div><div class=\"col-lg-3 col-sm-6 m-t\"><div class=\"p-sm border-top-bottom border-left-right b-r-lg text-center\"><div class=\"row vertical-align\"><div class=\"col-lg-3 text-primary m-t-sm\"><i class=\"fa fa-user fa-3x\"></i></div><div class=\"col-lg-9 text-right\"><p class=\"no-margins small font-bold\">{{ \'TOTALPATIENTS\' | translate }}</p><h2 class=\"no-margins\">{{todayTotal.patients | number}}</h2><p class=\"no-margins small {{todayPtDiffStatus.color}}\"><i class=\"fa {{todayPtDiffStatus.arrow}}\" aria-hidden=\"true\"></i> {{todayPatientsDiff | number}} ({{ \'FROMLASTWEEK\' | translate }})</p></div></div></div></div><div class=\"col-lg-3 col-sm-6 m-t\"><div class=\"p-sm border-top-bottom border-left-right b-r-lg text-center\"><div class=\"row vertical-align\"><div class=\"col-lg-3 text-primary m-t-sm\"><i class=\"fa fa-user-md fa-3x\"></i></div><div class=\"col-lg-9 text-right\"><p class=\"no-margins small font-bold\">{{ \'TOTALPROVIDERS\' | translate }}</p><h2 class=\"no-margins\">{{todayTotal.providers | number}}</h2><p class=\"no-margins small {{todayProvDiffStatus.color}}\"><i class=\"fa {{todayProvDiffStatus.arrow}}\" aria-hidden=\"true\"></i> {{todayProvidersDiff | number}} ({{ \'FROMLASTWEEK\' | translate }})</p></div></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-8\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5><i class=\"fa fa-cloud-download\" aria-hidden=\"true\"></i>&nbsp;{{ \'JUMPSTART\' | translate }} <small>{{ \'EHRCONNECTOR\' | translate }}</small></h5></div><div class=\"ibox-content\"><div class=\"col-sm-3\"><div class=\"widget text-center\"><div class=\"\"><i class=\"fa fa-connectdevelop fa-4x\"></i><h1 class=\"m-xs\">{{activeAgentsCount | number}}</h1><h3 class=\"font-bold no-margins\">{{ \'CONNECTIONS\' | translate }}</h3><small>{{ \'ACTIVE\' | translate }}</small></div></div></div><div class=\"col-sm-4\"><h4>{{ \'NEWPRACTICETOCONNECT\' | translate }}</h4><div class=\"well\">{{ \'SCHEDULEJUMPSTARTINSTALL\' | translate }}</div><button class=\"btn btn-primary btn-block btn-outline\" ng-click=\"openAddTicketModal(\'invite\', 3)\">{{ \'SENDINVITE\' | translate }} <i class=\"fa fa-envelope-o\" aria-hidden=\"true\"></i></button></div><div class=\"col-sm-1 text-center m-t\"><h3>{{ \'OR\' | translate }}</h3><i class=\"fa fa-sort fa-rotate-90 fa-3x\" aria-hidden=\"true\"></i></div><div class=\"col-sm-4\"><h4>{{ \'ACCESSTODB\' | translate }}</h4><div class=\"well\">{{ \'GORIGHTTOINSTALLATIONWIZARD\' | translate }}</div><a class=\"btn btn-warning btn-block btn-outline\" href=\"//start.healthjump.com/{{userProfile.customer.name.replace(\' \',\'\')}}/practice\" target=\"_blank\">{{ \'LAUNCHWIZARD\' | translate }} <i class=\"fa fa-external-link\" aria-hidden=\"true\"></i></a></div><div class=\"clearfix\"></div></div></div></div><div class=\"col-lg-4\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5><i class=\"fa fa-user-circle\" aria-hidden=\"true\"></i> &nbsp;{{ \'CLIENTSUCCESSMANAGER\' | translate }}</h5></div><div ng-switch=\"customer_success_manager\" class=\"ibox-content\"><div ng-switch-when=\"Jose Horta\"><div class=\"profile-image\"><img src=\"img/jose.jpg\" class=\"img-circle circle-border m-b-md\" alt=\"profile\"></div><div class=\"profile-info\"><div class=\"\"><h2 class=\"no-margins\">Jose Horta</h2><h4>{{ \'CLIENTSERVICESDIRECTOR\' | translate }}</h4><small>{{ \'CSMISBRIDGE\' | translate : {customername : userProfile.customer.name } }} {{ \'CSMENSURINGTHEPARTNERSHIP\' | translate }}</small></div><div class=\"m-t\"><button class=\"btn btn-success btn-outline btn-block\" ng-click=\"openAddTicketModal(\'csm\', 3)\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> {{ \'CONTACTCSM\' | translate}}</button></div></div></div><div ng-switch-when=\"Rose Baumgardner\"><div class=\"profile-image\"><img src=\"img/rose.jpg\" class=\"img-circle circle-border m-b-md\" alt=\"profile\"></div><div class=\"profile-info\"><div class=\"\"><h2 class=\"no-margins\">Rose Baumgardner</h2><h4>{{ \'DIRECTOROFOPERATIONS\' | translate }}</h4><small>{{ \'CSMISBRIDGE\' | translate : {customername : userProfile.customer.name } }} {{ \'CSMENSURINGTHEPARTNERSHIP\' | translate }}</small></div><div class=\"m-t\"><button class=\"btn btn-success btn-outline btn-block\" ng-click=\"openAddTicketModal(\'csm\', 3)\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> {{ \'CONTACTCSM\' | translate}}</button></div></div></div><div ng-switch-when=\"Kellie Arteaga\"><div class=\"profile-image\"><img src=\"img/kellie.jpg\" class=\"img-circle circle-border m-b-md\" alt=\"profile\"></div><div class=\"profile-info\"><div class=\"\"><h2 class=\"no-margins\">Kellie Arteaga</h2><h4>{{ \'SRSOLUTIONSENG\' | translate}}</h4><small>{{ \'CSMISBRIDGE\' | translate : {customername : userProfile.customer.name } }} {{ \'CSMENSURINGTHEPARTNERSHIP\' | translate }}</small></div><div class=\"m-t\"><button class=\"btn btn-success btn-outline btn-block\" ng-click=\"openAddTicketModal(\'csm\', 3)\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> {{ \'CONTACTCSM\' | translate}}</button></div></div></div><div ng-switch-default=\"\"><p>{{ \'CSMNOTYETASSIGNED\' | translate}}</p></div></div></div></div></div><div class=\"ibox-content m-b-sm border-bottom\"><div class=\"p-xs\"><div class=\"pull-left m-r-md\"><i class=\"fa fa-check-square-o text-info fa-5x\"></i></div><h2>{{ \'TASKS\' | translate}}</h2><span ng-bind-html=\"\'LISTOFOPENTASKS\' | translate : {customername : userProfile.customer.name }\"></span></div></div><div class=\"row\" id=\"board\"><div class=\"col-lg-4\"><div class=\"ibox\"><div class=\"ibox-content\"><h3>{{ \'HIGH\' | translate}} <i class=\"fa fa-star\" aria-hidden=\"true\"></i><i class=\"fa fa-star\" aria-hidden=\"true\"></i></h3><p class=\"small\"><i class=\"fa fa-hand-o-up\"></i> {{ \'DRAGTASK\' | translate}}</p><div class=\"input-group\"><input type=\"text\" placeholder=\"{{ \'ADDHIGHTASK\' | translate}}\" ng-model=\"ticketsubjectHigh\" class=\"input input-sm form-control\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-sm btn-white\" ng-click=\"openAddTicketModal(ticketsubjectHigh, 1)\"><i class=\"fa fa-plus\"></i> {{ \'ADDTASK\' | translate}}</button></span></div><ul id=\"high\" class=\"sortable-list connectList agile-list\" data-as-sortable=\"dragControlListeners\" data-ng-model=\"tickets.high\"><li class=\"\" ng-click=\"openViewTicketModal(ticketHigh)\" id=\"{{ticketHigh.status}}\" ticket-status=\"\" data-ng-repeat=\"ticketHigh in tickets.high\" data-as-sortable-item=\"\"><div class=\"agile-detail\" data-as-sortable-item-handle=\"\"><p>{{ticketHigh.summary}}</p><a href=\"#\" class=\"pull-right btn btn-xs btn-white\">{{ticketHigh.status}}</a> <i class=\"fa fa-clock-o\"></i> {{ticketHigh.created_on | date:\'MM.dd.y\'}}</div></li></ul></div></div></div><div class=\"col-lg-4\"><div class=\"ibox\"><div class=\"ibox-content\"><h3>{{ \'NORMAL\' | translate}} <i class=\"fa fa-star\" aria-hidden=\"true\"></i></h3><p class=\"small\"><i class=\"fa fa-hand-o-up\"></i> {{ \'DRAGTASK\' | translate}}</p><div class=\"input-group\"><input type=\"text\" placeholder=\"{{ \'ADDNEWTASK\' | translate}}\" ng-model=\"ticketsubjectNew\" class=\"input input-sm form-control\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-sm btn-white\" ng-click=\"openAddTicketModal(ticketsubjectNew, 3)\"><i class=\"fa fa-plus\"></i> {{ \'ADDTASK\' | translate}}</button></span></div><ul id=\"normal\" class=\"sortable-list connectList agile-list\" data-as-sortable=\"dragControlListeners\" data-ng-model=\"tickets.normal\"><li class=\"\" ng-click=\"openViewTicketModal(ticketNormal)\" id=\"{{ticketNormal.status}}\" ticket-status=\"\" data-ng-repeat=\"ticketNormal in tickets.normal\" data-as-sortable-item=\"\"><div class=\"agile-detail\" data-as-sortable-item-handle=\"\"><p>{{ticketNormal.summary}}</p><a href=\"#\" class=\"pull-right btn btn-xs btn-white\">{{ticketNormal.status}}</a> <i class=\"fa fa-clock-o\"></i> {{ticketNormal.created_on | date:\'MM.dd.y\'}}</div></li></ul></div></div></div><div class=\"col-lg-4\"><div class=\"ibox\"><div class=\"ibox-content\"><h3>{{ \'LOW\' | translate}} <i class=\"fa fa-star-half-o\" aria-hidden=\"true\"></i></h3><p class=\"small\"><i class=\"fa fa-hand-o-up\"></i> {{ \'DRAGTASK\' | translate}}</p><div class=\"input-group\"><input type=\"text\" placeholder=\"{{ \'ADDLOWTASK\' | translate}}\" ng-model=\"ticketsubjectLow\" class=\"input input-sm form-control\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-sm btn-white\" ng-click=\"openAddTicketModal(ticketsubjectLow, 5)\"><i class=\"fa fa-plus\"></i> {{ \'ADDTASK\' | translate}}</button></span></div><ul id=\"low\" class=\"sortable-list connectList agile-list\" data-as-sortable=\"dragControlListeners\" data-ng-model=\"tickets.low\"><li class=\"\" ng-click=\"openViewTicketModal(ticketLow)\" id=\"{{ticketLow.status}}\" ticket-status=\"\" data-ng-repeat=\"ticketLow in tickets.low\" data-as-sortable-item=\"\"><div class=\"agile-detail\" data-as-sortable-item-handle=\"\"><p>{{ticketLow.summary}}</p><a href=\"#\" class=\"pull-right btn btn-xs btn-white\">{{ticketLow.status}}</a> <i class=\"fa fa-clock-o\"></i> {{ticketLow.created_on | date:\'MM.dd.y\'}}</div></li></ul></div></div></div></div></div>");
$templateCache.put("app/views/login.html","<div class=\"loginscreen\"><div class=\"text-section\"><div class=\"text\"><h2><strong>Integrate</strong>, <strong>translate</strong>, and <strong>automate</strong> your clinical data with Healthjump.com</h2><ul><li><div><i class=\"fa fa-plus-circle\"></i></div>Add new connections</li><li><div><i class=\"fa fa-wrench\"></i></div>Manage existing connections</li><li><div><i class=\"fa fa-search\"></i></div>Explore your data</li><li><div><i class=\"fa fa-code\"></i></div>Write your own APIs</li><li><div><i class=\"fa fa-clock-o\"></i></div>Initiate batch scheduling</li></ul></div></div><div class=\"pattern-section\"></div><div class=\"login-container\"><h1 class=\"text-center\">Healthjump</h1><form id=\"login-form\" class=\"m-t\" role=\"form\"><div class=\"form-group\" ng-hide=\"login.getMFA || login.getEmail || login.getNewPassword\"><label for=\"email\">Email Address</label> <input type=\"email\" name=\"email\" class=\"form-control\" ng-model=\"login.email\" required=\"\"><p ng-show=\"login.empty.email\" class=\"text-danger\">Enter a valid email address</p></div><div class=\"form-group\" ng-hide=\"login.getMFA || login.getEmail || login.getNewPassword\"><label for=\"password\">Password</label> <input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"login.password\" required=\"\"><p ng-show=\"login.empty.password\" class=\"text-danger\">Enter a valid password</p></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\" ng-click=\"login.login()\" ng-disabled=\"login.inProcess\" ng-hide=\"login.getMFA || login.getEmail || login.getNewPassword\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"login.inProcess\"></i> {{ \'LOGIN\' | translate }}</button> <span ng-hide=\"login.getMFA || login.getEmail || login.getNewPassword\"><a href=\"#\" ng-click=\"login.beginForgotPassword()\"><small>{{ \'FORGOTPASS\' | translate }}</small></a></span></form><form id=\"mfa-form\" class=\"m-t\" role=\"form\"><div class=\"form-group\" ng-show=\"login.getMFA\"><input type=\"text\" name=\"MFA\" placeholder=\"Please input verification code\" class=\"form-control\" ng-model=\"login.verificationCode\"></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\" ng-click=\"login.sendMfaCode()\" ng-disabled=\"login.inProcess\" ng-show=\"login.getMFA\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"login.inProcess\" ng-hide=\"login.getNewPassword;\"></i> Send Code</button></form><form id=\"submit-email-form\" class=\"m-t\" role=\"form\"><div class=\"form-group\" ng-show=\"login.getEmail\"><label for=\"email\">What email address does your account use?</label> <input type=\"email\" name=\"email\" class=\"form-control\" ng-model=\"login.forgotPasswordEmail\" required=\"\"><p ng-show=\"submit-email-form.email.$error\" class=\"text-danger\">Enter a valid email address</p></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\" ng-show=\"login.getEmail\" ng-click=\"login.forgotPassword()\" ng-disabled=\"login.inProcess\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"login.inProcess\"></i> {{ \'Submit\' | translate }}</button></form><form id=\"forgot-password-form\" class=\"m-t\" role=\"form\" ng-show=\"login.getNewPassword\"><div class=\"form-group\"><input type=\"text\" name=\"newPasswordMFA\" placeholder=\"Please input verification code\" class=\"form-control\" ng-model=\"login.newPasswordVerificationCode\" required=\"\"><p ng-show=\"forgot-password-form.newPasswordMFA.$error\" class=\"text-danger\">Enter a valid verfication code</p></div><div class=\"form-group\"><input type=\"password\" name=\"getNewPassword\" placeholder=\"Please enter new password\" class=\"form-control\" ng-model=\"login.newPassword\"><p ng-show=\"forgot-password-form.getNewPassword.$error\" class=\"text-danger\" required=\"\">Enter a valid new password</p></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\" ng-click=\"login.confirmPassword()\" ng-disabled=\"login.inProcess\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"login.inProcess\"></i> Reset Password</button></form><div><p class=\"text-muted text-center\"><small>{{ \'DONOTHAVEACCOUNT\' | translate }}</small></p></div><p class=\"m-t text-center version\"><small>{{ \'HEALTHJUMP\' | translate }} <strong>{{ \'PARTNERPORTAL\' | translate }}</strong> v1.0 &copy; 2019</small></p></div></div>");
$templateCache.put("app/views/qm.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>QM Analysis</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li class=\"active\"><strong>QM Analysis</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\" ng-show=\"filtered\"><div class=\"col-lg-12 pull-right\" ng-hide=\"filtering\"><div ng-repeat=\"(key, value) in filters.filters\" class=\"pull-right\" style=\"margin-top: -2px;margin-right: 5px;\"><button class=\"btn btn-xs btn-default pull-right\" data-ng-click=\"clearqmfilter(key)\"><i class=\"fa fa-times\"></i> {{key.split(\'_\').join(\' \')}}: {{value}}</button></div><div class=\"pull-right\" style=\"cursor:pointer;\" data-ng-click=\"clearqmfilters()\"><i class=\"fa fa-times\"></i> Filters:&emsp;</div></div><div class=\"col-lg-12 pull-right\" ng-show=\"filtering\"><div ng-repeat=\"(key, value) in filters.filters\" class=\"pull-right\" style=\"margin-top: -2px;margin-right: 5px;\"><button class=\"btn btn-xs btn-default pull-right\" disabled=\"\">{{key.split(\'_\').join(\' \')}}: {{value}}</button></div><div class=\"pull-right\" style=\"cursor:pointer;\"><i class=\"fa fa-refresh fa-spin\"></i> Filters:&emsp;</div></div></div><div class=\"row\" ng-hide=\"filtered\"><div class=\"col-lg-12 pull-right\" ng-show=\"clearingfilters\"><div class=\"pull-right\" style=\"cursor:pointer;\"><i class=\"fa fa-refresh fa-spin\"></i> Clearing Filters</div></div></div><div class=\"row\"><div class=\"col-lg-7\"><div class=\"row\"><div class=\"col-lg-12\"><h2>DEMOGRAPHICS SUMMARY</h2></div></div><div class=\"row\"><div class=\"col-lg-4\"><div class=\"ibox\"><div class=\"ibox-content no-padding\" style=\"max-height: 450px;overflow: scroll;font-size: 11px;\"><table class=\"table table-bordered table-hover white-bg\" ng-hide=\"filtering\"><thead><tr><th>Client ID</th><th>Patient Count</th><th>%</th></tr></thead><tbody ng-repeat=\"(key, value) in cqm_data.client_id\"><tr ng-if=\"key != \'\'\" data-ng-click=\"filterdata(\'client_id\',key)\"><td>{{key}}</td><td>{{value.toLocaleString()}}</td><td>{{ getpercentfloat( value, PatientsSeenYearToDate,1 )}}%</td></tr></tbody></table><table class=\"table table-bordered white-bg\" ng-show=\"filtering\"><thead><tr><th>Client ID</th><th>Patient Count</th><th>%</th></tr></thead><tbody><tr><td colspan=\"3\"><i class=\"fa fa-refresh fa-spin\"></i></td></tr></tbody></table></div></div></div><div class=\"col-lg-8\"><div class=\"col-lg-12\"><div class=\"ibox m-b\"><div class=\"ibox-content no-padding\"><div class=\"widget style1 white-bg b-r-xl\"><div class=\"row\"><div class=\"col-xs-4 text-left\"><i class=\"fa fa-user fa-5x\"></i></div><div class=\"col-xs-8 text-right\"><span>Patients Seen Year To Date</span><h2 class=\"font-bold\">{{PatientsSeenYearToDate.toLocaleString()}}</h2><h3 ng-show=\"filtering\"><i class=\"fa fa-refresh fa-spin\"></i></h3></div></div></div></div></div></div><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title text-center\"><h5>EHR</h5></div><div class=\"ibox-content\"><div><h3 ng-show=\"filtering\"><i class=\"fa fa-refresh fa-spin\"></i></h3><canvas class=\"chart chart-doughnut\" chart-options=\"qm.ehrChartOptions\" chart-labels=\"ehrChartLabels\" chart-data=\"ehrChartData\" height=\"140\" responsive=\"true\"></canvas></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-6\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title text-center\"><h5>Age</h5><div class=\"ibox-tools pull-right\"><span class=\"label label-warning-light\">{{AgeUnknown.toLocaleString()}} Unknown</span></div></div><div class=\"ibox-content\"><div><h3 ng-show=\"filtering\"><i class=\"fa fa-refresh fa-spin\"></i></h3><canvas class=\"chart chart-doughnut\" chart-options=\"qm.ageChartOptions\" chart-labels=\"ageChartLabels\" chart-data=\"ageChartData\" height=\"140\" responsive=\"true\"></canvas></div></div></div></div><div class=\"col-lg-6\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title text-center\"><h5>Gender</h5><div class=\"ibox-tools pull-right\"><span class=\"label label-warning-light\">{{GenderUnknown.toLocaleString()}} Unknown</span></div></div><div class=\"ibox-content\"><div><h3 ng-show=\"filtering\"><i class=\"fa fa-refresh fa-spin\"></i></h3><canvas class=\"chart chart-doughnut\" chart-options=\"qm.genderChartOptions\" chart-labels=\"genderChartLabels\" chart-data=\"genderChartData\" height=\"140\" responsive=\"true\"></canvas></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><h2>DIAGNOSIS SUMMARY</h2></div><div class=\"col-lg-3\"><div class=\"ibox\"><div class=\"ibox-content text-center\"><p>Hypertensive</p><h1 class=\"no-margins\">{{htn_total.toLocaleString()}}</h1><div class=\"progress progress-mini\"><div style=\"width: {{htn_pct}}%;\" class=\"progress-bar\"></div></div><div class=\"badge badge-primary m-t-sm\">{{htn_pct}}%</div></div></div><div class=\"ibox\"><div class=\"ibox-content no-padding\"><table class=\"table table-bordered table-hover white-bg\" ng-hide=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody ng-repeat=\"(key, value) in cqm_data.htn_code_type\"><tr ng-if=\"key != \'\'\" data-ng-click=\"filterdata(\'htn_code_type\',key)\"><td>{{key}}</td><td ng-if=\"key != \'ICD9\' || (key == \'ICD9\' && value < 10000)\">{{value.toLocaleString()}}</td><td ng-if=\"key == \'ICD9\' && value >= 10000\" class=\"text-danger\">{{value.toLocaleString()}}</td></tr></tbody></table><table class=\"table table-bordered white-bg\" ng-show=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr><td colspan=\"2\"><i class=\"fa fa-refresh fa-spin\"></i></td></tr></tbody></table></div></div></div><div class=\"col-lg-3\"><div class=\"ibox\"><div class=\"ibox-content text-center\"><p>Diabetic</p><h1 class=\"no-margins\">{{diabetic_total.toLocaleString()}}</h1><div class=\"progress progress-mini\"><div style=\"width: {{diabetic_pct}}%;\" class=\"progress-bar\"></div></div><div class=\"badge badge-primary m-t-sm\">{{diabetic_pct}}%</div></div></div><div class=\"ibox\"><div class=\"ibox-content no-padding\"><table class=\"table table-bordered table-hover white-bg\" ng-hide=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody ng-repeat=\"(key, value) in cqm_data.diabetic_code_type\"><tr ng-if=\"key != \'\'\" data-ng-click=\"filterdata(\'diabetic_code_type\',key)\"><td>{{key}}</td><td ng-if=\"key != \'ICD9\' || (key == \'ICD9\' && value < 10000)\">{{value.toLocaleString()}}</td><td ng-if=\"key == \'ICD9\' && value >= 10000\" class=\"text-danger\">{{value.toLocaleString()}}</td></tr></tbody></table><table class=\"table table-bordered white-bg\" ng-show=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr><td colspan=\"2\"><i class=\"fa fa-refresh fa-spin\"></i></td></tr></tbody></table></div></div></div><div class=\"col-lg-3\"><div class=\"ibox\"><div class=\"ibox-content text-center\"><p>CAD</p><h1 class=\"no-margins\">{{cad_total.toLocaleString()}}</h1><div class=\"progress progress-mini\"><div style=\"width: {{cad_pct}}%;\" class=\"progress-bar\"></div></div><div class=\"badge badge-primary m-t-sm\">{{cad_pct}}%</div></div></div><div class=\"ibox\"><div class=\"ibox-content no-padding\"><table class=\"table table-bordered table-hover white-bg\" ng-hide=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody ng-repeat=\"(key, value) in cqm_data.cad_code_type\"><tr ng-if=\"key != \'\'\" data-ng-click=\"filterdata(\'cad_code_type\',key)\"><td>{{key}}</td><td ng-if=\"key != \'ICD9\' || (key == \'ICD9\' && value < 10000)\">{{value.toLocaleString()}}</td><td ng-if=\"key == \'ICD9\' && value >= 10000\" class=\"text-danger\">{{value.toLocaleString()}}</td></tr></tbody></table><table class=\"table table-bordered white-bg\" ng-show=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr><td colspan=\"2\"><i class=\"fa fa-refresh fa-spin\"></i></td></tr></tbody></table></div></div></div><div class=\"col-lg-3\"><div class=\"ibox\"><div class=\"ibox-content text-center\"><p>HF</p><h1 class=\"no-margins\">{{hf_total.toLocaleString()}}</h1><div class=\"progress progress-mini\"><div style=\"width: {{hf_pct}}%;\" class=\"progress-bar\"></div></div><div class=\"badge badge-primary m-t-sm\">{{hf_pct}}%</div></div></div><div class=\"ibox\"><div class=\"ibox-content no-padding\"><table class=\"table table-bordered table-hover white-bg\" ng-hide=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody ng-repeat=\"(key, value) in cqm_data.hf_code_type\"><tr ng-if=\"key != \'\'\" data-ng-click=\"filterdata(\'hf_code_type\',key)\"><td>{{key}}</td><td ng-if=\"key != \'ICD9\' || (key == \'ICD9\' && value < 10000)\">{{value.toLocaleString()}}</td><td ng-if=\"key == \'ICD9\' && value >= 10000\" class=\"text-danger\">{{value.toLocaleString()}}</td></tr></tbody></table><table class=\"table table-bordered white-bg\" ng-show=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr><td colspan=\"2\"><i class=\"fa fa-refresh fa-spin\"></i></td></tr></tbody></table></div></div></div></div></div><div class=\"col-lg-5\"><h2 class=\"text-center\"><i class=\"fa fa-compass\" aria-hidden=\"true\"></i>&nbsp;CQM SUMMARY</h2><div class=\"row\"><div class=\"col-lg-6\"><div class=\"col-lg-12\"><h5><i class=\"fa fa-2x fa-thumbs-up text-success\" aria-hidden=\"true\"></i> &nbsp; &nbsp; PNEUMO VACC</h5><table class=\"table table-bordered table-hover white-bg\" ng-hide=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody ng-repeat=\"(key, value) in cqm_data.pneumo_code_type\"><tr ng-if=\"key != \'\'\" data-ng-click=\"filterdata(\'pneumo_code_type\',key)\"><td>{{key}}</td><td ng-if=\"key != \'Text\' || (key == \'Text\' && value < 10000)\">{{value.toLocaleString()}}</td><td ng-if=\"key == \'Text\' && value >= 10000\" class=\"text-danger\">{{value.toLocaleString()}}</td></tr></tbody></table><table class=\"table table-bordered white-bg\" ng-show=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr><td colspan=\"2\"><i class=\"fa fa-refresh fa-spin\"></i></td></tr></tbody></table></div><div class=\"col-lg-12\"><h5><i class=\"fa fa-2x fa-exclamation-triangle text-danger\" aria-hidden=\"true\"></i> &nbsp; &nbsp; COLONOSCOPY</h5><table class=\"table table-bordered table-hover white-bg\" ng-hide=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody ng-repeat=\"(key, value) in cqm_data.colonoscopy_code_type\"><tr ng-if=\"key != \'\'\" data-ng-click=\"filterdata(\'colonoscopy_code_type\',key)\"><td>{{key}}</td><td ng-if=\"key != \'Text\' || (key == \'Text\' && value < 10000)\">{{value.toLocaleString()}}</td><td ng-if=\"key == \'Text\' && value >= 10000\" class=\"text-danger\">{{value.toLocaleString()}}</td></tr></tbody></table><table class=\"table table-bordered white-bg\" ng-show=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr><td colspan=\"2\"><i class=\"fa fa-refresh fa-spin\"></i></td></tr></tbody></table></div><div class=\"col-lg-12\"><h5><i class=\"fa fa-2x fa-thumbs-up text-success\" aria-hidden=\"true\"></i> &nbsp; &nbsp; DIABETIC EYE EXAM</h5><table class=\"table table-bordered table-hover white-bg\" ng-hide=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody ng-repeat=\"(key, value) in cqm_data.diabeyeexam_code_type\"><tr ng-if=\"key != \'\'\" data-ng-click=\"filterdata(\'diabeyeexam_code_type\',key)\"><td>{{key}}</td><td ng-if=\"key != \'Text\' || (key == \'Text\' && value < 10000)\">{{value.toLocaleString()}}</td><td ng-if=\"key == \'Text\' && value >= 10000\" class=\"text-danger\">{{value.toLocaleString()}}</td></tr></tbody></table><table class=\"table table-bordered white-bg\" ng-show=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr><td colspan=\"2\"><i class=\"fa fa-refresh fa-spin\"></i></td></tr></tbody></table></div><div class=\"col-lg-12\"><h5><i class=\"fa fa-2x fa-exclamation-triangle text-warning\" aria-hidden=\"true\"></i> &nbsp; &nbsp; HBA1C</h5><table class=\"table table-bordered table-hover white-bg\" ng-hide=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody ng-repeat=\"(key, value) in cqm_data.hba1c_code_type\"><tr ng-if=\"key != \'\'\" data-ng-click=\"filterdata(\'hba1c_code_type\',key)\"><td>{{key}}</td><td ng-if=\"key != \'Text\' || (key == \'Text\' && value < 10000)\">{{value.toLocaleString()}}</td><td ng-if=\"key == \'Text\' && value >= 10000\" class=\"text-danger\">{{value.toLocaleString()}}</td></tr></tbody></table><table class=\"table table-bordered white-bg\" ng-show=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr><td colspan=\"2\"><i class=\"fa fa-refresh fa-spin\"></i></td></tr></tbody></table></div><div class=\"col-lg-12\"><h5><i class=\"fa fa-2x fa-thumbs-up text-success\" aria-hidden=\"true\"></i> &nbsp; &nbsp; BLOOD PRESSURE</h5><table class=\"table table-bordered table-hover white-bg\" ng-hide=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody ng-repeat=\"(key, value) in cqm_data.bp_code_type\"><tr ng-if=\"key != \'\'\" data-ng-click=\"filterdata(\'bp_code_type\',key)\"><td>{{key}}</td><td ng-if=\"key != \'Text\' || (key == \'Text\' && value < 10000)\">{{value.toLocaleString()}}</td><td ng-if=\"key == \'Text\' && value >= 10000\" class=\"text-danger\">{{value.toLocaleString()}}</td></tr></tbody></table><table class=\"table table-bordered white-bg\" ng-show=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr><td colspan=\"2\"><i class=\"fa fa-refresh fa-spin\"></i></td></tr></tbody></table></div><div class=\"col-lg-12\"><h5><i class=\"fa fa-2x fa-thumbs-up text-success\" aria-hidden=\"true\"></i> &nbsp; &nbsp; BP GROUPS</h5><table class=\"table table-bordered table-hover white-bg\" ng-hide=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr data-ng-click=\"filterdata(\'bp_last_grouping\',\'Normal\')\"><td>Normal</td><td>{{cqm_data.bp_last_grouping[\'Normal\'].toLocaleString()}}</td></tr><tr data-ng-click=\"filterdata(\'bp_last_grouping\',\'Prehypertensive\')\"><td>Prehypertensive</td><td ng-if=\"cqm_data.bp_last_grouping[\'Prehypertensive\'] > 0\" class=\"text-warning\">{{cqm_data.bp_last_grouping[\'Prehypertensive\'].toLocaleString()}}</td><td ng-if=\"cqm_data.bp_last_grouping[\'Prehypertensive\'] == 0\">{{cqm_data.bp_last_grouping[\'Prehypertensive\'].toLocaleString()}}</td></tr><tr data-ng-click=\"filterdata(\'bp_last_grouping\',\'HTN Stage 1\')\"><td>HTN Stage 1</td><td ng-if=\"cqm_data.bp_last_grouping[\'HTN Stage 1\'] > 0\" class=\"text-warning\">{{cqm_data.bp_last_grouping[\'HTN Stage 1\'].toLocaleString()}}</td><td ng-if=\"cqm_data.bp_last_grouping[\'HTN Stage 1\'] == 0\">{{cqm_data.bp_last_grouping[\'HTN Stage 1\'].toLocaleString()}}</td></tr><tr data-ng-click=\"filterdata(\'bp_last_grouping\',\'HTN Stage 2\')\"><td>HTN Stage 2</td><td ng-if=\"cqm_data.bp_last_grouping[\'HTN Stage 2\'] > 0\" class=\"text-danger\">{{cqm_data.bp_last_grouping[\'HTN Stage 2\'].toLocaleString()}}</td><td ng-if=\"cqm_data.bp_last_grouping[\'HTN Stage 2\'] == 0\">{{cqm_data.bp_last_grouping[\'HTN Stage 2\'].toLocaleString()}}</td></tr></tbody></table><table class=\"table table-bordered white-bg\" ng-show=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr><td colspan=\"2\"><i class=\"fa fa-refresh fa-spin\"></i></td></tr></tbody></table></div><div class=\"col-lg-12\"><h5><i class=\"fa fa-2x fa-thumbs-up text-success\" aria-hidden=\"true\"></i> &nbsp; &nbsp; BMI</h5><table class=\"table table-bordered table-hover white-bg\" ng-hide=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody ng-repeat=\"(key, value) in cqm_data.bmi_code_type\"><tr ng-if=\"key != \'\'\" data-ng-click=\"filterdata(\'bmi_code_type\',key)\"><td>{{key}}</td><td ng-if=\"key != \'Text\' || (key == \'Text\' && value < 10000)\">{{value.toLocaleString()}}</td><td ng-if=\"key == \'Text\' && value >= 10000\" class=\"text-danger\">{{value.toLocaleString()}}</td></tr></tbody></table><table class=\"table table-bordered white-bg\" ng-show=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr><td colspan=\"2\"><i class=\"fa fa-refresh fa-spin\"></i></td></tr></tbody></table></div></div><div class=\"col-lg-6\"><div class=\"col-lg-12\"><h5><i class=\"fa fa-2x fa-thumbs-up text-success\" aria-hidden=\"true\"></i> &nbsp; &nbsp; DEPRESSION</h5><table class=\"table table-bordered table-hover white-bg\" ng-hide=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody ng-repeat=\"(key, value) in cqm_data.depression_code_type\"><tr ng-if=\"key != \'\'\" data-ng-click=\"filterdata(\'depression_code_type\',key)\"><td>{{key}}</td><td ng-if=\"key != \'Text\' || (key == \'Text\' && value < 10000)\">{{value.toLocaleString()}}</td><td ng-if=\"key == \'Text\' && value >= 10000\" class=\"text-danger\">{{value.toLocaleString()}}</td></tr></tbody></table><table class=\"table table-bordered white-bg\" ng-show=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr><td colspan=\"2\"><i class=\"fa fa-refresh fa-spin\"></i></td></tr></tbody></table></div><div class=\"col-lg-12\"><h5><i class=\"fa fa-2x fa-thumbs-up text-success\" aria-hidden=\"true\"></i> &nbsp; &nbsp; DEPRESSION PHQ9</h5><table class=\"table table-bordered table-hover white-bg\" ng-hide=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr data-ng-click=\"filterdata(\'depression_phq9_group\',\'None-Minimal (0-4)\')\"><td>None-Minimal (0-4)</td><td>{{cqm_data.depression_phq9_group[\'None-Minimal (0-4)\'].toLocaleString()}}</td></tr><tr data-ng-click=\"filterdata(\'depression_phq9_group\',\'Mild (5-9)\')\"><td>Mild (5-9)</td><td ng-if=\"cqm_data.depression_phq9_group[\'Mild (5-9)\'] > 0\" class=\"text-warning\">{{cqm_data.depression_phq9_group[\'Mild (5-9)\'].toLocaleString()}}</td><td ng-if=\"cqm_data.depression_phq9_group[\'Mild (5-9)\'] == 0\">{{cqm_data.depression_phq9_group[\'Mild (5-9)\'].toLocaleString()}}</td></tr></tbody></table><table class=\"table table-bordered white-bg\" ng-show=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr><td colspan=\"2\"><i class=\"fa fa-refresh fa-spin\"></i></td></tr></tbody></table></div><div class=\"col-lg-12\"><h5><i class=\"fa fa-2x fa-thumbs-up text-success\" aria-hidden=\"true\"></i> &nbsp; &nbsp; DEPRESSION PHQ2</h5><table class=\"table table-bordered table-hover white-bg\" ng-hide=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr data-ng-click=\"filterdata(\'depression_phq2_group\',\'< 3\')\"><td>< 3</td><td>{{cqm_data.depression_phq2_group[\'< 3\'].toLocaleString()}}</td></tr><tr data-ng-click=\"filterdata(\'depression_phq2_group\',\'3+\')\"><td>3+</td><td ng-if=\"cqm_data.depression_phq2_group[\'3+\'] > 0\" class=\"text-warning\">{{cqm_data.depression_phq2_group[\'3+\'].toLocaleString()}}</td><td ng-if=\"cqm_data.depression_phq2_group[\'3+\'] == 0\">{{cqm_data.depression_phq2_group[\'3+\'].toLocaleString()}}</td></tr></tbody></table><table class=\"table table-bordered white-bg\" ng-show=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr><td colspan=\"2\"><i class=\"fa fa-refresh fa-spin\"></i></td></tr></tbody></table></div><div class=\"col-lg-12\"><h5><i class=\"fa fa-2x fa-thumbs-up text-success\" aria-hidden=\"true\"></i> &nbsp; &nbsp; FALL RISK</h5><table class=\"table table-bordered table-hover white-bg\" ng-hide=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody ng-repeat=\"(key, value) in cqm_data.fallrisk_code_type\"><tr ng-if=\"key != \'\'\" data-ng-click=\"filterdata(\'fallrisk_code_type\',key)\"><td>{{key}}</td><td ng-if=\"key != \'Text\' || (key == \'Text\' && value < 10000)\">{{value.toLocaleString()}}</td><td ng-if=\"key == \'Text\' && value >= 10000\" class=\"text-danger\">{{value.toLocaleString()}}</td></tr></tbody></table><table class=\"table table-bordered white-bg\" ng-show=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr><td colspan=\"2\"><i class=\"fa fa-refresh fa-spin\"></i></td></tr></tbody></table></div><div class=\"col-lg-12\"><h5><i class=\"fa fa-2x fa-thumbs-up text-success\" aria-hidden=\"true\"></i> &nbsp; &nbsp; BMI GROUPS</h5><table class=\"table table-bordered table-hover white-bg\" ng-hide=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr data-ng-click=\"filterdata(\'bmi_group\',\'Underweight (< 18.5)\')\"><td>Underweight (< 18.5)</td><td>{{cqm_data.bmi_group[\'Underweight (< 18.5)\'].toLocaleString()}}</td></tr><tr data-ng-click=\"filterdata(\'bmi_group\',\'Normal (18.5–24.9)\')\"><td>Normal (18.5–24.9)</td><td>{{cqm_data.bmi_group[\'Normal (18.5–24.9)\'].toLocaleString()}}</td></tr><tr data-ng-click=\"filterdata(\'bmi_group\',\'Overweight (25-29.9)\')\"><td>Overweight (25-29.9)</td><td ng-if=\"cqm_data.bmi_group[\'Overweight (25-29.9)\'] == 0\">{{cqm_data.bmi_group[\'Overweight (25-29.9)\'].toLocaleString()}}</td><td ng-if=\"cqm_data.bmi_group[\'Overweight (25-29.9)\'] > 0\" class=\"text-warning\">{{cqm_data.bmi_group[\'Overweight (25-29.9)\'].toLocaleString()}}</td></tr><tr data-ng-click=\"filterdata(\'bmi_group\',\'Obesity I (30-34.9)\')\"><td>Obesity I (30-34.9)</td><td ng-if=\"cqm_data.bmi_group[\'Obesity I (30-34.9)\'] == 0\">{{cqm_data.bmi_group[\'Obesity I (30-34.9)\'].toLocaleString()}}</td><td ng-if=\"cqm_data.bmi_group[\'Obesity I (30-34.9)\'] > 0\" class=\"text-warning\">{{cqm_data.bmi_group[\'Obesity I (30-34.9)\'].toLocaleString()}}</td></tr><tr data-ng-click=\"filterdata(\'bmi_group\',\'Obesity II (30-34.9)\')\"><td>Obesity II (30-34.9)</td><td ng-if=\"cqm_data.bmi_group[\'Obesity II (30-34.9)\'] == 0\">{{cqm_data.bmi_group[\'Obesity II (30-34.9)\'].toLocaleString()}}</td><td ng-if=\"cqm_data.bmi_group[\'Obesity II (30-34.9)\'] > 0\" class=\"text-danger\">{{cqm_data.bmi_group[\'Obesity II (30-34.9)\'].toLocaleString()}}</td></tr><tr data-ng-click=\"filterdata(\'bmi_group\',\'Extreme Obesity III (40+)\')\"><td>Extreme Obesity III (40+)</td><td ng-if=\"cqm_data.bmi_group[\'Extreme Obesity III (40+)\'] == 0\">{{cqm_data.bmi_group[\'Extreme Obesity III (40+)\'].toLocaleString()}}</td><td ng-if=\"cqm_data.bmi_group[\'Extreme Obesity III (40+)\'] > 0\" class=\"text-danger\">{{cqm_data.bmi_group[\'Extreme Obesity III (40+)\'].toLocaleString()}}</td></tr></tbody></table><table class=\"table table-bordered white-bg\" ng-show=\"filtering\"><thead><tr><th>Type</th><th>Count</th></tr></thead><tbody><tr><td colspan=\"2\"><i class=\"fa fa-refresh fa-spin\"></i></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/views/roi.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>ROI Mapping</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li class=\"active\"><strong>ROI Mapping</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-6 animated fadeInRight\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Team Selection</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"input-group\"><input type=\"text\" placeholder=\"Search by team name\" ng-model=\"searchTeam\" class=\"input-sm form-control\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-sm btn-primary\">Search</button></span></div></div><div class=\"clearfix\"></div></div><div class=\"table-responsive roi-overflow\"><table class=\"table table-striped table-hover\"><thead><tr><th>Teams</th><th><input type=\"checkbox\" class=\"i-checks\" ng-model=\"selectedAll\" ng-click=\"allTeams();roi.loadCategories();\"> Select All</th></tr></thead><tbody><tr ng-repeat=\"c in filterTeamsList | orderBy: \'name\' | start: (currentPage - 1) * pageSize | limitTo: pageSize\"><td>{{c.name}}</td><td><input type=\"checkbox\" class=\"i-checks\" checklist-model=\"teams.selected\" checklist-value=\"c\" ng-change=\"roi.loadCategories();checkStatus()\"></td></tr></tbody></table><uib-pagination total-items=\"totalTeamsList\" ng-model=\"currentPage\" max-size=\"5\" boundary-links=\"true\" items-per-page=\"pageSize\" class=\"pagination-sm\"></uib-pagination></div><span><button ng-click=\"roi.loadCategories()\" type=\"button\" class=\"btn btn-sm btn-primary\">Master ROI Types & Categories</button></span></div></div><div ng-show=\"showPrompt\" class=\"col-lg-12\"><p class=\"text-center\"><i class=\"fa fa-building big-icon\"></i></p><h2 class=\"text-center\">Select team(s) to map categories</h2><p></p></div></div><div class=\"col-lg-6\" id=\"agentList\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Active Agents</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"input-group\"><input type=\"text\" placeholder=\"Search by agent ID, practice name, etc\" ng-model=\"searchPractice\" class=\"input-sm form-control\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-sm btn-primary\">Search</button></span></div></div><div class=\"clearfix\"></div></div><table class=\"table table-striped table-hover\"><thead><tr><th>Agent ID</th><th>Practice</th><th>Install Date</th></tr></thead><tbody><tr ng-repeat=\"p in filterPracticesList | start: (currentPage - 1) * pageSize | limitTo: pageSize\" ng-click=\"roi.loadDocumentDetails(p)\"><td>{{p.client_id}}</td><td>{{p.name}}</td><td>{{p.install_date}}</td></tr></tbody></table><uib-pagination total-items=\"totalPracticesList\" ng-model=\"currentPage\" max-size=\"5\" boundary-links=\"true\" items-per-page=\"pageSize\" class=\"pagination-sm\"></uib-pagination></div></div><div ng-show=\"showPrompt\" class=\"col-lg-12\"><p class=\"text-center\"><i class=\"fa fa-list-alt big-icon\"></i></p><h2 class=\"text-center\">Select practice to map documents</h2><p></p></div></div><div ng-hide=\"hideCategories\" class=\"col-lg-12 animated fadeInRight\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>ROI Type & Category Mapping</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-6\"><h5>Master ROI Type List</h5><tags-input class=\"roi-tags\" on-tag-added=\"onROITypeAdded($tag)\" on-tag-removing=\"onROIRemoval($tag)\" ng-model=\"request_types\" display-property=\"name\" placeholder=\"Add/remove ROI type\"></tags-input></div><div class=\"col-lg-6\"><h5>Master Categories List</h5><tags-input class=\"roi-tags category-tag\" on-tag-added=\"onCategoryAdded($tag)\" on-tag-removing=\"onCategoryRemoval($tag)\" ng-model=\"categories\" display-property=\"name\" placeholder=\"Add/remove category\"></tags-input></div></div></div><div class=\"ibox-title\" ng-if=\"teams.selected.length >= 1\"><h5>Team Mappings</h5></div><div class=\"ibox-content\" ng-if=\"teams.selected.length >= 1\"><div class=\"row\"><div class=\"col-lg-8\"><div class=\"input-group\"><input type=\"text\" placeholder=\"Search by team name\" ng-model=\"searchROI\" class=\"input-sm form-control\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-sm btn-primary\">Search</button></span></div></div><div class=\"clearfix\"></div></div><div class=\"table-responsive roi-overflow\"><table class=\"table roi-table table-striped table-hover\"><thead><tr><th ng-click=\"showStuff()\">Team</th><th>ROI Type</th><th>Categories</th><th></th></tr></thead><tbody><tr ng-repeat=\"roi in filterTeamROIList | orderBy: \'name\' | start: (currentPage - 1) * pageSize | limitTo: pageSize\"><td>{{roi.name}}</td><td>{{roi.request_type}}</td><td><tags-input class=\"roi-tags category-tag\" ng-model=\"roi.categories\" on-tag-added=\"updateROIMapping()\" on-tag-removed=\"updateROIMapping()\" display-property=\"name\" add-from-autocomplete-only=\"true\" replace-spaces-with-dashes=\"false\" placeholder=\"Add/remove category\"><auto-complete class=\"category-suggest\" source=\"loadTags($query)\"></auto-complete></tags-input></td><td><button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"deleteMapping(roi)\">Delete</button></td></tr></tbody></table><uib-pagination boundary-links=\"true\" boundary-link-numbers=\"true\" total-items=\"totalteamROIList\" ng-model=\"currentPage\" current-page=\"currentPage\" max-size=\"maxSize\" num-pages=\"numPages\" class=\"pagination-sm\"></uib-pagination></div></div><div class=\"ibox-title\" ng-if=\"teams.selected.length >= 1\"><h5 ng-if=\"teams.selected.length == 1\">Add New Mapping for <strong>{{teams.selected[0].name}}</strong> <i>(select more teams above to apply bulk mapping)</i></h5><h5 ng-if=\"teams.selected.length > 1 && teams.selected.length < 4\">Add New Mapping for <strong ng-repeat=\"c in teams.selected\">{{c.name}}{{$last ? \'\' : \', \'}}</strong></h5><h5 ng-if=\"teams.selected.length > 3\">Add New Mapping for <strong ng-repeat=\"c in teams.selected | limitTo: 3\">{{c.name}}{{$last ? \'\' : \', \'}}</strong> and <strong>{{teams.selected.length-3}}</strong> more</h5></div><div class=\"ibox-content\" ng-if=\"teams.selected.length >= 1\"><div class=\"table-responsive roi-overflow\"><table class=\"table table-striped table-hover\"><thead><tr><th>ROI Type</th><th>Categories</th><th></th></tr></thead><tbody><tr><td><select class=\"form-control\" ng-model=\"mappingToAdd.request_type\" ng-options=\"r.name as r.name for r in request_types\" required=\"\"></select></td><td><select class=\"form-control\" ng-model=\"mappingToAdd.categories\" ng-options=\"i.name for i in categories\" multiple=\"\" required=\"\"></select></td><td><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"addMapping()\" ng-disabled=\"!mappingToAdd.request_type || !mappingToAdd.categories\">Submit</button></td></tr></tbody></table></div></div></div></div></div><div class=\"row\"><div ng-hide=\"hideDocuments\" class=\"col-lg-12 animated fadeInRight\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Document Category Mapping</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-8\"><div class=\"input-group\"><input type=\"text\" placeholder=\"Search by document type, description, category\" ng-model=\"searchDocs\" class=\"input-sm form-control\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-sm btn-primary\">Search</button></span></div></div><div class=\"clearfix\"></div></div><div class=\"row\"><div class=\"col-sm-8\"><ul class=\"tag-list no-padding\"><li ng-repeat=\"tag in documentTags\" ng-click=\"filterDocs(tag)\"><a href=\"\" class=\"taggin-{{tag}}\"><i class=\"fa fa-tag\"></i> {{tag}}</a></li></ul></div><div class=\"clearfix\"></div></div><div class=\"table-responsive roi-overflow roi-overflow\"><table class=\"table roi-table table-striped table-hover\"><thead><tr><th></th><th>Document Type</th><th>Count</th><th>Last Generated</th><th>Categories</th><th><input type=\"checkbox\" class=\"i-checks\" ng-model=\"selectedAllDocs\" ng-click=\"allDocs()\"></th></tr></thead><tbody><tr ng-repeat=\"d in filterDocList | orderBy: \'type\' | start: (currentPage - 1) * pageSize | limitTo: pageSize\"><td><i class=\"fa fa-eye\" ng-click=\"openPDF(d.type)\" ng-show=\"d.preview\" style=\"color: #349AF0\"></i></td><td class=\"col-lg-3\">{{d.type}}</td><td class=\"col-lg-1\">{{d.count}}</td><td class=\"col-lg-2\">{{d.last_generated}}</td><td class=\"col-lg-5\"><tags-input class=\"category-tag roi-tags\" ng-model=\"d.categories\" display-property=\"name\" add-from-autocomplete-only=\"true\" replace-spaces-with-dashes=\"false\" on-tag-added=\"updateDocMappings();chartData()\" on-tag-removed=\"updateDocMappings();chartData()\" placeholder=\"Add/remove category\"><auto-complete class=\"category-suggest\" source=\"loadTags($query)\"></auto-complete></tags-input></td><td class=\"col-lg-1\"><input type=\"checkbox\" class=\"i-checks\" checklist-model=\"filterDocList.selected\" checklist-value=\"d\" ng-change=\"checkDocStatus()\"></td></tr></tbody></table><uib-pagination boundary-links=\"true\" boundary-link-numbers=\"true\" total-items=\"filterDocList.length\" ng-model=\"currentPage\" current-page=\"currentPage\" max-size=\"maxSize\" num-pages=\"numPages\" class=\"pagination-sm\"></uib-pagination></div></div><div class=\"ibox-title\" ng-if=\"filterDocList.selected.length > 1\"><h5 ng-if=\"filterDocList.selected.length > 1 && filterDocList.selected.length < 4\">Update Category mapping for <strong ng-repeat=\"d in filterDocList.selected\">{{d.name}}{{$last ? \'\' : \', \'}}</strong></h5><h5 ng-if=\"filterDocList.selected.length > 3\">Update Category mapping for <strong ng-repeat=\"d in filterDocList.selected | limitTo: 3\">{{d.name}}{{$last ? \'\' : \', \'}}</strong> and <strong>{{filterDocList.selected.length-3}}</strong> more</h5></div><div class=\"ibox-content\" ng-if=\"filterDocList.selected.length > 1\"><div class=\"table-responsive roi-overflow\"><table class=\"table table-striped table-hover\"><thead><tr><th>Categories</th><th></th></tr></thead><tbody><tr><td><select class=\"form-control\" ng-model=\"categoriesToAdd.categories\" ng-options=\"c.name for c in categories\" multiple=\"\" required=\"\"></select></td><td><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"addCategories();chartData()\" ng-disabled=\"!categoriesToAdd.categories\">Submit</button> <button type=\"button\" class=\"btn btn-sm btn-warning\" ng-click=\"clearAll();chartData()\">Clear All</button></td></tr></tbody></table></div></div></div></div><div ng-hide=\"hideDocuments\" class=\"col-lg-6 animated fadeInRight\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{mappedPercent}}% Documents Mapped</h5></div><div class=\"ibox-content\"><canvas class=\"chart chart-doughnut\" chart-options=\"mappedDocsChartOptions\" chart-labels=\"mappedDocsChartLabels\" chart-data=\"mappedDocsChartData\" responsive=\"true\"></canvas></div></div></div></div></div>");
$templateCache.put("app/views/common/addTicketModal.html","<div class=\"inmodal\"><div class=\"modal-header text-center\"><i class=\"fa fa-question-circle fa-5x\"></i><h4 class=\"modal-title\">{{ \'NEWTICKET\' | translate }}</h4></div><div class=\"modal-body\"><form role=\"form\"><div class=\"form-group\"><label>{{ \'TICKETSUBJECT\' | translate }}</label> <input type=\"text\" placeholder=\"{{ \'TICKETSUBJECT\' | translate }}\" ng-model=\"$parent.ticketsubject\" class=\"form-control\" required=\"\"></div><div class=\"form-group\"><label>{{ \'TICKETDESC\' | translate }}</label> <textarea rows=\"5\" class=\"form-control\" placeholder=\"{{ \'TICKETDESCPLACE\' | translate }}\" ng-model=\"$parent.ticketcontent\"></textarea></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">{{ \'CANCEL\' | translate }}</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"addTicket()\" ng-disabled=\"!$parent.ticketsubject || isProcessing\">{{ \'SEND\' | translate }}</button></div></div>");
$templateCache.put("app/views/common/addTicketModalCsm.html","<div class=\"inmodal\"><div class=\"modal-header text-center\"><div ng-switch=\"$parent.customer_success_manager\" class=\"ibox-content1\"><div ng-switch-when=\"Jose Horta\"><img src=\"img/jose.jpg\" class=\"img-circle circle-border img-md\" alt=\"profile\"></div><div ng-switch-when=\"Rose Baumgardner\"><img src=\"img/rose.jpg\" class=\"img-circle circle-border img-md\" alt=\"profile\"></div><div ng-switch-when=\"Kellie Arteaga\"><img src=\"img/kellie.jpg\" class=\"img-circle circle-border img-md\" alt=\"profile\"></div></div><h4 class=\"modal-title\">{{ \'CONTACTCSM\' | translate }}</h4></div><div class=\"modal-body\"><form role=\"form\"><div class=\"form-group\"><label>{{ \'MESSAGEDETAILS\' | translate }}</label> <textarea rows=\"5\" class=\"form-control\" placeholder=\"{{ \'MESSAGEDETAILSPLACE\' | translate }}\" ng-model=\"$parent.ticketcontent\"></textarea></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">{{ \'CANCEL\' | translate }}</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"addTicket()\" ng-disabled=\"!$parent.ticketsubject || isProcessing\">{{ \'SEND\' | translate }}</button></div></div>");
$templateCache.put("app/views/common/addTicketModalInvite.html","<div class=\"inmodal\"><div class=\"modal-header text-center\"><i class=\"fa fa-envelope-o fa-5x\"></i><h4 class=\"modal-title\">{{ \'SENDINVITE\' | translate }}</h4></div><div class=\"modal-body\"><form role=\"form\"><div class=\"form-group\"><label>{{ \'RECIPIENT\' | translate }}</label><br><input type=\"email\" placeholder=\"{{ \'RECIPIENTEMAIL\' | translate }}\" ng-model=\"$parent.recipientemail\" class=\"form-control\" required=\"\"></div><div class=\"form-group\"><label>{{ \'INVITETEXT\' | translate }}</label><br><div summernote=\"\" config=\"summerNoteOptions\" ng-model=\"$parent.ticketcontent\"></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">{{ \'CANCEL\' | translate }}</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"addTicket()\" ng-disabled=\"!$parent.recipientemail || isProcessing\">{{ \'SEND\' | translate }}</button></div></div>");
$templateCache.put("app/views/common/content.html","<div id=\"wrapper\"><div ng-include=\"\'app/views/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'app/views/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/views/common/footer.html\'\"></div></div></div>");
$templateCache.put("app/views/common/footer.html","<div class=\"footer\"><div class=\"pull-right\">Customer Portal - <span class=\"text-uppercase\"><strong>{{userProfile.customer.name}}</strong></span>.</div><div><strong>Copyright</strong> Healthjump &copy; 2019</div></div>");
$templateCache.put("app/views/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/views/common/modalViewTicket.html","<div class=\"spiner-example text-center\" ng-hide=\"$parent.selectedTicket.ticket.summary\">{{ \'FETCHINGDATA\' | translate }}<div class=\"sk-spinner sk-spinner-pulse\"></div></div><div class=\"inmodal\" ng-show=\"$parent.selectedTicket.ticket.summary\"><div class=\"modal-header text-center\"><i class=\"fa fa-question-circle fa-5x\"></i><h4 class=\"modal-title\">{{ $parent.selectedTicket.ticket.summary}}</h4></div><div class=\"modal-body\"><h2>Ticket #{{$parent.selectedTicket.id}}</h2><p>{{ $parent.selectedTicket.ticket.description}}</p><h3 ng-show=\"$parent.selectedTicket.comments.length\">{{ \'COMMENTS\' | translate }}</h3><div class=\"chat-discussion chat-discussion-custom\" ng-if=\"$parent.selectedTicket.comments.length\"><div class=\"chat-message left\" ng-repeat=\"comment in $parent.selectedTicket.comments| orderBy:\'created_on\'\"><img class=\"message-avatar\" ng-src=\"{{comment.user_avatar_url}}\" alt=\"\"><div class=\"message\"><a class=\"message-author\" href=\"\">{{comment.user_name}}</a> <span class=\"message-date\" set-date-format=\"\" strdate=\"comment.created_on\" dateformat=\"MM.DD.YYYY HH:mm\"></span> <span class=\"message-content\">{{comment.comment}}</span></div></div></div><form role=\"form\" class=\"m-t\"><div class=\"form-group\"><textarea rows=\"3\" class=\"form-control\" placeholder=\"{{ \'ADDCOMENTPLACE\' | translate }}\" ng-model=\"$parent.ticketcomment\"></textarea></div><button class=\"btn btn-primary\" type=\"button\" ng-click=\"addTicketComment()\" ng-disabled=\"!$parent.ticketcomment || isProcessing\">{{ \'COMMENT\' | translate }}</button></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"ok()\">{{ \'OK\' | translate }}</button></div></div>");
$templateCache.put("app/views/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown=\"\"><img alt=\"{{ \'PROFILEPICTURE\' | translate}}\" class=\"img-circle img-md\" ng-src=\"{{userProfile.profile_picture}}\" default-image=\"\" defimageurl=\"assets/images/default_avatar.jpg\"> <a uib-dropdown-toggle=\"\" href=\"\"><span class=\"clear\"><span class=\"block m-t-xs\"><strong class=\"font-bold\">{{userProfile.first_name}} {{userProfile.last_name}}</strong></span><span class=\"text-muted text-xs block\" ng-hide=\"userProfile.job_title\">{{userProfile.title}}<b class=\"caret\"></b></span> <span class=\"text-muted text-xs block\" ng-show=\"userProfile.job_title\">{{userProfile.job_title}}<b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs\"><li><a href=\"\" ng-click=\"logout()\">{{ \'LOGOUT\'|translate }}</a></li><li><a href=\"\" ng-click=\"changePassword()\">{{ \'Change password\'|translate }}</a></li><li><a href=\"\" ng-click=\"changeProfilePicture()\">{{ \'Change profile picture\'|translate }}</a></li></ul></div><div class=\"logo-element\">HJ</div></li><li ui-sref-active=\"active\"><a ui-sref=\"index.home\"><i class=\"fa fa-laptop\"></i> <span class=\"nav-label\">{{\'HOME\' | translate}}</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"agent.agents\"><i class=\"fa fa-connectdevelop\" aria-hidden=\"true\"></i> <span class=\"nav-label\">{{ \'SOURCES\'| translate}}</span></a></li><li ng-show=\"userProfile.roles.indexOf(\'data advisor\')!=-1\" ng-class=\"{active: $state.includes(\'advisor\')}\"><a href=\"#\"><i class=\"fa fa-tachometer\"></i> <span class=\"nav-label\">Data Advisor</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'advisor\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"advisor.qm\">CQM Analysis</a></li></ul></li><li ng-show=\"userProfile.roles.indexOf(\'roi mapping\')!=-1\" ng-class=\"{active: $state.includes(\'roi\')}\"><a ui-sref=\"roi.roi\"><i class=\"fa fa-file\" aria-hidden=\"true\"></i> <span class=\"nav-label\">ROI Mapping</span></a></li><li ng-show=\"userProfile.roles.indexOf(\'file_management\')!=-1\" ng-class=\"{active: $state.includes(\'fileManager\')}\"><a ui-sref=\"fileManager.fileManager\"><i class=\"fa fa-folder\" aria-hidden=\"true\"></i> <span class=\"nav-label\">File Manager</span></a></li><li ng-show=\"userProfile.roles.indexOf(\'dbexplorer\')!=-1\" ui-sref-active=\"active\"><a ui-sref=\"dbexplorer.dbexplorer\"><i class=\"fa fa-database\" aria-hidden=\"true\"></i> <span class=\"nav-label\">DB Explorer</span></a></li><li ng-class=\"{active: $state.includes(\'qc\')}\"><a href=\"#\"><i class=\"fa fa-check-square\"></i> <span class=\"nav-label\">{{ \'QUALITYCONTROL\' | translate}}</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'qc\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"qc.results\">{{ \'RESULTS\' | translate}}</a></li><li ui-sref-active=\"active\"><a ui-sref=\"qc.latest\">{{\'LATEST\' | translate}}</a></li></ul></li><li ng-show=\"userProfile.roles.indexOf(\'admin\')!=-1\" ng-class=\"($state.includes(\'financial\') || $state.includes(\'quality\') || $state.includes(\'clinical\')) ? \'active\' : \'\'\"><a href=\"\"><i class=\"fa fa-table\"></i> <span class=\"nav-label\">{{ \'ANALYZE\' | translate}}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\"><li ng-class=\"($state.includes(\'financial.charges\') || $state.includes(\'financial.transactions\')) ? \'active\' : \'\'\"><a href=\"\"><i class=\"fa fa-money\"></i> <span class=\"nav-label\">{{ \'FINANCIAL\' | translate}}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level collapse\" ng-class=\"{in: $state.includes(\'financial\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"financial.charges\">{{ \'CHARGES\' | translate}}</a></li><li ui-sref-active=\"active\"><a ui-sref=\"financial.transactions\">{{ \'TRANSACTIONS\' | translate}}</a></li></ul></li><li ng-class=\"($state.includes(\'clinical.appointments\') || $state.includes(\'clinical.demographics\') || $state.includes(\'clinical.diagnosis\') || $state.includes(\'clinical.encounters\')) ? \'active\' : \'\'\"><a href=\"\"><i class=\"fa fa-hospital-o\"></i> <span class=\"nav-label\">{{ \'CLINICAL\' | translate}}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level collapse\" ng-class=\"{in: $state.includes(\'clinical\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"clinical.appointments\">{{\'APPOINTMENTS\'|translate}}</a></li><li ui-sref-active=\"active\"><a ui-sref=\"clinical.demographics\">{{\'DEMOGRAPHICS\'|translate}}</a></li><li ui-sref-active=\"active\"><a ui-sref=\"clinical.diagnosis\">{{\'DIAGNOSIS\'|translate}}</a></li><li ui-sref-active=\"active\"><a ui-sref=\"clinical.encounters\">{{\'ENCOUNTERS\'|translate}}</a></li></ul></li><li ng-class=\"($state.includes(\'quality.qualitymetrics\')) ? \'active\' : \'\'\"><a href=\"\"><i class=\"fa fa-check-square-o\"></i> <span class=\"nav-label\">{{\'QUALITY\'|translate}}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level collapse\" ng-class=\"{in: $state.includes(\'quality\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"quality.qualitymetrics\">{{\'QUALITYMETRICS\'|translate}}</a></li></ul></li></ul></li><li id=\"SavedDashboardListLi\" ng-show=\"savedDashMenuHTML.length\" ng-class=\"{active: $state.includes(\'analyzesaved\')}\"><a href=\"\"><i class=\"fa fa-table\"></i> <span class=\"nav-label\">{{\'SAVEDDASHBOARDS\'|translate}}</span><span class=\"fa arrow\"></span></a><ul id=\"SavedDashboardListUl\" class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'analyzesaved\')}\"><li ui-sref-active=\"active\" ng-repeat=\"savedash in savedDashMenuHTML\"><a ui-sref=\"analyzesaved.saveddashboard({pageId: {{savedash.id}} })\">{{savedash.page}}</a></li></ul></li><li ng-class=\"{active: $state.includes(\'app\')}\" ng-show=\"hjChatTeamList[0]\"><a href=\"#\"><i class=\"fa fa-check-square\"></i> <span class=\"nav-label\">{{ \'CHAT\' | translate}}</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'app\')}\"><li ui-sref-active=\"active\" ng-repeat=\"team in hjChatTeamList\"><a href=\"{{team.url}}\" target=\"_blank\">{{team.name}}</a></li></ul></li></ul></div></nav><script type=\"text/ng-template\" id=\"modalUpdatePassword.html\"><div class=\"inmodal\"> <div class=\"modal-header text-center\"> <h4 class=\"modal-title\">{{ \'CHANGEPASSWORD\' | translate }}</h4> </div> <form role=\"form\" name=\'currentPasswordForm\'> <div class=\"modal-body\" ng-hide=\'passwordConfirmed || getChangePasswordMFA\'> <div class=\"form-group\"> <label>{{ \'CURRENTPASSWORD\' | translate }}</label> <input type=\"password\" placeholder=\"{{ \'CURRENTPASSWORDPLACE\' | translate }}\" ng-model=\"currentPasswordForm.currentpassword\" name=\"currentPassword\" class=\"form-control\" ng-minlength=\"8\" ng-maxlength=\"20\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/\" required> </div> </div> <div class=\"modal-footer\" ng-hide=\'passwordConfirmed || getChangePasswordMFA\'> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">{{ \'CANCEL\' | translate }}</button> <button class=\"btn btn-primary\" type=\"submit\" ng-click=\"confirmCurrentPassword()\" ng-disabled=\"!currentPasswordForm.$valid || isProcessing\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"isProcessing\"></i>Submit</button> </div> </form> <form role=\"form\" name=\"changePasswordForm\"> <div class=\"modal-body\" ng-show=\'passwordConfirmed\'> <div class=\"form-group\"> <label>{{ \'NEWPASSWORD\' | translate }}</label> <input type=\"password\" placeholder=\"{{ \'NEWPASSWORDPLACE\' | translate }}\" ng-model=\"changePasswordForm.newpassword\" name=\"newPassword\" class=\"form-control\" ng-minlength=\"8\" ng-maxlength=\"20\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/\" required> <p ng-show=\"changePasswordForm.newPassword.$error.pattern\" class=\"text-danger\"> {{ \'PASSVALIDMSG\' | translate }}</p> </div> <div class=\"form-group\"> <label>{{ \'CONFIRMPASSWORD\' | translate }}</label> <input type=\"password\" placeholder=\"{{ \'CONFPASSWORDPLACE\' | translate }}\" ng-model=\"confirmnewpassword\" name=\"confirmNewPassword\" class=\"form-control\" valid-password=\"changePasswordForm.newpassword\" required> <p ng-show=\"changePasswordForm.confirmNewPassword.$error.noMatch && !changePasswordForm.newPassword.$error.pattern\" class=\"text-danger\">{{ \'PASSNOTMATCH\' | translate }}</span> </div> </div> <div class=\"modal-footer\" ng-show=\'passwordConfirmed\'> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">{{ \'CANCEL\' | translate }}</button> <button class=\"btn btn-primary\" type=\"submit\" ng-click=\"requestChangePassword()\" ng-disabled=\"!changePasswordForm.$valid || isProcessing\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"isProcessing\"></i> {{ \'UPDATE\' | translate }}</button> </div> </form> <form role=\"form\" name=\'changePasswordMFAForm\'> <div class=\"modal-body\" ng-show=\'getChangePasswordMFA\'> <div class=\"form-group\"> <label>Verification Code</label> <input type=\"text\" placeholder=\'Please input verification code\' ng-model=\'changePasswordMFAForm.MFACode\' name=\"changePasswordMFA\" class=\"form-control\" required> </div> </div> <div class=\"modal-footer\" ng-show=\'getChangePasswordMFA\'> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel()\">{{ \'CANCEL\' | translate }}</button> <button class=\"btn btn-primary\" type=\"submit\" ng-click=\"sendChangePasswordMFACode()\" ng-disabled=\"!changePasswordMFAForm.$valid || isProcessing\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"isProcessing\"></i>Submit</button> </div> </form> </div></script><script type=\"text/ng-template\" id=\"modalUpdateProfilePicture.html\"><div class=\"inmodal\" style=\'padding: 30px 60px 10px 60px; position: relative;\'> <div style=\'z-index: 2000;\'> <img src=\"\" id=\'profile-image\' width=\"270px\"> </div> <div class=\"modal-header\" style=\'padding: 20px 0 20px 0; border: none\'> <h6 class=\"modal-title\" style=\'float: left; font-size: 18px;\'>{{ \'Upload a photo\' | translate }}</h4> <input type=\'file\' name=\'...\' accept=\"image/*\" class=\"fileinput-new\" id=\'profilePictureInput\' ng-show=\'showFileInput\'> </div> <div class=\"modal-body\" id=\'photo-container\' ng-model=\'photoContainer\' ng-click=\'getPhoto();\' style=\'border: none; width: 100%; height: 370px; margin: 0 auto; display: flex; align-items: center; justify-content: center; cursor: pointer; outline: none\'> <p class=\'text-center\' ng-hide=\'photoSelected\'>Click to upload a JPG, PNG, or WEBP image</p> </div> <div class=\"modal-footer\" style=\'border:none; margin-top: 20px;\'> <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel();\">{{ \'CANCEL\' | translate }}</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"requestChangeProfilePicture();cancel();\" ng-disabled=\"!photoSelected\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"isProcessing\"></i> {{ \'UPDATE\' | translate }}</button> </div> <div id=\'cropped-image\' width=\"270px\"></div> </div></script>");
$templateCache.put("app/views/common/roi_pdfModal.html","<div class=\"inmodal\" id=\"pdfModal\"><div class=\"modal-body\" style=\"height:400px\"><iframe src=\"{{ pdfUrl }}\" width=\"100%\" height=\"100%\"></iframe></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"cancel()\">Close</button></div></div>");
$templateCache.put("app/views/common/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span><form role=\"search\" class=\"navbar-form-custom\" method=\"post\" action=\"\"><div class=\"form-group\"><input type=\"text\" placeholder=\"\" class=\"form-control\" name=\"top-search\" id=\"top-search\"></div></form></div><ul class=\"nav navbar-top-links navbar-right\"><li uib-dropdown=\"\"><a class=\"count-info\" uib-dropdown-toggle=\"\">{{ \'LANGUAGE\' | translate }}</a><ul uib-dropdown-menu=\"\" class=\"animated fadeInRight m-t-xs\" ng-controller=\"translateCtrl\"><li><a ng-click=\"changeLanguage(\'en\')\">English</a></li></ul></li><li><a href=\"\" ng-click=\"logout()\"><i class=\"fa fa-sign-out\"></i> {{ \'LOGOUT\'|translate }}</a></li></ul></nav></div><script type=\"text/ng-template\" id=\"modalScheduleInstall.html\"><div class=\"inmodal scheduling-modal\"> <!-- <button class=\'close-button\' ng-click=\'cancel();\'>X</button> --> <form role=\"form\" name=\'installTypeForm\' ng-hide=\'installTypeSelected\'> <div class=\'modal-header\'><hr></div> <div class=\"modal-body modal-styles flex-center\"> <div class=\"form-group\"> <button ng-click=\'confirmInstallType(\"installation\");\' ng-class=\"{\'selectedType\':install.type === \'installation\'}\" class=\'btn btn-primary\'> New Installation <div class=\'type-guide-tooltip flex-center\'>?</div> </button> </div> <div class=\"form-group\"> <button ng-click=\'confirmInstallType(\"reinstallation\");\' ng-class=\"{\'selectedType\':install.type === \'reinstallation\'}\" class=\'btn btn-primary\'> Re-Installation <div class=\'type-guide-tooltip flex-center\'>?</div> </button> </div> <div class=\"form-group\"> <button ng-click=\'confirmInstallType(\"maintenance\");\' ng-class=\"{\'selectedType\':install.type === \'maintenance\'}\" class=\'btn btn-primary\'> Maintenance <div class=\'type-guide-tooltip flex-center\'>?</div> </button> </div> </div> </form> <form role=\"form\" name=\'scheduleInstallForm\' ng-show=\'installTypeSelected\'> <div class=\'modal-header\'> <hr> <div class=\'steps\' ng-class=\"install.progress >= 1 ? \'step-finished\' : \'\'\"> <p>Step 1</p> <p class=\'step-description\'>Enter practice details</p> <div class=\'icon-container\'> <i class=\'fa\' ng-class=\"install.progress > 1 ? \'fa-check\' : \'fa-circle\'\"></i> <div class=\'icon-background\' ng-show=\'install.progress > 1\'></div> </div> </div> <div class=\'steps\' ng-class=\"install.progress >= 2 ? \'step-finished\' : \'\'\"> <p>Step 2</p> <p class=\'step-description\'>Choose scheduling type</p> <div class=\'icon-container\'> <i class=\'fa\' ng-class=\"install.progress > 2 ? \'fa-check\' : \'fa-circle\'\"></i> <div class=\'icon-background\' ng-show=\'install.progress > 2\'></div> </div> </div> <div class=\'steps\' ng-class=\"install.progress >= 3 ? \'step-finished\' : \'\'\"> <p>Step 3</p> <p class=\'step-description\'>Enter practice contacts</p> <div class=\'icon-container\'> <i class=\'fa\' ng-class=\"install.progress > 3 ? \'fa-check\' : \'fa-circle\'\"></i> <div class=\'icon-background\' ng-show=\'install.progress > 3\'></div> </div> </div> <!-- <div class=\'steps\' ng-class=\"install.progress >= 4 ? \'step-finished\' : \'\'\"> <p>Step 4</p> <p class=\'step-description\'>Fourth step description</p> <i class=\'fa\' ng-class=\"install.progress > 4 ? \'fa-check\' : \'fa-circle\'\"></i> <div class=\'icon-background\' ng-show=\'install.progress > 4\'></div> </div> --> </div> <div class=\"modal-body modal-styles\" ng-hide=\'installParametersFilled\'> <div class=\'new-install-group\' ng-show=\'install.type === \"installation\"\'> <div class=\"form-group input-group\"> <input type=\"text\" placeholder=\"Practice Name\" ng-model=\"install.practiceName\" name=\"practiceName\" class=\"form-control\" ng-minlength=\"1\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/\"> </div> <div class=\"form-group input-group\"> <select name=\"EHR\" id=\"EHR\"> <option ng-repeat=\"e in ehrList\" value=\"e.name\">{{e}}</option> </select> </div> </div> <div class=\'re-install-group\' ng-show=\'install.type === \"reinstallation\" || install.type === \"maintenance\"\'> <div class=\"form-group input-group\"> <div class=\'select-connection-button\' ng-click=\'showConnectionsFunc();\'> <p>Select Connection</p> <i class=\'fa fa-caret-down\'></i> </div> <ul class=\'select-connection-list\' ng-show=\'showConnections\'> <li ng-repeat=\'p in previousConnections\' ng-click=\'chooseConnection(p);\' ng-class=\"{\'selected-connection\':install.selectedConnection.id === p.id}\" > <div class=\'connection-id\'>{{p.id}}</div> <div class=\'connection-name\'>{{p.name}}</div> <div class=\'connection-ehr\'>{{p.ehr}}</div> </li> </ul> </div> </div> </div> <div class=\"modal-body modal-styles flex-center schedule-type-modal\" ng-show=\'installParametersFilled && !install.scheduleTypeSelected\'> <div class=\"form-group\"> <button ng-click=\'chooseScheduleType(\"installation\");\' ng-class=\"{\'selectedType\':install.scheduleType === \'installation\'}\" class=\'btn btn-primary\'> Schedule Install </button> </div> <div class=\"form-group\"> <button ng-click=\'chooseScheduleType(\"createLink\");\' ng-class=\"{\'selectedType\':install.scheduleType === \'createLink\'}\" class=\'btn btn-primary\'> Create Shareable Link </button> </div> </div> <div class=\"modal-body modal-styles shareable-link-modal\" ng-show=\'install.scheduleTypeSelected && install.scheduleType === \"createLink\"\'> <div class=\"form-group input-group copy-box-group\"> <div class=\"form-control copy-box\">{{install.copyData}}</div> <i ng-click=\'copyLink();\' class=\'fa fa-copy\'></i> </div> <div class=\"form-group input-group\" ng-hide=\'install.contactsConfirmed\'> <p>If you would like Healthjump to send a scheduling email to the practice, please enter the practice\'s contacts below:</p> <input type=\"text\" placeholder=\"Add Email\" ng-model=\"install.emailList\" name=\"emailList\" class=\"form-control\" ng-minlength=\"1\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/\"> <textArea rows=\'5\' cols= \'50\' placeholder=\"\" ng-model=\"install.emailMessage\" name=\"emailMessage\" class=\"form-control\" ng-minlength=\"1\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/\"></textArea> </div> <div class=\"form-group input-group confirmation-details\" ng-show=\'install.contactsConfirmed\'> <h3>Thank You!</h3> <p>Once the installation has been booked, you will receive an email with meeting details, including:</p> <ul> <li>Time</li> <li>Date</li> <li>Invitees</li> <li>Video Conference Link</li> </ul> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"goBack(1);\">Back</button> <button class=\"btn btn-primary\" type=\"submit\" ng-click=\"goNext();\" ng-disabled=\"!scheduleInstallForm.$valid || isProcessing\"><i class=\"fa fa-spinner fa-spin\" ng-show=\"isProcessing\"></i>Next</button> </div> <div class=\"modal-footer\" ng-show=\'install.contactsConfirmed\'> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"cancel();\">Close</button> </div> </form> </div></script>");
$templateCache.put("app/views/common/warning-dialog.html","<div class=\"modal-header\"><h3>Oh no! You\'ve been idle for 15 minutes.</h3></div><div idle-countdown=\"countdown\" ng-init=\"countdown=60\" class=\"modal-body\"><uib-progressbar max=\"60\" value=\"60\" animate=\"false\" class=\"progress-striped active\">You\'ll be logged out in {{countdown}} second(s).</uib-progressbar></div>");
$templateCache.put("app/views/qc/latest.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>{{ \'QCRESULTS\'| translate }}</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">{{ \'HOME\' | translate }}</a></li><li><a>{{ \'QUALITYCONTROL\' | translate }}</a></li><li class=\"active\"><strong>{{ \'LATESTDATA\' | translate }}</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12 m-t-lg\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{ \'LASTDATALOAD\' | translate }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><plotly plotly-data=\"plotylyChart.data\" plotly-layout=\"plotylyChart.layout\" plotly-options=\"plotylyChart.frames\"></plotly></div></div></div></div><div class=\"row\"><div class=\"col-lg-12 m-t-lg\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{ \'TABLEMISSINGLASTNIGHT\' | translate }}</h5></div><div class=\"ibox-content\"><div class=\"col-sm-4\" ng-repeat=\"(key, value) in issue_tables\"><span class=\"col-sm-7\"><i class=\"fa fa-table\"></i> {{key}}</span> <span class=\"col-sm-2\">{{value.length}}</span> <span class=\"col-sm-3 font-bold text-navy\">{{((value.length/155)*100).toFixed(1)}}%</span></div>&nbsp;</div></div></div></div></div>");
$templateCache.put("app/views/qc/recipies.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>QC - Recipies</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Quality Control</a></li><li class=\"active\"><strong>Recipies</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-10 col-lg-offset-1\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"text-center border-bottom\"><h1><strong>Healthjump Quality Control \"Recipes\"</strong></h1></div><div class=\"m-lg\"><h2>Jumpstart Only:</h2><ul><li>No QC</li></ul><h2>Jumpconnect Basic:</h2><ul><li>Queries ran</li><li>Data last updated</li></ul><h2>Jumpconnect Pro:</h2><ul><li>Follow-up: Top 200 Appointments that could be potentially duplicating.</li><li>Volume of encounters over the last year</li><li>Counts of posted charges without Primary Insurance over the past year.</li><li>Appointment join to Provider via provider_id (NPI).</li><li>Demographic join to Encounter test via patient_id.</li><li>Counts of posted charges with a CPT code and without Diagnosis code over the past year.</li><li>Encounters that fail to join demographics table via patient_id</li><li>Counts of posted charges without Place of Service over the past year.</li><li>Appointments that fail to join demographics table via patient_id</li><li>Counts of posted charges by beginning DOS Month over the past year.</li><li>Follow-up: Top 200 Appointments with null or empty duration</li><li>Counts of posted charges by beginning DOS over the past 90 days.</li><li>Counts of charges where DOS is null or in the future.</li><li>Encounter script should be pulling statuses.</li><li>Counts of charges with a beginning DOS after the Post date.</li><li>\"Count of Appts missing duration, patient_id, provider NPI, resource, appt_type, or appt_date, and any duplicate appts.\"</li><li>Encounter join to Charge test via visit_id.</li><li>Appointment volume for the past and future 30 days.</li><li>Appointment volume for the past year by month.</li><li>Counts of charges with a CPT code and no units.</li><li>Encounters missing Insurance Type or SubscriberID.</li><li>Follow-Up: Encounter join to Charge test via visit_id.</li><li>Follow-up: Count of Appts by Resource with no provider_id (NPI).</li><li>Count of encounters by enc_type with enc_date in the future.</li><li>Counts of Charges by posting date.</li><li>Counts of all charges by beginning DOS over the past 90 days.</li><li>Appointment join to Demographic via patient_id.</li><li>\"Patients missing DOB, Phone, Address, or Last Name\"</li><li>Show all providers for a given client_id.</li><li>Counts of charges and encounter over the past 7 days.</li><li>And More!</li></ul>-- OR Request a new one! --</div></div></div></div></div></div>");
$templateCache.put("app/views/qc/results.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>{{ \'QCRESULTS\'| translate }}</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">{{ \'HOME\' | translate }}</a></li><li><a>{{ \'QUALITYCONTROL\' | translate }}</a></li><li class=\"active\"><strong>{{ \'RESULTS\' | translate }}</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-8\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Status w/ counts <small>(click to filter)</small></h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><ul class=\"list-group clear-list m-b-sm\"><li class=\"list-group-item col-md-6\" ng-switch=\"status\" ng-repeat=\"(status, count) in statusCount\" ng-click=\"filterQCResult(status)\"><span ng-switch-when=\"Passed - No Issues\" class=\"badge badge-primary m-r-md\">{{count}}</span> <span ng-switch-when=\"Passed - Verified in source, see comments\" class=\"badge badge-primary m-r-md\">{{count}}</span> <span ng-switch-default=\"\" class=\"badge badge-warning m-r-md\">{{count}}</span> <span>{{status ? status : \'No Status\'}}</span></li></ul><div class=\"clearfix\"></div></div></div></div><div class=\"col-lg-4\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{ \'SEARCH\' | translate }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"input-group\"><input type=\"text\" placeholder=\"{{ \'SEARCH\' | translate }}\" ng-model=\"search\" ng-change=\"filterQCRes()\" class=\"input-sm form-control\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-sm btn-primary\">{{ \'Go\' | translate }}!</button></span></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>{{ \'RESULTDATA\' | translate }}</h5><div ibox-tools=\"\"></div></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th>{{ \'AGENTNAME\' | translate }}</th><th>{{ \'EMRNAME\' | translate }}</th><th>{{ \'Recipe\' | translate }}</th><th>{{ \'STATUS\' | translate }}</th><th>{{ \'DATE\' | translate }}</th><th>{{ \'COMMENT\' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"agent in qcresult | filter:filterQCRes\"><td>{{agent.agentname}}</td><td>{{agent.emrname}}</td><td>{{agent.recipe}}</td><td>{{agent.status}}</td><td width=\"10%\"><set-date-format ng-if=\"agent.date\" strdate=\"agent.date\" dateformat=\"YYYY-MM-DD\"></set-date-format></td><td>{{agent.comment}}</td></tr></tbody></table></div></div></div></div></div></div>");}]);